import cargo from "./cargo/my";

export default {
  "STT Sudah Di Scan": "STT Already Scanned",
  "Semua waktu": "All time",
  urgentRelabel: {
    searchPlaceholder: "Search STT no.",
    download: "Download",
    printAll: "Print all receipts",
    printSize: "Print Size {size}",
    column: {
      no: "No",
      sttNo: "STT No.",
      shipmentType: "Shipment type",
      rootSttNo: "Origin STT No.",
      processedBy: "Processed by",
      overtimeDuration: "Overtime duration",
      overtimeDurationDays: "{day} days",
      bkdDate: "BKD Date",
      originCity: "Origin city",
      destinationCity: "Destination city",
      printReceipt: "Print Receipt"
    },
    empty: {
      header: "No Relabel Monitor STT yet",
      message:
        "STT from HAL Reroute awaiting Relabel will appear here."
    },
    filter: {
      title: "Filter",
      processedBy: "Processed by",
      processedByPlaceholder: "Select processed by",
      shipmentType: "Shipment type",
      shipmentTypePlaceholder: "Select shipment type",
      originCity: "Origin city",
      originCityPlaceholder: "Select origin city",
      destinationCity: "Destination city",
      destinationCityPlaceholder: "Select destination city",
      bkdUpdateDate: "BKD update date",
      reset: "Reset",
      apply: "Apply",
      optionClient: "Client",
      optionConsolidator: "Consolidator",
      allProducts: "All Products",
      productCount: "{count} Products"
    },
    cityFilter: {
      defaultTitle: "City",
      defaultPlaceholder: "Select city",
      locationCount: "{count} Locations"
    }
  },
  bookingSdn: {
    notice: "This route may experience delivery delays, but you can still proceed with booking."
  },
  "Selisih berat maks.": "Maximum weight difference",
  loading: "Your Request is In Progress",
  "COD International Client": "COD International Client",
  validation: {
    phone: {
      invalid: "Invalid phone number. Please try again.",
      validMsisdn: "Valid phone number with MSISDN type",
      validPstn: "Valid phone number with PSTN type"
    }
  },
  "Jaringan Internet Terputus": "Oops, Connection was Disconnected",
  "Tidak Terhubung ke Internet": "Oops, Connection was Disconnected",
  "Silahkan periksa jaringan internet Anda":
    "Please check your connection internet",
  "Pastikan koneksi internet Anda aktif dan muat ulang":
    "Please check your connection internet",
  "Data tidak ditemukan pada halaman ini": "No data found on this page",
  "Jangan khawatir ini bukan kesalahan Anda. Terjadi kesalahan pada system, silahkan coba lagi nanti":
    "Don't worry, this is not your fault. An error occurred in the system, please try again later",
  "There was an error in our system, please try again":
    "There was an error in our system, please try again",
  "Apa yang Anda cari tidak ditemukan atau tidak ada.":
    "Oops.. No data to show yet",
  "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.":
    "Scan failed because the STT adjustment has not been approved by the Lion Parcel team. Please wait to be contacted by CS.",
  "Silahkan menunggu CS follow up untuk konfirmasi adjust ulang STT.":
    "Please wait for CS to follow up to confirm the STT re-adjustment.",
  "STT gagal discan karena paket akan diberi status POD setelah diambil oleh penerima.":
    "STT failed to scan because the package will be given POD status after being picked up by the recipient.",
  "STT Number tidak dapat ditemukan": "STT Number cannot be found",
  "Paket akan diambil penerima": "The recipient will pick up the package",
  "Oke, mengerti": "OK, got it",
  "Alasan gagal scan": "Reason for scan failure",
  "STT gagal scan": "STT scan failed",
  Baru: "New",
  "Dalam proses": "In process",
  "Dalam eskalasi": "In escalation",
  "Sudah direspon": "Already responded",
  "Ditunda sementara": "Temporarily suspended",
  Ditutup: "Closed",
  Selesai: "Done",
  "Menunggu dokumen": "Waiting for document",
  "Dokumen diterima": "Document received",
  "Dalam investigasi": "Under investigation",
  "Diproses asuransi": "Insurance processing",
  "Konfirmasi customer": "Customer confirmation",
  Dibayar: "Paid",
  Ditolak: "Rejected",
  Rekonsiliasi: "Reconciliation",
  "Rekonsiliasi | Detail shuttle": "Reconciliation | Shuttle detail",
  "status tidak dikenal": "unknown status",
  STT: "STT",
  "STT Manual": "Manual STT",
  FPR: "FPR",
  Transaksi: "Transaction",
  Misroute: "Misroute",
  Shortland: "Shortland",
  Scrap: "Scrap",
  Pengiriman: "Delivery",
  "Coba lagi": "Try Again",
  "Pengiriman Keluar (Kota Asal)": "Outgoing Delivery (Origin City)",
  "Pengiriman Masuk (Kota Tujuan)": "Incoming Delivery (Destination City)",
  "Pembatalan STT": "STT Cancellation",
  "Top Up": "Top Up",
  "Komisi Pengiriman": "Delivery Commission",
  "Komisi Pengiriman Tier X": "Delivery Commission Tier X",
  Kejarcuan: "Kejarcuan",
  "STT Client": "STT Client",
  "Mutasi Saldo": "Balance Mutation",
  "Saldo Tertahan": "Hold Balance",
  Kendala:
    "Experiencing issues with the delivery process? Contact Customer\nService at 021-80820072 or contact the corresponding origin city.",
  "Dalam SLA": "On SLA",
  "Melewati SLA": "Over SLA",
  "Perbaiki booking gagal": "Repair failed booking",
  "Berat/Paket": "Weight/Package",
  "Ketik atau pilih client/partner": "Type or select client/partner",
  attachment: "Attach File",
  parsingErrorSpec: {
    rateNotFoundHeader: "Shipment Rates Not Found",
    rateNotFoundMessage:
      "Shipment rates for the selected route are not available",
    embargoHeader: "Route Under Embargo!",
    embargoMessage: "Unable to process your request. Please reset your route",
    balanceBelowHeader: "Your Balance Is Below the Limit!",
    balanceBelowMessage:
      "Top up your balance now. Ensure your balance is sufficient before shipping activities.",
    posBalanceHeader: "Insufficient POS Balance",
    posBalanceMessage:
      "Please contact POS to top up balance for address changes.",
    requestFailedHeader: "Request Failed !",
    updateFailedHeader: "Update Failed!",
    okUnderstand: "OK, I Understand"
  },
  attach: "Attachement",
  "STT belum di STI DEST & DEL": "STT hasn't been processed STI DEST & DEL",
  downloadReceipt: "Download Receipt",
  bosspackNote: "BOSSPACK (Maximum pickup time is 14:00)",
  "Menunggu Proses Print": "Waiting for printing process",
  "Kami sedang menyiapkan data Anda untuk dicetak":
    "We are preparing your data for printing",
  "Berat kotor kargo": "Cargo gross weight",
  "Berat volume kargo": "Cargo volume weight",
  sidebar: {
    currentVersion: "Current version.",
    revertToPreviousVersion: "Revert to previous version",
    searchMenuPlaceholder: "Search menu",
    menuNotFound: "Menu not found",
    menuNotFoundDescription: "The menu you are looking for does not exist",
    back: "Back",
    feedback: {
      title: "Give your rating",
      subtitle: "Your feedback is valuable to us",
      subtitleCardReview: "Your feedback is valuable for improvement",
      rateButton: "Rate"
    }
  },
  layout: {
    firebaseNotification: {
      cancel: {
        success: "<b>Cargo No. {cargoNo}</b> cancelled successfully",
        failed:
          "<b>Cargo No. {cargoNo}</b> - Cancellation failed because <b>{reason}</b>."
      },
      booking: {
        success:
          "<b>Cargo No. {cargoNo}</b> cargo booking succeeded to <b>{destination}</b>",
        failed:
          "<b>Cargo No. {cargoNo}</b> booking failed because <b>{reason}</b>"
      }
    }
  },
  featureName: {
    "Manajemen User": "User Management",
    "Daftar CARGO": "Cargo List",
    Beranda: "Dashboard",
    "Manifest cari STT": "Manifest search for STT",
    "Lacak Pengiriman": "Track Shipment",
    "Kiriman Penting": "Urgent Delivery",
    "Performa DEX Asesmen": "DEX Performance Assessment",
    "DEX Asesmen": "DEX Assessment",
    "Proses STI": "STI Process",
    "Proses BAG": "BAG Process",
    "Proses RTC": "RTC Process",
    "Proses DISPATCH": "DISPATCH process",
    "Proses Custom Status": "Custom Status Process",
    "Handover Vendor (HND)": "Vendor Handover (HND)",
    "STT Kurang Bayar": "STT Underpayment",
    "STT Dalam Proses": "STT In Process",
    "Manajemen Kurir": "Courier Management",
    "Cek Tarif": "Check Rate",
    "Daftar Booking": "Booking List",
    "Cetak Tagihan": "Print Invoice",
    "Cetak Resi": "Print Receipt",
    "Pusat Resolusi": "Resolution Center",
    Notifikasi: "Notification",
    "Rekon Delivery": "Delivery Reconciliation",
    "Batas POD Terlewati": "POD Deadline Passed",
    "Batas POD Hari Ini": "POD Deadline Today",
    "Batas RTS Terlewati": "RTS Deadline Passed",
    "Batas RTS Hari ini": "RTS Deadline Today",
    "Batas RTS Besok": "RTS Deadline Tomorrow",
    "Proses CARGO": "CARGO Process",
    "Pusat Panduan": "Guide Center"
  },
  outgoingShipment: {
    bagging: {
      uploadPhoto: {
        headerLeading:
          "You must upload photo evidence if the difference between",
        headerTrailing: "cargo weight and reweighed weight is 1 kg or more",
        rulesTitle: "Photo requirements:",
        ruleGoodResolution: "Photos must have good resolution.",
        ruleScaleReadable:
          "The actual weight on the scale must be clearly readable.",
        ruleAllPackagesVisible:
          "All packages being weighed must be clearly visible.",
        ruleMinimumOne: "At least 1 photo",
        guideWeighingWithItem: "Scale photo <br /> with the item",
        guideMeasurementWithItem: "Measurement photo <br /> with the item",
        additionalPhoto: "Additional photo"
      }
    }
  },
  dashboard: {
    summary: "Summary",
    onTime: "On Time",
    late: "Late",
    resi: "Shipment",
    route: "Route",
    byRoute: "By Route",
    distributionByProduct: "Distribution by Product",
    delivery: "Delivery",
    totalResi: "Total Shipment",
    status: "Status",
    detail: "Detail",
    posReferral: "POS Referral",
    termsAndConditions: "Terms and Conditions:",
    registerNow: "Register Now!",
    claimMbgSuccess: "You have successfully claimed MBG of",
    claim: "Claim",
    totalClaim: "Total Claim",
    filter: "Filter",
    reset: "Reset",
    apply: "Apply",
    allShipments: "All Shipments",
    deliveryPerformance: "Delivery Performance",
    shippingCost: "Shipping Cost",
    cancelledCodValue: "Cancelled COD Value",
    codVsNonCod: "COD vs Non COD",
    rejectionReason: "Rejection Reason",
    tooltipClaimData: "Data displayed from September 2022",
    routes: "Routes",
    stt: "STT",
    referralInviteCopy:
      "Invite your friends to join as Lion Parcel POS Agent Partner using the referral code and get incentive",
    referralShareCopy:
      "Share this referral code and invite your friends to join Lion Parcel POS Agent Partner.",
    packageInfo: "Package Information",
    cod: "COD",
    performance: "Performance",
    emptyState: "Oops.. No data to display",
    greeting: "Hi, {name}!",
    lastSync: "Last Data Sync",
    sttNoteBefore: "STT is updated every ",
    sttNoteStrong: "10 minutes",
    sttNoteAfter: " and will appear when cutoff starts",
    codIntro:
      "Below is the total STT you processed in the last 3 days with each status.",
    seeMore: "See More",
    filterLabels: {
      selectService: "Select service",
      selectDelivery: "Select delivery",
      selectDate: "Select Date",
      allServices: "All Services",
      allBranches: "All Branches",
      maxDaysError: "Date range must not exceed 365 days"
    },
    advanceFilter: {
      serviceType: "Service Type",
      deliveryType: "Delivery Type"
    },
    claimSubmitted: "Submitted",
    claimApproved: "Approved",
    claimRejected: "Rejected",
    claimCompleted: "Completed",
    tabUtama: "Main",
    tabPerforma: "Performance",
    tabHangingBkd: "Hanging BKD",
    tabCustomer: "Customer",
    tabLeaderboard: "Leaderboard",
    tabCod: "COD",
    tabRevenue: "Revenue",
    shortcut: {
      menuUtama: "Main Menu",
      bookingRetail: "Retail Booking",
      bookingKlien: "Client Booking",
      bookingShipment: "App & Marketplace Booking",
      bookingInstant: "Instant Booking",
      ppob: "PPOB",
      new: "New"
    },
    console: {
      card: {
        remainingTime: "Remaining time",
        maxTime: "Maximum Time"
      },
      tabs: {
        allStt: "All STT",
        currentStt: "Current STT",
        cod: "COD",
        hangingBkd: "Hanging BKD",
        hangingOutgoing: "Hanging Outgoing",
        hangingIncoming: "Hanging Incoming",
        hangingLastMile: "Hanging Last Mile",
        performance: "Performance"
      },
      common: {
        viewDetail: "View Detail",
        downloadXlsx: "Download .xlsx",
        total: "Total"
      },
      allStt: {
        failedToLoad: "Failed to load data",
        incomingStt: "Incoming STT",
        transitStt: "Transit STT",
        outgoingStt: "Outgoing STT",
        loadMore: "Load More",
        cardTitles: {
          sttNotReceived: "STT Not Received",
          sttCargoPlane: "STT Cargo Plane",
          sttCargoTruck: "STT Cargo Truck",
          sttCargoTrain: "STT Cargo Train",
          sttTransit: "STT Transit",
          sttMisroute: "STT Misroute",
          sttShortland: "STT Shortland",
          sttNotFinished: "STT Not Finished",
          sttStiDest: "STT STI-DEST",
          sttStiDestSc: "STT STI DEST-SC",
          sttDel: "STT DEL",
          sttDex: "STT DEX",
          sttHal: "STT HAL",
          sttBkd: "STT BKD",
          sttPup: "STT PUP",
          sttStiSc: "STT STI-SC",
          sttSti: "STT STI",
          sttBagging: "STT Bagging",
          sttRejected: "STT Rejected"
        },
        cardDescriptions: {
          incomingNotReceived:
            "Total STT that has not arrived at destination city Consolidator",
          incomingCargoPlane:
            "Total STT to consolidator city with latest status Cargo Plane",
          incomingCargoTruck:
            "Total STT to consolidator city with latest status Cargo Truck",
          incomingCargoTrain:
            "Total STT to consolidator city with latest status Cargo Train",
          incomingTransit:
            "Total STT to consolidator city with latest status Transit",
          incomingMisroute:
            "Total STT to consolidator city with latest status Misroute",
          incomingShortland:
            "Total STT to consolidator city with latest status Shortland",
          incomingNotFinished:
            "Total STT that already arrived at destination city Consolidator but delivery process is not completed",
          incomingStiDest:
            "Total STT in destination city with latest status STI-DEST",
          incomingStiDestSc:
            "Total STT in destination city with latest status STI DEST-SC",
          incomingDel: "Total STT in destination city with latest status DEL",
          incomingDex: "Total STT in destination city with latest status DEX",
          incomingHal:
            "Package is held at destination city Consolidator for several reasons.",
          transitUndelivered:
            "Total transit STT that has not arrived at transit consolidator",
          transitUndeliveredCargoPlane:
            "Total STT to transit city with latest status Cargo Plane",
          transitUndeliveredCargoTruck:
            "Total STT to transit city with latest status Cargo Truck",
          transitUndeliveredCargoTrain:
            "Total STT to transit city with latest status Cargo Train",
          transitUnfinished:
            "Total transit STT that has arrived at transit consolidator but delivery process is not completed",
          transitUnfinishedCargoPlane:
            "Total STT originating from transit Consolidator with latest status Cargo Plane",
          transitUnfinishedCargoTruck:
            "Total STT originating from transit Consolidator with latest status Cargo Truck",
          transitUnfinishedCargoTrain:
            "Total STT originating from transit Consolidator with latest status Cargo Train",
          transitUnfinishedTransit:
            "Total STT in transit city with latest status Transit",
          outgoingNotReceived:
            "Total STT not yet received by origin city Consolidator",
          outgoingBkd: "Total STT in origin city with latest status BKD",
          outgoingPup: "Total STT in origin city with latest status PUP",
          outgoingStiSc: "Total STT in origin city with latest status STI-SC",
          outgoingNotFinished:
            "Total STT sent from origin city but not yet arrived at destination city",
          outgoingSti:
            "Total STT originating from consolidator with latest status STI",
          outgoingBagging:
            "Total STT originating from consolidator with latest status Bagging",
          outgoingShortland:
            "Total STT originating from consolidator with latest status Shortland",
          outgoingCargoPlane:
            "Total STT originating from consolidator with latest status Cargo Plane",
          outgoingCargoTruck:
            "Total STT originating from consolidator with latest status Cargo Truck",
          outgoingCargoTrain:
            "Total STT originating from consolidator with latest status Cargo Train",
          outgoingMisroute:
            "Total STT originating from consolidator with latest status Misroute",
          outgoingRejected:
            "Package is rejected by cargo team because it does not comply with Cargo Plane regulations"
        }
      },
      currentStt: {
        outgoing: "Outgoing",
        incoming: "Incoming",
        infoTitle: "Information {type}",
        posListTitle: "List of POS that have not sent STT",
        notProcessed: "Not Processed",
        processed: "Processed",
        errorTitle: "Page under maintenance",
        errorMessage:
          "Sorry, this page is under maintenance. We will be back online soon.",
        whatsappActiveAgainAt: "Active again at",
        andReloadPage: "and reload the page",
        whatsappClickHint: "Click Chat on WhatsApp.",
        whatsappCooldownHint:
          "You can only contact this POS again after the next 1 hour!",
        clickToDetail: "Click for Detail",
        sortDesc: "Sort from largest to smallest",
        sortAsc: "Sort from smallest to largest",
        table: {
          no: "No",
          posName: "POS Name",
          posCode: "POS Code",
          posPhone: "POS Phone Number",
          unprocessed: "Not Processed",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging"
        },
        cutOffTitles: {
          cycle1: "Cycle 1",
          cycle2: "Cycle 2",
          needSti: "Need at STI",
          needCargoPlane: "Need at Air Cargo",
          needCargoTruckTrain: "Need at Truck/Train Cargo",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging",
          bkdToSti: "BKD to STI",
          stiToCargoPlane: "STI to Air Cargo",
          stiToCargoTruckTrain: "STI to Truck/Train Cargo",
          onTime: "On Time",
          late: "Late",
          invalidSkippingStatus: "Invalid/Skipping Status",
          needDel: "Need at DEL",
          needPod: "Need at POD"
        },
        cutOffDescriptions: {
          cycle: "List of STT not updated and still within cutoff time",
          cycle1Incoming:
            "List of STT not updated and still within cutoff time Cycle 1",
          cycle2Incoming:
            "List of STT not updated and still within cutoff time Cycle 2",
          backlogToday: "List of STT not updated and already past cutoff time",
          backlog2to7:
            "List of STT not processed today and already past cutoff time",
          hanging: "List of STT not updated and already more than 7 days",
          onTime:
            "List of STT that has been updated and still within cutoff time",
          late: "List of STT that has been updated outside cutoff time",
          invalid:
            "List of STT that has been processed but skipped required status"
        }
      },
      detailProcess: {
        locationSti: "at STI",
        locationDel: "at DEL",
        locationCargoPlane: "at Air Cargo",
        locationPod: "at POD",
        locationCargoTruckTrain: "at Truck/Train Cargo",
        columns: {
          onTime: "On Time",
          late: "Late",
          invalid: "Invalid",
          backlogToday: "Today's Backlog",
          backlog2to7: "Backlog 2-7 Days",
          hanging: "Hanging"
        },
        tooltips: {
          onTime:
            "List of STT that has been updated and still within cutoff time",
          late: "List of STT that has been updated outside cutoff time",
          invalid:
            "List of STT that has been processed but skipped required status",
          backlogToday:
            "List of STT not processed today and already past cutoff time",
          backlog2to7:
            "List of STT not processed for 2-7 days and already past cutoff time",
          hanging: "List of STT not updated and already more than 7 days"
        }
      }
    },
    performa: {
      lastSync: "Last Data Sync"
    },
    customer: {
      topCustomer: "Top Customer",
      updated: "Updated",
      tooltip:
        "List of customers who transact at your POS, ranked by total transactions and calculated for the previous month.",
      emptyMessage: "Oops.. No data to display yet",
      dataLabel: "Data",
      ranking: "Rank",
      pelanggan: "Customer",
      labelPelanggan: "Customer Label",
      periodeSaatIni: "Current period",
      reloadPage: "Reload",
      systemError: "System error occurred",
      systemErrorHint: 'Click "Reload" to refresh the page.',
      lastSend: "Last send:",
      omzetNaik: "Revenue Up",
      omzetTurun: "Revenue Down",
      pelangganBaru: "New Customer",
      pelangganChurn: "Churned Customer",
      misbooking: "MISBOOKING > 5%",
      rts: "RTS > 5%",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      }
    },
    hanging: {
      emptyHeader: "Data not available",
      emptyMessage: "If data exists, it will appear here automatically.",
      searchEmptyHeader: "Search results not found",
      searchEmptyMessage: "Please check your search keyword or filters.",
      confirmTitle: "Update Status?",
      confirmSuccess: "Yes, update",
      confirmDoneTitle: "Confirm completed?",
      confirmDoneMessage:
        "Ensure you have followed up or searched for the Hanging STT.",
      confirmDoneSuccess: "Yes, done",
      cancel: "Cancel",
      confirmUpdateMessage:
        "Are you sure you want to update status to <b>{status}?</b>",
      templateIntro: "Hello, I am from",
      templateLionParcel: "Lion Parcel",
      templateHanging: "I would like to follow up on hanging status STT",
      templateMoreThan3Days: "more than 3 days",
      templateTotal: "Total of {count} STT:",
      templateThanks: "Thank you for your assistance",
      accountTypePos: "POS",
      accountTypeKonsolidator: "Consolidator",
      successUpdate: "Successfully updated activity status",
      failUpdate: "Failed to update activity status",
      successUpdateStatus: "Successfully updated status <b>{status}</b>",
      successUpdateStatusWithRatio:
        "Successfully updated status <b>{status} {success}/{total}</b>",
      failUpdateStatus: "Failed to update status <b>{status}</b>",
      all: "All",
      searchOrScan: "Search or scan",
      statusPackageExistence: "Package existence status",
      activityStatus: "Activity status",
      followUpStatus: "Follow up status",
      statusNotFound: "Not found",
      statusFoundConsole: "Package found at Console",
      statusFoundPos: "Package found at POS",
      notCompleted: "Not Completed",
      completed: "Completed",
      notFollowedUp: "Not Followed Up",
      followedUp: "Followed Up",
      historyEmptyHeader: "No history yet",
      historyEmptyMessage: "You do not have any history at the moment.",
      allActivities: "All activities",
      followUpDone: "Follow up completed",
      followUpAirport: "Follow Up to Airport Agent",
      followUpCourierTruck: "Follow Up to Truck Courier",
      followUpChecker: "Follow Up to Checker",
      searchSttWarehouse: "Search STT in Warehouse",
      followUpConsole: "Follow Up to Console",
      followUpPartnerClient: "Follow Up to Partner/Client",
      followUpUser: "Follow Up to User",
      searchItemWarehouse: "Search Item in Warehouse",
      followUpOps: "Follow Up to Ops",
      followUpCourier: "Follow Up to Courier",
      followUpPicLastMile: "Follow Up to Last Mile PIC",
      followUpTo: "Follow Up to",
      dashboardTitleIncoming: "Incoming Hanging Dashboard",
      dashboardTitleOutgoing: "Outgoing Hanging Dashboard",
      dashboardTitleLastMile: "Last Mile Hanging Dashboard",
      dashboardTitleBkd: "STI Hanging Dashboard",
      incomingInfoPrefix: "AWB with hanging STT",
      incomingInfoOnStatus: "on status",
      incomingInfoStatuses: "ARR/DROPOFF_TRUCKING/STI-DEST/SHORTLAND",
      incomingInfoActionPrefix: "please reattempt",
      incomingInfoAction: "DEL",
      outgoingInfoPrefix: "Hanging STT",
      outgoingInfoOnStatus: "on status",
      outgoingInfoStatuses: "STI, BAGGING",
      outgoingInfoActionPrefix: "must be immediately",
      outgoingInfoAction: "CARGO",
      lastMileInfoPrefix: "Hanging STT",
      lastMileInfoOnStatus: "on",
      lastMileInfoStatuses: "DEL/DEX/CODREJ",
      lastMileInfoActionPrefix: "please reattempt",
      lastMileInfoAction: "DEL or RTS.",
      bkdInfoPrefix: "Hanging STT",
      bkdInfoOnStatus: "on status",
      bkdInfoStatuses: "BKD, ADJUSTED, PUP, STI-SC, STO-SC",
      bkdInfoActionPrefix: "must be immediately",
      bkdInfoAction: "STI",
      day3Plus: "≥ 3 days",
      syncLast: "Last Sync",
      searchStt: "Search STT",
      history: "History",
      total: "Total",
      mustBeDone: "to be done",
      hanging: "hanging",
      activityDone: "Activities completed",
      processedToday: "processed today",
      totalBag: "Total BAG",
      totalStt: "Total STT",
      totalActivityMustDo: "Total Activities That Must Be Done",
      alreadyProcessed: "already processed",
      activity: "Activity",
      awb: "AWB",
      bag: "BAG",
      stt: "STT",
      courier: "Courier",
      userOps: "Ops User",
      pos: "POS",
      subKon: "SUB-CON",
      corporate: "CORPORATE",
      historyIncomingTitle: "Incoming Hanging History",
      historyOutgoingTitle: "Outgoing Hanging History",
      historyLastMileTitle: "Last Mile Hanging History",
      historyBkdTitle: "BKD Hanging History",
      historyBkdConsoleTitle: "BKD Console Hanging History",
      historyBkdPosTitle: "BKD Pos Hanging History",
      historyHangingTab: "Hanging History",
      historyFollowUpTab: "Follow Up History",
      templateHelpQuestion: "Are the STTs above available there?",
      templateHangingAwb:
        "I would like to follow up AWB with hanging status ({groupName})",
      templateTotalAwb:
        "Total of {totalAwb} AWB with {totalPiece} pieces, namely:",
      templateHelpQuestionAwb: "Are the AWBs above available there?",
      templateMessage: "Message Template",
      whatsapp: "WhatsApp",
      confirmDone: "Confirm Complete",
      packageLocation: "Package location",
      notes: "Notes",
      dayUnit: "Days",
      day7Plus: "≥7 Days"
    },
    tooltipTotalStatusDelivery: "Total STT successfully booked",
    onProcess: "In Process",
    tooltipOnProcess: "Total STT currently in the delivery process",
    accepted: "Delivered",
    tooltipAccepted: "Total STT successfully delivered",
    failedDelivery: "Delivery Failed",
    tooltipFailedDelivery: "Total STT that failed to be delivered",
    return: "Returned",
    tooltipReturn: "Total STT that were returned",
    codValue: {
      title: "COD Value",
      estTotalCodValue: "Estimated Total COD Value",
      tooltipEstTotalCodValue: {
        list1: "Estimated total COD value to be received",
        list2: "Total COD STT successfully booked"
      },
      onProcess: "In Process",
      tooltipOnProcess: {
        list1: "Estimated total COD value currently in delivery process",
        list2: "Total COD STT currently in delivery process"
      },
      accepted: "Delivered",
      tooltipAccepted: {
        list1: "Estimated total COD value to be received",
        list2: "Total COD STT successfully booked"
      },
      failed: "COD Value",
      tooltipFailed: {
        list1: "Estimated total COD value that failed to be delivered",
        list2: "Total COD STT that failed to be delivered"
      }
    },
    sectionShipping: {
      inProgress: "To Be Billed",
      success: "Billed",
      tooltipSuccess:
        "Billed data refers to data that has not yet been paid or is in the process of payment (unpaid or partially paid)",
      paid: "Paid",
      tooltipPaid:
        "Paid data refers to data that has been successfully paid (paid)"
    },
    hangingBkd: {
      title: "BKD Hanging Dashboard",
      total: "Total",
      stt: "STT",
      adminPos: "POS Admin",
      bkd: "BKD",
      pup: "PUP",
      sttHanging: "Hanging STT",
      days: "≥ 3 days",
      on: "in",
      statuses: "BKD, STT ADJUSTED, PUP",
      mustBe: "must be processed to",
      sti: "STI",
      lastSync: "Last Sync",
      searchStt: "Search STT",
      history: "History",
      totalActivity: "Total Activities That Must Be Done",
      activityDone: "Activities Completed",
      processedToday: "processed today",
      historyPage: {
        pageTitle: "BKD Hanging History",
        tabs: {
          historyHanging: "Hanging History",
          historyFollowUp: "Follow Up History"
        },
        back: "Back",
        historyHanging: {
          manifestNo: "Manifest No.",
          sttNo: "STT No.",
          hanging: "Hanging",
          packageExistenceStatus: "Package Status",
          packageExistenceLocation: "Package Location",
          description: "Description",
          aggregator: "Aggregator",
          emptyHeader: "No data available",
          emptyMessage:
            "If data becomes available, it will automatically appear here.",
          days: "Days",
          day7Plus: "≥7 Days",
          notFound: "Not Found",
          foundConsole: "Package Found at Console",
          foundPos: "Package Found at POS"
        },
        historyFollowUp: {
          activityStatus: "Activity status",
          allActivities: "All activities",
          followUpPartnerClient: "Follow Up to Partner/Client",
          followUpUser: "Follow Up to User",
          searchWarehouse: "Search Item in Warehouse",
          followUpCompleted: "Follow up completed",
          noHistoryTitle: "No history yet",
          noHistoryMessage: "You do not have any history at the moment.",
          followUpTo: "Follow Up to",
          searchSttWarehouse: "Search STT in Warehouse"
        }
      }
    },
    leaderboard: {
      updated: "Updated",
      national: "National",
      newPos: "New POS",
      emptyState: {
        noConnection: {
          header: "Internet connection lost",
          message: "Check your internal network and click 'Reload'.",
          button: "Reload"
        },
        noData: {
          header: "No leaderboard yet",
          message:
            "Start your transactions and earn rewards up to tens of millions from the POS leaderboard!"
        }
      },
      jumpButtons: {
        viewYourRank: "View your rank",
        viewNearestTopReward: "View nearest top reward",
        viewTopRank: "View top rank"
      },
      columns: {
        rank: "Rank",
        posName: "POS Name",
        achievement: "Achievement",
        cityCode: "3LC",
        totalRevenue: "Total Revenue",
        estimatedReward: "Estimated Reward"
      },
      cardLiolio: {
        noData: {
          header: "POS leaderboard program for {month} has not started yet.",
          message: "Please wait to earn rewards coming for you"
        },
        reward: {
          congrats: "Congratulations! You received a reward"
        },
        encourage:
          "Increase your revenue & earn rewards up to tens of millions next time!",
        totals: {
          revenue: "Total Revenue"
        }
      },
      podium: {
        title: {
          rank: "Rank",
          newPos: "New POS",
          area: "Area",
          national: "National Rank"
        },
        reward: {
          label: "Estimated reward"
        }
      },
      cardReward: {
        totalEstimatedReward: "Total estimated reward",
        totalRevenue: "Total revenue",
        tooltip: {
          revenueInfo:
            "Revenue accumulation is calculated from STT Retail and CBP based on POD time"
        }
      },
      filterMonth: {
        placeholder: "Month",
        selectMonth: "Select month",
        currentMonth: "This month",
        monthNames: {
          january: "January",
          february: "February",
          march: "March",
          april: "April",
          may: "May",
          june: "June",
          july: "July",
          august: "August",
          september: "September",
          october: "October",
          november: "November",
          december: "December"
        }
      },
      topCustomer: {
        title: "Top 10 Customers",
        table: {
          no: "No",
          customer: "Customer",
          currentPeriod: "Current period"
        },
        lastSent: "Last shipment:",
        empty: "No data available",
        ok: "OK",
        stt: "STT",
        kg: "kg"
      },
      sliderLeaderboard: {
        title: "How to increase your reward",
        scope: {
          area: "area",
          newPos: "new POS"
        },
        slides: {
          national1: "Increase revenue up to",
          national2: "Earn national reward",
          areaOrNewPos1: "Reach revenue",
          areaOrNewPos2: "to earn reward",
          topCustomerPrefix: "Encourage",
          topCustomerHighlight: "top 10 customers",
          topCustomerSuffix: "to transact more often and earn higher rewards!",
          operational1: "Extend operational hours",
          operational2: "to increase revenue."
        }
      }
    },
    filterHistoryHanging: {
      searchPlaceholder: "Search or scan",
      today: "Today",
      day3: "3 Days",
      day4: "4 Days",
      day5: "5 Days",
      day6: "6 Days",
      day7Plus: "≥7 Days"
    },
    customerLeaderboardFilter: {
      customerName: "Customer name",
      allLabels: "All labels",
      omzetUp: "Revenue Increased",
      omzetDown: "Revenue Decreased",
      churnCustomer: "Churned Customer",
      newCustomer: "New Customer"
    },
    errorBreakdownTable: {
      service: "Service",
      channel: "Channel",
      shipmentType: "Shipment Type",
      destinationCity: "Destination City",
      commodity: "Commodity",
      systemError: "A system issue occurred",
      reloadInstruction: "Click “Reload” to refresh the page.",
      reload: "Reload",
      emptyData: "Oops.. No data available to display yet"
    },
    breakdownTable: {
      service: "Service",
      channel: "Channel",
      shipmentType: "Shipment Type",
      destinationCity: "Destination City",
      commodity: "Commodity",
      scrollMore: "Scroll to see more",
      lastSync: "Last data synchronization"
    },
    lineComparisonChart: {
      systemError: "A system error occurred",
      reloadInstruction: "Click “Reload” to refresh the page.",
      reload: "Reload",
      performance: "Performance",
      totalOmzet: "Total revenue",
      totalRevenue: "Total income",
      totalStt: "Total STT",
      current: "Current",
      comparison: "Comparison",
      monthsShort: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      },
      omzet: "revenue",
      berat: "weight"
    },
    totalRevenueSection: {
      title: "Total revenue (Retail & CBP)",
      systemError: "A system error occurred",
      reloadInstruction: "Click “Reload” to refresh the page.",
      reload: "Reload",
      previous: "Previous",
      previousLower: "previous"
    },
    cardTotalProfit: {
      title: "Total income",
      systemError: "A system error occurred",
      reloadInstruction: "Click “Reload” to refresh the page.",
      reload: "Reload",
      earnedProfitTitle: "Earned income",
      earnedProfitDescription:
        "Total income you have already received and credited to your POS balance.",
      pendingProfitTitle: "Estimated pending income",
      pendingProfitDescription:
        "Total income you will receive but is waiting for POD delivery."
    },
    dateRangeCompare: {
      selectDatePeriod: "Select date period",
      selectDate: "Select date",
      mainPeriod: "Main period",
      comparePeriod: "Comparison period",
      reset: "Reset",
      apply: "Apply",
      presets: {
        customDate: "Custom date",
        last7Days: "Last 7 days",
        last14Days: "Last 14 days",
        lastMonth: "Last 1 month",
        last3Months: "Last 3 months"
      },
      weekdays: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun"
      }
    },
    filterGrouping: {
      comparisonTitle: "Comparison of total revenue & income",
      showData: "Show data"
    },
    topCommodity: {
      updatedAt: "Updated",
      title: "Top commodities",
      yourPos: "Your POS",
      tooltip:
        "Commodity data with the highest transactions in your area, along with the number of STT you have booked.",
      emptyState: {
        header: "No commodities yet",
        message: "There are no commodities to display"
      },
      table: {
        trending: "Trending",
        bookingAtPos: "Bookings at your POS",
        totalBooking: "Total bookings in"
      },
      retry: "Try again"
    },
    metrics: {
      revenue: "Revenue",
      stt: "STT",
      weight: "Weight"
    },
    breakdownFilter: {
      select: "Select",
      reset: "Reset",
      apply: "Apply",
      searchHere: "Search {label} here",
      service: "Service",
      channel: "Channel",
      productType: "Delivery type",
      destinationCity: "Destination city",
      commodity: "Commodity"
    },
    cardProgress: {
      complete: "Complete",
      activitiesToday: "activities today"
    },
    cardCollapsibleHanging: {
      followUpOps: "Follow Up to Ops {username}",
      followUpPartner: "Follow Up to {name} ({code})",
      followUpUser: "Follow Up to {username}",
      searchSttWarehouse: "Search STT in Warehouse",
      notSearched: "Not yet searched",
      doneSearchStt: "STT search done",
      notFollowedUp: "Not yet followed up",
      doneFollowUp: "Follow up done",
      aggregator: "Aggregator",
      days: "Days",
      sevenOrMoreDays: "≥7 Days",
      notFound: "Not Found",
      foundConsole: "Package Found in Console",
      foundPos: "Package Found in POS",
      templateMessage: "Template Message",
      confirmDone: "Confirm Done",
      awb: "AWB",
      origin: "Origin",
      koli: "Pieces",
      bag: "BAG",
      stt: "STT",
      no: "No.",
      bagNo: "Bag No.",
      manifestNo: "Manifest No.",
      sttNo: "STT No.",
      productType: "Product Type",
      hanging: "Hanging",
      destinationCity: "Destination City",
      packageStatus: "Package Status",
      packageLocation: "Package Location",
      confirmDoneTitle: "Confirm Done?",
      yesDone: "Yes, Done",
      confirmDoneMessage:
        "Make sure you have followed up or found the Hanging STT.",
      cancel: "Cancel"
    },
    copyTemplate: {
      templateText: "Text Template",
      greeting: "Hello, I am from {accountType} Lion Parcel {cityCode}.",
      followUpHanging:
        "I want to follow up AWB with hanging status ({groupName}) for more than 3 days.",
      totalAwb:
        "There are a total of {totalAwb} AWB with {totalPiece} pieces, as follows:",
      awbItem: "{awbNo} - Origin {origin}",
      helpThanks: "Could you check the above AWB? Thank you for your help.",
      copyText: "Copy text",
      copiedSuccess: "Successfully copied"
    }
  },
  bulkAction: {
    searchPlaceholder: "Search by activity name or ID",
    uploadFile: "Upload File",
    uploadFileNow: "Upload File Now",
    emptyNoBulk: "No bulk uploads to display yet",
    emptyNoResult: "No results found",
    emptyNoResultDesc:
      "What you are looking for was not found or does not exist",
    emptyNoDataOnPage: "No data found on this page",
    tabExistingData: "Available Data",
    tabTemplate: "Template",
    searchFile: "Search file",
    downloadCsv: "Download csv",
    searchTemplate: "Search template",
    learnTemplateDesc:
      "Learn how to fill the template by downloading the file below.",
    downloadExtension: "Download {extension}",
    followTemplateHint: "Follow the bulk upload template guide",
    activityNamePlaceholder: "Enter upload activity name",
    attachmentOriginal: "Original File Attachment",
    attachmentFailed: "Failed File Attachment",
    columnUploadId: "Upload ID",
    columnNamaAktivitas: "Activity Name",
    columnTipeBerkas: "File Type",
    columnWaktuDibuat: "Created Time",
    columnStatus: "Status",
    columnLampiran: "Attachment",
    detailTitle: "Activity Detail",
    detailNamaAktivitas: "Activity Name",
    detailTipeBerkas: "File Type",
    detailNamaVersi: "Retail Base Rate Version Name",
    detailClient: "Client",
    detailPeriode: "Retail Price Period",
    detailTanggalAktif: "Price Active Date",
    detailWaktuDibuat: "Created Time",
    detailDibuatOleh: "Created By",
    statusAll: "All Status",
    statusUploading: "Uploading",
    statusPartially: "Partially",
    statusSuccess: "Success",
    statusFailed: "Failed"
  },
  bulkPrintResi: {
    listSttTitle: "STT Number List",
    maxSttHint: "Maximum 50 STT can be processed.",
    placeholderStt: "Enter STT number or scan barcode",
    tagPlaceholder: "Press enter to add STT number",
    showStt: "Show STT Numbers",
    clearAll: "Clear All",
    tableSectionTitle: "STT Print List",
    clientPartnerName: "Client / Partner Name",
    totalCharge: "Total Charge",
    printThermalResi: "Print Thermal Receipt",
    printThermalResiToPdf: "Print Thermal Receipt to PDF",
    printBasicSaveToPdf: "Print Basic/Save to PDF",
    errorSttNotFound: "STT data not found",
    modalFailedTitle: "Label Print Failed",
    modalFailedMessage:
      "Ensure all your devices are connected. <br/> Check and try again",
    modalSuccessTitle: "Label Printed Successfully",
    modalSuccessMessage: "You have successfully printed the selected data",
    columnNo: "No",
    columnNoStt: "No. STT",
    columnNoReferensi: "Reference No.",
    columnTotalKoli: "Total Pcs",
    columnTotalBerat: "Total Weight",
    columnAlamatTujuan: "Destination Address",
    columnPengirim: "Sender",
    columnPenerima: "Recipient",
    columnAsuransi: "Insurance",
    columnCod: "COD",
    columnBiayaPengiriman: "Shipping Cost",
    columnSurcharge: "Surcharge",
    columnBiayaAsuransi: "Insurance Cost",
    columnTotalTarif: "Total Tariff"
  },
  universalPrint: {
    loading: "STT print request is being processed"
  },
  printReceipt: {
    grossVolumeWeightKg: "Gross/volume weight",
    sttKoli: "STT/Pieces",
    listSttLabel: "STT Number List",
    maxSttInfo: "Maximum of 50 STT can be processed at once.",
    sttPlaceholder: "Type or select STT No.",
    createInvoice: "Generate Invoice",
    deleteAll: "Clear All",
    generalInfo: "General Information",
    partnerName: "Partner Name",
    createdAt: "Created Date",
    totalTariff: "Total Tariff",
    totalInvoice: "Total Invoice",
    payInvoice: "Pay Invoice",
    printBasic: "Print Basic/Save to PDF",
    send: "Send",
    billed: "Billed",
    invoicePaidAuto: "Auto-paid Invoices (Cashless)",
    pageTitle: "Generate Invoice",
    errorSttNotFound: "{n}/{total} STT data not found",
    totalTariffLabel: "Total Tariff",
    totalInvoiceLabel: "Total Invoice",
    modalSendTitle: "Send Invoice",
    emailLabel: "Email Address",
    emailPlaceholder: "Enter your email to send invoice here",
    emailError: "Enter valid email address",
    cancel: "Cancel",
    sendLabel: "Send",
    sendEmailSuccess: "Email sent successfully!",
    date: "Date",
    posName: "POS Name",
    totalResi: "Total Receipts",
    totalTariffBeforeDiscount: "Total Tariff Before Discount",
    totalTariffAfterDiscount: "Total Tariff After Discount",
    destination: "Destination",
    sender: "Sender",
    recipient: "Recipient",
    totalKoli: "Total Pcs",
    totalWeight: "Total Weight",
    destinationAddress: "Destination address",
    no: "No",
    noStt: "STT No.",
    add: "Add",
    save: "Save",
    waMessage:
      "Hello {name}, thank you for entrusting your shipping needs to Lion Parcel.\n\nPlease find below the summary of the invoice for the services used:\n\nInvoice No: {invoiceNo}\n\nTotal STT: {totalStt}\n\nTotal Invoice: {totalAmount}\n\nWe kindly request you to settle the payment at your earliest convenience so that your future shipping services can run smoothly.\n\nThank you for your attention and cooperation.",
    sendInvoiceError: "Failed to Send Invoice",
    insurance: "Insurance",
    codRate: "COD Fee",
    other: "Other",
    booking: {
      title: "Print Invoice & Receipt",
      successBooked: "successfully booked",
      checkHistory: "Check history to successfully print invoice and receipt",
      table: {
        sttNo: "STT No.",
        senderName: "Sender Name",
        shipmentType: "Shipment Type",
        invoice: "Invoice",
        paidViaApp: "Paid via App",
        paidByRecipient: "Paid by Recipient",
        activity: "Activity",
        chargableWeight: "Chargeable Weight"
      },
      printReceipt: "Print Receipt",
      createInvoice: "Create Invoice",
      successHistory: "Successful Booking History",
      lastBooking: "Last booking",
      selectAll: "Select All",
      selected: "Selected",
      printThermal: "Print Thermal Receipt",
      emptyList: "No booking history list",
      previewPrint: "Preview Create Invoice",
      totalStt: "Total STT",
      totalTariff: "Total Tariff",
      totalInvoice: "Total Invoice",
      billedTo: "Billed To",
      selectBillingRecipient: "Select billing recipient",
      notes: "Notes",
      notePlaceholder: "Enter notes for invoice recipient",
      cancel: "Cancel",
      failedFetchList: "Failed to fetch successful booking history data!"
    }
  },
  receipt: {
    createdAt: "created",
    createdAtV2: "created at",
    estimation: "estimate",
    ref: "Ref",
    shipper: "shipper",
    receiver: "receiver",
    destination: "destination",
    home: "home",
    office: "office",
    goodsValue: "good value",
    totalCost: "total cost",
    shippingCost: "shipment",
    shippingCostV2: "Shipment",
    insurance: "insurance",
    totalWeight: "total weight",
    chargeableWeight: "chargeable\nweight",
    taxBm: "Tax/BM",
    others: "other",
    othersV2: "Other",
    downloadApps:
      "Download Lion Parcel App via Appstore or Playstore and track your package now!",
    toc: "T&C : lionparcel.com/sk",
    goodValue: "good value",
    currencyDisplayGoodValue: "{value} USD",
    goodsPrice: "goods price",
    returnFee: "return fee",
    returnFeeV2: "Return",
    returnFeeV3: "Est. Return",
    estTax: "Est. Tax",
    returnCost: "return cost",
    codFee: "COD Fee",
    dfodFee: "DFOD Fee",
    returStatement: "*if return",
    senderPage: "Scissors for shipper",
    terms: "Terms and Conditions Apply.",
    info: "For more information: https://lionparcel.com/sk",
    infoTracking: "to track your\npackage in real\ntime!",
    infoTrackingPrn: {
      info1: "Want to know the",
      info2: "status of your package? ",
      info3: "Track it in real-time!",
      info4: ""
    },
    scanHere: "scan here",
    customSla: "*Excludes customs SLA",
    no: "No.",
    productName: "Product Name",
    variant: "Variant",
    quantity: "Qty",
    trackPackageHere: "Track your\npackage here",
  },
  tagihan: {
    pageTitle: "Generate Invoice",
    createTitle: "Create Invoice",
    editTitle: "Edit Invoice",
    detailTitle: "Invoice Details",
    searchPlaceholder: "Search Invoice ID, Billed To Name",
    selectStatus: "Select Status",
    emptyTitle: "No invoices",
    emptyDescription: "Invoices will appear here when available.",
    errorGetDetail: "Failed to Get Invoice Details",
    table: {
      no: "No",
      invoiceId: "Invoice ID",
      billedTo: "Billed To",
      totalAmount: "Total Invoice",
      totalPaid: "Amount Paid",
      status: "Status",
      activities: "Activities",
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      action: "Actions",
      noStt: "STT No.",
      recipient: "Recipient",
      destinationCity: "Destination City",
      productType: "Product Type",
      totalTariff: "Total Tariff",
      paidByRecipient: "Paid by Recipient",
      paidViaApp: "Paid via App"
    },
    status: {
      all: "All",
      unpaid: "Unpaid",
      partiallyPaid: "Partially Paid",
      paid: "Paid"
    },
    activity: {
      printInvoice: "Print Invoice",
      sendInvoice: "Send Invoice"
    },
    action: {
      editInvoice: "Edit Invoice",
      updatePaid: "Update Paid",
      sendInvoice: "Send Invoice",
      downloadPdfA4: "Download PDF (A4)",
      downloadPngA4: "Download PNG (A4)",
      downloadPdfStruk: "Download PDF (Receipt size)"
    },
    form: {
      sender: "Sender",
      totalStt: "Total STT",
      totalTariff: "Total Tariff",
      totalAmount: "Total Invoice",
      billedTo: "Billed To",
      note: "Note",
      optional: "(Optional)",
      notePlaceholder: "Enter note for invoice recipient",
      sendTo: "Send To",
      close: "Close",
      moreSenders: "+{n} More",
      selectBilledTo: "Select billing recipient",
      saveInvoice: "Save Invoice",
      createInvoice: "Create Invoice",
      confirmCreateTitle: "Create Invoice?",
      confirmCreateMessage: "Ensure all STT and total invoice are correct.",
      cancel: "Cancel"
    },
    modal: {
      updateLunas: "Update Paid",
      invoiceInfo: "Invoice Information",
      paymentHistory: "Payment History",
      payment: "Payment",
      remainingAmount: "Remaining amount",
      amountExceeds: "Amount exceeds remaining invoice",
      updateInvoice: "Update Invoice",
      successCreate: "Invoice Created Successfully",
      successUpdate: "Invoice Updated Successfully",
      totalAmount: "Total Invoice",
      remainingLabel: "Remaining Invoice",
      close: "Close",
      downloadInvoice: "Download Invoice",
      downloadPdfA4: "PDF (A4)",
      downloadPngA4: "PNG (A4)",
      downloadStruk: "PDF (Receipt size)",
      successSendTitle: "Invoice Sent Successfully",
      sendTo: "Send to",
      via: "Via",
      format: "Format"
    },
    pdf: {
      billedTo: "Billed To",
      createdBy: "Created By",
      createdAt: "Created Date",
      totalStt: "Total STT",
      totalAmount: "Total Invoice",
      balanceDue: "Balance Due",
      note: "Note",
      no: "No",
      sttNo: "STT No.",
      recipient: "Recipient",
      productType: "Product Type",
      chargeableWeight: "Chargeable weight",
      totalTariff: "Total Tariff"
    },
    create: {
      selectCustomer: "Select Customer",
      sttType: "STT Type",
      sttTypePlaceholder: "Select STT Type",
      serviceType: "Service Type",
      serviceTypePlaceholder: "Select Service Type",
      service: "Service",
      sttNo: "STT No.",
      sttInputPlaceholder: "Type or select STT No.",
      datePlaceholder: "Select Date",
      namePlaceholder: "Name or Phone Number",
      add: "Add",
      notYetAdded: "Not yet added",
      save: "Save",
      inputEmail: "Enter Email",
      inputWhatsappNumber: "Enter WhatsApp Number",
      mandatoryEmail: "Email is required.",
      mandatoryWhatsapp: "WhatsApp number is required.",
      formatEmail: "Invalid email format",
      formatWhatsapp: "Invalid WhatsApp number format",
      alreadyAddedEmail: "Email has already been added.",
      alreadyAddedWhatsapp: "WhatsApp number has already been added.",
      formatBill: "Billing Format",
      selectFormat: "Select Format",
      mandatoryFormat: "Format must be selected."
    },
    sender: "Sender",
    client: "Client",
    whatsappMessage: `Hello {name},

Thank you for trusting Lion Parcel with your shipping needs.
Please find below the summary of your service charges:

Invoice Number: {invoiceNo}

Total Shipments (STT): {totalStt}

Total Invoice Amount:: {totalAmount}

Kindly help to settle the payment at your earliest convenience to ensure your shipping services continue smoothly without any disruption.

Thank you for your attention and cooperation.`,
    trackPackageHere: "Track your\npackage here",
    productTable: {
      no: "No.",
      name: "Product Name",
      variant: "Variant",
      qty: "Qty"
    },
    customSla: "*Excludes customs SLA"
  },
  shipmentRates: {
    titleAddressOriginDestination: "District, Origin & Destination City",
    titleShipmentType: "Product Type",
    titleCommodityType: "Commodity Type",
    placeholderSelectCommodity: "Input & select commodity",
    titleWeight: "Weight/Package",
    titleDimensionPackage: "Dimensions/Package",
    titleDimensionSuffix: "L x W x H",
    titleItemPrice: "Item Price",
    placeholderItemPrice: "e.g 6.00",
    titlePrefixItemPrice: "RM",
    titleButtonCheckRates: "Check Rates",
    titleToggleFilterOpen: "Hide",
    titleToggleFilterClose: "Show",
    errorMaximalWeight: "Maximal weight",
    titleMenuDownload: "Download Shipment Rates",
    subtitleMenuDownload:
      "Use Download Shipment Rates to compare client and partner rates. Before downloading, make sure all data is filled in correctly and accordingly.",
    titleRouteName: "Shipment Rates",
    placeholderOrigin: "Input & select origin city",
    placeholderDestination: "Input & select destination city",
    defaultOptionProduct: "All Product",
    defaultOptionCommodity: "All Commodity",
    emptyListMessage: "Oops.. No data to show yet",
    titleDownloadSuccess: "Shipment Rates Download Success",
    titleNotFoundRates: "Shipment Rates Not Found",
    codYes: "Yes",
    codNo: "No",
    tooltipSLA:
      "This SLA is city level.<br/> There will be an upgrade to a district-level </br> SLA system or destination address.",
    detailRates: {
      commodity: "Commodity",
      product: "Product Type",
      shipmentRates: "Total Cost",
      shipmentTime: "City Level Delivery Estimates",
      clientPartner: "Client/Partner",
      baseRate: "Base Rate",
      heavyweightSurcharge: "Heavyweight Surcharge",
      commodityRate: "Commodity Rate",
      documentSurcharge: "Document Surcharge",
      originForwardRate: "Origin Forward Rate",
      publishRate: "Publish Rate",
      shippingSurcharge: "Shipping Surcharge",
      destinationForwardRate: "Destination Forward Rate"
    },
    embargo: "Embargo",
    errorOttopackNotAllProduct:
      "Shipping Costs for your selected product does not include Insurance",
    errorOttopackAllProduct:
      "Shipping Costs for OTOPACK150 and OTOPACK250 products does not include Insurance",
    errorFullEmbargo:
      "The selected origin and/or destination city are currently under Embargo",
    errorPartialEmbargo:
      "Some commodities at the selected origin & destination are currently under Embargo.",
    titleAddressOrigin: "District, Origin",
    titleAddressDestination: "Destination City",
    detailTitle: "Rates Detail",
    baseRate: "Base Rate",
    commodityRate: "Commodity Rate",
    documentSurcharge: "Document Surcharge",
    heavyweightSurcharge: "Heavyweight Surcharge",
    clientPartner: "Client/Partner",
    codReturnTooltip: "Payment upon return package",
    promoUntil: "until",
    columnServiceType: "Product Type",
    columnCommodity: "Commodity",
    columnClientPartnerName: "Client/Partner Name",
    columnBaseRate: "Base Rate",
    columnCommodityRate: "Commodity Rate",
    columnHeavyweightSurcharge: "Heavyweight Surcharge",
    columnDocumentSurcharge: "Document Surcharge",
    columnShipmentTime: "Shipment Time",
    columnDfodFee: "DFOD Fee",
    columnCodFee: "COD Fee",
    columnCodReturnFee: "COD Return Fee",
    columnTotalCost: "Total Cost",
    retail: "Retail",
    confirmExitTitle: "Are you sure you want to leave?",
    confirmExitMessage:
      "Please confirm. You will lose all data if you leave this page.",
    confirmExitButton: "Leave",
    confirmBackButton: "Back",
    bookingButton: "Book Shipment",
    columnCod: "COD",
    actionBooking: "Booking",
    slaDaySuffixId: "Hari",
    slaDaySuffixEn: "Working days",
    until: "Until",
    download: {
      downloadDescTop:
        "Before downloading the STT manual list, please double check the list",
      downloadDescBot:
        "client/partner is correct and in accordance with their respective status."
    },
    allClient: "All Clients/Pa...",
    allStatus: "All Status"
  },
  modalButtonBackTitle: "Back",
  modalButtonTryAgainTitle: "Try Again",
  errorNotFoundMessage: "Oops.. No data to show yet",
  errorNotFoundTitle: "Not Found",
  errorKeywordCaseNotFoundMessage: "Please search with other keywords",
  errorKeywordCaseNotFoundTitle: "Can't Find Transaction Data",
  invoice: {
    date: "date",
    shipperName: "shipper name",
    shipperPhone: "shipper phone",
    shipperAddress: "shipper address",
    conssigneeID: "ID conssignee",
    conssigneeName: "conssignee name",
    conssigneePhone: "conssignee phone",
    conssigneeEmail: "conssignee email",
    conssigneeAddress: "conssignee address",
    postCode: "post code",
    dutyTaxTerms: "Duty & Tax Terms",
    signatureOfShipper: "signature of shipper",
    itemDescription: "Item Description/ Commodity",
    unitValue: "Item Price",
    qty: "Quantity",
    totalValue: "Total Item Prices",
    weight: "Weight",
    deliveryType: "Service type",
    piecesGrossWeight: "Pieces/weight",
    totalKoli: "Total Pieces",
    note: "*Note : Publish rate not include tax fee",
    term:
      "I declare all the information contained in this invoice to be true and correct, and i am willing to bear\nany cost if the information is incorrect.",
    commodity: "commodity",
    HSCODE: "HSCODE",
    unitValueGoods: "unit value goods",
    totalItem: "total item",
    totalValueGoods: "total value goods",
    totalWeight: "total weight"
  },
  placeholderDatePicker: "Select Date",
  showFilter: "View",
  hideFilter: "Hide",
  showingPagination: "Showing",
  cnManifest: {
    pageTitle: "CN Manifest",
    filterTypeSttListing: "STT Listing Type",
    filterTypeUser: "User Type",
    filterPartner: "Client/Partner/Customer Name",
    filterDestinationCity: "Destination City",
    placeholderDestinationCity: "Input & select destination city",
    placeholderSttNo: "Input or Choose STT Number",
    placeholderClientPartner: "Type or select client/partner name",
    filterDateStart: "Starting From",
    filterDateEnd: "Until",
    errorInvalidStartDate: "Start date cannot be later than the end date",
    errorInvalidDuration: "Selected period must not exceed 14 days",
    errorInvalidEndDate: "End date cannot be less than the start date",
    emptyListMessage: "Oops.. No data to show yet",
    buttonSearch: "Search",
    buttonExportCsv: "Export to CSV",
    exportError: "Download Failed",
    columnNo: "No.",
    columnBookingDate: "Booking Date",
    columnNoStt: "No. STT",
    columnDestinationCity: "Destination City",
    columnTotalPiece: "Total Pieces",
    columnTotalWeight: "Total Weight",
    columnTotalVolume: "Total Volume",
    columnProduct: "Product",
    columnRecipient: "Recipient",
    columnRecipientAddress: "Recipient Address",
    columnRecipientPhone: "Recipient Phone No.",
    columnCommodityType: "Commodity Type",
    columnHsCode: "HS Code",
    columnNpwp: "NPWP",
    columnItemPrice: "Item Price",
    columnBm: "BM",
    columnPpn: "PPN",
    columnPph: "PPH",
    columnTotalGoodTax: "Total Good Tax",
    columnTaxImposition: "Tax Imposition",
    columnStatus: "Status",
    columnBookedBy: "Booked By",
    columnTotalAmount: "Total Amount",
    sttListingTypeBookingDate: "Booking Date",
    sttListingTypeSttList: "No. STT / No. Ref",
    filterDestinationCityAll: "All",
    tagPlaceholderStt: "Press enter to add No. STT",
    userTypeConsole: "Consolidator",
    userTypeSubconsole: "Subconsolidator",
    userTypePos: "POS",
    userTypeClient: "Client",
    userTypeCustomer: "Customer"
  },
  placeholderSTTColumn: "Search for STT number",
  placeholderCargoColumn: "Search for Cargo number",
  shortland: {
    title: "Shortland",
    searchPlaceholder: "Search STT No. genesis/elexys",
    timeRangeCustom: "custom",
    timeRangeToday: "Today",
    timeRangeLast7Days: "Last 7 days",
    timeRangeLast14Days: "Last 14 days",
    downloadButton: "Download Shortland",
    emptyMessage: "No Shortland data to display",
    table: {
      no: "No.",
      cargoNo: "Cargo No.",
      cargoType: "Cargo Type",
      sttNoElexys: "STT No. Elexys",
      sttNoGenesis: "STT No. Genesis",
      sttNoPiecesGenesis: "STT No. Pieces Genesis",
      destinationCity: "Destination City",
      commodity: "Commodity",
      koli: "Pieces",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    },
    csv: {
      no: "No",
      cargoNo: "Cargo No.",
      cargoType: "Cargo Type",
      sttNoElexys: "STT No. Elexys",
      sttNoGenesis: "STT No. Genesis",
      sttNoPiecesGenesis: "STT No. Pieces Genesis",
      sttNo: "STT No.",
      sttNoPieces: "STT No. Pieces",
      arrivalCity: "Arrival City",
      commodity: "Commodity",
      koli: "Pieces",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    }
  },
  trackingCargo: {
    trackingSTTTabTitle: "STT Tracking",
    trackingCargoTabTitle: "Cargo Tracking",
    buttonTracking: "Track",
    buttonPrintReceipt: "Print Tracking",
    buttonShowDetailStt: "View STT Details",
    sttDetailTitle: "STT Details",
    titleToggleFilterOpen: "Show",
    titleToggleFilterClose: "Hide",
    bookedBy: "Booked by",
    bookedFor: "Booked for",
    bookedAtLabel: "Booked",
    sttDetailInfo: {
      detailShipperName: "Shipper Name",
      detailRecipientName: "Recipient Name",
      detailDistrictOriginCity: "District, Origin City",
      detailDistrictDestinationCity: "District, Destination City"
    },
    columnsSttDetail: {
      colNoSttGenesis: "No. STT Genesis",
      colNoSttElexys: "No. STT Elexys",
      colNoStt: "No. STT",
      colStatusPayment: "Payment Status",
      colPieces: "Pieces",
      colCurrentStatus: "Current Status",
      colCurrentStatusForModal: "Current Status",
      colResponse: "Response",
      colShipmentType: "Product Type",
      colShipmentTime: "Shipment Time",
      colShipmentTimeForModal: "Shipment Time",
      colChargeableWeight: "Chargeable Weight",
      colAssessmentStatus: "Assessment Status"
    },
    paymentStatus: {
      cod: "COD Payment",
      unpaid: "Unpaid",
      paid: "Paid"
    },
    assessmentStatus: {
      waiting: "Waiting",
      rejected: "Rejected",
      approved: "Approved"
    },
    timeInternational: "(International Time)",
    timeInternationalLabel: "International<br/>Time",
    proofPodLink: "View proof of delivery",
    proofAdjustBookLink: "View weight change proof photo",
    reportIssue: "Report Issue",
    needRelabel: "Need relabel",
    customerRequestRts: "Customer requested RTS",
    printThermalReceipt: "Print Thermal Receipt",
    printThermalReceiptPdf: "Print Thermal Receipt PDF",
    printBasicSavePdf: "Print Basic/Save to PDF",
    detailCargoTitle: "Cargo Details",
    cargoOriginCity: "Origin City",
    cargoDestCity: "Destination City",
    cargoDestType: "Destination Type",
    cargoHistoryTitle: "Shipment History",
    colCargoNo: "Cargo No.",
    colStatus: "Status",
    colTotalStt: "Total STT",
    sttHistoryTitle: "History Status",
    sttHistoryTitleLowerCase: "History status",
    columnHistoryStatus: {
      colStatusDate: "Status Date",
      colCurrentStatus: "Current Status",
      colPieces: "Pieces",
      colLocation: "Location",
      colRemarks: "Remarks"
    },
    error: {
      errMessageEmptyTitle: "Oops.. No tracking detail to show yet",
      errMessageEmpty: "Track your package easily with the STT number here",
      errMessageEmptyCargo:
        "Track your package easily with the Cargo number here",
      errDataNotFoundTitle: "STT Not Found",
      errDataNotFoundMsg: "Please double-check the STT you input",
      errUnusedTitle: "STT is not yet in use",
      errUnusedMsg:
        "STT you are looking for is not yet in use or <i>unused</i>."
    },
    sttReturn: "Return",
    sttBefore: "Before",
    sttElexys: "Elexys",
    customToday: "custom, today, last 7 days, this month"
  },
  "Rentang Waktu": "Time Range",
  custom: "custom",
  "hari ini": "today",
  kemarin: "yesterday",
  "Print STT gagal": "Print STT failed",
  "3 hari terakhir": "Last 3 Days",
  "7 hari terakhir": "Last 7 Days",
  "Print Label": "Print Label",
  "14 hari terakhir": "Last 14 Days",
  "30 hari terakhir": "Last 30 Days",
  "31 hari terakhir": "Last 31 Days",
  "satu bulan": "one month",
  "bulan ini": "this month",
  "tahun ini": "this year",
  "Tentukan Tanggal": "Set a Date",
  "Minggu Kemarin": "Last Week",
  "Pilih Range Tanggal": "Select a date range",
  "Cari Manifest ID": "Search manifest ID",
  "Nama Consolidator": "Consolidator Name",
  "Kode Sub Consolidator": "Sub Consolidator Code",
  "Kode POS": "POS Code",
  "POS Pengembalian STT": "STT Return POS",
  "Akun untuk booking STT yang dikembalikan ke pengirim atau diteruskan ke alamat yang benar":
    "Account for STT bookings that are returned to sender or forwarded to the correct address",
  "Total STT": "Total STT",
  "Total\nKoli": "Total\nPieces",
  "Total Koli": "Total pieces",
  "Tanggal Dibuat": "Created Date",
  "Dibuat Oleh": "Created By",
  "Print PDF": "Print PDF File",
  "Download data": "Download data",
  "Download Excel": "Download Excel File",
  "Perlu di STI": "Need STI",
  "Nama Partner": "Partner Name",
  "Tanggal STI": "STI Date",
  "No. STT/ID Manifest": "STT Number/Manifest ID",
  "Buat Bagging": "Create Bagging",
  "Ubah Bagging": "Edit Bagging",
  "Ubah Cargo": "Edit Cargo",
  Kargo: "Cargo",
  "Komoditas Kargo": "Cargo Commodity",
  "Masukan NOG": "input NOG",
  "Masukan nomor penerbangan": "Input flight number",
  "Waktu Berangkat": "Departure Time",
  "Waktu Tiba": "Arrival Time",
  "Pilih waktu": "select Time",
  "Maks.": "Max.",
  Dimensi: "Dimension",
  "Ubah Kargo": "Cargo Booking",
  "Ubah & Print PDF": "Booking & Print PDF File",
  "Booking & Print PDF": "Booking & Print PDF File",
  "Ubah & Print Label": "Booking & Print Label",
  "Tidak ada STT atau bagging di dalam kargo ini":
    "No STT or bagging in this cargo",
  "Perubahan Gagal !": "Update Failed !",
  "Permintaan Gagal !": "Request Failed !",
  "Harga Destination Forward Rate  dan INTERPACK untuk rute yang dipilih tidak tersedia":
    "Destination Forward Rate and INTERPACK prices for the selected route are not available.",
  "Perbarui Harga": "Update Price",
  "Total Tarif": "Total Rates",
  "Detail Pembayaran": "Payment Detail",
  "Biaya Pengiriman": "Shipping costs",
  "Biaya Tambahan Komoditas": "Commodity Surcharge",
  "Biaya Tambahan Berat": "Heavy Surcharge",
  "Biaya Tambahan Dokumen": "Additional Document Fee",
  Asuransi: "Insurance",
  "Biaya Admin": "Admin Fees",
  "Est. Pajak": "Tax Est.",
  "Simpan Perubahan": "Save Changes",
  "Pos pembooking": "Booking POS",
  "Pilih POS": "Select POS",
  "Pengiriman kargo gagal diubah.": "Cargo status change failed.",
  "Semua STT dari No. Bag yang sama akan terhapus dari daftar pengiriman":
    "All STTs from the same bag number will be deleted from the shipment list",
  "STT Berhasil Dihapus": "Delete STT Success",
  "Anda dapat menambahkan STT baru ke daftar pengiriman":
    "You can add a new STT to your shipment list",
  "No. STT tidak bisa diupdate": "STT number cannot be updated",
  "Total berat kotor aktual": "Total Actual Weight",
  "Total berat volume aktual": "Total Actual Dimension Weight",
  "Total koli aktual": "Total Actual Pieces",
  "Pilih kargo": "Select Cargo",
  "Simpan transportasi": "Save",
  "Booking manual": "Manual Booking",
  "Booking auto": "Auto Booking",
  "Jika memilih booking manual. Anda harus booking terlebih dulu di sistem nGen.":
    "If you select manual booking, you must first book in the nGen system",
  "Nomor Kargo Tidak Ditemukan": "Cargo Number Not Found",
  "Isi Manual": "Booking Manual",
  "Cek Kembali": "Check Again",
  "Booking Kargo Sedang Diproses": "Cargo Booking on Process",
  "Anda akan mendapat notifikasi jika booking kargo berhasil":
    "You will be notified if the cargo booking is successfull.",
  "Cek kembali nomor kargo Anda atau lakukan Booking Kargo secara manual":
    "Double check your cargo number or cargo booking manually",
  "Pastikan nomor cargo telah sesuai, kesalahan pada nomor cargo akan menjadi tanggung jawab konsolidator terkait":
    "Make sure the cargo number is correct, errors in the cargo number will be the responsibility of the relevant consolidator",
  "Pembuatan Berhasil !": "Create Success!",
  "Pembuatan Gagal!": "Create Failed",
  "Pengiriman kargo gagal dibuat.": "Cargo shipment failed to create",
  "Maksimal Koli Pesawat adalah 15 koli": "Maximum Plane Pieces is 15 Pieces",
  "Mohon ubah jumlah koli di dalam kargo atau pilih transportasi kargo lainnya":
    "Please change the number of pieces in the cargo or choose another cargo transport",
  "Transportasi Lain": "Other Transport",
  "Ubah Koli": "Edit Pieces",
  "Yakin Meninggalkan Halaman?": "Are you sure you want to exit?",
  "Perubahan yang Anda tambahkan akan terhapus":
    "The changes you added will be deleted",
  cargo,
  "Pilih Produk": "Select Product",
  "Contoh : No. STT : 99LP1234567890123/88-22-12345678 atau ID Manifest : PUM00000":
    "Example: STT Number : 99LP1234567890123/88-22-12345678 or ID Manifest : PUM00000",
  "Contoh : 99LP1234567890123/88-22-12345678":
    "Example : 99LP1234567890123/88-22-12345678",
  "Masukkan no STT atau scan barcode/QR code":
    "Input the STT number or scan the barcode/QR code.",
  "Masukan No. STT/ID Manifest atau Scan Barcode/QR Code":
    "Input STT number/manifest ID or scan barcode/QR code",
  "*Terjadi kelebihan berat sehingga customers perlu menyelesaikan tagihan kurang bayar":
    "*Overweight occurs {isIdManifest} so customers need to settle underpaid bills",
  "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Bagging.":
    "There is excess weight so status cannot be updated to Bagging",
  "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Cargo.":
    "There is excess weight so status cannot be updated to Cargo",
  "Tunggu sampai customers selesai melunasi tagihan kurang bayar":
    "Wait until customer finishes paying the underpayment bill",
  Tambah: "Add",
  "Yakin ingin keluar?": "Are you sure you want to exit?",
  "Semua perubahan yang belum disimpan akan dibatalkan.":
    "All unsaved changes will be undone.",
  "Ya, batalkan": "Yes, cancel",
  "Verifikasi Kode OTP": "OTP Code Verification",
  "Masukkan kode OTP yang dikirimkan melalui email ke":
    "Enter the OTP code sent via email to",
  "Butuh bantuan? Hubungi via WhatsApp": "Need help? Contact us via WhatsApp",
  "atau email ke": "or email to",
  Oke: "Okay",
  "Yakin Ingin Keluar?": "Are you sure you want to exit?",
  "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.":
    "Double-check, you will lose all data if you exit this page.",
  "Sebelum keluar, pastikan kembali tidak ada aktivitas yang sedang berjalan.":
    "Before exiting, make sure there is no activity running again",
  "Sebelum Anda keluar pastikan kembali tidak ada proses aktivitas yang berjalan atau semua aktivitas sudah selesai.":
    "Before exiting, make sure there is no activity running again",
  Keluar: "Exit",
  Kembali: "Back",
  "Konfirmasi Pembuatan": "Confirmation of Create",
  "Konfirmasi Perubahan": "Confirmation of Update?",
  "Anda yakin ingin menyimpan perubahan detail Partner":
    "Are you sure you want to save changes to Partner details?",
  "Yakin ingin keluar ?": "Are you sure you want to exit?",
  "LIHAT SEMUA": "SEE ALL",
  "Daftar POS": "POS List",
  "Daftar district": "District List",
  "Kode Referral": "Referral Code",
  "Kode Referrer": "Referrer Code",
  "Masukan alasan pembekuan": "Enter the reason for the freeze",
  "Konfirmasi Pembekuan": "Freeze Confirmation",
  "Masukan alasan pembekuan partner. Selama pembekuan, partner tidak dapat melakukan aktivitas operasional.":
    "Enter the reason for the partner's suspension. During the suspension, the partner cannot perform any operational activities.",
  "Terjadi kesalahan pada system, silahkan<br>coba lagi nanti.":
    "An error occurred in the system, please try<br>again later.",
  "Konfirmasi Pengaktifan": "Confirm Activation",
  "Anda yakin ingin melakukan pembekuan untuk partner":
    "Are you sure you want to freeze for your partner",
  "Anda yakin ingin melakukan pengaktifan atas pembekuan partner":
    "Are you sure you want to activate the partner freeze?",
  "Pembekuan Berhasil !": "Freezing Successful!",
  "berhasil dibekukan.": "successfully frozen.",
  "berhasil diaktifkan kembali.": "successfully reactivated.",
  "Pembekuan Gagal !": "Freezing Failed !",
  "Pengaktifan Gagal !": "Activation Failed !",
  "Tambah Rekening Bank": "Add Bank Account",
  "Tambah 3LC lainnya": "Add another 3LC",
  "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.":
    "Make sure all STT details are correct",
  "Input ID Manifest Berhasil -": "Success Input - Manifest No.",
  "No. ID Manifest": "Manifest ID",
  "ID Manifest": "Manifest ID",
  "Masukan No. STT atau Scan Barcode/QR Code untuk<br />barang yang ingin dihapus dari daftar Bagging.":
    "Input STT number or Scan Barcode/QR Code for the item</br>you want to delete from the Bagging list.",
  "Hapus Barang": "Delete Confirmation",
  "Masukan No. STT atau Scan Barcode/QR Code</br>untuk barang yang ingin dihapus dari daftar STI.":
    "Input STT Number or Scan Barcode/QR Code for the item</br>you want to delete from the STI list.",
  "Masukan No. STT atau Scan Barcode/QR Code":
    "Input STT number or scan barcode/QR code",
  Terhapus: "Deleted",
  Batal: "Cancel",
  Hapus: "Delete",
  "ID Manifest sudah di input": "ID Manifest has been input",
  "No. STT sudah di input": "STT number has been input",
  "ID Manifest tidak dapat diproses": "Manifest ID cannot be processed",
  "STT No tidak dapat diproses": "STT No cannot be processed",
  "Nomor STT atau Nomor Bagging tidak dapat diproses":
    "STT/Bagging numbers cannot be processed. Check & reset",
  "Hapus STT": "Delete STT?",
  "STT yang Anda hapus akan hilang dari daftar pengiriman":
    "STT you deleted will disappear from the shipment list",
  "STT tidak dapat diproses": "STT cannot be processed",
  "No. STT tidak ditemukan/sudah terhapus":
    "STT number not found or deleted. Check & reset",
  "No. STT/No. Bag tidak ditemukan atau sudah terhapus":
    "STT/Bagging number not found or deleted. Check & reset",
  "Nomor STT atau Nomor Bagging tidak ditemukan":
    "STT/Bagging number not found",
  "Perubahan Status STT Berhasil !": "Update Success!",
  "Status STT berhasil diupdate menjadi STI.":
    "STT Number is updated to <b>“STI”</b>",
  "Tambah ID Manifest Gagal!": "Add Failed",
  "Tambah No. STT Gagal!": "Add Failed",
  "Tambah No. STT Gagal": "Add Failed",
  "Scan ID Manifest Gagal!": "Scan Failed",
  "Scan No. STT Gagal!": "Scan Failed",
  "Scan No. STT Gagal": "Scan Failed",
  "Perubahan Status Gagal !": "Status Change Failed!",
  "Perubahan Berhasil Disimpan !": "Bagging Change Saved",
  "Perubahan status STI gagal dibuat.":
    "STT status has been failed to update to <span class='font-semibold'>“STI”</span>",
  "Pembuatan Bagging Gagal !": "Failed to create Bagging status change.",
  "Bagging gagal dibuat.": "Failed to create Bagging.",
  "Perubahan status Bagging gagal dibuat.": "Bagging status change failed.",
  "STT Tidak dapat ditemukan": "STT not found",
  "Tambah No. Id Manifest Berhasil!": "Successfully added Manifest ID number!",
  "Perubahan Status Berhasil !": "Update Success!",
  "Beberapa STT berhasil ditambahkan, namun terdapat kegagalan pada beberapa STT. STT yang gagal tidak terdapat di dalam list.":
    "Some STT numbers were successfully added, but there were failures with others. The failed STT numbers are not in the list.",
  "Beberapa status STT berhasil diupdate menjadi <b>“STI”</b>, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.":
    "Some STT statuses updated to <b>“STI”</b>, but some failed. Remove problematic STTs to continue update",
  "Beberapa status Bagging berhasil dibuat menjadi Bagging, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.":
    "Some STT statuses updated to “Bagging”, but some failed. Remove problematic STTs to continue update",
  "Beberapa status STT berhasil diupdate menjadi Bagging, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.":
    "Some STT statuses updated to “Bagging”, but some failed. Remove problematic STTs to continue update",
  "Komoditas group tidak sama": "Commodity group is not the same",
  "No. STT tidak sesuai dengan kota tujuan yang dipilih":
    "STT No. does not match the selected destination city",
  "STT tidak sesuai dengan kota tujuan yang dipilih":
    "STT does not match the selected destination city",
  "No. Referensi": "No. Reference",
  "Berat\nKotor": "Gross\nWeight",
  "Berat Kotor": "Gross Weight",
  "Berat\nDimensi": "Dimension\nWeight",
  "Berat Dimensi": "Dimension Weight",
  Wilayah: "Region",
  "Status Terakhir": "Current Status",
  "Input No. STT berhasil -": "Successfullly Input - STT No.",
  "Input No. STT berhasil": "Successful STT Number Input",
  "Kota Asal": "Origin City",
  "Kota Tujuan": "Destination city",
  "Dest.": "Destination",
  Produk: "Service type",
  Komoditas: "Commodity",
  "Komoditas Group": "Commodity Group",
  "Komoditas Group (Kargo)": "Commodity Group (Cargo)",
  "Komoditas kargo tidak sama": "Cargo commodities are not the same",
  "Pilih komoditas": "Select Commodity",
  "Biaya COD": "COD Cost",
  "No. Bagging": "Bagging Number",
  Catatan: "Remarks",
  Kurir: "Courier",
  "Perbarui Halaman": "Update Page",
  "Terdapat data baru, silahkan perbarui<br />halaman.":
    "New data found, please update the page.",
  Perbarui: "Update",
  "Total Berat Kotor": "Total Gross Weight",
  "Total Berat Barang": "Total Gross Weight",
  "Total Berat Kotor Bag": "Total Bag Gross Weight",
  "Total Berat Dimensi": "Total Dimension Weight",
  "Total Berat Dimensi Bag": "Total Bag Dimension Weight",
  "Total Berat Bag Dikenakan Biaya": "Total Bag Chargeable Weight",
  "Total Berat Volume": "Total Dimension Weight",
  "Total Volume Weight": "Total Dimension Weight",
  "Berat Kotor Bag": "Gross Weight of Pieces",
  "Total Bag Gross Weight": "Total Weight Gross of Pieces",
  "Total Bag Volume Weight": "Total Dimension Weight of Pieces",
  "Bag Volume Weight": "Total Weight Dimension Pieces",
  "Total Bag Chargeable Weight": "Total Chargeable Weight",
  "Bag Chargeable Weight": "Total Chargeable Weight",
  "No. STT tidak dapat dihapus. Minimal barang pengiriman bagging adalah 1 STT.":
    "STT number cannot be deleted. Minimum bagging shipment item is 1 STT.",
  Pembayaran: "Payment",
  "Kurang Bayar": "Unpaid",
  "Sudah Lunas": "Paid",
  "STT Paid/Unpaid": "STT Paid/Unpaid",
  "STT Kurang Bayar": "STT Paid/Unpaid",
  "Print Bagging": "Bagging Print",
  "Detail Bagging": "Bagging Detail",
  "Dimensi Bag": "Dimension Pieces",
  "Dimensi wajib diisi": "Dimension Required",
  "Berat kotor bag wajib diisi": "Gross Weight of Pieces Required",
  "Status Bagging": "Bagging Status",
  "(P x L x T)": "(L x W x H)",
  "Berat Volume Bag": "Weight Dimension Bag",
  "Berat Bag Dikenakan Biaya": "Total Chargeable Weight",
  "Pembuatan Bagging Berhasil !": "Create Success!",
  "Bagging berhasil dibuat.": "Bagging was created",
  "Buat Bagging & Print Label": "Create bagging & Print Label",
  "No. STT Sukses": "Success STT",
  "No. STT Gagal": "Failed STT",
  "No. STT": "STT Number",
  Sukses: "Success",
  "Nomor kendala": "Ticket Number",
  "berhasil Eskalasi ulang.": "Re-escalation successful.",
  "Gagal menyelesaikan kendala!": "Failed to solve the issue!",
  Cari: "Search",
  "No. kargo atau booking id": "No. cargo or booking id",
  Urutkan: "Sorting",
  Terbaru: "Latest",
  Terlama: "Oldest",
  Menampilkan: "Showing",
  "data dari total": "Data from a total",
  untuk: "of",
  "Data tidak ditemukan": "Data not found",
  "Maaf, data yang Anda cari tidak ditemukan.":
    "Sorry, the <b>“{searchValue}”</b> data you were looking for was not found.",
  Process: "Proceed",
  "Update STI & Print PDF": "Update STI & Print PDF File",
  "Perubahan Status Gagal!": "Update Failed!",
  "Pilih jam Pick Up": "Select Pick-Up Time",
  "Permintaan Update dan Adjust STT": "STT Update and Adjustment Request",
  "Permintaan untuk mengajukan perubahan berat, pembaruan informasi, atau pembatalan STT.":
    "Request to submit weight changes, information updates, or STT cancellation.",
  "Status yang tidak diperbolehkan": "Prohibited statuses",
  "Foto Timbangan": "Scale Photo",
  "Silakan upload lampiran file Foto Timbangan.":
    "Please upload the Scale Photo attachment.",
  "Form Pengajuan Cancel": "Cancellation Submission Form",
  "Silakan upload lampiran file Form Pengajuan Cancel.":
    "Please upload the Cancellation Submission Form attachment.",
  "Screenshot Percakapan Customer": "Customer Conversation Screenshot",
  "Silakan upload lampiran file Screenshot Percakapan Customer.":
    "Please upload the Customer Conversation Screenshot attachment.",
  "Case Non Operation": "Non-Operation Case",
  "Permintaan Penarikan Paket": "Package Withdrawal Request",
  "Permintaan untuk menarik kembali paket yang sudah berhasil dikirim karena adanya kendala proses handling di POS.":
    "Request to withdraw a package that has been successfully sent due to handling process issues at the POS.",
  "Kendala Booking MP/CA/Client": "MP/CA/Client Booking Issue",
  "Kendala yang terjadi saat proses booking setelah paket berhasil pickup atau dropoff untuk MP, CA, atau Client.":
    "Issues that occur during the booking process after a package has been successfully picked up or dropped off for MP, CA, or Client.",
  "Status yang diperbolehkan": "Permitted statuses",
  "Semua status shipment sebelum BKD": "All shipment statuses before BKD",
  "Screenshot Gagal Booking": "Failed Booking Screenshot",
  "Silakan upload lampiran file Screenshot Gagal Booking.":
    "Please upload the Failed Booking Screenshot attachment.",
  "Case Operation": "Operation Case",
  "Kendala Pickup": "Pickup Issue",
  "Kendala yang terjadi saat proses pickup paket MP, CA, atau Client.":
    "Issues that occur during the pickup process for MP, CA, or Client packages.",
  "Screenshot Gagal Pickup di Driver App":
    "Failed Pickup Screenshot in Driver App",
  "Silakan upload lampiran file Screenshot Gagal Pickup di Driver App.":
    "Please upload the Failed Pickup Screenshot in Driver App attachment.",
  "Paket Belum Sampai": "Package Not Yet Arrived",
  "Kendala paket mengalami hanging atau tidak terdapat pembaruan status pada tracking dari status terakhir.":
    "Package is stuck or there is no status update in the tracking from the last status.",
  "Screnshot Percakapan Customer": "Customer Conversation Screenshot",
  "Silakan upload lampiran file Screnshot Percakapan Customer.":
    "Please upload the Customer Conversation Screenshot attachment.",
  "Paket Bermasalah": "Problematic Package",
  "Kendala paket tidak dapat diproses karena mengalami damaged, missing, atau, rejected bandara.":
    "Package cannot be processed due to being damaged, missing, or rejected at the airport.",
  "Foto Kondisi Paket": "Package Condition Photo",
  "Silakan upload lampiran file Foto Kondisi Paket.":
    "Please upload the Package Condition Photo attachment.",
  "Paket Gagal Antar": "Failed Delivery Package",
  "Kendala paket gagal diantar ke alamat tujuan.":
    "Package failed to be delivered to the destination address.",
  "Sanggah Terima": "Delivery Dispute",
  "Kendala customer mengklaim tidak menerima paket meskipun status pengiriman berhasil (POD).":
    "Customer claims not to have received the package despite the delivery status being successful (POD).",
  "Permintaan Hold Paket": "Package Hold Request",
  "Permintaan dari POS atau Konsolidator untuk menahan paket sementara.":
    "Request from POS or Consolidator to temporarily hold a package.",
  Missroute: "Missroute",
  "Kesalahan handling paket oleh tim operasional atau POS yang menyebabkan paket terkirim ke tujuan salah.":
    "Package handling error by the operational team or POS that causes the package to be sent to the wrong destination.",
  "Foto Paket": "Package Photo",
  "Silakan upload lampiran file Foto Paket.":
    "Please upload the Package Photo attachment.",
  "Shipment RTSHQ Redelivery": "Shipment RTSHQ Redelivery",
  "Permintaan untuk mengirimkan kembali paket RTSHQ.":
    "Request to redeliver an RTSHQ package.",
  "Kendala System Genesis": "Genesis System Issue",
  "Kendala yang terjadi dalam penggunaan sistem Genesis":
    "Issues that occur in the use of the Genesis system.",
  "Screenshot Kendala Sistem Genesis": "Genesis System Issue Screenshot",
  "Silakan upload lampiran file Screenshot Kendala Sistem Genesis.":
    "Please upload the Genesis System Issue Screenshot attachment.",
  "Penalti Late Handover": "Late Handover Penalty",
  "Banding penalti yang diberikan akibat keterlambatan dalam handover paket ke konsolidator origin.":
    "Penalty appeal issued due to delays in handing over packages to the origin consolidator.",
  "Bukti Banding Penalti": "Penalty Appeal Evidence",
  "Silakan upload lampiran file Bukti Banding Penalti.":
    "Please upload the Penalty Appeal Evidence attachment.",
  "Penalti Cancel": "Cancellation Penalty",
  "Banding penalti yang dikenakan akibat melakukan pembatalan proses pengiriman atau booking STT.":
    "Penalty appeal imposed due to cancellation of the delivery process or STT booking.",
  "Penalti License Fee": "License Fee Penalty",
  "Banding penalti yang berkaitan dengan lisensi sistem.":
    "Penalty appeal related to system licensing.",
  "Penalti DTPOL": "DTPOL Penalty",
  "Banding penalti yang terkait perhitungan data DTPOL.":
    "Penalty appeal related to DTPOL data calculation.",
  "Penalti Lainnya": "Other Penalty",
  "Banding penalti yang dikenakan di luar kategori penalti.":
    "Penalty appeal imposed outside the penalty category.",
  "Kendala Customer Apps": "Customer Apps Issue",
  "Kendala yang terjadi dalam penggunaan sistem Customer Apps.":
    "Issues that occur in the use of the Customer Apps system.",
  "Screenshot Kendala Sistem Customer Apps":
    "Customer Apps System Issue Screenshot",
  "Silakan upload lampiran file Screenshot Kendala Sistem Customer Apps.":
    "Please upload the Customer Apps System Issue Screenshot attachment.",
  "Kendala Driver Apps": "Driver Apps Issue",
  "Kendala yang terjadi dalam penggunaan sistem Driver App.":
    "Issues that occur in the use of the Driver App system.",
  "Screenshot Kendala Sistem Driver Apps":
    "Driver Apps System Issue Screenshot",
  "Silakan upload lampiran file Screenshot Kendala Sistem Driver Apps.":
    "Please upload the Driver Apps System Issue Screenshot attachment.",
  "Panduan lampiran file - ": "File attachment guidelines - ",
  booking: {
    titleConfirmReject: "Cancellation Confirmation?",
    messageConfirmReject:
      "Select cancellation reason. Canceled STT numbers are non-refundable",
    submitConfirmReject: "Yes, Cancel",
    cancelConfirmReject: "No",
    placeholderReason: "Select cancellation reason",
    titleSuccessReject: "Cancellation Success!",
    messageSuccessReject:
      'Order with STT number "{sttNumber}" canceled successfully. Check detailed status for cancellation reason',
    messageInputNewStt:
      "Cancellation of a booking for the reasons mentioned above must include the latest STT number.",
    errorInputNewStt: "STT number is invalid, check & change again.",
    errorInputNewSttSame: "STT number cannot be the same as the one in Cancel",
    generateNewSttForReturn: "Create new STT for package return",
    printReceipt: "Print Receipt",
    printThermalResiSuccess: "Print Thermal Receipt",
    printBasicPdfSuccess: "Print Basic/Save to PDF",
    successOk: "OK",
    printTitle: "Print Receipt",
    successCancelBook: "STT booking cancellation successful",
    successCancelBookDesc:
      "successfully cancelled and a new STT has been created with the number",
    errorNotAllowEditBeforeCs:
      "Your account cannot make changes. Please contact ",
    errorNotAllowEditAfterCs: " for change requests.",
    productPoster: {
      shippingEmbargo: "Shipping Embargo",
      notAvailable: "Not available",
      legacyBookingMotto: {
        sameday: "Package arrives on the same day",
        bosspack: "Priority Delivery",
        onepack: "Express <br>Delivery",
        regpack: "Regular <br>Delivery",
        minipack: "Small <br>Package",
        jagopack: "Cheapest <br>Delivery",
        bigpack: "Large Package Delivery",
        bigpackfast: "Large Package & Fast Delivery",
        jumbopack: "Large Package Delivery",
        interpack: "International <br>Shipment",
        interpackmaxi: "International big <br>Shipment",
        otopack: "Automotive <br>Delivery",
        jumbopackh2h: "Large Package Delivery",
        vippack: "VIP Delivery"
      }
    }
  },
  manualStt: {
    searchPlaceholder: "Search STT number genesis",
    emptyData: "Manual STT data",
    columnSttNo: "No. STT",
    columnClientPartnerName: "Client/Partner Name",
    columnCode: "Client/Partner Code",
    columnMixpack: "MIXPACK",
    columnCreatedAt: "Created Date",
    columnStatus: "Status",
    yes: "Yes",
    no: "No",
    table: {
      noStt: "No. STT",
      clientPartnerName: "Client/Partner Name",
      clientPartnerCode: "Client/Partner Code",
      mixpack: "MIXPACK",
      createdAt: "Created Date",
      status: "Status",
      yes: "Yes",
      no: "No"
    },
    statusAll: "All Status",
    statusUsed: "Used",
    statusUnused: "Unused",
    emptyMessage: "Manual STT data",
    buttonGenerateStt: "Generate STT",
    placeholderSearchClientPartner: "Type or select client/partner",
    placeholderSearchClientBranch: "Type or select client branch",
    placeholderClientPartner: "Type or select client/partner",
    placeholderClientBranch: "Type or select client branch",
    placeholderAmount: "e.g 20",
    confirmLeave: {
      title: "Leave Page?",
      message:
        "You have not completed the form. Your request will not be processed if you leave this page.",
      leave: "Leave",
      back: "Back"
    },
    leaveConfirmTitle: "Leave Page?",
    leaveConfirmMessage:
      "You have not completed the form. Your request will not be processed if you leave this page.",
    leaveConfirmLeave: "Leave",
    leaveConfirmBack: "Back",
    generate: {
      title: "Generate Manual STT",
      infoText:
        "Before proceeding with Auto Generate, please ensure the details are filled in correctly.",
      typeStt: "STT Type",
      clientPartner: "Client/Partner",
      amountStt: "STT Quantity",
      placeholderClientBranch: "Type or select client branch",
      placeholderClientPartner: "Type or select client/partner",
      placeholderAmount: "e.g 20",
      placeholderTypeStt: "Select STT Type",
      typeClient: "Client",
      typePartner: "Partner",
      back: "Back",
      autoGenerate: "Auto Generate",
      errorAmountMax: "STT quantity must not exceed {max}"
    },
    generateTitle: "Generate Manual STT",
    generateInfo:
      "Before proceeding with Auto Generate, please ensure the details are filled in correctly.",
    labelTypeStt: "STT Type",
    labelClientPartner: "Client/Partner",
    labelAmountStt: "STT Quantity",
    optionSelectType: "Select STT Type",
    optionClient: "Client",
    optionPartner: "Partner",
    validationAmountMax: "STT quantity must not exceed {max}",
    buttonBack: "Back",
    buttonAutoGenerate: "Auto Generate",
    download: {
      title: "Download STT List",
      infoText:
        "Before downloading the manual STT list, please ensure the client/partner list is correct and matches the respective status.",
      labelClientPartner: "Client/Partner Name",
      placeholderClientPartner: "Type or select client/partner",
      labelStatus: "Status",
      statusAll: "All Status",
      statusUsed: "Used",
      statusUnused: "Unused",
      buttonDownload: "Download",
      successTitle: "Manual STT Download Successful!",
      successOk: "OK"
    },
    downloadTitle: "Download STT List",
    downloadInfo:
      "Before downloading the manual STT list, please ensure the client/partner list is correct and matches the respective status.",
    downloadLabelClientPartner: "Client/Partner Name",
    downloadLabelStatus: "Status",
    downloadButton: "Download",
    downloadSuccessTitle: "Manual STT Download Successful!",
    downloadSuccessOk: "OK",
    generateFailed: "Generate Failed!",
    printForm: {
      title: "Booking Form",
      sectionShipping: "S H I P M E N T  D E T A I L S",
      date: "Date",
      sttManual: "Manual STT",
      originDistrictCity: "Origin District, City",
      senderName: "Sender Name",
      senderAddress: "Sender Address",
      senderPhone: "Phone Number",
      shipmentProduct: "Shipment Product",
      shipmentProductPlaceholder: "(Select one product)",
      clientName: "Client/POS Name",
      externalRefNo: "External Reference No.",
      optionalPlaceholder: "(Optional)",
      destinationDistrictCity: "Destination District, City",
      recipientName: "Recipient Name",
      recipientAddress: "Recipient Address",
      recipientPhone: "Phone Number",
      sectionGoods: "G O O D S  D E T A I L S",
      goodsDescription: "Goods Description",
      goodsDetail: "Goods Details",
      goodsEstimate: "Estimated Goods Value",
      woodpacking: "Wood Packing",
      woodpackingDescription: "Wooden Packaging",
      insurance: "Insurance",
      insuranceFree: "Free",
      insuranceBasic: "Basic",
      insurancePremium: "Premium",
      columnPieces: "Pieces",
      columnGrossWeight: "Gross Weight (Kg)",
      columnDimension: "Dimensions (L x W x H)",
      columnVolumeWeight: "Volume Weight (Kg)",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight"
    }
  },
  "Cek Tarif": "Shipment Rates",
  Akun: "Account",
  Nama: "{prefix}Name{suffix}",
  "No. Telepon": "Phone Number",
  Ubah: "Edit",
  "Tipe Akun": "Account Type",
  Alamat: "Address",
  "Kode Hub": "Hub Code",
  "Nama Hub": "Hub Name",
  Long: "Longitude",
  Lat: "Latitude",
  "Ubah Password": "Edit Password",
  "Sebelum keluar silahkan pastikan kembali tidak ada aktivitas yang sedang berjalan.":
    "Before exiting, make sure there is no activity running again",
  "Ubah Email": "Edit Email",
  "Email Lama": "Current Email",
  "Email Baru": "New Email",
  "Masukan email baru": "Input new email",
  "Masukkan password Anda": "Enter your password",
  "Masukkan password": "Enter password",
  "Kode OTP salah, cek & coba lagi": "Incorrect OTP code, check & try again",
  "Email Berhasil Diperbarui": "Email Updated Successfully",
  "Email baru Anda sudah berhasil disimpan.":
    "Your new email has been successfully saved.",
  Verifikasi: "Verification",
  "Kirim ulang kode OTP dalam": "Resend the OTP code in",
  "Belum menerima kode?": "Haven't received the code yet?",
  "Kirim Ulang": "Resend Code",
  "Anda yakin ingin menyimpan perubahan detail Akun ?":
    "Are you sure you want to save changes to your Account details ?",
  Simpan: "Save",
  "Perubahan email berhasil !": "You have successfully update email",
  "Perubahan Email Gagal": "Email Change Failed",
  "Perubahan email gagal": "Email Change Failed",
  "Password Lama": "Current password",
  "Password Baru": "New password",
  "Masukan password lama": "Input current password",
  "Masukan password baru": "Input new password",
  "Password lama Anda salah": "Input your current password correctly",
  "Password minimal 8 karakter": "Password at least 8 characters",
  "Password harus berisi minimal 8 karakter":
    "Your password must be at least 8 characters",
  "Konfirmasi password baru": "Input confirm new password",
  "Konfirmasi Password Baru": "Confirm New password",
  "Password baru tidak sama":
    "Your new password is not the same. Check and reset",
  "Setelah password berhasil terubah, gunakan password baru untuk Log In.":
    "After the password is successfully changed, use the new password to Log In",
  "Perubahan password berhasil !": "You have successfully update password",
  "Anda yakin ingin menyimpan perubahan password baru ?":
    "You will use a new password when logging in",
  "Ubah Password Melalui Aplikasi": "Change Password Via Application",
  "Silahkan ubah password Anda melalui aplikasi Lion Parcel":
    "Please change your password via the Lion Parcel application",
  Tutup: "Close",
  Ya: "Yes",
  Tidak: "No",
  Laporan: "Report",
  Loading: "Loading",
  profile: {
    balanceAvailable: "Balance",
    logout: "Log Out",
    logoutConfirmTitle: "Confirm Log Out?",
    logoutConfirmMessage:
      "Before you logout, make sure that there are no active processes running or that all activities have been completed.",
    changePassword: {
      title: "Update New Password?",
      msg: "Are you sure you want to save the new password changes?"
    },
    aturUlang: "Password Reset Successful",
    pesanAturUlang: "Your new password has been successfully saved",
    passwordOne: "The password must not be the same as the previous password",
    passwordTwo: "The password must not be the same as the previous password"
  },
  breadcrumb: {
    home: "Home",
    pusatResolusi: "Resolution Center",
    notification: "Notification",
    seeAllMessages: "See all messages",
    noMessagesToShow: "No messages to display",
    profile: "Profile",
    active: "Active",
    inactive: "Inactive",
    helpCenter: "Guide Center"
  },
  notification: {
    searchPlaceholder: "Search messages",
    loading: "Loading.......",
    emptyNoResult: "No results found",
    emptyNoResultDescription:
      "What you are looking for was not found or does not exist.",
    emptyNoMessage: "No messages to display",
    mainNews: "Main News",
    download: "Download",
    filterNewest: "Newest",
    filterOldest: "Oldest",
    timezone: "WIB",
    sharedNewsPrefix: "shared a new announcement :",
    loginRequest: "Login Request",
    from: "from",
    reject: "Reject",
    accept: "Accept",
    actionAccepted: "Accepted",
    actionRejected: "Rejected",
    actionAcceptVerb: "accepted",
    actionRejectVerb: "rejected",
    loginRequestHandled:
      "Login request for <b>{accountName}</b> has been {action}.",
    okUpper: "OK",
    failedProcessTitle: "Failed to process",
    tryAgain: "Try again",
    back: "Back",
    confirmRejectTitle: "Reject login request?",
    confirmAcceptTitle: "Accept login request?",
    confirmRejectMessage:
      "Are you sure you want to reject this user's login request?",
    confirmAcceptMessage:
      "When accepted, the user will have access to Genesis.",
    confirmActionButton: "Yes, {action}",
    cancel: "Cancel",
    kemarin: "Yesterday",
    hariIni: "Today"
  },
  integration: {
    breadcrumb: "API Integration",
    title: "Generate New Token",
    subtitle: "Generate token to connect your app to Lion Parcel.",
    ok: "OK",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    copy: "Copy",
    generate: "Generate",
    contactHelp: "Is there a problem when generating token? Please contact",
    systemErrorTryAgain: "There was an error in our system, please try again",
    tryAgain: "Try Again",
    clientIdCopied: "Client ID successfully copied",
    clientSecretCopied: "Client Secret successfully copied",
    promptSuccess:
      "Token successfully created, please use it to connect app plugin.",
    promptExpired: "Client ID & Client Secret expired, please generate again.",
    errorGenerateMessage:
      "There was an error in our system, <br> please generate again.",
    errorGenerateTitle: "Token Generated Failed!"
  },
  balance: {
    router: "Balance",
    balanceAvailable: "Available Balance",
    searchPlaceholder: "Search for STT Number",
    searchPlaceholderGenesis: "Search STT No. or Genesis Transaction ID",
    downloadButtontitle: "Download Statement",
    downloadPopupTitle: "Download Balance Statement",
    downloadSuccessTitle: "Balance Statement Downloaded Successfully",
    activityTitle: "Activity",
    activityPlaceholder: "Select the activity type",
    transactionDatePickerTitle: "Transaction Date",
    emptyMessage: "Oops.. No data to display yet",
    filterAll: "All",
    balanceDeposit: "Deposit Balance",
    tierLevel: "Tier Level",
    tooltipBalanceAvailableTitle: "Available Balance",
    tooltipBalanceAvailableMessage:
      "Available balance is the balance used for STT transactions",
    tooltipBalanceDepositTitle: "Deposit Balance",
    tooltipBalanceDepositMessage:
      "Deposit balance is the security deposit when creating a new POS Partner account and cannot be withdrawn until POS closure",
    tooltipTierLevel: "POS Tiering",
    warningNearLimit: "Your balance is approaching the limit",
    warningBelowLimit: "Your balance is below the limit",
    warningAtLimit: "Your balance has reached the limit",
    fillBalanceNow:
      "Top up your balance now. Ensure your balance is available before shipment activities.",
    topupViaAdmin: "You can top up your balance via Admin",
    filterPlaceholder: "Filter",
    activityAll: "All",
    activityDebit: "Debit",
    activityCredit: "Credit",
    downloadButton: "Download",
    tabMutation: "Balance",
    tabNett: "Net Balance",
    tabHold: "Hold Balance",
    tabNetBalance: "Net Balance",
    withdraw: {
      title: "Withdraw",
      balanceAvailable: "Available Balance",
      codIncomeTitle: "COD Income",
      amountLabel: "Withdrawal Amount",
      amountPlaceholder: "e.g. 100.00",
      minWithdrawMessage: "Minimum withdrawal is",
      balanceInsufficient: "Insufficient balance",
      balanceBelowMin: "Your remaining balance is below",
      minWithdraw: "Min. withdrawal",
      maxWithdrawTotal: "Max. withdrawal is total balance",
      maxWithdrawOnceWeek: "Max. withdrawal once per week",
      maxWithdrawTotalMinBalance: "Max. withdrawal is total balance -",
      beneficiaryLabel: "Beneficiary Account Number",
      passwordLabel: "Genesis Password",
      passwordPlaceholder: "Enter account password",
      passwordWrong: "Wrong password",
      cancel: "Cancel",
      withdraw: "Withdraw",
      cashbackDisclaimer:
        "Cashback balance can only be used for shipment transactions (STT booking) and partners cannot withdraw cashback balance."
    },
    tableTitle: {
      genesisTransactionId: "Genesis Transaction ID",
      type: "Type",
      activity: "Activity",
      amount: "Amount",
      lastBalance: "Last Balance",
      trancasationDate: "Transaction Date",
      note: "Note",
      bankName: "Bank Name",
      accountName: "Account Name",
      accountNumber: "Account Number",
      genesisRefId: "Genesis Reference ID",
      status: "Status",
      sttNo: "STT No."
    },
    hold: {
      searchPlaceholder: "Search STT No.",
      allStatus: "All Status",
      selectCodType: "Select COD Type",
      downloadReport: "Download Report",
      totalHoldBalance: "Total Hold Balance",
      infoPodReturn:
        "Your balance will be returned after the package is successfully received by the recipient (POD)",
      statusAll: "All Status",
      statusHold: "Hold Balance",
      statusReturned: "Balance Returned",
      codAll: "All STT Types",
      codRetail: "COD Retail",
      codCustomerApp: "COD Customer App",
      codCorporate: "COD Corporate",
      dfodRetail: "DFOD Retail",
      dfodCustomerApp: "DFOD Customer App",
      tableTitle: {
        sttNo: "STT No.",
        bookingDate: "Booking Date",
        bookingShipment: "Booking Shipment",
        bookingReturn: "Booking Return",
        bookingCod: "Booking COD",
        totalSttFee: "Total STT Fee",
        senderName: "Sender Name",
        status: "Status",
        action: "Action",
        detail: "Detail",
        tracking: "Tracking"
      },
      modal: {
        title: "Download Report",
        status: "Status",
        transactionDate: "Transaction Date",
        codType: "COD Type",
        selectStatus: "Select Status",
        selectCodType: "Select COD Type",
        search: "Search"
      }
    }
  },
  titleSearchReport: "Search Report",
  report: {
    title: "Report",
    searchByName: "Search report name",
    cari: "Search",
    generateFailed: "Generate Report Failed !",
    sectionStt: "STT",
    sectionFinance: "Finance",
    sectionDelivery: "Delivery",
    category: {
      stt: "STT",
      finance: "Finance",
      delivery: "Delivery"
    },
    cards: {
      titleSttReport: "STT Report",
      titleSttClient: "STT Client Report",
      titleSttManual: "Manual STT Report",
      titlePembatalanStt: "STT Cancellation Report",
      titleFpr: "FPR Report",
      titleCod: "COD Report",
      titleTopUp: "Top Up Report",
      titlePendapatan: "Income Report",
      titlePembayaran: "Payment Report",
      titleTransaksi: "Transaction Report",
      titleReferralPos: "POS Referral Report",
      titleBonusKomisi: "Bonus Commission Report",
      titleKomisiAffiliate: "Affiliate Commission Report",
      titleKomisiPosInduk: "Parent POS Commission Report",
      titleTransit: "Transit Report",
      titleMisroute: "Misroute Report",
      titleShortland: "Shortland Report",
      titlePengiriman: "Delivery Report",
      titleScrap: "Scrap Report",
      titlePengirimanKeluar: "Outgoing Delivery Report (Origin City)",
      titlePengirimanMasuk: "Incoming Delivery Report (Destination City)",
      titleKomisiPengiriman: "Delivery Commission Report",
      titleKomisiPengirimanTierX: "Delivery Commission Tier X Report",
      colPartnerName: "Partner Name",
      placeholderPartnerName: "Type or select a parent/branch POS",
      colCity: "City",
      labelLastSyncData: "Last Sync Data",
      descLastSyncData:
        "Refresh the page to update the latest data sync information",
      colDate: "Date",
      labelAllPOS: "All POS",
      labelAllClient: "All Client",
      waitingDownload: "Report search is in progress, please wait.",
      reportType: "Report Type",
      reportSearch: "Search Report",
      generateFailed: "Generate failed",
      reportTypeData: "Data Type",
      sttBookedBy: "STT Booked By",
      descStt: "STT",
      descSttClient: "STT Client",
      descSttManual: "Manual STT",
      descPembatalanStt: "STT Cancellation",
      descFpr: "FPR",
      descCod: "COD",
      descTopUp: "Top Up",
      descPendapatan: "Income",
      descPembayaran: "Payment",
      descTransaksi: "Transaction",
      descReferralPos: "POS Referral",
      descBonusKomisi: "Bonus Commission",
      descKomisiAffiliate: "Affiliate Commission",
      descKomisiPosInduk: "Parent POS Commission",
      descTransit: "Transit",
      descMisroute: "Misroute",
      descShortland: "Shortland",
      descPengiriman: "Delivery",
      descScrap: "Scrap",
      descPengirimanKeluar: "Outgoing Delivery (Origin City)",
      descPengirimanMasuk: "Incoming Delivery (Destination City)",
      descKomisiPengiriman: "Delivery Commission",
      descDtpolTierX: "DTPOL Tier X"
    },
    modal: {
      sttBookedFor: "STT Booked For",
      placeholderPosParent: "Type or select parent POS",
      placeholderPosBranch: "Type or select parent/branch POS",
      placeholderSelect: "Select",
      clientPartnerTitleClient: "Client Name",
      clientPartnerTitleBookedFor: "Booked For",
      clientPartnerTitlePartner: "Partner Name",
      clientPartnerTitleKlien: "Client Name",
      placeholderPartner: "Select Partner",
      placeholderClient: "Select Client",
      selectBookedBy: "Select STT creator",
      bookedForClient: "Client",
      bookedForPos: "POS",
      bookedForClientBranch: "Branch Client",
      reportTypeOutbound: "Outbound",
      reportTypeInbound: "Inbound",
      dataTypeDetailStt: "Detail STT",
      dataTypeCost: "Cost detail",
      allPartner: "All Partner",
      misrouteType: "Misroute Type",
      scrapType: "Scrap Type",
      shortlandType: "Shortland Type",
      cancelBased: "Cancellation based on",
      sttStatus: "STT Status",
      topUpType: "Top Up Type",
      deliveryBy: "Delivery By",
      placeholderCity: "Select city",
      placeholderAccount: "Select account",
      selectType: "Select type",
      selectTypeMisroute: "Select type",
      originCity: "Origin City",
      destinationCity: "Destination City",
      shortlandCity: "Shortland City",
      misrouteCity: "Misroute City",
      topUpVirtualAccount: "Top Up Virtual Account",
      topUpManual: "Top Up Manual",
      used: "Used",
      unused: "Unused",
      console: "Console",
      subConsole: "Sub Console",
      pos: "POS",
      all: "All",
      dataNotFound: "Data not found",
      dataNotFoundMessage: "Sorry, the data you are looking for was not found.",
      showingReportSearch: "Showing report search",
      reportDescription: "Report",
      download: "Download",
      dateRangeErrorStart: "Start date must be from the 1st to the 30th/31st.",
      dateRangeErrorChange: "Please change the date.",
      lastSyncLoadFailed: "Failed to load last sync data for<br />STT Report !",
      allPrefix: "All"
    }
  },
  announcement: {
    menuTitle: "Announcement",
    detailTitle: "Announcement | Detail",
    editTitle: "Announcement | Edit",
    createTitle: "Announcement | Create",
    createName: "Create New Announcement",
    searchPlaceholder: "Search activity name",
    buttonCreate: "Create Announcement",
    emptyData: "Announcement data",
    allStatus: "All Status",
    statusDraft: "Draft",
    statusSent: "Sent",
    announcementId: "Announcement ID",
    nameActivity: "Activity Name",
    targetUser: "Target User",
    releaseDate: "Release Date",
    status: "Status",
    createdAt: "Created Date",
    description: "Description",
    attachment: "Attachment",
    banner: "Banner",
    target: "Target",
    pinnedMessage: "Pin Message",
    pinnedYes: "Message Pinned",
    lastModified: "Last Modified",
    edit: "Edit",
    optional: "(Optional)",
    placeholderName: "Enter activity name",
    placeholderDescription: "Write news description here",
    changeFile: "Change File",
    targetHint: "Target will receive notifications on their Genesis account",
    pinnedHint:
      "Pinned messages will appear at the top of the notification page. Use this to highlight important messages.",
    save: "Save",
    successTitle: "Changes Saved Successfully!",
    news: "News",
    successChanged: "successfully changed",
    successMessage: 'News "{name}" has been updated successfully',
    ok: "OK",
    confirmLeaveTitle: "Are you sure you want to leave?",
    confirmLeaveMessage:
      "Please confirm, you will lose all data if you leave this page.",
    leave: "Leave",
    back: "Back",
    confirmSaveTitle: "Confirm Changes",
    confirmSaveMessage: 'Are you sure you want to save changes to "{name}"',
    confirmSaveMessageTwo: "Are you sure you want to save the changes",
    confirmDeleteTitle: "Are you sure you want to delete this activity?",
    confirmDeleteMessage:
      "Please confirm, you will lose this activity data when you delete it",
    delete: "Delete",
    invalidEndDate: "End date must not be less than or equal to current date",
    maxSizeFormatBanner:
      "Max size: 5MB, Format: jpg, png. Recommended ratio 2:4 (e.g. 200px X 800px)",
    loading: "Loading...",
    invalidFileMessage:
      "Please ensure file format and size are correct (max 16MB)",
    targetWillReceive:
      "Target will receive notifications on their Genesis account",
    selectTargetHint: "Select target that will receive notifications.",
    pinnedActive: "Message pinned",
    pinnedInactive: "Message not pinned",
    invalidReleaseDate:
      "Release date must not be less than or at least one hour from now",
    captionBanner:
      "Max size: 5MB, Format: jpg, png. Recommended ratio 2:4 (e.g. 200px X 800px)"
  },
  "Pilih Status": "Select status",
  "Semua Status": "All status",
  "Status Terbaru": "Status",
  "Tanggal Diubah": "Modified Date",
  "Nama User": "User Name",
  "Pilih kota tujuan": "Select destination city",
  "Tipe Partner": "Partner Type",
  "Detail Custom Process": "Custom Process Detail",
  "Total Berat Dikenakan Biaya": "Total Chargeable Weight",
  "Berat Dikenakan Biaya": "Chargeable Weight",
  "Berat\nDikenakan Biaya": "Chargeable\nWeight",
  "Print Resi Custom Process": "Print Custom Process Receipts",
  "No. STT Pengganti": "No. STT Replacement",
  "Tipe Konsol": "Consolidator Type",
  "Nama Konsol": "Consolidator Name",
  "3LC": "3LC",
  "Masukan nama konsol": "Input consolidator name",
  "Masukan 3LC": "Input 3LC",
  "Masukan STT pengganti atau catatan lainnya":
    "Input replacement number or add notes.",
  Alasan: "Reason",
  customStatus: {
    updateStatus: "Update Status",
    remarks: "Remarks",
    remarksPlaceholder: "Input replacement number or add notes.",
    singleSttWarningRtsRtsHq:
      "For RTS and RTSHQ status, only 1 STT number can be updated",
    singleSttWarningOther:
      "For {status} status, only 1 STT number can be updated",
    hubDestination: "Destination hub",
    vehicleNumber: "Vehicle number",
    pos: "POS",
    selectPos: "Select POS",
    editAddress: "Edit Address",
    editReceiverAddress: "Edit Recipient Address",
    backlineAddressUpdated:
      "This recipient address has been updated by backline, you can continue processing misbooking from a console account",
    mustEditAddressMisbooking:
      "You must update the recipient address to process MISBOOKING.",
    totalStt: "Total STT",
    download: "Download",
    ok: "OK",
    addSttFailedTitle: "Add STT Number Failed",
    scanSttFailedTitle: "Scan STT Number Failed",
    sttAlreadyInput: "STT number has already been entered",
    updateSuccessTitleInOutHub: "Status Update Successful",
    updateSuccessMessageInOutHub:
      'STT status updated successfully to "{status}"',
    printReceipt: "Print Receipt",
    printThermalReceipt: "Print Thermal Receipt",
    printBasicPdf: "Print Basic/Save to PDF",
    updateFailedTitle: "Status Update Failed!",
    leavePageTitle: "Are you sure you want to leave?",
    leavePageMessage:
      "Please confirm, all data will be lost if you leave this page.",
    selectConsoleType: "Select consolidator type",
    consolidator: "Consolidator",
    subConsolidator: "Sub Consolidator",
    selectRemarks: "Select Remarks",
    remarksOptionCustomer: "Address change request from Customer",
    remarksOptionPos: "Address change request from POS",
    isPaid:
      "There was an overload so the status could not be updated to {status}",
    delete:
      "Input STT Number or Scan Barcode/QR Code for the item</br>you want to delete from the {status} list.",
    titleSuccess: "Update Success!",
    confirmUpdateTitle: "Confirm Update Status?",
    successMessageNewStt:
      "STT No. <b>{listStt}</b> successfully updated to {status} with replacement STT No. <b>{newStt}</b>",
    successMessage: "STT Number is updated to <b>“{status}”</b>",
    partialMessage:
      "Some STT statuses were successfully updated to {status}, but there was a failure in some STTs. Please download to find out the error.",
    failedMessage: "Status change {status} failed to create.",
    buttonCancel: "Ok, understand"
  },
  courierManagement: {
    menuTitle: "Courier Management",
    listTitle: "Courier List",
    approvalListTitle: "Courier Approval List",
    addTitle: "Courier Management | Add",
    addCourier: "Add Courier",
    detailTitle: "Courier Management | Detail",
    editTitle: "Courier Management | Edit",
    edit: "Edit",
    editDetailCourier: "Edit courier detail",
    detailParent: "Courier Management Detail",
    tabList: "Courier Management",
    tabApproval: "Courier Approval",
    save: "Save",
    detailCourier: "Courier Detail",
    courierName: "Courier name",
    placeholderCourierName: "Enter courier name",
    phoneLabel: "Phone number",
    courierType: "Courier type",
    announcementCourierType: "Announcement courier type",
    vehicleType: "Vehicle type",
    plateNumber: "Plate number",
    placeholderPlateNumber: "Enter plate number",
    ownershipName: "Ownership name",
    placeholderOwnershipName: "Enter ownership name",
    bank: "Bank",
    bankName: "Bank name",
    codDelivery: "COD delivery available?",
    yes: "Yes",
    cod: "COD",
    yesShort: "YES",
    noShort: "NO",
    accountOwnerName: "Account owner name",
    placeholderAccountOwnerName: "Enter account owner name",
    accountNumber: "Account number",
    placeholderAccountNumber: "Enter account number",
    areaDelivery: "Area Delivery",
    no: "No",
    district: "District",
    select3lc: "Select 3LC",
    searchDistrict: "Search and select district",
    add3lc: "Add another 3LC",
    courierStatus: "Courier status",
    statusToggleHint: "You can activate this status anytime",
    active: "Active",
    inactive: "Inactive",
    connectedDevices: "Connected Devices",
    lastActiveToday: "Last active today",
    lastActiveAt: "Last active",
    delete: "Delete",
    back: "Back",
    cancel: "Cancel",
    posName: "POS Name",
    placeholderPosName: "Enter POS name",
    consolidatorName: "Consolidator Name",
    noAreaDeliveryData: "No area delivery data",
    confirmSaveCourier: "Save courier changes?",
    confirmSaveCourierMessage:
      "Ensure the courier details you changed are correct.",
    courierUpdateSuccess: "Courier updated successfully",
    courierUpdateSuccessMessage:
      "Please check the courier details you updated.",
    checkCourier: "Check Courier",
    confirmDeleteDevice: "Confirm device removal",
    confirmDeleteDeviceMessage:
      "Device <b>{deviceName} ({deviceOs})</b> will no longer be able to access your account unless you sign in again",
    courierCreateSuccess: "Courier added successfully",
    courierCreateSuccessMessage: "Check the courier details you added.",
    failedAddCourier: "Failed to add courier",
    failedEditCourier: "Failed to update courier",
    downloadData: "Download Courier Data",
    searchPlaceholder: "Search name, courier id & phone",
    driverType: "Courier type",
    placeholderDriverType: "Select courier type",
    status: "Status",
    placeholderStatus: "Select status",
    emptyListHeader: "No courier data yet ",
    emptyListMessage: "Add a courier and check the list here.",
    emptyApprovalHeader: "No Courier Data",
    emptyApprovalMessage: "Please add a courier first",
    acceptRequest: "Accept this request?",
    acceptRequestMessage:
      "Courier will still be able to access Lion Parcel Driver app.",
    accept: "Yes, accept",
    rejectRequest: "Reject this request?",
    rejectRequestMessage:
      "Courier will not be able to access Lion Parcel Driver app.",
    reject: "Yes, reject",
    requestSuccess: "Request successfully {action}",
    requestRejected: "rejected",
    requestAccepted: "accepted",
    okGotIt: "OK, got it",
    kurirId: "Courier ID",
    nameWithPartner: "{partnerTitle} {name}",
    name: "Name",
    consoleName: "Console/POS Name",
    tipePermintaan: "Request Type",
    atur: "Set",
    riwayatPermintaanKurir: "Courier request history",
    belumAdaDataRiwayatKurir: "No Courier History Data Yet",
    partnerType: "Partner Type",
    placeholderPartnerType: "Enter Partner Type",
    phonePlaceholder: "812345678901",
    threeLc: "3LC",
    deleteDeviceSuccess: "Device removed successfully",
    deleteDeviceFailed: "Failed to remove device!",
    placeholderAnnouncementCourierType: "Select announcement courier type",
    placeholderVehicleType: "Select vehicle type",
    motorcycle: "Motorcycle",
    truck: "Truck",
    placeholderBank: "Select Bank",
    invalidPhone: "Invalid phone number, please try again",
    invalidPlate: "Invalid plate number, please try again",
    invalidBankAccount: "Invalid bank account number, please try again",
    courierTypeRequired: "Courier type is required",
    console: "Consolidator",
    all: "All",
    courierData: "Courier Data"
  },
  codReconcile: {
    title: "Reconciliation",
    menuTitle: "Reconciliation",
    menuReportTitle: "Reconciliation & Report",
    reportTitle: "Reconciliation Report",
    tabCourier: "Courier",
    tabPartner: "Partner",
    tabPicShuttle: "PIC Shuttle",
    detailCourierTitle: "Courier Detail",
    detailPicShuttleTitle: "PIC Shuttle Detail",
    detailShuttleTitle: "Reconciliation | Shuttle Detail",
    detailPageTitle: "Reconciliation | Courier Detail",
    summary: {
      totalMoneyToDeposit: "Total Amount to Deposit",
      totalSttToDeposit: "Total STT to Deposit",
      totalCodMoney: "Total COD Amount",
      mustDeposit: "To Deposit",
      alreadyDeposit: "Deposited",
      dex: "DEX",
      codrej: "CODREJ",
      inDelivery: "In Delivery",
      del: "DEL",
      podCodrejDex: "POD/CODREJ/DEX",
      progressDelivery: "Delivery Progress",
      noStt: "No. STT",
      serviceType: "Service Type",
      nominal: "Amount"
    },
    list: {
      searchPlaceholder: "ID, name or courier phone number",
      downloadReconcile: "Download Reconciliation",
      emptyDexAutomationConfig:
        "No Fake DEX Indication Automation Configuration",
      emptyDexAutomationConfigMessage:
        "Start creating Fake DEX Indication Automation Configuration and check the list here",
      emptyHeaderMessage: "No courier reconciliation data yet",
      emptyMessage:
        "All reconciliation data (Failed, success & in delivery) will be recorded here!",
      no: "No.",
      courierName: "Courier Name",
      deliverySuccess: "Successful Delivery",
      action: "Action",
      sisaHarusDisetor: "Remaining to deposit",
      setorHarian: "Daily deposit",
      detailCourier: "Courier detail",
      downloadDetailCourier: "Download courier detail",
      mustDeposit: "To deposit",
      alreadyDeposit: "Deposited",
      progressDelivery: "Delivery Progress"
    },
    detail: {
      courierName: "Courier Name",
      picShuttleName: "PIC Shuttle Name",
      phoneNumber: "Phone number",
      courierId: "Courier ID",
      partner: "Partner",
      threeLc: "3LC",
      checkRemainingDeposit: "Check yesterday's remaining deposit",
      downloadDetailCourier: "Download courier detail",
      setorHarian: "Daily deposit",
      totalMoneyToDeposit: "Total amount to deposit",
      totalSttToDeposit: "Total STT to deposit",
      totalCodMoney: "Total COD amount",
      tabDetailStt: "STT Detail",
      tabRiwayatSetorUang: "Money deposit history",
      tabRiwayatSetorPaket: "Package deposit history",
      tabMoney: "Money",
      tabPackage: "Package",
      tabOnDelivery: "On Delivery",
      tanggal: "Date",
      nominalUang: "Amount",
      totalStt: "Total STT",
      catatan: "Notes",
      lihatDetail: "View detail",
      nilaiCod: "COD Value",
      noStt: "No. STT",
      statusTerakhir: "Last Status",
      tipePembayaranCod: "COD Payment Type",
      statusSetoran: "Deposit status",
      statusSetoranLast: "Last status",
      alasan: "Reason",
      namaPenerima: "Recipient Name",
      tanggalDel: "DEL Date",
      pengirimanBerhasil: "Successful delivery",
      pengirimanGagal: "Failed delivery",
      dalamPengiriman: "In delivery",
      performaPengiriman: "Delivery Performance",
      emptyHeaderDelivery: "No delivery yet",
      emptyMessageDelivery:
        "All delivery data (Failed, success & in delivery) will be recorded here!",
      paymentMethod: "Payment Method",
      depositLocation: "Deposit Location",
      biayaKirim: "Shipping Cost",
      biayaAsuransi: "Insurance Cost",
      biayaLainLain: "Other Costs",
      totalBiaya: "Total Cost",
      detail: "Detail",
      close: "Close",
      total: "Total",
      pengirim: "Sender",
      jenisKiriman: "Shipment Type",
      berat: "Weight",
      volume: "Volume",
      waktu: "Time",
      namaPenerimaTab: "Recipient name"
    },
    report: {
      lastSyncData: "Last Data Synchronization",
      downloadDetail: "Download Detail",
      deliveryFailed: "Delivery Failed",
      deliveryFailedCodrej: "Delivery Failed (CODREJ)",
      deliveryFailedDex: "Delivery Failed (DEX)",
      notYetDeposited: "(Not Yet Deposited)",
      alreadyDeposited: "(Already Deposited)",
      inDeliveryProcess: "In Delivery Process",
      cash: "Cash",
      tooltip: {
        podTotalValue:
          "Total COD value of STT COD successfully delivered (POD) to recipient.",
        podTotalStt: "Total STT COD successfully delivered (POD).",
        podPercentage:
          "Percentage of successful STT COD delivery (POD) from total STT COD.",
        podNotDepositedValue:
          "Total COD value successfully delivered (POD) to recipient and COD money has not been deposited by courier to admin POS.",
        podNotDepositedStt:
          "Total STT COD successfully delivered and COD money has not been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        podNotDepositedPercentage:
          "Percentage of total STT COD successfully delivered and COD money has not been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        podDepositedValue:
          "Total COD value successfully delivered (POD) to recipient and COD money has been deposited by courier to admin POS.",
        podDepositedStt:
          "Total STT COD successfully delivered and COD money has been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        podDepositedPercentage:
          "Percentage of total STT COD successfully delivered and COD money has been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        failedTotalStt:
          "STT COD failed to deliver (DEX & CODREJ) to recipient.",
        failedPercentage:
          "Percentage of failed STT COD delivery (DEX & CODREJ) from total STT COD.",
        codrejNotDepositedValue:
          "Total COD value failed to deliver (CODREJ) to recipient and COD money has not been deposited by courier to admin POS.",
        codrejNotDepositedStt:
          "Total STT COD failed to deliver and COD money has not been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        codrejNotDepositedPercentage:
          "Percentage of total STT COD failed to deliver and COD money has not been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        codrejDepositedValue:
          "Total COD value failed to deliver (CODREJ) to recipient and COD money has been deposited by courier to admin POS.",
        codrejDepositedStt:
          "Total STT COD failed to deliver and COD money has been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        codrejDepositedPercentage:
          "Percentage of total STT COD failed to deliver and COD money has been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        dexNotDepositedValue:
          "Total COD value failed to deliver (DEX) to recipient and COD money has not been deposited by courier to admin POS.",
        dexNotDepositedStt:
          "Total STT COD failed to deliver and COD money has not been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        dexNotDepositedPercentage:
          "Percentage of total STT COD failed to deliver and COD money has not been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        dexDepositedValue:
          "Total COD value failed to deliver (DEX) to recipient and COD money has been deposited by courier to admin POS.",
        dexDepositedStt:
          "Total STT COD failed to deliver and COD money has been deposited by courier to admin POS/Total overall STT COD successfully delivered (deposited and not deposited).",
        dexDepositedPercentage:
          "Percentage of total STT COD failed to deliver and COD money has been deposited by courier to admin POS from total overall COD value successfully delivered (deposited and not deposited).",
        delStt: "Total STT COD currently in delivery (DEL).",
        delPercentage:
          "Percentage of STT COD currently in delivery (DEL) from total STT COD.",
        delValue: "Total COD value from STT COD currently in delivery."
      }
    },
    dailyDeposit: {
      titleSetorHarian: "Courier Daily Deposit",
      titleSetorHarianPicShuttle: "PIC Shuttle Daily Deposit",
      cekSisaSetoranKemarin: "Check yesterday's remaining deposit",
      totalUangHarusDisetor: "Total amount to deposit",
      jumlahUangDisetor: "Amount deposited",
      placeholderAmount: "e.g 100.000",
      placeholderInputAmount: "Enter amount deposited",
      errorAmount: "Enter amount according to amount to be deposited",
      catatan: "Notes",
      simpan: "Save",
      batal: "Cancel",
      setor: "Deposit",
      setoranMasuk: "Deposits received",
      belumAdaSetoran: "No deposits yet",
      foto: "Photo",
      uploadPhotoHint: "Maximum 5 MB, format .JPG, .PNG, .JPEG, .WEBP",
      uploadPhotoError:
        "Photo upload failed, ensure size and format are correct",
      successSetorUang: "Successfully deposited money",
      successSetorPaket: "Successfully deposited package",
      nominalUang: "Amount",
      totalStt: "Total STT",
      buktiFoto: "Proof of photo",
      catatanLabel: "Notes",
      lihatBukti: "View proof",
      noData: "Oops.. No data to display yet",
      noStt: "No. STT",
      noSttShipment: "No. STT/Shipment",
      layanan: "Service",
      serviceType: "Service Type",
      nominal: "Amount",
      buktiSetor: "Deposit proof",
      lastStatus: "Last Status",
      koli: "Pieces",
      oleh: "by",
      amountDepositedLabel: "deposited",
      placeholderStt: "Enter STT no. or scan barcode/QR code",
      exampleStt: "Example: 99LP1234567890123/88-22-12345678",
      successTitle: "Daily deposit successful!",
      successMessage:
        "Amount of {amount} & {count} STT successfully deposited.",
      failTitle: "Daily deposit failed!",
      scanSuccess: "Scan successful",
      sttAlreadySelected: "STT already selected",
      emptyTitleSttNotFound: "STT number not found",
      emptyMessageSttNotFound:
        "Ensure STT number is correct, check & try again.",
      emptyMessageNoStt: "No STT to deposit yet",
      courierUnknown: "Unknown Courier",
      tabMoney: "Money",
      tabPackage: "Package",
      failGetDetailCourier: "Failed to get courier detail",
      failGetSummary: "Failed to Get Summary!",
      failUploadCourierNotesPhoto: "Failed to upload courier notes photo",
      failSaveCourierNotes: "Failed to save courier notes",
      successSetor: "Deposit success",
      noHistoryFromDriverApp: "No deposit history from Driver App",
      failGetSettlement: "Failed to get settlement data",
      deposit: "Deposit",
      depositIn: "Deposit {type} in",
      amount: "Total",
      failDeletePhoto: "Failed to delete Photo from storage!",
      uploadedBy: "Uploaded by"
    },
    overallSummary: "Overall Summary"
  },
  "Status terbaru yang Anda pilih hanya untuk No.STT INTERPACK. Cek & atur ulang":
    "The latest status you select is only for INTERPACK STT Number Check & reset",
  "Status terbaru yang Anda pilih salah. Status harus diperbarui ke <b>“OCC - IMP”</b>. Cek & atur ulang":
    "The latest status you selected is incorrect. The status should be updated to <b>“OCC - IMP”</b>. Check & reset",
  "Status terbaru yang Anda pilih salah. Status harus diperbarui ke <b>“OCC - EXP”</b>. Cek & atur ulang":
    "The latest status you selected is incorrect. The status should be updated to <b>“OCC - EXP”</b>. Check & reset",
  "Buat Booking Baru": "Create Booking",
  "Buat Booking Retail": "Create Booking Retail",
  "Buat Booking Klien": "Create Booking Client",
  "Detail Pengiriman": "Shipment Details",
  "Detail STT": "STT Details",
  "Booking baru": "Create booking",
  "Penghasilan COD": "COD Income",
  "Penarikan": "Withdrawal",
  "Gagal Print Resi Vendor": "Failed to Print Vendor Receipt",
  "Beberapa label tidak dapat dicetak": "Some of the labels can not be printed",
  optional: "Optional",
  pusatResolusi: {
    cekKendala: "Check for problems",
    laporkanKendala: "Report problems",
    sttNumberNeverReported: "No. STT/problem has never been reported",
    sttNumberMessage: "You can report any issues for this STT/issue.",
    cekKendalaGagal: "Check Problem Failed!",
    tabEscalate: "Escalation tickets",
    tabMyTicket: "My tickets",
    tabFollowed: "Followed tickets",
    searchPlaceholder: "Search issue no./STT/shipment",
    escalatedBy: "Being escalated by {name}",
    refresh: "Refresh",
    filter: "Filter",
    filterReset: "Reset",
    filterCategory: "Category",
    filterSelectCategory: "Select category",
    filterStatus: "Status",
    filterTicketType: "Ticket type",
    filterClaim: "Claim",
    filterPriority: "Priority",
    filterApply: "Apply",
    sortOldest: "Oldest",
    sortNewest: "Newest",
    needToBeSolved: "Need to be solved",
    newMessage: "New message",
    mention: "Mention",
    needReview: "Need review",
    emptyInternet: "Internet disconnected",
    emptyServer: "System error occurred",
    emptyNoData: "No issues yet",
    emptySearchNotFound: "Issues not found",
    emptyInternetDesc: "Check your network connection.",
    emptyServerDesc: 'Click "Reload" or try again later.',
    emptyNoDataDesc: "Start by reporting your first issue.",
    emptySearchDesc: "Check or search for another issue no./STT/shipment id.",
    columnIssueNo: "Issue no.",
    columnSttShipment: "No. STT/shipment id",
    columnCategory: "Issue category",
    columnPriority: "Priority",
    columnStatus: "Status",
    columnCreatedAt: "Created at",
    columnAction: "Action",
    badgeNeedToSolve: "Need to be solved",
    badgeClaim: "Claim",
    tooltipReviewExpired: "Review period has ended",
    newMessagePlaceholder: "Enter & add new message here",
    messageTemplateList: "Message template list",
    deleteMessage: "Delete message",
    editMessage: "Edit message",
    issue: "Issue",
    valid: "Valid",
    notValid: "Not valid",
    ulasanToast: "Ticket review <b>no. problem",
    successSaved: "successfully saved.",
    failedSaved: "save failed.",
    insertNote: "Insert your note",
    failedToSaveNote: "Failed to save note",
    sttIssue: "STT is in Trouble",
    category: "Category",
    updatedDate: "Updated Date",
    replyMessage: "Reply Message",
    maxSize: "Maximum photo size is no more than",
    eachSize: "and each size is",
    addAttachment: "Add Attachment",
    createdDate: "Created Date",
    statusReport: "Issue Report Status",
    detail: {
      detailGoods: "Goods detail",
      grossWeight: "Gross weight",
      dimension: "Dimension",
      chargeableWeight: "Chargeable weight",
      koli: "Pieces",
      codCharge: "COD charge",
      goodsPrice: "Goods price",
      insurance: "Insurance",
      yes: "Yes",
      no: "No",
      commodity: "Commodity",
      isEscalation: "Your escalation ticket is currently open in another tab.",
      isNotEscalation: "Your ticket is currently open in another tab.",
      isEscalationSecondMessage:
        "Continue working on the ticket in that tab or browser.",
      ticketActor: "Ticket has been escalated by",
      youStillCan: "You can still escalate tickets for other issues.",
      notes: "Notes"
    },
    create: {
      reportIssue: "Report issue",
      issueType: "Issue type",
      sttLabel: "No. STT/shipment id",
      sttPlaceholder: "Enter STT/shipment no.",
      lastStatus: "Last status",
      check: "Check",
      reload: "Reload",
      category: "Issue category",
      selectCategory: "Select issue category",
      description: "Description",
      deleteDescription: "Remove description",
      descPlaceholder: "Enter description",
      submit: "Submit report",
      uploadDesc:
        "Attached files are proof of the problem. Check the instructions on the side. Maximum of 3 files: video (.mp4, .webm, .mov) up to 200 MB, document & image (.png, .jpg, .jpeg, .pdf, .docx, .csv, .xlsx, .xls) up to 5 MB",
      problemDescTop: "The problem has been reported, ",
      problemDescBot: "but not yet listed in the Genesis constraints category.",
      noKendala: "No. issue",
      kategoriKendala: "Problem category",
      pengirimanNbantuan: "Delivery & assistance",
      sistemNbandingPinalti: "Penalty system & appeal",
      failedCheck: "Failed to check the problem report!",
      faieldCheckCategory: "Failed to fetch category data!",
      confirmMessage:
        "Make sure the details you submit are correct because you can only report 1 problem for 1 STT.",
      yes: "Yes, correct",
      cancel: "Cancel",
      failed: "Failed to create problem report!",
      fail: "Failed to report the issue",
      success: "The issue reported successfully!",
      everReported:
        "The issue was previously reported with the following error:",
      seeDetail: "See detail",
      back: "Back",
      problemHavBeenReported:
        "The issue has been reported,<br />but is not yet listed in the Genesis issue category.",
      lastStatusMessage:
        "The last STT status of this issue is no longer eligible.",
      sttIssueCategory:
        "The issue category does not match the last status report guidelines.",
      ticketDetail:
        "The issue has been reported, before the latest resolution center.",
      teamWillProcess: "The team will process your issue.",
      snackbarMessage:
        "Message template added successfully. Click <br /> “Save” to close.",
      snackbarMessageEdit:
        "Message template successfully changed. Click “Save” <br /> to close.",
      snackbarMessageTemplateList:
        "The message template order has been successfully changed. Click <br /> “Save” to close.",
      snackbarMessageDelete:
        "The message template was successfully deleted. Click <br /> “Save” to close.",
      snackbarMessageSuccess: "Message template changes saved successfully.",
      snackbarMessageFailed: "Message template changes failed to save.",
      deleteTemplate: "Delete this message template?",
      deleteTemplateMessage:
        "The message you deleted will disappear from the template list.",
      noBack: "No, back",
      yesDelete: "Yes, delete",
      reportNewIssue: "Report New Issues",
      typeOrChoose: "Type or select the shipping constraint category",
      noShipment: "Shipment ID number",
      noStt: "STT Number",
      ticketDesc: "Ticket Description",
      writeUrReply: "Write your reply message here",
      photoProof: "Photo Proof",
      photoProofDesc:
        "Photographic evidence can be a photo of the package/receipt/customer chat/package weight when weighed",
      logisticsDocumentationPhotoTwo:
        "Max file size: 5 MB, Format: jpg, png. Recommended dimensions: 2:4 (e.g., 200px X 800px). Standard logistics requirements",
      doxMaxSizeDesc:
        "Documents .pdf, word & excel, max. size: 16 mb, max. files: 2 Documents can be Quarantine Letters, MSDS (Material Safety Data Sheet), SPTJ (Letter of Release of Liability) & PTI (Notification of Contents)",
      reportIt: "Report",
      isReportDone: "Is the Problem Report Correct?",
      sttNoIsReported: "STT Number Has Been Reported",
      makesureDetail:
        "Make sure the details you submit are correct because you can only report 1 issue for 1 STT",
      lookatStatus: "View the status of the issue report you have submitted",
      seeReport: "See Report",
      successSendReport: "Report sent successfully",
      ourTeamWillProcess: "Our team will process your issue",
      reportFailed: "Issue Reporting Failed",
      sttNoFailed: "STT No. validation failed",
      sttNoShipmentFailed: "Shipment No. validation failed",
      failedToAddComment: "Failed to add comment",
      attachment: "File attachment guide:",
      thereIs: "There is",
      problemReported: "problem reported for this STT"
    },
    detailPage: {
      updated: "Updated"
    },
    summaryTab: "Summary",
    detailInfoTab: "Detail information",
    modal: {
      reload: "Reload",
      systemError: "System error occurred",
      systemErrorMessage: 'Click "Reload" or try again later.'
    },
    review: {
      titleIssueNo: "Issue no. {ticketNo}",
      giveRating: "Rate this issue report!",
      ratingHint: "(thumb down = disappointing, thumb up = very satisfying)",
      reviewLabel: "Give your review",
      reviewPlaceholder: "Share your feedback on using Genesis",
      optional: "Optional",
      cancel: "Cancel",
      submit: "Submit",
      save: "Save",
      rating: "Your Rating",
      timeLimit: "The review deadline has expired",
      giveusrating: "Give us your rating!"
    },
    finish: {
      title: "Add a comment before marking the issue as solved.",
      sendAndFinish: "Send & finish",
      cancel: "Cancel"
    },
    reopen: {
      title: "Please provide a reason before reopening the ticket",
      reopenTicket: "Reopen ticket",
      cancel: "Cancel"
    },
    success: {
      title: "Issue no. {noIssue} has been solved!",
      message: "Issue has been marked as solved.",
      ok: "OK, got it",
      toastSuccess: "Issue no. {noIssue} has been solved successfully.",
      failedToSendMessage: "Failed to send message",
      insertYourMessage: "Insert your message"
    },
    history: {
      newMessagesAt: "{count} new messages at {time}.",
      viewMessages: "View messages",
      attachment: "Attachment",
      new: "New",
      today: "Today",
      yesterday: "Yesterday",
      csAgentOnDuty: "CS agent on duty",
      transferredTo: "transferred to",
      priorityChangedTo: "Ticket priority changed to",
      by: "by",
      categoryChanged: "Issue category",
      changedTo: "changed to",
      escalationTask: "Escalation task",
      completedBy: "completed by",
      ticketInEscalation: "in escalation",
      for: "for",
      ticket: "Ticket",
      madeByNew: "created by",
      madeBy: "by",
      systemError: "System error occurred",
      systemErrorDesc: 'Click "Reload" or try again later.',
      internetError: "Internet disconnected",
      internetErrorDesc: 'Check your connection then click "Reload".',
      reload: "Reload",
      dalamProses: "In the process",
      ditundaSementara: "Temporarily postponed",
      direspon: "Responded",
      selesai: "Done",
      ditutup: "Closed",
      menungguDokumen: "Waiting for documents",
      dokumenDiterima: "Documents received",
      dalamInvestigasi: "Under investigation",
      diprosesAsuransi: "Insurance under process",
      konfirmasiCustomer: "Customer confirmation",
      dibayar: "Paid",
      ditolak: "Rejected",
      rekonsiliasi: "Reconciliation",
      klaim: "Claim",
      failedToFinishIssue: "Failed to resolve the issue!",
      addTemplateTitle: "Add message template"
    },
    follow: {
      description: "Follow this issue to get updates and leave comments!",
      button: "Follow issue"
    },
    reply: {
      placeholder: "Reply",
      send: "Send"
    },
    chatBox: {
      partnerList: "Partner List",
      letsCreateMessage: "Create a template to send messages faster",
      addTemplate: "Add template",
      image: "Image",
      uploadErrorMessage: "Adjust and re-upload the file",
      anda: "you just uploaded",
      maxChar: "Max 1.000 characters.",
      insertAt: `Enter the {'@'} symbol to mention someone`
    },
    deldex: {
      summary: "Summary",
      lastCourier: "Last courier",
      detailDex: "View DEX details"
    },
    modalDex: {
      detailValidDex: "DEX Validation Details",
      reason: "Reason"
    },
    partnerSection: {
      partnerTitle: "Reporting partner",
      escalationPartner: "Escalation partner",
      isYou: "You",
      finishedAt: "Finished at",
      lookAtPrev: "See previous escalations",
      csAgent: "CS agent on duty",
      partnerFollower: "Partner follower",
      follower: "follower",
      seeAlittle: "See a little",
      seeAll: "See all",
      prevPartner: "Previously assigned escalation partner"
    },
    summary: {
      updatedDate: "Updated date",
      bookingDate: "Booking date",
      sendroute: "Delivery route",
      deliveryType: "Delivery type",
      deliveryEst: "Estimated delivery",
      track: "Track",
      detailTrackStt: "STT tracking details"
    },
    choose: "Choose",
    dataResolution: "resolution center data",
    noReportedIssue: "No Issues Reported Yet",
    ifYouHaveIssue: "If you have any issues, we're always here to help!",
    inProcess: "In Processing",
    needHelp: "Need your response",
    all: "All",
    sender: "Sender",
    receiver: "Receiver",
    csName: "CS Name",
    reportSent: "The issue report has been sent",
    reportInProcess: "Report of the issue is handled by",
    confused: "Don't know how to report? Read the guide!",
    makeSure: "Make sure the type & category matches your issue.",
    checkModalLabel: "Report no./STT/shipment id",
    checkModalPlaceHolder: "Enter the problem number/STT/shipment id",
    checkNow: "Check now",
    new: "New",
    inProcess2: "In process",
    inEscalation: "In escalation",
    onHold: "Temporarily suspended",
    solved: "Solved",
    closed: "Closed",
    problemAlreadyReported:
      "The problem has already been reported, before the latest resolution center.",
    alreadyReportedHaventListed:
      "The issue has been reported, <br/>but has not yet been listed in the Genesis issue category.",
    shipmentId: "No STT / shipment id",
    problemCategory: "Problem Category",
    claim: "For claim information you can check",
    here: "here",
    contactCs: "Contact CS to report new problems",
    phone: "Telephone",
    solveProblem: "Finish the issue",
    escalatedTo: "Escalated to",
    askRevertTicket: "Package Withdrawal Request",
    failedToDeliver: "Failed Delivery Package",
    refute: "Delivery Dispute",
    infobar: {
      alreadyReported:
        "This STT number has already been reported. Check the details to track the report.",
      reportLimit: "You can no longer report any issues!",
      issue: "The issue",
      prohibitedReport: "can no longer be reported.",
      seeDetail: "See details"
    }
  },
  bookingShipment: {
    appsMarketplace: {
      title: "App & Marketplace Booking",
      emptyHeader: "No shipment/booking ID data yet",
      emptyMessage: "Add shipment/booking ID first.",
      scanLabel: "Shipment/booking ID",
      instantToggle: "Enable Instant booking",
      tooltipScan: "Scan will directly complete booking",
      placeholderScan: "Enter or scan shipment/booking ID",
      buttonAdd: "Add",
      errorAddFailed: "Adding shipment ID failed !",
      totalShipmentStt: "Total Shipment/STT",
      successBooked: "Successfully booked",
      successBookedCount: "Successfully booked ({n})",
      notBooked: "Not booked",
      notBookedCount: "Not booked ({n})",
      failedBooked: "Failed to book",
      failedBookedCount: "Failed to book ({n})",
      sortOldest: "Oldest",
      sortNewest: "Newest",
      printAll: "Print all",
      printThermalResi: "Print thermal receipt PRN",
      printThermalPdf: "Print thermal receipt PDF",
      printResiA4: "Print receipt A4 PDF",
      receiptA6: "Receipt A6",
      receiptA4: "Receipt A4",
      printReceiptA6: "Print A6",
      printReceiptA4: "Print A4",
      addAddress: "Add recipient/address",
      importantInformation: "Important Information",
      agreementCommodityMatch:
        "I agree that the commodity in the package matches the commodity stated in the shipment detail information in the system.",
      agreementCommodityDefault:
        "I agree that if no commodity is stated in the shipment detail information in the system, it will be categorized as General commodity.",
      agreementForbiddenCommodity:
        "I agree that the commodity being shipped is not a prohibited commodity for shipment.",
      viewDetails: "View details.",
      confirmBookingAgreement:
        "By this I agree and want to continue the booking process.",
      continueBooking: "Continue booking",
      skipBooking: "Skip booking",
      no: "No",
      shipmentBookingId: "Shipment/Booking ID",
      noStt: "STT No.",
      productType: "Product type",
      chargeableWeight: "Chargeable weight",
      weightPieces: "Weight/Pieces",
      dimension: "Dimension",
      totalTariff: "Total tariff",
      bookingStatus: "Booking status",
      action: "Action",
      dataNotFound: "Data not found",
      filterNotMatch: "Please ensure the selected filters are correct",
      success: "Success",
      unbooked: "Unbooked",
      failed: "Failed",
      failedWithReason: "Failed: {reason}",
      piece: "piece"
    },
    column: {
      sttRecipientEmail: "Recipient Email",
      sttIdentityNumber: "Recipient ID Number",
      sttInterTaxNumber: "Recipient Tax ID Number",
      sttDutyTaxTerms: "Customs & Tax Payment",
      detailShipment: "Shipment Details",
      manualSttNumber: "Manual STT Number",
      noStt: "No. STT",
      externalRefNumber: "External Reference Number",
      shipmentId: "Shipment ID",
      shipperName: "Shipper Name",
      recipientName: "Recipient Name",
      shipperNameBookingNew: "Name",
      recipientNameBookingNew: "Name",
      shipperPhoneNumber: "Shipper Phone Number",
      recipientPhoneNumber: "Recipient Phone Number",
      shipperAddress: "Shipper Address",
      saveSender: "Save shipper data",
      saveReceiver: "Save recipient data",
      recipientAddress: "Recipient Address",
      districtOriginCity: "District, Origin City",
      districtDestinationCity: "District, destination city ",
      postalCode: "Postal code",
      itemDetails: "Item Details",
      selectServiceType: "Select Service Type",
      commodity: "Commodity",
      insurance: "Insurance",
      itemPrice: "Item Price",
      crossBorderInformation: "Cross-Border information",
      taxIdentificationNumber: "Tax Identification Number (TIN)",
      ftzIdNumber: "ID number",
      ftzEmail: "Email",
      shipmentStatus: "Shipment Status",
      additionalInformation: "Additional Information",
      additionalInterpack: "(Only INTERPACK)",
      additionalInterpackMaxi: "(Only INTERPACK MAXI)",
      commodityDetails: "Commodity Details",
      logisticsDocumentationPhoto: "Logistics Documentation Photo",
      grossWeight: "Gross Weight",
      dimensionsPackage: "Dimensions/Package",
      dimensionWeight: "Dimension Weight",
      totalItem: "Total Item",
      totalGrossWeight: "Total Gross Weight",
      totalDimensionWeight: "Total Dimension Weight",
      chargeableWeight: "Chargeable Weight",
      home: "Home",
      office: "Office",
      photo: "Photo",
      paymentMethod: "Payment Method",
      clientName: "Client Name",
      woodPacking: "Woodpacking",
      piecePerPack: "Piece Per Pack",
      nextCommodity: "Next Commodity",
      codFeeOptional: "Cod Fee",
      protection: "Protection",
      shippingProtection: "Shipping protection",
      titleCIPL: "Item details for CIPL (Commercial Invoice and Packing List)",
      detailitemCIPL: "Item details",
      quantityCIPL: "Quantity",
      priceCIPL: "Item price",
      numberShipment: "Shipment Number",
      codAmount: "COD Amount",
      codType: "COD Type",
      photoSupportWeightChange: "Supporting photos for weight change"
    },
    shipment: {
      chargeableWeight: {
        label: "Chargeable Weight",
        detail: "Weight details",
        totalItem: "Total items",
        totalGrossWeight: "Total gross weight",
        totalDimensionWeight: "Total dimension weight"
      }
    },
    detail: {
      sttInfo: "STT Information",
      shipperSection: "Shipper",
      recipientSection: "Recipient",
      intlShipmentDetail: "International shipment details",
      freeTradeZone: "Free trade zone",
      commercialInvoice: "Commercial Invoice",
      viewData: "View Data",
      currentStatus: "Current Status",
      createdFor: "Created For",
      shipperAddress: "Address",
      shipperPhoneNumber: "Phone Number",
      recipientAddress: "Address",
      recipientPhoneNumber: "Phone Number",
      addressType: "Address Type",
      serviceType: "Service Type",
      totalPieces: "Total Items (Pieces)",
      totalChargeableWeight: "Total Chargeable Weight",
      itemPriceEstimate: "Item Price Estimate",
      shipmentInsurance: "Shipping Protection",
      bookedBy: "Booked By",
      billedTo: "Billed to",
      source: "Source",
      returnDO: "Return DO",
      dimensions: "Dimensions (L x W x H)",
      troubledStatus: "Troubled Status",
      rejectedDate: "Rejected Date",
      modifiedDate: "Modified Date",
      createdDate: "Created Date",
      printReceipt: "Print Receipt",
      printThermalReceipt: "Print Thermal Receipt",
      printThermalReceiptPDF: "Print Thermal Receipt PDF",
      PrintBasic: "Print Basic/Save to PDF",
      PrintCommercialInvoice: "Print Commercial Invoice",
      bookedVia: "Booked Via",
      estimatedArrivalTime: "Estimated arrival time"
    },
    bulkPrint: {
      allDataDisplayed: "All data displayed"
    },
    action: {
      addItems: "Add Items",
      saveShipperData: "Save shipper data",
      saveRecipientData: "Save recipient data",
      cancelBooking: "Cancel Booking",
      editBooking: "Edit Booking",
      buttonQuit: "Quit",
      buttonStay: "Stay Here"
    },
    weightPieces: {
      no: "No",
      remove: "Delete",
      weightAbove: "Weights above",
      charged: ", and you cannot add more items.",
      infobarWeightComma:
        "Use a dot (.) for weights <1 kg. Example: 0.5 for 500 grams.",
      error: {
        mandatoryWeight: "Gross weight required",
        prohibitedOnePiece: "are allowed only for one item.",
        changeWeightOrNewBooking: "Change the weight or create a new booking."
      }
    },
    placeholder: {
      shipperName: "Enter name",
      shipperPhoneNumber: "Enter phone number",
      recipientName: "Enter name",
      shipperAddress: "Enter address",
      recipientAddress: "Enter address",
      districtOriginCity: "Input & select district, origin city",
      districtDestinationCity: "Enter & select district, destination city",
      postalCode: "Enter & select postal code",
      commodity: "Type and select commodity name",
      itemPrice: "Minimum item price is RM3.2",
      taxIdentificationNumber: "00.00000000000",
      shipmentStatus: "Select shipment status",
      commodityDetails: "Input commodity details",
      dimensionsPackage: "L x W x H",
      codFee: "Minimum cod fee is RM3.2",
      email: "Enter recipient email",
      sttIdentityNumber: "Enter recipient identity number",
      sttInterTaxNumber: "Enter recipient tax ID",
      shipmentId: "Enter shipment ID"
    },
    description: {
      logisticsDocumentationPhotoOne:
        "Supporting photos should include pre-packing, post-packing images of the package, and sender's TIN/ID Card.",
      logisticsDocumentationPhotoTwo:
        "Max file size: 5 MB, Format: jpg, png. Recommended dimensions: 2:4 (e.g., 200px X 800px). Standard logistics requirements"
    },
    product: {
      tagline: "International Shipment",
      sla: "working days",
      descAgent: "Agent Disc",
      zeroCurrency: "RM-"
    },
    validate: {
      uploadPhotos: "Please upload minimal 3 photos",
      itemPrice: "Minimum item price is RM3.2"
    },
    estimation: {
      totalCost: "Total Cost",
      title: "Payment Details",
      cityRate: "City Rate",
      forwardRate: "Forward Rate",
      shipmentRates: "Shipment Rates",
      commoditySurcharge: "Commodity Surcharge",
      weightAdditionalCharge: "Weight Additional Charge",
      additionalDocumentCost: "Additional Document Cost",
      woodpackingCost: "Woodpacking Cost",
      additionalCost: "Additional Cost",
      codFee: "COD Fee",
      padFee: "PAD Fee",
      insurance: "Protection",
      adminCost: "Admin Fee",
      shippingProtectionFee: "Protection",
      taxEstimate: "Tax Estimate",
      returnCost: "Return Cost",
      protection: "Shipping protection"
    },
    payment: {
      title: "Payment Method",
      cash: "Cash",
      choose: "Select payment method",
      disable: {
        invoiceLimitFrozen: "Billing limit is temporarily unavailable."
      }
    },
    bookButton: {
      printLater: "Booking, Print Later ",
      printThermal: "Booking, Print Thermal STT",
      printThermalPdf: "Booking, Print Thermal STT PDF",
      printBasic: "Booking, Print Basic/Save to PDF",
      failedBook: "Booking Failed !"
    },
    placeholderSelect: {
      selectDistrictOriginCity: "Select district, origin city",
      SelectDistrictDestinationCity: "Select district, destination city",
      SelectclientPartner: "Select client/partner",
      selectDate: "Select date"
    },
    list: {
      tabBookingList: "Booking list",
      searchStt: "Search for STT number",
      handoverSummary: "Handover summary",
      dataUpdatedEvery10Min: "Data updated every 10 minutes",
      refresh: "Refresh",
      handoverStiNow: "Handover STI now, <br /> avoid being late!",
      handoverStiLate: "Handover STI late, process now!",
      emptyHeaderMessage: "No booking list yet",
      emptyHeaderMessageFiltered: "Data not found",
      emptyMessage: "Start booking your customer shipments.",
      emptyMessageFiltered: "Check and reset your search",
      createBooking: "Create Booking",
      bookingRetail: "Booking Retail",
      bookingClient: "Client Booking",
      others: "Others",
      bookingAppMarketplace: "App & marketplace booking",
      bookingInstant: "Instant booking",
      copySttNumber: "Copy STT number",
      trackShipment: "Track shipment",
      reportIssue: "Report issue",
      printThermalResiPdf: "Print thermal receipt PDF",
      printResiA4Pdf: "Print receipt A4 PDF",
      printCommercialInvoice: "Print Commercial Invoice",
      copySttSuccess: "STT number copied to clipboard",
      adjustmentAccepted: "Accepted",
      adjustmentRejected: "Rejected",
      adjustmentPending: "Pending",
      filter: {
        bookingPeriod: "Period",
        BookedFor: "Booked For",
        shipperPhoneNumber: "Shipper Phone Number",
        recipientPhoneNumber: "Recipient Phone Number",
        serviceType: "Service Type",
        selectServiceType: "Select service type",
        selectStatus: "Select status",
        status: "Status",
        shipmentInsurance: "Shipment Insurance",
        statusAdjusted: "STT Adjusted",
        statusAdjustedPod: "STT Adjusted POD",
        assessmentStatusAll: "All",
        assessmentStatusWaiting: "Waiting",
        assessmentStatusRejected: "Rejected",
        assessmentStatusApproved: "Approved"
      },
      table: {
        noSTTGenesis: "STT Genesis No.",
        shipmentID: "Shipment ID",
        noSttAndShipment: "STT No.",
        noShipment: "Shipment No.",
        destinationAddress: "Destination Address",
        status: "Status",
        bookingDate: "Booking Date",
        totalPieces: "Total Pieces",
        totalWeight: "Total Weight",
        serviceType: "Service Type",
        serviceTypeAndChargeableWeight: "Service type",
        chargeableWeight: "Chargeable weight",
        commodity: "Commodity",
        createdFor: "Created For",
        insurance: "Insurance",
        troubledStatus: "Troubled Status",
        clientName: "Client Name",
        lastStatus: "Last Status",
        bookedFor: "Booked for",
        destinationCity: "Destination city",
        atur: "Actions"
      },
      action: {
        createBooking: "Create Booking",
        edit: "Edit Booking",
        thermalReceipt: "Print Thermal STT",
        thermalPdf: "Print Thermal STT  PDF",
        basicPdf: "Print Basic/Save to PDF"
      }
    },
    tooltip: {
      manualStt: "Manual STT (Optional)",
      manualSttMsg: "Input this field if you want to use manual STT",
      insurance: "",
      insuranceMsg: "Protection fees follow applicable terms and conditions.",
      tax: "Tax Identification Number (TIN)",
      taxMsg:
        "Taxpayers can be individuals or companies according to those who have been registered.",
      shipmentStatus: "Shipment Status",
      shipmentStatusMsg: "Input the condition of the goods",
      detailCommodity: "Commodity Details",
      detailCommodityMsg:
        "Input detailed information about the shipment commodity",
      weight: "Gross Weight (kg)",
      weightMsg:
        "Minimum item weight is 1 kg. Input decimal with “.” if needed",
      updateCost: "Update Cost",
      shipmentId: "Only for Corporate Pickup (CP) shipment booking"
    },
    error: {
      noRef: "External Reference Number is required",
      minimumRef: "External reference number must be at least 3 digits.",
      senderName: "Shipper name is required",
      recipientName: "Recipient name is required",
      senderNamePhone: "Shipper phone number is required",
      recipientNamePhone: "Recipient phone number is required",
      invalidNumber: "Invalid phone number. Check & reset",
      senderAddress: "Shipper address is required",
      recepientAddress: "Recepient address is required",
      destination: "District, destination city is required",
      addressType: "Address type is required",
      postalCode: "Postal code is required",
      commodity: "Commodity is required",
      mandatoryCommodity: "Commodity is required",
      itemPrice: "Item price is required",
      detailCommodity: "Commodity details are required",
      serviceType: "Service type is required",
      embargoStatus: "Destination city of the shipment is still Embargo status",
      sameOriginDestination:
        "Shipper and recipient addresses cannot be the same",
      phoneCountryCode: "Input country code correctly",
      phoneCharacter: "Phone number must not be less than 5 characters",
      inactiveCity: "Inactive City and/or District",
      inactiveCommodity: "Inactive commodity",
      commodityNotFound: "Data not found",
      insurance: "Shipment insurance is required",
      inactiveInsurance: "Inactive insurance",
      shipmentStatus: "Shipment status is required",
      uploadPhoto:
        "Failed to upload Photo {value} to storage. Please delete it and try again.",
      weightMaximum:
        "Total weight of goods exceeds the maximum limit of 400 kg/STT",
      totalPayment: "Total Payment",
      additionalInfoEmailRequired: "Recipient email is required",
      additionalInfoEmailFormat: "Invalid email format",
      sttIdentityNumberRequired: "Recipient identity number is required",
      sttIdentityNumberMaxLength:
        "Recipient ID number maximum length is 100 characters",
      sttInterTaxNumberRequired: "Recipient tax ID is required",
      sttInterTaxNumberMaxLength:
        "Recipient tax ID number maximum length is 100 characters",
      embargo: "Route is embargo",
      routeNotFound: "Route not available",
      exceedMaxWeightCheck:
        "The total weight of the goods exceeds the maximum limit of 400kg/STT, check & change again."
    },
    message: {
      updated: "has been updated"
    },
    filter: "Filter",
    filterLabels: {
      bookingPeriod: "Booking period",
      dateRange: "From date - to date",
      dateRangeLabel: "Date range",
      originDistrictCity: "District, origin city",
      destinationDistrictCity: "District, destination city",
      bookedFor: "Booked for",
      selectClientPartner: "Select client/partner",
      senderPhone: "Sender phone number",
      receiverPhone: "Receiver phone number",
      shipmentType: "Product type",
      selectShipmentType: "Select product type",
      status: "Status",
      selectStatus: "Select status",
      troubledStatus: "Troubled status",
      finalStatus: "Final status",
      ongoingStatus: "Ongoing status",
      deliveryServiceType: "Delivery service type",
      shippingProtection: "Shipping protection",
      yes: "Yes",
      no: "No",
      apply: "Apply"
    }
  },
  bookingShipmentV2: {
    action: {
      duplicateRetail: "Duplicate STT for retail",
      duplicateClient: "Duplicate STT for client"
    }
  },
  bookingCbp: {
    tabTitle: "Client CBP Booking List",
    banner:
      "<strong>IMPORTANT!</strong> Search and select client name first <strong>before creating manifest.</strong>",
    bannerSearchClientFirst:
      "<strong>IMPORTANT!</strong> Search and select client name first <strong>before creating manifest.</strong>",
    searchPlaceholder: "Search client name",
    placeholderSearchClient: "Search or select client name",
    createManifest: "Create Manifest",
    buttonCreateManifest: "Create Manifest",
    emptyHeader: "No Client CBP Booking List",
    emptyMessage: "Start creating Client CBP booking list and check it here",
    emptyListMessage: "No client CBP booking list yet",
    statusAll: "All",
    statusUnprinted: "Not yet manifested",
    statusPrinted: "Manifested",
    copySttTooltip: "Copy STT number",
    tooltipCopyStt: "Copy STT number",
    copyNotification: "STT number copied to clipboard",
    copySttSuccess: "STT number copied to clipboard",
    columnStt: "STT No.",
    columnStatusManifest: "Manifest status",
    errorPrintManifest: "Failed to Print Manifest!",
    sidebarMenuName: "Corporate Booking (CBP)",
    manifest: {
      posName: "POS Name",
      posCity: "POS origin city",
      pickUpDate: "Pick Up Date",
      clientName: "Client name",
      clientCity: "Client origin city",
      totalStt: "Total STT",
      totalPieces: "Total Pieces",
      totalWeight: "Total Gross Weight",
      docTitle: "CBP Client Manifest",
      origin: "Origin"
    }
  },
  "Packing Kayu": "Woodpacking",
  "Biaya Packing Kayu": "Woodpacking Charge",
  "Biaya Tambahan": "Additional Charge",
  required: "is required",
  selecDate: "Select date",
  chooseHub: "Choose HUB",
  chooseSelected: "Selected",
  bagging: {
    koli: "Pieces",
    chargeableWeightReweigh: "Chargeable weight (Reweigh)",
    totalSttKoli: "Total STT (pieces)",
    placeholderSearch: "Search No. Bag",
    titleButtonCreate: "Create Bagging",
    disputeSummaryTitle: "BAG with weight dispute",
    disputeSummaryDataRange: "Data",
    disputeSummaryCount: "({0}%) BAG",
    bagWithWeightDispute: "Bag with weight dispute",
    proses: "Process",
    noBagging: "No. Bagging",
    toReadyToCargo: "to Ready for Cargo",
    hapus: "Delete",
    fromReadyToCargo: "from Ready for Cargo",
    modalTitleSTTPaid: "Ensure STT Number is Paid",
    modalMessageSTTPaid:
      "Verify adjusted or overweight STT numbers are fully paid",
    ok: "OK",
    emptyStateMessage: "No bagging data to display yet",
    noBag: "No. Bag",
    totalSTT: "Total STT",
    beratBagDikenakanBiaya: "Chargeable bag weight",
    totalBeratKotorBag: "Total bag gross weight",
    totalBeratVolumeBag: "Total bag volume weight",
    totalSttGrossWeight: "Total STT gross weight",
    totalSttVolumeWeight: "Total STT volume weight",
    buktiFotoPerubahan: "Photo proof of changes",
    grossWeight: "Gross Weight",
    volumeWeight: "Volume Weight",
    destinationCity: "Destination City",
    payment: "Payment",
    woodpacking: "Woodpacking",
    commodity: "Commodity",
    totalPieces: "Total pieces",
    CodAmount: "COD amount",
    dibuatOlehHub: "Created by HUB",
    action: "Action",
    printPdf: "Print PDF",
    printLabel: "Print Label",
    downloadExcel: "Download Excel",
    codFee: "COD Fee",
    totalKoli: "Total Pieces",
    komoditas: "Commodity",
    tableTitle: {
      totalSttKoli: "Total STT & pieces",
      partnerName: "Partner Name",
      userType: "User Type",
      destinationType: "Destination City",
      baggingDate: "Bagging Date",
      totalPieces: "Total Pieces",
      notFoundSTTBagging: "STT/Bagging No. not found",
      weightGross: "Weight Gross",
      totalSTTDG: "Total STT DG",
      serviceType: "Service Type",
      updatedBy: "Updated by",
      createdBy: "Created by"
    },
    createdBaggingDate: "Created Date",
    chargeableWeightStt: "Chargeable weight (STT)",
    chargeableWeight: "Chargeable weight",
    printBagging: "Print Bagging",
    ubah: "Edit",
    noStt: "STT No.",
    baggingConfirmationTitle: "Create Bagging?",
    rtcBaggingConfirmationTitle: "Continue Bagging Process?",
    rtcBaggingConfirmationMessage:
      "Bagging will be added to the Ready for Cargo list",
    baggingConfirmationEditTitle: "Save Changes?",
    baggingConfirmationEditSub:
      "Save the Bagging detail changes with No. {bagNo}",
    editBagging: "Save Bagging",
    editBaggingAndPrint: "Save Bagging & Print Label",
    successEditBagTitle: "Detail Bag No {bagNo} was changed",
    rtcTitleContinue: "Continue process to",
    rtcTitleRemove: "Remove Bagging from",
    rtcSubtitleContinue: "Bag No. will be updated and added to the list",
    rtcSubtitleRemove: "Bag No. will be removed from the list",
    confirmRtcProcessTitle: "Continue process to Ready for Cargo?",
    confirmBaggingDeleteTitle: "Remove Bagging from Ready for Cargo?",
    confirmRtcProcessMessage:
      "Bag No. will be automatically updated and added into the Ready to Cargo list",
    confirmBaggingDeleteMessage:
      "Bag No. will be removed from the Ready to Cargo list",
    rtcTitleErrorUpdate: "Bag No. failed to update",
    rtcTitleErrorDelete: "Bag No. failed to delete",
    rtcSubtitleErrorUpdate: "Bag No. failed to be added to the list",
    rtcSubtitleErrorDelete: "Bag No. failed to be removed from the list",
    rtcModalPartialTitle: "Some bagging failed to be ready for cargo",
    rtcModalPartialMessage:
      "Some STT status in bag is invalid. Please check & download bag",
    rtcModalConfirmBoth: "Continue process & remove to Ready for Cargo?",
    rtcModalConfirmMessage: "Ensure selected Bag No. is correct",
    rtcKembali: "Back",
    rtcLanjutkan: "Continue",
    rtcHapus: "Delete",
    rtcSiapDikargo: "Ready for Cargo",
    rtcSuccessProcess: "Bagging will be processed",
    rtcSuccessAndDeleted: "and deleted",
    rtcSuccessRTC: "RTC",
    rtcSuccessDeleteTitle: "Bag No. successfully deleted",
    rtcSuccessDeleteMessage:
      "Bag No. has been removed from Ready for Cargo list",
    rtcSuccessMessage: "View your bagging during cargo booking process",
    rtcErrorBothTitle: "Add and remove Bag No. failed",
    rtcErrorBothMessage: "Add and remove Bag No. failed.",
    rtcErrorSiapDikargo: "Ready for Cargo",
    rtcSttUnpaidTitle: "Some Bag No. failed to process",
    rtcSttUnpaidMessage:
      "Overweight and underpaid. Wait until customer settles the bill",
    downloadBagFailedNoBag: "Bag No.",
    downloadBagFailedNoStt: "STT No.",
    downloadBagFailedStatus: "Last STT/Bag status",
    downloadBagFailedReason: "Failure reason",
    belumSiapDikargo: "Not ready to cargo",
    siapDikargo: "Ready to cargo",
    placeholderAdd: "Example: STT: 99LP1234567890123",
    secondPlaceholderAdd: "Input No. STT/Shipment/Bag",
    editDimensionInfo: "Edit if dimension changes",
    volumeWeightBag: "Bag volume weight",
    chargeableWeightBag: "Chargeable bag weight",
    errorBagExceed: "Bag weight exceeds STT weight.",
    kotaAsal: "Origin City",
    kotaTujuanBag: "Bag Destination City",
    createdBy: "Created by",
    createdDate: "Created Date",
    updatedBy: "Updated by",
    updatedDate: "Updated Date",
    bagGrossWeight: "Bag gross weight",
    bagVolumeWeight: "Bag volume weight",
    createSuccessTitle: "Bagging Creation Successful!",
    createSuccessMessage: "Bagging was created.",
    createRtcSuccessTitle: "Bagging Ready for Cargo Creation Successful!",
    createRtcSuccessMessage:
      "Bagging was created and will be updated to Ready for Cargo",
    createPartialMessage:
      "Some STT numbers were successfully grouped into Bagging, but some STTs failed.<br />Please download to see the errors.",
    createFailedTitle: "Bagging Creation Failed!",
    createFailedMessage: "Failed to create Bagging.",
    scanSttFailedTitle: "Scan STT No. Failed",
    addSttFailedTitle: "Add STT No. Failed",
    updateSuccessTitle: "Changes Saved!",
    updatePartialTitle: "Status Update Successful!",
    updatePartialMessage:
      "Some STT statuses were successfully updated to Bagging, but some STTs failed.<br />Please download to see the errors.",
    updateFailedTitle: "Status Update Failed!",
    updateFailedMessage: "Bagging status change failed.",
    successAddSttNumber: "Successfully added STT number!",
    yes: "Yes",
    no: "No",
    scanFailedListTitle: "Failed scan list",
    excel: {
      title: "Failed scan list",
      noStt: "STT/Bag No.",
      status: "Last STT/Bag status",
      reason: "Failure reason"
    }
  },
  "Tanggal Bagging": "Bagging Date",
  "Tipe User": "User Type",
  "Terjadi Kendala pada proses pengiriman? Hubungi Customer Service 021-80820072\natau hubungi Origin yang bersangkutan.":
    "Problems with the shipment process? Contact Customer Service 021-80820072\nor contact the relevant origin city.",
  Pilih: "Choose",
  "No. Seri Kendaraan/</br>Penerbangan": "No. Vehicle Machine/</br>Flight",
  "Jam Keberangkatan</br>- Kedatangan": "Departure</br>- Arrival Hour",
  hari: "day",
  "Pilih Tipe Kargo": "Choose Cargo Type",
  Pesawat: "Plane",
  Truk: "Truck",
  Kereta: "Train",
  Kapal: "Ship",
  "Booking Kargo": "Cargo Booking",
  "Proses Kargo": "Cargo Process",
  Periksa: "Check",
  "Masukan No. kargo": "Input cargo number",
  "No. Kargo": "Cargo Number",
  "Total Berat</br>Kotor": "Total Actual Cargo</br>Gross Weight",
  "Total Berat</br>Volume": "Total Actual Cargo</br>Dimension Weight",
  "Oops.. Belum ada data yang dapat ditampilkan": "Oops.. No data to show yet",
  OKE: "OK",
  "Buat Pickup": "Create Pick Up",
  "Nama POS": "POS Name",
  "Tanggal Pickup": "Pick Up Date",
  "Nama Vendor/Partner": "Vendor/Partner Name",
  "No. Seri Kendaraan": "Vehicle Number",
  "Nama Kurir": "Courier Name",
  "No. Telp Kurir": "Courier Phone Number",
  "Nama Driver": "Driver Name",
  "No. Telp Driver": "Driver Phone Number",
  "Pos/Pengirim": "Pos/Shipper",
  Tanggal: "Date",
  "Terjadi Kendala Pada Paket Kiriman Anda ? Hubungi Tim Klaim Kami Melalui":
    "Problems with your shipment? Contact our claims team via",
  manifest: {
    product: "Service\nType"
  },
  "S&K": "T&C",
  "Buat Pickup Manifest": "Create a Pick Up Manifest",
  "Pilih atau masukan nama driver": "Select or input a driver name",
  "Masukan nama driver": "Input a driver name",
  "Masukan no. telp driver": "Input a driver phone number",
  "Pilih atau masukan No. seri kendaraan": "Select or input vehicle number",
  "Masukan No. seri kendaraan": "Input vehicle number",
  "Tanggal STT": "STT Date",
  "Masukan No. STT atau Scan Barcode/QR Code untuk<br/>barang yang ingin dihapus dari daftar Pickup.":
    "Input STT Number or Scan Barcode/QR Code for the item</br>you want to delete from the Pickup Manifest list.",
  "Data Kendaraan sudah ada": "Vehicle data already exists",
  "Tambah Driver": "Add Driver",
  "Tambah No. Seri Kendaraan": "Add Vehicle Number",
  "No. Seri": "Vehicle Number",
  oleh: "by",
  "Terjadi gangguan sistem": "A system error occurred",
  "Klik Muat ulang atau coba beberapa saat lagi.":
    "Click Reload or try again later.",
  "Muat ulang": "Reload",
  "Jaringan internet terputus": "The internet network is down",
  "Periksa jaringan internal Anda lalu klik Muat ulang.":
    "Check your internal network then click Reload.",
  "Lebih sedikit": "See less",
  Selengkapnya: "See more",
  Lampiran: "Attachment",
  Pickup: "Proses PUP",
  "Pickup Manifest": "Pick Up Manifest",
  "Lanjutkan Proses ke": "Continue Process to",
  "Hapus Bagging dari": "Remove Bagging from",
  "No. Bagging akan otomatis terupdate dan masuk ke daftar":
    "No. Bagging will be automatically updated and entered into the list",
  "No. Bagging akan otomatis terhapus dari daftar":
    "No. Bagging will be automatically removed from the list",
  "No. Bagging Gagal Diupdate": "Bagging No. Failed to Update",
  "No. Bagging Gagal Dihapus": "No. Bagging Failed to Delete",
  "No. Bagging telah gagal ditambahkan ke daftar":
    "No. Bagging has failed to be added to the list",
  "No. Bagging telah gagal terhapus dari daftar":
    "No. Bagging has failed to be removed from the list",
  "Lanjutkan Proses & Hapus ke Siap Dikargo?":
    "Continue Process & Clear to Ready to Cargo?",
  "Siap Dikargo?": "Ready to be Cargoed?",
  "Pastikan No. Bagging yang dipilih telah sesuai":
    "Make sure No. The bagging selected is appropriate",
  "Siap Dikargo": "Ready to Cargo",
  Lanjutkan: "Continue",
  "Nomor Bag": "Bag Number",
  "Nomor STT": "STT Number",
  "Status Terakhir STT/Bag": "Last Status of STT/Bag",
  "Alasan Gagal": "Failed Reason",
  pickup: {
    confirmTitleCreate: "Create Pick Up Manifest?",
    confirmTextSuccess: "Create",
    activePickupWarning: {
      title: "Continue with a new Pick Up request?",
      body:
        "The system will add the new shipment while the previous shipment remains active.",
      buttonBack: "Back",
      buttonConfirm: "Continue"
    },
    cancel: {
      button: "Cancel",
      confirm: {
        title: "Are you sure you want to cancel the shipment?",
        instruction: "Enter the cancellation reason before proceeding.",
        reasonPlaceholder: "Cancellation reason",
        back: "Cancel",
        continue: "Continue",
        charCounter: "{current}/{max}"
      },
      success: {
        title: "Shipment successfully cancelled",
        body: "The shipment cancellation has been successfully processed.",
        close: "Close"
      },
      failed: {
        title: 'Failed to cancel "{shipmentId}"',
        body: "Pick up cancellation failed. Please check and try again.",
        back: "Back",
        retry: "Retry"
      },
      sidebar: {
        reasonLabel: "Cancellation reason"
      }
    },
    bookingSummary: {
      titleSuggestion: "Pick Up recommendation",
      titleBucket: "Ready to pick up",
      changeAddress: "Change address",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Nearest schedule:",
      viewStt: "View AWB",
      viewActivePickup: "View active Pick Up {count}",
      empty:
        "Pick Up request data is not yet available. Please create a Pick Up manually.",
      createManual: "Create Pick Up Manual",
      piece: "pcs",
      wood: "WOOD",
      addressIsEmpty: "Pick Up address has not been added yet.",
      addAddress: "Add address"
    },
    scheduleConfig: {
      pageTitle: "Set Pick Up schedule",
      breadcrumb: {
        parent: "Pick Up Schedule Configuration"
      },
      sidebar: {
        addressTitle: "Pick Up Address",
        changeAddress: "Change address",
        addAddress: "Add address",
        saveSchedule: "Save schedule",
        defaultBadge: "Primary",
        coordinatesLabel: "Coordinate point:",
        empty: "No saved address yet"
      },
      shipment: {
        sectionTitle: "Shipment Information",
        estimateAdditionalKoli: "Estimated additional pieces",
        estimateWeight: "Estimated weight",
        weightSuffix: "kg",
        serviceType: "Shipping service",
        placeholderKoli: "Enter estimated additional pieces",
        placeholderWeight: "Enter estimated weight",
        placeholderService: "Select shipping service"
      },
      scheduleSectionTitle: "Pick Up Schedule",
      regular: {
        title: "Regular schedule",
        tooltip:
          "The latest Pick Up schedule will be applied starting tomorrow.",
        maxSlotsNote: "(Max. 3 schedules per day.)",
        addTime: "Add time",
        emptySlots: "No time selected",
        popoverTitle: "Select Pick Up time",
        durationFooter: "Duration 1 hour",
        duplicateTime: "This time has already been added",
        confirmTime: "Select",
        emptyTimeOptions: "No time options available",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        }
      },
      special: {
        modalTitle: "Select Pick-up schedule",
        pickDateLabel: "Select date",
        pickTimeLabel: "Select time",
        save: "Save",
        duplicateDate: "This date has already been added",
        modalMaxSlotsNote: "Max. 3 schedules per day.",
        title: "Special schedule",
        tooltipTitle: "Special Schedule",
        tooltipDescription:
          "Special schedules will override regular schedules on the selected dates.",
        maxDatesNote: "(Max. 3 dates.)",
        addDate: "Select Pick-up date",
        reset: "Reset",
        addTime: "Add time"
      }
    },
    requestSuccess: {
      title: "Pick Up request sent",
      description: "Pick Up request with Order ID",
      description2: " has been created.",
      summary: {
        totalLabel: "Total request",
        totalValue: "{totalKoli} pcs • {totalWeightKg} kg",
        dateLabel: "Pick Up date",
        timeLabel: "Pick Up time"
      },
      button: {
        close: "Close",
        viewDetail: "View detail",
        viewDetailAWB: "View detail"
      }
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Create Manual Pick Up"
      },
      banner: {
        sttPrefix: "You have ",
        sttSuffix: " that can be processed.",
        viewAll: "View all"
      },
      field: {
        addressLabel: "Pick Up address",
        koliLabel: "Estimated pcs",
        koliPlaceholder: "Enter pcs",
        weightLabel: "Estimated weight",
        weightPlaceholder: "Enter weight",
        weightUnit: "kg",
        serviceLabel: "Shipping service",
        servicePlaceholder: "Select shipping service",
        dateLabel: "Date",
        timeLabel: "Time",
        courierNoteLabel: "Note for courier",
        courierNotePlaceholder: "Enter note"
      },
      specialHandling: {
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        woodPacking: "Wood Packing"
      },
      address: {
        mainBadge: "Main",
        coordinate: "Coordinat points: {lat}"
      },
      addressEmpty: "Choose pick up address",
      addressListTitle: "Address list",
      recommendationLabel: "Recommended pieces and weight",
      recommendationChip: "{koli} pcs • {weight} kg",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimated pcs is required",
        weight: "Estimated weight is required",
        date: "Date is required",
        time: "Time is required",
        service: "Shipping service is required",
        address: "Pick up address is required"
      },
      changeAddress: "Change address",
      chooseAddress: "Choose address",
      addAddress: "Add address",
      timePlaceholder: "Select Pick Up time",
      back: "Back",
      retry: "Retry",
      submit: "Request",
      sttListTitle: "List of Airway Bill available for Pick Up ({count})",
      sttListEmpty: "List of Airway Bill is not available yet",
      success: {
        title: "Pick Up request sent successfully",
        message: "Pick Up will be processed by the courier shortly.",
        button: "OK, got it"
      },
      error: {
        title: "Pick Up request failed",
        message: "Please try again in a few moments.",
        button: "Close"
      }
    },
    detail: {
      printLabel: "Print label",
      dhlCourierNamePrefix: "[DHL Courier]",
      labelUnavailable: "Label not available yet",
      header: {
        title: "Detail - {pickupId}",
        woodPacking: "WOOD"
      },
      summary: {
        shared: {
          sttUnit: "AWB",
          koliUnit: "pcs",
          weightUnit: "kg",
          additionalLabel: "+ Additional"
        },
        totalRequest: {
          title: "Total Request"
        },
        totalPickup: {
          title: "Total Pick Up",
          additionalKoli: "Additional {additionalKoli} pcs"
        },
        agentHub: {
          title: "In Transit Hub"
        }
      },
      stt: {
        sectionTitle: "List of Airway Bill Picked Up",
        emptyTitle: "No Airway Bill list yet",
        table: {
          colNo: "No",
          colSttNo: "No. AWB",
          colKoli: "Pcs & Weight",
          colBerat: "Weight",
          weightSuffix: "{weight} kg"
        },
        pagination: {
          caption: "{shown} of {total} data"
        }
      },
      sidebar: {
        title: "Pick Up Status",
        createdAtLabel: "Created date",
        createdBy: "By {name}",
        courierSection: "Courier Information",
        courierEmpty: "Courier not yet assigned",
        proofPhotos: "Proof of Photo",
        merge: {
          infoMessage:
            "This shipment is a merge of {shipmentCount} with total pcs and weight calculated in aggregate.",
          shipmentUnit: "shipments",
          viewLink: "View shipments",
          listTitle: "List of merged shipments",
          listItem: "{shipmentId} ({koliCount} pcs - {weightKg} kg)",
          listItemIdOnly: "{shipmentId}"
        }
      },
      status: {
        waitingCourier: "Waiting for Courier",
        pickUpPackage: "Pick Up Package",
        mergedPickUp: "Merged Pick Up",
        cancelled: "Cancelled",
        done: "Done"
      }
    }
  },
  pickupManifest: {
    breadcrumb: "PUP Process",
    placeholderPickupDate: "Select pickup date",
    inputSttLabel: "Input STT Using",
    scanStt: "Scan STT",
    listBkd: "List BKD",
    exampleStt: "Example: 99LP1234567890123/88-22-12345678",
    buatPickupPrintPdf: "Create Pick Up & Print PDF",
    download: "Download",
    ok: "OK"
  },
  pickupDashboard: {
    menuName: "Pickup Dashboard",
    tabCourierList: "Courier List",
    tabPickup: "Pick Up",
    tabAllPickUp: "All Pick Up",
    searchPlaceholder: "Sender name, sender phone number, Shipment ID",
    shipmentType: "Shipment Type",
    downloadDataCourier: "Courier Data",
    downloadDataPickUp: "Pick Up Data",
    column: {
      no: "No.",
      sttNo: "STT No.",
      shipmentId: "Shipment ID",
      senderName: "Sender Name",
      courierName: "Courier Name",
      shipmentType: "Shipment Type",
      totalShipment: "Total Shipment (koli)",
      totalKoli: "Total Pieces",
      pickUpDate: "Pick Up Date",
      pickUpProof: "Pick Up Proof",
      depositTime: "Deposit Time",
      depositProof: "Deposit Proof",
      bkdDate: "BKD Date",
      cancelDate: "Cancellation Date",
      cancelReason: "Reason",
      proof: "Proof",
      assign: "Assign",
      booking: "Booking",
      remainingTime: "Remaining Time",
      address: "Address",
      transferPickUp: "Transfer Pick Up",
      areaName: "Area Name",
      dedicatedCourier: "Dedicated Courier",
      createdDate: "Created Date",
      createdBy: "Created By",
      lastUpdated: "Last Updated",
      updatedBy: "Updated By",
      action: "Actions"
    },
    transferSuccess: "Transfer Successful",
    transferFailed: "Transfer Failed!",
    transferSuccessMessage:
      "Courier {courierName} has been assigned for Pick Up <b>{packageCount} Package(s).</b>",
    transferPickUp: "Transfer Pick Up",
    transferMultiplePickUp: "Transfer Multiple Pick Up",
    assignPickUp: "Assign Pick Up",
    dataPickUp: "Data Pick Up",
    selectCourier: "Select courier",
    selectCourierPlaceholder: "Select destination courier",
    assign: "Assign",
    totalSender: "Total Senders",
    package: "Package",
    shipment: "Shipment",
    koli: "Pieces",
    sender: "Sender",
    selectedSender: "senders selected",
    selectedShipment: "shipments selected",
    viewDetail: "View Detail",
    viewProof: "View Proof",
    booking: "Booking",
    manualAssign: "Manual Assign",
    multipleManualAssign: "Multiple Manual Assign",
    scheduleAssign: "Set assign schedule",
    date: "Date",
    time: "Time",
    selectTime: "Select time",
    noTimeOptions: "No time options available",
    manualAssignSuccessTitle: "Manual Assign Successful",
    manualAssignSuccessMessage:
      "Courier has been assigned for Pick Up package(s).",
    manualAssignFailedTitle: "Assign Failed",
    manualAssignPartialMessage:
      "{count} shipment(s) were already assigned previously.",
    downloadFailedTitle: "Failed to Download Data!",
    systemError: "A system issue occurred",
    today: "Today",
    yesterday: "Yesterday",
    custom: "Custom",
    selectDate: "Select date",
    bookingPickUp: "Pick Up Booking",
    totalPickUp: "Total Pick Up",
    belumDiPickUp: "Pending Pickup",
    belumDisetor: "Awaiting Handover",
    belumBkd: "Pending Booking",
    sudahBkd: "Already Booking",
    riwayatGagal: "Failed History",
    courier: "Courier",
    waitingAssign: "Waiting Assign",
    belumDiassign: "Awaiting Assignment",
    manageArea: {
      title: "Pick Up Area Management",
      viewYourArea: "View Your Area",
      yourAreaTitle: "Your Area",
      yourAreaData: "your area data",
      setDedicatedCourier: "Set Dedicated Courier",
      assignCourierTitle: "Set Courier",
      setShift: "Set Shift",
      selectCourierPlaceholder: "Select courier",
      noCourierAvailable: "No courier available",
      searchPlaceholder: "Search by ID, Courier name, Area",
      search: "Search",
      sort: "Sort",
      sortAZ: "A - Z",
      sortZA: "Z - A",
      unassignedBanner:
        "{count} sub-district(s) do not have area and dedicated courier yet.",
      createTitle: "Set Dedicated Area",
      save: "Save",
      confirmTitle: "Save Dedicated Area?",
      confirmMessage:
        "The area and dedicated courier you selected will be added. This setting can still be changed.",
      cancel: "Cancel",
      successTitle: "Dedicated Area Added",
      successMessage:
        "The area and dedicated courier you selected have been saved successfully.",
      ok: "OK",
      column: {
        areaName: "Area Name",
        dedicatedCourier: "Dedicated Courier",
        shipmentType: "Shipment Type",
        createdDate: "Created Date",
        createdBy: "Created By",
        lastUpdated: "Last Updated",
        updatedBy: "Updated By",
        action: "Actions"
      },
      transferColumn: {
        no: "No.",
        village: "Sub-district",
        subDistrict: "Sub-district",
        district: "District",
        province: "State"
      },
      subDistrict: "sub-district",
      moreCourier: "courier",
      edit: "Edit",
      transferArea: "Transfer Area",
      transfer: "Transfer",
      transferAreaTitle: "Transfer Area {areaName}",
      destinationAreaLabel: "Select Destination Area",
      destinationAreaPlaceholder: "Select Area",
      noDestinationArea: "No destination area",
      searchSubDistrictPlaceholder: "Search Sub-district",
      transferFailedTitle: "Failed to Transfer Package",
      transferFailedMessage:
        "The system failed to transfer the package(s). Please try again.",
      transferConfirmTitle:
        "Transfer {count} sub-district(s) to district {destinationAreaName}?",
      transferConfirmMessage:
        "If the sub-district is transferred, the area & dedicated courier will follow the destination area settings.",
      confirmTransfer: "Yes, Transfer",
      back: "Back",
      delete: "Delete",
      emptyHeader: "No area data yet",
      emptyHeaderWithUnassigned: "Area and dedicated courier not set yet",
      emptyMessage: "You do not have a dedicated area yet",
      emptyMessageWithUnassigned:
        "Please start setting up area & dedicated courier",
      searchNotFound: "Search results not found",
      searchNotFoundHint: "Please check your keyword or change the filter.",
      deleteSuccess: "Area {areaName} & dedicated courier have been deleted.",
      deleteFailed: "Failed to Delete Data",
      deleteFailedMessage:
        "Please try again and ensure your internet connection is stable.",
      createFailedTitle: "Failed to Set Dedicated Area",
      createFailedDefaultMessage:
        "The system failed to save your area or courier. Please try again.",
      createFailedInternetMessage:
        "Please try again and ensure your internet connection is stable.",
      editSuccess: "Area details have been updated successfully.",
      editFailed: "Failed to Edit Data",
      editFailedDefaultMessage:
        "The system failed to save your changes. Please try again.",
      editFailedInternetMessage:
        "Please try again and ensure your internet connection is stable.",
      leaveConfirmTitle: "Are you sure you want to leave?",
      leaveConfirmMessage:
        "The process in progress will be cancelled and data will be deleted.",
      leaveConfirmSuccess: "Yes, Leave"
    },
    emptyState: {
      noCourier: "No courier data yet",
      noCourierHint: "Please add new couriers in the courier management menu",
      noPackage: "No packages yet",
      noPackageHint: "No packages in this list yet",
      searchNotFound: "Search results not found",
      searchNotFoundHint: "Please check your keyword or change the filter."
    },
    tryAgain: "Try Again",
    partialTransferSuccess: "Partial Transfer Successful",
    partialTransferMessage: "{count} shipment(s) failed to transfer.",
    transferAllFailed: "Transfer Failed",
    transferAllFailedMessage: "{count} shipment(s) could not be transferred.",
    pickUpRemaining: "Pick Up time remaining 30 minutes for {count} seller(s).",
    allTime: "All time",
    dateRangeTitle: "Date Range",
    reset: "Reset",
    downloadData: "Download Data",
    dateRangePicker: {
      selectDate: "Select date",
      customRange: "Custom range",
      last7Days: "Last 7 days",
      last14Days: "Last 14 days",
      last30Days: "Last 30 days",
      allTime: "All time",
      weekdays: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun"
      },
      reset: "Reset",
      apply: "Apply"
    }
  },
  "Transfer Berhasil": "Transfer Successful",
  "Transfer Gagal !": "Transfer Failed!",

  pickupAddress: {
    common: {
      primary: "Default",
      coordinates: "Coordinates",
      select: "Select",
      delete: "Delete",
      back: "Back",
      cancel: "Cancel"
    },
    savedList: {
      title: "List saved address",
      edit: "Edit",
      setPrimary: "Set as default address",
      add: "Add address"
    },
    deleteConfirmation: {
      title: "Delete this address?",
      message: "You will lose this address from the saved address list."
    },
    form: {
      addTitle: "Add new address",
      editTitle: "Edit address",
      addressName: "Address name",
      addressNamePlaceholder: "Enter address name",
      picName: "PIC name",
      picNamePlaceholder: "Enter PIC name",
      phoneNumber: "Phone number",
      district: "District/city",
      districtPlaceholder: "Select district/city",
      pickupAddress: "Pick Up address",
      pickupAddressPlaceholder: "Enter Pick Up address",
      coordinates: "Coordinate points Google Maps",
      coordinatesPlaceholder: "e.g: -6.523523523523",
      findLocation: "Find points",
      setPrimary: "Set as default address",
      submit: "Save"
    },
    guide: {
      link: "View guides",
      title: "Find coordinate points",
      openMapsPrefix: "Open",
      googleMaps: "Google Maps",
      openMapsSuffix: "Open google maps on your laptop/computer.",
      searchLocation: "Search & select the Pick Up address location.",
      copyCoordinates:
        "Right-click on the location & left-click on the coordinate point.",
      coordinatesExample: "(Example: -6.18959, 106.76477)",
      enterCoordinates: "Enter the coordinate point into the provided form."
    },
    success: {
      addedTitle: '"{name}" added successfully',
      editedTitle: '"{name}" updated successfully',
      message: "You can now use this address for Pick Up.",
      button: "OK, got it"
    }
  },
  pickupCorporate: {
    menuPickUp: "Pick Up",
    menuListPickUp: "Pick Up List",
    menuScheduleConfig: "Schedule Configuration",
    menuCreateConfig: "Create new configuration",
    menuCreatePickUp: "Create New Pick Up",
    menuEditConfig: "Edit configuration",
    buttonCreateInstant: "Create Instant Pick Up",
    searchPlaceholder: "Search shipment no.",
    periodeTitle: "Pick Up Schedule",
    filterVehicleType: "Vehicle Type",
    filterVehiclePlaceholder: "Select vehicle type",
    filterPickupType: "Pick Up Type",
    filterServiceType: "Service Type",
    emptyHeaderMessage: "No pick up list yet",
    emptyMessage: "Create an instant pick up and check the list here.",
    typeScheduled: "Scheduled Pick Up",
    typeInstant: "Instant Pick Up",
    sortLabel: "Sort by",
    sortNearest: "Nearest Pick Up schedule",
    sortFarthest: "Farthest Pick Up schedule",
    sortMaxPickup: "Highest tonnage",
    sortMinPickup: "Lowest tonnage",
    sortMaxKoli: "Highest number of pieces",
    sortMinKoli: "Lowest number of pieces",
    columnNo: "No",
    columnShipmentId: "Shipment ID",
    columnClientRef: "Client reference",
    columnSchedule: "Pick Up Schedule",
    columnVehicleType: "Vehicle type",
    columnEstKoli: "Estimated pieces",
    columnPickupType: "Pick Up Type",
    columnServiceType: "Service type",
    columnStatus: "Status",
    actualKoli: "Actual",
    koli: "pieces",
    seeAll: "(See all)",
    statusFindingCourier: "Finding Courier",
    statusCourierAssigned: "Courier Assigned",
    statusPickedUp: "Picked Up",
    statusDone: "Done",
    statusCancelledCourier: "Cancelled by Courier",
    statusCancelledClient: "Cancelled by Client",
    statusCancelledAdmin: "Cancelled by Admin",
    selectStatus: "Select Status",
    bannerNewFeatureTitle: "New feature: You can now do instant Pick Up!",
    bannerNewFeatureDesc:
      'Want your packages picked up right away? Just click "Create Instant Pick Up", fill in the Pick Up details, and you\'re done!',
    detailInfo: "Detail Information",
    the3lcPickUp: "3LC Pick Up",
    addressPickUp: "Pick Up Address",
    coordLabel: "Coordinates",
    coordLabelGoogle: "Google Maps coordinates",
    datePickUp: "Pick Up Date",
    timePickUp: "Pick Up Time",
    statusRequest: "Pick Up request status",
    cancelPickUp: "Cancel Pick Up",
    cancelButton: "Cancel",
    modalCancelTitle: "Cancel Pick Up?",
    modalCancelMessage:
      "Pick Up request will not be processed if you cancel this Pick Up.",
    modalCancelSuccessTitle: "Pick Up cancelled successfully",
    modalCancelSuccessMessage:
      'Pick Up with shipment number "{shipmentId}" has been cancelled successfully.',
    cancelFailedMessage:
      "Pick Up cancellation failed. Please check and try again.",
    copySuccess: "Shipment ID copied successfully",
    clientRef: "Client Reference",
    districtCity: "District, City",
    courierNote: "Note for courier",
    estimateKoli: "Estimated Pieces",
    actualKoliLabel: "Actual pieces",
    estimateTonase: "Estimated tonnage",
    vehicleType: "Vehicle Type",
    serviceType: "Service Type",
    proofPhoto: "Pick Up proof photo",
    photoN: "Photo {n}",
    listStt: "STT List",
    emptyStt: "No STT list yet",
    emptySttMessage:
      "Wait for your STT to be processed by Lion Parcel Agent/POS.",
    vehicleNo: "Vehicle number",
    courierName: "Courier name",
    courierPhone: "Courier contact number",
    cancelReason: "Cancellation reason",
    dateCreated: "Date Created",
    dateUpdated: "Date Updated",
    back: "Back",
    retry: "Retry",
    yesCancel: "Yes, cancel",
    titleCreate: "Create Instant Pick Up",
    placeholderClient: "Select client reference",
    placeholderCourierNote: "Enter your note for the courier",
    fleetAndSchedule: "Fleet and Schedule",
    placeholderService: "Select service type",
    placeholderTime: "Minimum 4 hours from request time",
    modalSuccessTitle: "Instant Pick Up created successfully",
    modalSuccessMessage:
      'Pick Up request with shipment number "{shipmentId}" has been created.',
    modalFailedTitle: "Instant Pick Up failed to create",
    modalFailedMessage:
      "New Pick Up schedule configuration request failed to create. Please check and try again.",
    errorTimeTitle: "Pick Up time must be at least 4 hours from now",
    errorTimeMessage: "Please adjust your Pick Up time.",
    transportType: "Vehicle Type",
    pickupDate: "Pick Up Date",
    pickupDay: "Pick Up Day",
    jamPickup: "Pick Up Time",
    save: "Save",
    ok: "OK",
    buttonCreateConfig: "Create New Configuration",
    bannerScheduleTitle:
      "New feature: You can now configure Pick Up schedules!",
    bannerScheduleDesc:
      'Want to schedule regular Pick Ups? Just click "Create new configuration", fill in the Pick Up details, and choose the repeat schedule!',
    emptyScheduleHeader: "No Schedule Configuration List",
    emptyScheduleMessage:
      "Start creating Schedule Configuration and check the list here",
    columnConfigName: "Schedule configuration name",
    dateStart: "Start Date",
    dateEnd: "End Date",
    repeatPickup: "Pick Up repetition",
    titleCreateConfig: "Create New Configuration",
    titleEditConfig: "Edit configuration",
    placeholderConfigName: "E.g.: Pick Up JABODETABEK",
    dateStartPickUp: "Pick Up start date",
    dateEndPickUp: "Pick Up end date",
    validationEndBeforeStart:
      "Pick Up end date must not be earlier than Pick Up start date",
    maxPickupTime: "Maximum Pick Up collection time 4:00 PM (MYT)",
    modalConfirmTitle: "Save Pick Up schedule configuration changes?",
    modalConfirmMessage: "Please ensure the data you entered is correct.",
    modalSuccessConfigTitleCreated: "created successfully",
    modalSuccessConfigTitleUpdated: "updated successfully",
    modalSuccessConfigCreated:
      "New Pick Up schedule configuration has been created.",
    modalSuccessConfigUpdated:
      "Pick Up schedule configuration changes have been saved.",
    modalFailedConfigMessage:
      "New Pick Up schedule configuration failed to create. Please check and try again.",
    pickupInterval: "Pick Up",
    weekOnce: "week(s)",
    hariPickup: "Pick Up Day",
    tanggalMulaiPickup: "Pick Up Start Date",
    tanggalBerakhirPickup: "Pick Up End Date",
    configName: "Schedule configuration name",
    repeatPickUpLabel: "Pick Up repetition",
    nextPickUpDay: "Next pick up on",
    statusSchedule: "Pick Up schedule status",
    statusConfig: "Schedule configuration status",
    editButton: "Edit",
    clickToActivateStatus:
      "Click the button below to activate or deactivate status",
    statusActive: "Active",
    statusInactive: "Inactive",
    filterPlaceholderClient: "Select client reference",
    filterPlaceholderVehicle: "Select vehicle type",
    utama: "Default",
    addAddress: "Add new address",
    selectOtherAddress: "Select other address",
    noAddressSaved: "No saved address yet",
    placeholderAddress: "Enter Pick Up address",
    successAddressSaved: "You can now use this address for Pick Up.",
    searchAndSelectAddress: "Search & select Pick Up address location.",
    namaAlamat: "Address name",
    namaPIC: "PIC name",
    noHP: "Phone number",
    kecamatanKota: "District, City",
    simpanAlamat: "Save address",
    placeholderNamaAlamat: "Enter address name",
    placeholderNamaPIC: "Enter PIC name",
    okeMengerti: "OK, got it",
    titleAddAddress: "Add new address",
    titleEditAddress: "Edit address",
    searchDistrictCity: "Type or select district, city",
    postalCode: "Postal code",
    placeholderPostalCode: "Enter postal code",
    placeholderCoordinate: "Example: -6.523523523523",
    successAddAddressTitle: '"{name}" added successfully',
    successEditAddressTitle: '"{name}" updated successfully',
    geoHelpText: "Having trouble finding the coordinate location?",
    geoCheckHere: "Check here.",
    geoModalTitle: "How to find location coordinates",
    savedAddressListTitle: "Saved address list",
    editAddress: "Edit address",
    selectAndSetDefault: "Select & set as default address",
    delete: "Delete",
    select: "Select",
    cancel: "Cancel",
    deleteAddressTitle: "Delete this address?",
    deleteAddressMessage:
      "You will lose this address from the saved address list.",
    placeholderEstimateTonase: "Enter estimated tonnage",
    placeholderEstimateKoli: "Enter estimated pieces",
    selecDate: "Select date",
    pickupTimeLabel: "Package will be picked up on {date} - {time}",
    modalFailedConfigTitle: '"{client}" failed to be {action}',
    updated: "updated",
    created: "created",
    repeatInterval: "Repeat every",
    repeatEvery: "Repeat on",
    week: "Week",
    weekOption: "{count} Week",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    andDay: "and {day}",
    repeatScheduleLabel: "{days} {time}, every {interval} week(s)",
    errorGetData: "Failed to retrieve data!",
    errorSystem: "An error occurred in the system. Please try again later.",
    successDeleteAddressTitle: '"{name}" deleted successfully',
    successDeleteAddressMessage: "You can add the new address again.",
    geolocation: {
      step1: "Open",
      onLaptop: "on your laptop/computer.",
      rightClickCoordinate:
        "Right-click on the location & left-click on the coordinates.",
      enterCoordinate: "Enter the coordinates into the provided form."
    },
    bookingSummary: {
      titleSuggestion: "Recommended to pick up",
      titleBucket: "Ready to pick up",
      changeAddress: "Change address",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Nearest schedule:",
      viewStt: "View STT",
      viewActivePickup: "View active Pick Up {count}",
      empty:
        "Pickup request data is unavailable. Please create the pickup manually",
      createManual: "Create Pick Up Manually",
      piece: "pcs",
      wood: "WOOD",
      addressIsEmpty: "No pick-up address has been added.",
      addAddress: "Add address"
    },
    scheduleConfig: {
      pageTitle: "Set Pick Up schedule",
      breadcrumb: {
        parent: "Pick Up Schedule Configuration"
      },
      sidebar: {
        addressTitle: "Pick Up Address",
        changeAddress: "Change address",
        saveSchedule: "Save schedule",
        defaultBadge: "Primary",
        coordinatesLabel: "Coordinate point:",
        empty: "No saved address yet"
      },
      shipment: {
        sectionTitle: "Shipment Information",
        estimateAdditionalKoli: "Estimated additional pieces",
        estimateWeight: "Estimated weight",
        weightSuffix: "kg",
        serviceType: "Shipping type",
        placeholderKoli: "Enter estimated additional pieces",
        placeholderWeight: "Enter estimated weight",
        placeholderService: "Select shipping service"
      },
      scheduleSectionTitle: "Pick Up Schedule",
      regular: {
        title: "Regular schedule",
        tooltip:
          "The latest Pick Up schedule will be applied starting tomorrow.",
        maxSlotsNote: "(Max. 3 schedules per day.)",
        addTime: "Add time",
        emptySlots: "No time selected",
        popoverTitle: "Select Pick Up time",
        durationFooter: "Duration 1 hour",
        duplicateTime: "This time has already been added",
        confirmTime: "Select",
        emptyTimeOptions: "No time options available",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        }
      },
      special: {
        modalTitle: "Select Pick-up schedule",
        pickDateLabel: "Select date",
        pickTimeLabel: "Select time",
        save: "Save",
        duplicateDate: "This date has already been added",
        modalMaxSlotsNote: "Max. 3 schedules per day.",
        title: "Special schedule",
        tooltipTitle: "Special Schedule",
        tooltipDescription:
          "Special schedules will override regular schedules on the selected dates.",
        maxDatesNote: "(Max. 3 dates.)",
        addDate: "Select Pick-up date",
        reset: "Reset",
        addTime: "Add time"
      },
      successModal: {
        title: "Pick Up Schedule saved successfully",
        description:
          "Configuration has been saved & will be applied starting tomorrow.",
        buttonClose: "Close"
      },
      successNotification: "Pick Up schedule successfully saved",
      leaveModal: {
        title: "Leave from this page?",
        description: "All changes will be discarded if you leave.",
        buttonCancel: "Stay here",
        buttonConfirm: "Yes, leave"
      }
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Create Manual Pick Up"
      },
      banner: {
        sttPrefix: "You have ",
        sttSuffix: " Airway Bill that can be processed.",
        viewAll: "View all"
      },
      field: {
        addressLabel: "Pick Up address",
        koliLabel: "Estimated pcs",
        koliPlaceholder: "Enter pcs",
        weightLabel: "Estimated weight",
        weightPlaceholder: "Enter weight",
        weightUnit: "kg",
        serviceLabel: "Shipping service",
        servicePlaceholder: "Select shipping service",
        dateLabel: "Date",
        timeLabel: "Time",
        courierNoteLabel: "Note for courier",
        courierNotePlaceholder: "Enter note"
      },
      specialHandling: {
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        woodPacking: "Wood Packing"
      },
      address: {
        mainBadge: "Main",
        coordinate: "Coordinat points: {lat}"
      },
      suggestionHint:
        "Data is filled automatically based on recommendations; you can change it.",
      addressEmpty: "Choose pick up address",
      addressListTitle: "Address list",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimated pcs is required",
        weight: "Estimated weight is required",
        date: "Date is required",
        time: "Time is required",
        service: "Shipping service is required",
        address: "Pick up address is required"
      },
      changeAddress: "Change address",
      chooseAddress: "Choose address",
      addAddress: "Add address",
      submit: "Request",
      sttListTitle: "List of Airway Bill available for Pick Up ({count})",
      sttListEmpty: "List of Airway Bill is not available yet",
      success: {
        title: "Pick Up request sent successfully",
        message: "Pick Up will be processed by the courier shortly.",
        button: "OK, got it"
      },
      error: {
        title: "Pick Up request failed",
        message: "Please try again in a few moments.",
        button: "Close"
      }
    }
  },
  partnerManagement: {
    route: {
      partnerManagement: "Partner Management",
      partnerManagementDetail: "Partner Management | Detail",
      detailPartner: "Detail Partner",
      consolidatorCreate: "Consolidator | Create",
      buatConsolidator: "Create Consolidator",
      subConsolidatorCreate: "Sub Consolidator | Create",
      buatSubConsolidator: "Create Sub Consolidator",
      posCreate: "POS | Create",
      buatPos: "Create POS",
      hubCreate: "Hub | Create",
      buatHub: "Create Hub",
      detailHub: "Detail Hub",
      hubEdit: "Hub | Edit",
      ubahHub: "Edit Hub",
      consolidatorEdit: "Consolidator | Edit",
      ubahConsolidator: "Edit Consolidator",
      subConsolidatorEdit: "Sub Consolidator | Edit",
      ubahSubConsolidator: "Edit Sub Consolidator",
      posEdit: "POS | Edit",
      ubahPos: "Edit POS",
      changePartnerName: "Enter partner name",
      posReturnStt: "Post Return Stt",
      posReturnSttDesc:
        "Account for STT bookings that were returned to sender or forwarded to the correct address",
      choosePosName: "Choose POS name",
      address: "Address",
      partnerAddress: "Enter partner address"
    },
    fileAttachment: "Supporting Documents",
    validate: {
      minimumUpload: "Please upload at least 3 files",
      processUpload: "Uploading file to storage",
      processDelete: "Deleting file from storage"
    },
    description: {
      fileOne:
        "Supporting files can be NPWP, KTP, KK, POS closure document or other files.",
      fileTwo:
        "Max. 3 MB, format: jpg, png, pdf. Recommended ratio 2:4 (e.g. 200px × 800px)"
    },
    label: {
      attachment: "Attachment",
      noHandphone: "Mobile Number"
    },
    error: {
      uploadFile:
        "Failed to upload Attachment {value} to storage. Please remove and try again.",
      phoneInvalid: "Enter a valid phone number",
      phoneHandphoneInvalid: "Enter a valid mobile number"
    },
    button: {
      unfreeze: "Unfreeze",
      freeze: "Freeze"
    },
    detail: {
      contactInfo: "Contact Information",
      name: "Name",
      phone: "Phone Number",
      jobTitle: "Job Title",
      email: "Email",
      additionalInfo: "Additional Information",
      saldoDeposit: "Deposit Balance",
      firstTopUp: "First Top Up",
      firstTransaction: "First Transaction",
      firstPickupManifest: "First Pick Up Manifest",
      lastTransaction: "Last Transaction",
      tabPosParent: "Parent POS Detail",
      tabPosBranch: "Branch POS & Pickup List",
      createdAt: "Created Date",
      lastUpdated: "Last Updated",
      enterDeposit: "Enter deposit balance",
      bankInfo: "Bank Information",
      dateChanged: "Date Changed"
    },
    filter: {
      selectStatus: "Select status"
    },
    list: {
      searchConsolidator: "Search consolidator name",
      searchSubConsolidator: "Search sub consolidator name",
      searchPos: "Search POS name/code",
      searchHub: "Search hub name/code",
      createConsolidator: "Create Consolidator",
      createSubConsolidator: "Create Sub Consolidator",
      createPos: "Create POS",
      createHub: "Create Hub",
      emptyConsolidator: "Consolidator data",
      emptySubConsolidator: "Partner management",
      emptyPos: "POS data",
      emptyHub: "Hub data",
      no: "No.",
      codeConsolidator: "Consolidator Code",
      nameConsolidator: "Consolidator Name",
      totalKota: "Total City",
      totalKotaTooltip:
        "Total City is the number of cities handled by the Partner.",
      kotaAsal: "Origin City",
      akhirKontrak: "Contract End",
      statusKontrak: "Contract Status",
      statusPartner: "Partner Status",
      freezed: "Freezed",
      action: "Action",
      codeSubConsolidator: "Sub Consolidator Code",
      nameSubConsolidator: "Sub Consolidator Name",
      kecamatanKota: "District, City",
      namaConsolidator: "Consolidator Name",
      codePos: "POS Code",
      namePos: "POS Name",
      tipePos: "POS Type",
      lastTransaction: "Last Transaction",
      saldoTersedia: "Available Balance",
      namaPartnerArea: "Partner Area Name",
      codeHub: "Hub Code",
      nameHub: "Hub Name",
      consolidator: "Consolidator",
      kotaHub: "Hub City",
      status: "Status",
      enterLocation: "Enter or select location",
      additionalCity: "Additional City",
      additionalCityDesc:
        "Enter additional cities you wish to handle. Partners can handle more than one (1) city.",
      maxAdditionalCity: "Maximum additional cities 5",
      enterCity: "Enter or select additional cities",
      consoleName: "Subconsolidator Ownership Name",
      consoleNameDesc: "Enter or select subconsolidator ownership",
      enterPartner: "Enter or select partner area",
      tax: "Tax Registration No. (NPWP)",
      enterTax: "Enter the Tax Registration Number (NPWP) correctly",
      partnerType: "Partner Area Type",
      enterLatitude: "Enter Latitude",
      enterLongtitude: "Enter Longitude",
      choosePosParent: "Type or select pos parent",
      posOwnerName: "POS Ownership Name",
      typePosOwner: "Type or select post ownership",
      posCommition: "Branch POS Commission",
      enterPosCommition: "Enter branch POS commission",
      optional: "(Optional)",
      name: "Name",
      enterName: "Enter name",
      position: "Position",
      enterPosition: "Enter position",
      addPhone: "Add Phone Number",
      enterEmailError: "Enter the correct email format",
      accountWillActive:
        "The account will be active and expire according to the selected date.",
      startFrom: "Starting From",
      until: "Until",
      noBank: "No bank account saved yet.",
      addAccount: "Add Account,",
      referral: "Referral Code",
      enterReferral: "Enter referral code",
      referralNotFound: "Referral Code not found",
      confirmCreation: "Confirm Creation",
      areUsure: "Are you sure you want to save the Partner creation",
      success: "successfully created",
      city: "City",
      typePosParent: "Type or select the parent post",
      posCommitionDesc:
        "New rule: Branch POS Commission value is derived from Branch Commission existing in Booking Commission configuration",
      successChange: "successfully changed",
      elexys: "Elexys Code",
      contract: "Contract Period"
    },
    code: "Code",
    name: "Name",
    districts: "List of districts",
    accountName: "Account Name",
    bank: "Bank Name",
    accNo: "Account No.",
    startFrom: "Starting From",
    sampai: "Until",
    chooseBank: "Choose bank",
    inputAccount: "Enter Account Number",
    check: "Check",
    choose3lc: "Choose 3LC"
  },
  uploadFile: {
    loading: "Loading...",
    clickToUpload: "Click to upload",
    orDragAndDrop: "or drag and drop"
  },
  bulkBooking: {
    repair: "Repair",
    booking: "Booking",
    invalidShipmentId: "Invalid Shipment ID",
    bookingFailed: "Booking Failed!",
    manualSttMinimum: "Manual STT number must contain at least 3 digits.",
    deleteRepairFailed: "Failed to delete failed booking repair!",
    repairDetailFetchFailed: "Failed to load repair booking details!",
    codConfigurationFailed: "Failed to get COD configuration!",
    editCustomerNameInvalid: "Invalid name. Please try again.",
    editCustomerAddressInvalid: "Invalid address. Please try again.",
    uploadActivityFailedTitle: "Upload Activity Failed",
    uploadActivityFailedMessage: "Activity “{fileName}” failed to upload",
    searchPlaceholder: "Search upload ID or name",
    uploadBulkBooking: "Upload Bulk Booking",
    columnUploadId: "Upload ID",
    columnNamaAktivitas: "Activity name",
    columnTipeBerkas: "File type",
    columnNamaBerkas: "File name",
    columnStatus: "Status",
    columnDibuatUntuk: "Created for",
    columnTanggalDibuat: "Created date",
    columnAtur: "Actions",
    columnTipeBooking: "Booking type",
    columnNamaFile: "File name",
    columnCatatan: "Notes",
    statusSuccess: "Success",
    statusFailed: "Failed",
    statusPartially: "Partially",
    statusUploading: "Uploading",
    repairedCount: "successfully repaired",
    downloadSuccessFile: "Download success file",
    downloadFailedFile: "Download failed file",
    downloadOriginalFile: "Download original file",
    repairFailedBooking: "Repair failed booking",
    repairBannerFailed: "{count} item(s) failed. Please fix and update.",
    printStt: "Print STT",
    bookingUlang: "Re-upload Booking",
    resubmitBooking: "Resubmit Booking",
    emptyState: "Bulk Booking",
    emptyStateFailed: "Failed Booking",
    downloadTemplate: "Download Template",
    bulkPrintResiThermal: "Bulk Print Thermal Receipt",
    bulkPrintResiBasic: "Bulk Print Basic Receipt",
    columnTotalStt: "Total STT",
    actionMore: "More",
    saveSenderDetail: "Save shipper detail",
    saveRecipientDetail: "Save recipient detail",
    vendorNinjaInfo: "For selected destination, maximum 1 package is allowed",
    deleteBooking: "Delete this booking",
    clientName: "Client Name",
    filterClientName: "Client Search Filter",
    cityOriginClient: "City of origin of the client (3LC)",
    insertName: "Enter & select client's city of origin (3LC)",
    serviceType: "Delivery Service Type",
    chooseType: "Select the type of delivery service",
    insertAlias: "Enter & select branch client name/alias/code",
    clientNameMustInsert: "Client name is required",
    clinetNotBook: "Client cannot make a booking",
    clientList: "Client List",
    searchbyName: "Search by client name/alias",
    originCity: "Origin City",
    clientType: "Client Type",
    service: "Delivery Service",
    clientCode: "Client Code",
    districtRequired: "District, City of Origin must be filled in",
    errormessageName: "Sender name must be at least 3 characters.",
    messageNameRequired: "Sender name is required.",
    senderAddress3: "Sender address must be at least 3 characters.",
    senderAddressReq: "Sender address is required.",
    phoneNumberInvalid: "The phone number is invalid, please try again",
    sender: "Sender",
    home: "Home",
    recipientNameError: "Recipient name must be at least 3 characters.",
    recipientNameReq: "Recipient name is required.",
    recAddresMin3: "Recipient address must be at least 3 characters.",
    recAddresReq: "Recipient address is required.",
    download: "Download",
    filter: {
      label: "Filter",
      uploadStatus: "Upload status",
      fileType: "File type",
      createdFor: "Created for",
      placeholderUploadStatus: "Select upload status",
      placeholderFileType: "Select file type",
      placeholderClientPos: "Select client/POS",
      reset: "Reset",
      apply: "Apply",
      statusSuccess: "Success",
      statusPartially: "Partially",
      statusFailed: "Failed",
      statusUploading: "Uploading",
      typeClient: "Client",
      typeRetail: "Retail",
      date: "Date"
    },
    create: {
      uploadFileTitle: "Upload file",
      bookingTypeRetail: "Retail",
      bookingTypeClient: "Client",
      clickToUpload: "Click to upload",
      uploadHint: "Format .xlsx, max. {maxFileMb} MB & {maxStt} STT.",
      uploadHintLimit: "Only the first {maxStt} data rows will be processed",
      activityNamePlaceholder: "Enter a name or note for this activity",
      changeFile: "Change",
      downloadTemplateHint:
        "Please download the booking template, complete the data per the format guide, then upload your file again.",
      templateInternational: "International booking",
      templateDomestic: "Domestic booking",
      templateRetailInternational: "Retail international booking",
      templateRetailDomestic: "Retail domestic booking",
      templateClientInternational: "Client international booking",
      templateClientDomestic: "Client domestic booking",
      checkFormatTitle: "Check the data format in each column",
      checkFormatHint:
        "Before uploading a bulk booking, ensure all data in the columns you filled matches the format in the data below.",
      commodityData: "Commodity data",
      districtData: "District data",
      title: "Upload Bulk Booking",
      upload: "Upload",
      activityName: "Activity name",
      placeholderActivityName: "Enter activity name",
      infoBadgeInterpackFtz:
        "Currently not available for INTERPACK and Free Trade Zone shipment types.",
      fileType: "File type",
      retail: "Retail",
      client: "Client",
      uploadFile: "Upload file",
      change: "Change",
      validationChars: "characters",
      templateRetail: "Retail booking template",
      templateClient: "Client booking template",
      dataCommodity: "Commodity data",
      dataDistrict: "District data",
      downloadTemplate: "Download template",
      downloadTemplateDescription:
        "Download the template, fill in the data columns, check the format, and upload it here!",
      checkFormat: "Check the data format in each column",
      checkFormatDescription:
        "Before uploading bulk bookings, ensure that all data in each column matches the required format.",
      modalProcessingTitle: "Bulk booking is being processed!",
      modalProcessingMessage:
        'Booking "{name}" is in progress. Please wait a moment.',
      modalFailedUploadMessage:
        'Booking "{name}" was unsuccessful. Please upload the file again.',
      modalSuccessTitle: "OK",
      uploadSuccessTitle: "Bulk booking uploaded successfully",
      modalErrorRowEmpty: "Some rows are empty!",
      modalErrorDataExceed: "Booking data exceeds limit!",
      modalErrorHeaderInvalid: "File header is invalid!",
      modalErrorRowEmptyAlt: "Some rows are empty!",
      modalErrorQueueFull: "Bulk booking queue is full",
      modalErrorFileSize: "Bulk booking file size exceeds {size} MB",
      modalErrorSystem: "System error occurred",
      modalSubtitleRowEmpty: "Check file, complete all rows & upload again.",
      modalSubtitleDataExceed:
        "Maximum 100 rows. Please remove some uploaded data.",
      modalSubtitleHeaderInvalid:
        "Check file & upload again according to template format",
      modalSubtitleRowEmptyAlt: "Check file, complete all rows & upload again.",
      modalSubtitleQueueFull: "Please wait a moment and try again.",
      modalSubtitleFileSize: "Change file and upload your file again.",
      modalSubtitleSystem: 'Click "Reload" or wait a moment.',
      btnUploadAgain: "Upload again",
      btnReload: "Reload",
      btnUnderstand: "OK, got it",
      btnBack: "Back",
      uploadFileCaption:
        "Format .xlsx. Maximum {maxStt} STT and file {maxMb} MB.<br/>Only the first 500 data rows will be processed.",
      uploadFileErrorFormat: "File format is invalid",
      modalOnProcess:
        "Please wait for the upload process to complete and check the details.",
      searchPlaceholder: "Search Upload ID/Activity Name",
      selectPlaceholder: "Select client/partner/Internal",
      clientNameTitle: "Client / Partner Name",
      clientNamePlaceholder: "Search client / partner",
      templatePlaceholder: "Select template format",
      attachment: "Attachment",
      hintSection1:
        "Make sure all the data you enter is correct and appropriate",
      hintSection2:
        "with the file to be uploaded. Learn how to fill out the template",
      hintSection3: "here",
      errorClient: "Partner or Client is currently inactive",
      successBookingTitle: "File Upload Successful",
      successBookingMessage:
        "The data in the shipment file has been successfully booked.",
      errorPartial:
        "Some shipment records were successfully booked as STTs, but failures occurred with others. Please download the file to identify the errors.",
      failedBookingTitle: "File Upload Failed",
      failedBookingMessage: "The data in the shipment file failed to book"
    },
    modal: {
      delete: "Yes, delete",
      back: "Back",
      deleteTitle: "Delete booking ({value})?",
      deleteMessage:
        "Your shipment will not be processed if you delete this booking.",
      successDeleteTitle: "Booking successfully deleted!",
      successDeleteMessage:
        "You can still create a new shipment by making a bulk booking again.",
      successTitle: "Booking successful ({value})",
      done: "Done",
      nextBooking: "Next booking",
      printThermalReceipt: "Print thermal receipt",
      productType: "Shipping type",
      deliveryEst: "Estimated delivery",
      recipient: "Recipient",
      districtCity: "District, destination city",
      codCost: "COD fee",
      mustPaid: "Amount to be paid by recipient",
      totalTariff: "Total tariff"
    },
    edit: {
      confirmDeleteTitle: "Delete booking",
      confirmDeleteMessage:
        "Your shipment will not be processed if this booking is deleted.",
      successDeleteTitle: "Booking repair has been deleted",
      successDeleteMessage:
        "New shipments can still be processed through the bulk booking feature."
    },
    filterStatus: {
      parent: "Select status upload",
      success: "Success",
      partially: "Partially",
      failed: "Failed",
      uploading: "Uploading"
    },
    client: {
      label: "Client",
      placeholder: "Enter & select branch client name/alias/code",
      errorMandatory: "Client name is required",
      errorBooking: "Client is unable to make a booking",
      buttonList: "Client List",
      modalTitle: "Client List",
      searchPlaceholder: "Search by client name/alias",
      filter: {
        searchTitle: "Client Search Filter",
        cityOrigin: "Client Origin City (3LC)",
        cityOriginPlaceholder: "Enter & select client origin city (3LC)",
        shipmentType: "Shipment Service Type",
        shipmentTypePlaceholder: "Select shipment service type"
      },
      table: {
        name: "Client Name",
        alias: "Alias",
        originCity: "Origin City",
        category: "Client Type",
        packageType: "Shipping Service",
        code: "Client Code"
      }
    },
    templates: {
      international: "International booking",
      domestic: "Domestic booking"
    },
    commodities: {
      commodityData: "Commodity data",
      districtData: "District data"
    },
    common: {
      retailInternational: "Retail International",
      retailDomestic: "Retail Domestic",
      clientInternational: "Client International",
      clientDomestic: "Client Domestic",
      bookingInternational: "International booking",
      bookingDomestic: "Domestic booking",
      commodityData: "Commodity data",
      districtData: "District data"
    }
  },
  "Pembuatan Pickup Manifest Berhasil !": "Create Success!",
  "Pickup Manifest berhasil dibuat.": "<b>Pick Up manifest</b> was created",
  "Beberapa No. STT berhasil dibuat menjadi Pickup Manifest, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.":
    "Some STT statuses updated to <b>“Pick Up Manifest”</b>, but some failed. Remove problematic STTs to continue update",
  "Pembuatan Pickup Manifest Gagal !": "Create Failed!",
  "Pickup Manifest gagal dibuat.":
    "STT status has been failed to update to <b>“Pick Up Manifest”</b>",
  "Pembuatan Gagal !": "Update Failed!",
  "Pembuatan Booking Baru Berhasil !": "Booking Success",
  "Perubahan Booking Berhasil !": "Update Success!",
  "Tipe Kargo": "Cargo Type",
  "Produk Kargo": "Cargo Product",
  "Tanggal Keberangkatan": "Departure Date",
  "Tanggal Kedatangan": "Arrival Date",
  "Total Berat": "Total Weight",
  "Kode Bandara Tujuan": "Destination Airport Code",
  "No. Penerbangan": "Flight Number",
  "Detail Kargo": "Cargo Details",
  "Total Berat Kotor Kargo": "Total Gross Weight of Cargo",
  "Total Berat Volume Kargo": "Total Weight Dimension of Cargo",
  "Total Berat Kotor Kargo Aktual": "Total Actual Cargo Gross Weight",
  "Total Dimensi": "Total Dimension",
  "Total Berat Volume Kargo Aktual": "Total Actual Cargo Dimension Weight",
  "Total Koli Kargo Aktual": "Total Actual Cargo Pieces",
  "Dibatalkan / Gagal Booking": "Canceled / Failed Booking",
  "Booking Ulang": "Booking Again",
  "Print Resi Kargo": "Print Cargo Receipts",
  "Nomor telepon tidak valid, mohon ulangi kembali":
    "Invalid phone number. Check & reset",
  "diskon Agen": "Agent discount",
  "Jika tidak diisi, tagihan COD akan mengikuti harga barang.":
    "If not filled in, the COD bill will follow the price of the goods.",
  "Harap isi komoditas dengan benar sesuai":
    "Please fill in the commodity correctly according to",
  "syarat & ketentuan": "terms & conditions",
  "yang berlaku.": "applicable.",
  "Gagal Mendapat Konfigurasi COD !": "Failed to Get COD Configuration!",
  "tidak perlu menagih biaya pengiriman ke pengirim.":
    "no need to charge shipping costs to the sender.",
  "Informasi Penting COD!": "Important COD Information!",
  "Informasi Penting DFOD!": "Important DFOD Information!",
  "Harga barang COD maksimum": "Maximum COD item price",
  "Harga barang COD minimum": "Minimum COD item price",
  "Nomor telepon valid dengan tipe MSISDN":
    "Valid phone number with MSISDN type",
  "cek & ubah lagi.": "check & change again.",
  "Harga barang minimum": "Minimum item price",
  "Nomor telepon valid dengan tipe PSTN": "Valid phone number with PSTN type",
  "Jenis pengiriman tidak tersedia karena terjadi embargo.":
    "This shipping type is not available due to an embargo.",
  "COD tidak berlaku untuk client CLIENT CABANG MALAY":
    "COD does not apply to MALAY BRANCH CLIENT clients",
  "Harga barang DFOD maksimum": "Maximum DFOD item price",
  "Harga barang DFOD minimum": "Minimum DFOD item price",
  "Harga barang harus di atas atau sama dengan  5 juta":
    "The price of the item must be above or equal to 5 million",
  "Total tarif": "Total rate",
  "Rute yang dipilih belum memiliki tarif pengiriman":
    "The selected route does not have a shipping rate yet",
  "Klik “Coba Lagi” untuk menampilkan ulang": "Click “Try Again” to redisplay",
  "Terjadi gangguan sistem untuk kota tujuan Anda karena alasan tertentu":
    "There was a system outage for your destination city for some reason.",
  "Jenis Pengiriman Gagal Ditampilkan": "Shipping Type Failed to Display",
  "Pengiriman Prioritas": "Priority Shipping",
  "Paket sampai di hari<br> yang sama":
    "The package arrived<br> on the same day",
  "Tipe Kota Tujuan": "Destination City District Type",
  "Riwayat Pengiriman": "History Shipment",
  "Total Berat <br /> Kotor": "Total Gross <br /> Weight",
  "Total Berat <br /> Dimensi": "Total Dimension <br /> Weight",
  "Total Berat <br /> Kotor Kargo": "Total Gross <br /> Cargo Weight",
  "Total Berat <br /> Dimensi Kargo": "Total Dimension <br /> Weight of Cargo",
  "Tanggal Status": "Status Date",
  Status: "Current Status",
  "Tanggal Penerbangan": "Flight Date",
  "Estimasi Keberangkatan": "Estimated Departure",
  "Estimasi Kedatangan": "Estimated Arrival",
  "Saldo Anda dibawah limit": "Your Balance is Below Limit!",
  "Saldo dibawah limit": "Balance Below Limit",
  "Saldo Anda mendekati limit": "Balance Close to Limit",
  "Saldo mendekati limit": "Your Balance is Close to Limit!",
  "Sisa Saldo": "Remaining Balance",
  "Sisa saldo": "Remaining balance",
  "Lakukan pengisian saldo sekarang juga. Pastikan saldo Anda tersedia sebelum melakukan aktivitas pengiriman.":
    "Top up your balance now. Make sure your balance is available before shipment activities.",
  "Tanggal Booking": "Booking Date",
  Penerima: "Recipient",
  "Alamat Penerima": "Recipient Address",
  "No. Telp Penerima": "Recipient Phone Number",
  "Tipe Komoditas": "Commodity Type",
  NPWP: "TAX IDENTIFICATION NUMBER (TIN)",
  "Harga Barang": "Item Price",
  "Pengenaan Pajak": "Tax Basis",
  "Print Resi Cargo": "Cargo Print",
  "KARGO TRUK": "CARGO TRUCK",
  "KARGO KERETA": "CARGO TRAIN",
  "KARGO KAPAL": "CARGO SHIP",
  "Koli Ke": "Pieces",
  "Aktual Total Berat Kotor Kargo": "Total Actual Cargo Gross Weight",
  "Aktual Total Berat Dimensi Kargo": "Total Actual Cargo Dimension Weight",
  "Terjadi kendala pada proses pengiriman? Hubungi Customer Service 021-80820072 atau hubungi Kota Asal yang bersangkutan.":
    "Problems with the shipment process? Contact Customer Service 021-80820072 or contact the relevant origin city",
  "Yakin Keluar Halaman?": "Are You Sure Want to Quit?",
  "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.":
    "You haven't finished filling out the form. The request will not be processed if you quit this page",
  "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar dari halaman ini.":
    "Make sure again, you will lose all data if you quit this page",
  "Pilih No. Telepon Penerima": "Select Consignee Phone Number",
  "Informasi penting! Sampaikan ke customer Anda bahwa rute yang dipilih estimasi pengirimannnya":
    "Important information! Tell your customers that the selected route has an estimated delivery time.",
  "hari kerja.": "working days.",
  "Pilih Sub Consolidator": "Select Sub Consolidator",
  revamp: {
    booking: {
      client: "Your Client",
      pos: "Your POS",
      serviceAvailable: "currently does not support",
      codOrDfod: "COD or DFOD",
      contactLP: " services, please contact Admin Lion Parcel",
      detailSender: "Shipper details",
      detailRecipient: "Recipient details",
      detailPackageAndServiceType: "Item Details & Service Type",
      itemWeight: "Item Weight",
      insuranceWarning:
        "Shipments without insurance can only be claimed up to 10x the shipping fee / maximum to the applicable terms and conditions.",
      deliveryInsurance: "Shipping Insurance",
      detailCommodity: "Commodity Details",
      additionalPhoto: "Additional Photos",
      beforeAndAfterPackingPhoto: "Photos before & after package packing",
      packageBeforePacking: "Package before packing",
      packageAfterPacking: "Package after packing",
      recipientIdPhoto: "Recipient’s ID photo",
      recipientId: "Recipient’s ID",
      recipientTaxIdPhoto: "Recipient’s Tax ID photo",
      bookNow: "Book now",
      selectSchedule: "Choose schedule",
      shippingProtection: "Shipping protection",
      shippingIsProtected: "Shipping is protected",
      recipientIdNumber: "Recipient ID number",
      recipientTaxIdNumber: "Recipient Tax ID number",
      shippingRate: "Shipping rate",
      codAmount: "COD amount",
      heavyWeightSurcharge: "Chargeable weight",
      totalPieces: "Total pieces",
      billedTo: "Billed to",
      paymentMethod: "Payment method",
      publishRatesShippingSurcharge: "Publish rates + shipping surcharge",
      originForwardRates: "Origin forward rates",
      destinationForwardRates: "Destination forward rates",
      totalShippingRates: "Total shipping rates",
      commoditySurcharge: "Commodity surcharge",
      documentSurcharge: "Document surcharge",
      woodPackingSurcharge: "Wood packing surcharge",
      totalSurcharge: "Total surcharge",
      protectionFee: "Protection",
      protectionAdminFee: "Protection admin fee",
      codItemPrice: "Item price",
      codCost: "COD cost",
      tacticalPromo: "Tactical promo",
      totalRates: "Total rates",
      chargesPayableByRecipient: "Charges payable by recipient",
      taxEstimate: "Tax estimate",
      returnCost: "Return cost",
      free: "Free",
      discount10Percent: "10% discount"
    }
  },
  remarks: {
    misbooking:
      "The district/city on the receipt does not match the detailed address.",
    change: "Change remark"
  },
  onProcessStt: {
    pageTitle: "On Process STT",
    editBooking: "Edit Booking",
    filter: {
      searchPlaceholder: "Search for STT number"
    },
    table: {
      sttNumber: "STT number",
      shipmentNumber: "Shipment ID",
      destination: "Destination Address",
      status: "Latest Status",
      adjustmentStatus: "Adjustment Status",
      serviceType: "Service Type",
      bookingDate: "Booking Date",
      lastUpdate: "Last Updated",
      bookingFor: "Booking For",
      destinationCity: "Destination city",
      action: "Action"
    },
    emptyData: "On Process STT data",
    deleteTooltip: "Cancel Booking",
    action: {
      editBooking: "Edit Booking",
      printThermal: "Print Thermal Receipt",
      printThermalPdf: "Print Thermal Receipt PDF",
      printBasicPdf: "Print Basic/Save to PDF",
      printCommercialInvoice: "Print Commercial Invoice"
    },
    tooltip: {
      dexAttempt: "DEX attempt"
    }
  },
  customProcess: {
    selectStatus: "Select status",
    allStatus: "All status",
    updateStatus: "Update Status",
    emptyData: "Custom Process",
    reasonPlaceholder: "Select reason",
    titleModalReroute: "Confirm status update to REROUTE?",
    titleModalMisbooking: "Confirm status update to MISBOOKING?",
    msgModalRerouteMisbooking:
      "Make sure all STT details are correct, because there will be a deduction from the POS balance.",
    titleModalRejected: "Confirm status update to REJECTED?",
    msgModalRejected: "Make sure all STT details are correct.",
    titleModalDefault: "Confirm update status?",
    msgModalDefault: "Make sure all STT details are correct.",
    no: "No.",
    totalStt: "Total STT",
    remarks: "Remarks",
    action: "Action",
    print: "Print",
    forStatusOnlyOneStt: "For status ",
    statusRts: "RTS",
    statusRtshq: "RTSHQ",
    and: "and",
    onlyOneSttSuffix: ", only 1 STT number can be updated",
    mustChangeAddressMisbooking:
      "Receiver address must be updated to process MISBOOKING.",
    addressChangedByBackline:
      "This receiver address has been updated by backline, you can proceed with misbooking update from console account",
    hubDestination: "Destination hub",
    vehicleNumber: "Vehicle number",
    selectPos: "Select POS",
    changeAddress: "Change Address",
    changeReceiverAddress: "Change Receiver Address",
    scanSttFailed: "Scan STT Number Failed",
    addSttFailed: "Add STT Number Failed",
    statusChangeSuccess: "Status Update Successful",
    printReceipt: "Print Receipt",
    printThermalReceipt: "Print Thermal Receipt",
    printBasicPdf: "Print Basic/Save to PDF",
    selectConsoleType: "Select console type",
    consolidator: "Consolidator",
    subConsolidator: "Sub Consolidator",
    selectRemarks: "Select Remarks",
    remarkAddressChangeCustomer: "Address change request from Customer",
    remarkAddressChangePos: "Address change request from POS",
    deliveryDetail: "Delivery Details",
    deliveryProduct: "Delivery Product",
    chooseProduct: "Choose Product",
    senderName: "Sender Name",
    receiverName: "Recipient Name",
    senderAddress: "Sender Address",
    receiverAddress: "Recipient Address",
    senderPhone: "Sender Phone No.",
    receiverPhone: "Recipient Phone No.",
    receiverPhonePlaceholder: "Enter the correct phone number",
    district: "Sub-district, City of Origin",
    districtCity: "District, Destination City",
    chooseCity: "Select the destination city",
    posCode: "ZIP Code",
    addressType: "Address Type",
    itemDetail: "Item Details",
    commodityType: "Commodity Type",
    typeCommodity: "Type or select the commodity name",
    deliveryStatus: "Delivery Status",
    deliveryStatusDesc:
      "Delivery status applies to shipments from the FTZ City of Origin. Enter the condition of the goods to be shipped.",
    chooseStatus: "Select the shipping status to be sent",
    tax: "Tax Registration Number (NPWP)",
    taxDesc: "Taxpayers can be individuals or companies as registered.",
    pcpDesc: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
    enterPcp: "Enter pieces per pack",
    nextCommodity: "Next Commodity",
    nextCommodityDesc: "Fill with the commodity items in one package.",
    enterNext: "Enter the next commodity",
    localBatam: "Local Product / Batam",
    outerBatam: "Ex-outside Batam / transit",
    wrong: "Wrong delivery / return",
    errorCod:
      "The destination district & city you entered does not yet provide COD services, please change the data",
    forwardArea:
      "The destination district & city you entered does not yet provide DO services, please change the data",
    balanceInsufficient: "POS balance is insufficient",
    updateFailed: "Update Failed!",
    understand: "Okay, I understand"
  },
  customProcessManifest: {
    detailTitle: "Custom Process Detail",
    customStatus: "Custom Status",
    totalSTT: "Total STT",
    totalKoli: "Total pieces",
    totalGrossWeight: "Total Gross Weight",
    totalChargeableWeight: "Total Chargeable Weight",
    createdAt: "Created Date",
    printReceiptCustomProcess: "Print Custom Process Receipts",
    printPdf: "Print PDF",
    consolidatorCity: "Consolidator city",
    createdBy: "Created by",
    createdDateAndTime: "Created date and time",
    status: "Status",
    totalSTTPieces: "Total STT/pieces",
    totalDimensionWeight: "Total dimension weight",
    noSTT: "STT number",
    noSTTReplacement: "No. STT replacement",
    originCity: "Origin city",
    destinationCity: "Destination city",
    origin: "Origin",
    destination: "Destination",
    grossWeight: "Gross weight",
    dimensionweight: "Dimension weight",
    chargeableWeight: "Chargeable Weight",
    vehicleNumber: "Vehicle number"
  },
  instantBooking: {
    title: "Instant booking",
    pageTitle: "Booking {'|'} Instant Booking",
    form: {
      originCity: "Origin City",
      posName: "POS Name",
      shipmentIdBookingId: "Shipment ID/Booking ID",
      shipmentIdExample: "Example: B29QHDMQEZ",
      shipmentIdPlaceholder: "Enter shipment ID/booking ID or scan barcode"
    },
    summary: {
      totalShipment: "Total Shipment",
      totalBookingSuccess: "Total Successful Bookings",
      totalBookingProgress: "Total Bookings in Progress",
      totalBookingFailed: "Total Failed Bookings"
    },
    print: {
      receipt: "Print Receipt",
      thermalPdf: "Print Thermal Receipt PDF",
      basicPdf: "Print Basic/Save as PDF",
      invoice: "Print Invoice",
      confirmTitle: "Print All Successful STT?",
      confirmMessage:
        "STT with status <strong>{inProgress}</strong> & <strong>{failed}</strong> will not be printed",
      checkAgain: "Review Again",
      print: "Print"
    },
    modal: {
      addShipmentFailedTitle: "Failed to Add Shipment ID!",
      back: "Back",
      confirmExitTitle: "Are You Sure You Want to Leave?",
      confirmExitMessage:
        "Please make sure you have printed the receipt to complete the instant booking process",
      exit: "Leave"
    },
    table: {
      no: "No.",
      shipmentId: "Shipment ID",
      sttNo: "STT No.",
      sender: "Sender",
      receiver: "Recipient",
      receiverAddress: "Recipient Address",
      totalPieces: "Total Pieces",
      totalWeight: "Total Weight",
      totalTariff: "Total Tariff",
      failedReason: "Failure Reason",
      status: "Status",
      printLabel: "Print Label",
      action: "Action"
    },
    status: {
      success: "Success",
      inProgress: "In Progress",
      failed: "Failed",
      printSuccess: "Success",
      printFailed: "Print Failed",
      printProcessing: "Processing"
    },
    error: {
      invalidShipment:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because {reason}",
      duplicateShipment:
        "Shipment ID <b>“{shipmentId}”</b> has already been added",
      alreadyBooked:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because it is already booked",
      destinationNotFound:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because the address or destination city/district was not found",
      mandatoryEmpty:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because required data is empty or unavailable",
      emptyGoods:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because goods data is empty or unavailable",
      pcuOnly:
        "Shipment ID <b>“{shipmentId}”</b> can only be processed by POS PCU because it uses the Jumbopack product.",
      unknownShipment:
        "Shipment ID <b>“{shipmentId}”</b> cannot be processed because it is {reason}",
      reasonUnknown: "unknown",
      reasonMultipleDestination: "has more than one destination address.",
      reasonDisallowed:
        "shipment ID is not allowed to be booked via instant booking",
      reasonFavorite: "it is a Shipment Favorite delivery.",
      failedGetReceiptData: "Failed to get receipt data"
    }
  },
  bookingV3: {
    create: {
      title: "Create booking",
      pageTitle: "Booking {'|'} Create"
    },
    bookingApps: {
      title: "Apps & marketplace booking",
      pageTitle: "Booking {'|'} Apps Booking"
    },
    edit: {
      title: "Edit booking",
      pageTitle: "Booking {'|'} Edit"
    },
    bookingSuccess: "Booking Created Successfully",
    list: {
      searchStt: "Search for STT number"
    },
    shipperPhoneNumber: "Phone Number",
    recipientPhoneNumber: "Phone Number",
    shipperAddress: "Address",
    recipientAddress: "Address",
    districtCity: "Kecamatan, kota",
    commodity: "Commodity",
    commodityNote: "Fill in the commodity according to the",
    commodityTnC: "T&C.",
    commodityPlaceholder: "Search & select commodity",
    commodityRecommendationErrorTitle: "A system issue has occurred",
    commodityRecommendationErrorMessage: `Please click "Reload" to refresh the page.`,
    commodityRecommendationErrorButton: "Reload",
    commodityViewAll: "View all",
    commodityMostUsed: "Most used",
    commodityEmptyByCategory: "Enter a keyword or select a category.",
    commodityEmptySearch: "Search not found. Check & change other keywords.",
    commoditySearchResult: "Search results",
    commodityErrorRequired: "Commodity is required.",
    commodityErrorInactive: "Inactive commodity.",
    commodityNotFound: "Commodity not found.",
    receiptLanguage: "Receipt language",
    errorCountryNotFound: "Country not found",
    searchCountryPlaceholder: "Search country name",
    errorCustomerNotFound: "Customer not found",
    productType: {
      title: "Shipping type",
      info: {
        infoPrice: "The price does not include",
        otherPrice: "other fees",
        infoTariff: ", check total price in the summary!"
      },
      titleToggle: "Agent discount",
      tooltip: {
        title: "Other fees (if applicable):",
        priceMsg: `<ul class="px-2 py-4">
        <li>• Commodity surcharge</li>
        <li>• Weight surcharge</li>
        <li>• Document surcharge</li>
        <li>• Protection fee</li>
        <li>• Protection admin fee</li>
        <li>• COD fee</li>
        <li>• Woodpacking surcharge</li>
      </ul>`
      },
      card: {
        labelDay: "day",
        labelDiscountAgen: "Agent discount",
        labelAvailable: "Not available",
        labelEmbargo: "Embargo",
        labelRecommended: "Recommended"
      },
      error: {
        errorSystem: {
          title: "A system has occurred",
          subtitle: "Please click “Reload” to refresh the page.",
          button: "Reload"
        }
      }
    },
    sttManualReference: {
      labelStt: "Manual STT number",
      placeholderStt: "Enter manual STT number",
      labelOptional: "(optional)",
      labelReference: "External reference number",
      placeholderReference: "Enter external reference number",
      checkStt: "Currently checking",
      error: {
        sttManual: "Manual STT number format is invalid.",
        required: "No. referensi eksternal wajib diisi",
        minRefExt: "Min. 3 characters.",
        minRefExtAlreadyUsed:
          "The external reference number has already been used",
        refExtFailedSystem: "System failed."
      },
      success: {
        sttApproved: "The external reference numbers can be used."
      }
    },
    deliveryService: {
      label: "Service shipping",
      error: {
        eligibleDestinationCOD: "COD/DFOD not available at destination city.",
        phoneNumberBlacklist: "COD/DFOD not available, contact our CS.",
        phoneNumberLimit: "Shipper exceeded COD/DFOD limit.",
        eligiblePartnerCOD: "Partner doesn’t support COD/DFOD.",
        eligibleCOD: "Shipper cannot use COD/DFOD."
      }
    },
    docInternational: {
      title: "International document",
      titleFTZ: "Free trade zone",
      CIPLLabel: "Item details for CIPL (Commercial Invoice and Packing List)",
      CIPLLabelFTZ:
        "Item details for CIPL (Commercial Invoice and Packing List)",
      commodityPlaceholder: "Enter or select a item to view all options",
      commodityPlaceholderFTZ: "Enter or select a item to view all options",
      emailLabel: "Recipient email",
      idNumberLabel: "Recipient identity number",
      taxNumberLabel: "Recipient tax ID ",
      shipmentStatusLabel: "Shipment status",
      shipmentStatusLabelFTZ: "Shipment status",
      emailLabelFTZ: "Email",
      idNumberLabelFTZ: "Identity number",
      taxNumberLabelFTZ: "Tax ID ",
      supportingDocumentLabel: "Supporting photos",
      supportingDocumentLabelFTZ: "Supporting photos",
      supportingDocumentIdLabel: "Identity card",
      supportingDocumentIdLabelFTZ: "Identity card",
      supportingDocumentTaxLabel: "Tax ID card",
      supportingDocumentTaxLabelFTZ: "Tax ID card",
      supportingDocumentBeforePackingLabel: "Package before packing",
      supportingDocumentBeforePackingLabelFTZ: "Package before packing",
      supportingDocumentAfterPackingLabel: "Package after packing",
      supportingDocumentAfterPackingLabelFTZ: "Package after packing",
      supportingDocumentSpec: "Max file size: 5 MB, Formats: jpg, jpeg, png.",
      supportingDocumentSpecFTZ:
        "Max file size: 5 MB, Formats: jpg, jpeg, png.",
      emailPlaceholder: "Enter email",
      emailPlaceholderFTZ: "Enter email",
      idNumberPlaceholder: "Enter identity number",
      idNumberPlaceholderFTZ: "Enter identity number",
      taxNumberPlaceholder: "Enter tax ID",
      taxNumberPlaceholderFTZ: "Enter tax ID",
      shipmentStatusPlaceholder: "Enter shipment status",
      shipmentStatusPlaceholderFTZ: "Enter shipment status",
      goodsPricePrefix: "RM",
      goodsPricePrefixFTZ: "RM",
      deleteCIPLBtnText: "Delete",
      deleteCIPLBtnTextFTZ: "Delete",
      addCIPLBtnText: "Add item",
      addCIPLBtnTextFTZ: "Add item",
      itemDetailCIPLHeadingText: "Item detail",
      itemDetailCIPLHeadingTextFTZ: "Item detail",
      quantityCIPLHeadingText: "Quantity",
      quantityCIPLHeadingTextFTZ: "Quantity",
      itemPriceCIPLHeadingText: "Item price",
      itemPriceCIPLHeadingTextFTZ: "Item price",
      dutyTaxTermsLabel: "Customs & Tax Payment",
      dutyTaxTermsPlaceholder: "Select terms of duty & tax",
      dutyTaxTermsTooltipDescription: `<ul class="custom-list">
        <li><span class="font-bold">Delivered Duty Paid (DDP):</span> The shipper will cover all customs duties and taxes. </li>
        <li><span class="font-bold">Delivery At Place (DAP):</span> The recipient will cover all customs duties and taxes when the package arrives at its destination. </li>
      </ul>`,
      dutyTaxTermsBannerPrefix:
        "If any customs duties and taxes apply, the charges will be billed to",
      shipper: "Shipper",
      recipient: "Recipient",
      dutyTaxTermsOptionDDP: "Paid by Shipper (DDP)",
      dutyTaxTermsOptionDAP: "Paid by Recipient (DAP)",
      dutyTaxTermsBannerDDP:
        "DDP selected: import duty and tax are billed to the Shipper.",
      dutyTaxTermsBannerDAP:
        "DAP selected: import duty and tax are billed to the Recipient.",
      countryCodeLabel: "Country Code",
      countryCodePlaceholder: "e.g. ID",
      dgTypeLabel: "DG Type",
      dgTypePlaceholder: "Select DG type",
      dgTypeOptionNON: "NON - General Goods",
      dgTypeOptionBAT: "BAT - Battery",
      dgTypeOptionLIQ: "LIQ - General Liquid",
      dgTypeOptionGAS: "GAS - Gas & Aerosol",
      dgTypeOptionMIX: "MIX - Mixed DG Goods",
      quarantineTypeLabel: "Quarantine Type",
      quarantineTypePlaceholder: "Select quarantine type",
      quarantineTypeOptionNON: "NON - General Goods",
      quarantineTypeOptionPLT: "PLT - Plant Products",
      quarantineTypeOptionANM: "ANM - Animal Products",
      quarantineTypeOptionFIS: "FIS - Fish Products",
      quarantineTypeOptionMIX: "MIX - Mixed Quarantine Goods",
      dutyTaxTermsOptionDap: "Paid by Recipient (DAP)",
      dutyTaxTermsOptionDdp: "Paid by Shipper (DDP)",
      dutyTaxTermsTooltipDapDescription:
        "The recipient will cover all customs duties and taxes when the package arrives at its destination.",
      dutyTaxTermsTooltipDdpDescription:
        "The shipper will cover all customs duties and taxes.",
      dutyTaxTermsInfoBarDap:
        "If any customs duties and taxes apply, the charges will be billed to <strong>recipient</strong>.",
      dutyTaxTermsInfoBarDdp:
        "If any customs duties and taxes apply, the charges will be billed to <strong>shipper</strong>.",
      error: {
        emailMandatory: "Recipient email is required.",
        idNumberMandatory: "Recipient identity number is required.",
        taxNumberMandatory: "Recipient tax id is required.",
        taxNumberMin: "Recipient tax id is min 15 characters",
        dutyTaxTermsMandatory: "Customs & Tax Payment is required.",
        emailValid: "Recipient email is not valid.",
        emailValidFTZ: "Email is not valid",
        itemDetailMandatory: "Item details is required",
        quantityMandatory: "Quantity required",
        goodsPriceMandatory: "Good price required",
        supportingDocumentMandatory: "Supporting photos is required.",
        supportingDocumentMaxSize: "Supporting photo max 5 MB"
      }
    },
    modalSuccess: {
      title: "Booking success!",
      createInvoice: "Create Invoice",
      print: "Print thermal receipt PDF",
      close: "Close",
      recipient: "Recipient name",
      serviceType: "Shipping type",
      chargableWeight: "Chargeable weight",
      destination: "District, destination city",
      estimation: "Estimated delivery",
      codFee: "COD amount",
      payable: "Charges payable by recipient",
      tariff: "Total rates"
    },
    modalFailed: {
      title: "Booking failed!",
      balance: "Current POS balance",
      price: "Booking price",
      reason: {
        title: "Reason:",
        embargo: "Route under embargo",
        freeze: "Account on freeze, contact CS Lion Parcel.",
        connection: "Your connection was interrupted",
        inactive: "Inactive account, contact CS Lion Parcel.",
        tariff: "Shipping cost not available",
        posFreeze: "POS/agent account on freeze, contact CS Lion Parcel.",
        posInactive: "Inactive POS account, contact CS Lion Parcel.",
        codUnavailable: "COD not available",
        priceChange: "Price changes",
        clientFreeze: "Client account on freeze, contact CS Lion Parcel.",
        clientInactive: "Inactive client account, contact CS Lion Parcel.",
        system: "System Error",
        commodity: "Inactive commodity",
        balance: "Insufficient balance",
        balanceNegative: "Negative balance",
        pieceBalance: "There are no remaining available quantity to process.",
        pieceBalanceAvailable:
          "Booking cannot be processed because the shipment has not been picked up yet.",
        pieceBalanceInfucient:
          "The entered package quantity exceeds the remaining available quantity. Please check and try again."
      },
      button: {
        back: "Back",
        understand: "Ok, understand",
        reload: "Try again",
        changeDestinationProduct: "Change destination/other shipping type",
        chooseOther: "Choose another service",
        changeCommodity: "Change other commodities",
        topUp: "Top up now"
      }
    },
    senderName: {
      error: {
        required: "Name is required.",
        min: "Name minimum of 3 characters."
      }
    },
    senderPhone: {
      fraud: {
        limited1: "This number has reached the daily COD/DFOD",
        limited2: "transaction limit.",
        limited3: "",
        limitedTooltip:
          "New phone numbers are limited to 10 COD/DFOD STTs per day (excluding CNX) or if total STT rates exceed RM78.45.",
        suspected: "This number has a high COD/DFOD return rate"
      },
      error: {
        required: "Phone number is required.",
        invalid: "Invalid phone number."
      }
    },
    senderAddress: {
      error: {
        required: "Address is required.",
        min: "Address minimum of 3 characters.",
        senderRecipientMismatch:
          "Shipper and recipient addresses cannot be the same."
      }
    },
    receiverName: {
      error: {
        required: "Name is required.",
        min: "Name minimum of 3 characters."
      }
    },
    receiverPhone: {
      fraud: {
        limited: "This number has reached the daily COD/DFOD {highlight}",
        limitedKeyword: "transaction limit.",
        limitedTooltip:
          "New phone numbers are limited to 10 COD/DFOD STTs per day (excluding CNX) or if total STT rates exceed RM78.45.",
        suspected: "Nomor memiliki tingkat retur COD/DFOD yang tinggi."
      },
      error: {
        required: "Phone number is required.",
        invalid: "Invalid phone number."
      }
    },
    receiverAddress: {
      error: {
        required: "Address is required.",
        min: "Address minimum of 3 characters.",
        senderRecipientMismatch:
          "Shipper and recipient addresses cannot be the same."
      }
    },
    receiverDestinationCity: {
      misbookingGuidance:
        "This destination is prone to misdelivery. Make sure the selection matches the recipient's address.",
      error: {
        notfound: "District, destination city not found.",
        required: "District, destination city are required.",
        embargo: "The chosen route is embargoed.",
        unavailable: "The chosen route is not available."
      }
    },
    receiverPostalCode: {
      error: {
        notfound: "Postal code not found.",
        required: "Postal code is required."
      }
    },
    shipment: {
      chargeableWeight: {
        label: "Chargeable weight",
        detail: "Item weight details",
        totalItem: "Total item",
        totalGrossWeight: "Total gross weight",
        totalDimensionWeight: "Total dimension weight"
      },
      checkTariff: {
        label: "Total rates",
        detail: {
          title: "Payment details",
          ratesAndsurcharge: "Publish rates + shipping surcharge",
          originRates: "Origin forward rates",
          destinationRates: "Destination forward rates",
          shippingCost: "Shipping rates",
          surcharge: {
            commodity: "Commodity surcharge",
            weight: "Heavyweight surcharge",
            document: "Document surcharge",
            woodpacking: "Woodpacking surcharge",
            total: "Total surcharge"
          },
          insurance: {
            protection: "Protection fee",
            free: "Free",
            basic: "Basic",
            adminFee: "Protection admin fee"
          },
          cod: {
            itemPrice: "COD item price",
            cost: "COD amount"
          },
          promo: {
            tactical: "Tactical promo",
            campaign: "Campaign promo"
          },
          chargesPayable: "Charges payable by recipient",
          estimationTax: "Tax estimate",
          returnCost: "Return cost",
          error: "Error system"
        }
      },
      detailItems: {
        label: "Item details"
      },
      itemPrice: {
        label: "Item price",
        placeholder: "Enter item price",
        error: {
          mandatory: "Item price is required.",
          minimum: "Minimum item price is",
          min: "Minimum item price {price}",
          max: "Maximum item price {price}",
          codMax: "Maximum COD item price {price}, check & update.",
          codMin: "Minimum COD item price {price}, check & update.",
          dfodMax: "Maximum DFOD item price {price}, check & update.",
          dfodMin: "Minimum DFOD item price {price}, check & update."
        }
      },
      insurance: {
        label: "Protection",
        protected: "Shipping is protected",
        protection: "Shipping protection",
        discount: "agent discount",
        tooltip: {
          title: "",
          message:
            "Free protection up to {startFrom}. For items over {startFrom}, a {cost}% fee of the item price applies (min. {minFee})."
        }
      },
      weightPieces: {
        title: "Item weight",
        no: "No",
        grossWeight: "Gross weight",
        dimension: "Dimensions/package (L x W x H)",
        dimensionWeight: "Dimension weight",
        remove: "Delete",
        addItems: "Add item",
        weightAbove: "A surcharge will apply for weights over",
        charged: ", and you cannot add more items.",
        districtOnePiece:
          "The district and the destination city are allowed only for one item.",
        infobarWeightComma:
          "Use a period (.) for weights <1 kg. Example: 0.5 for 500 grams.",
        error: {
          mandatoryWeight: "Gross weight required",
          mandatoryDimension: "Dimension weight is required",
          maximumWeight:
            "Total item weight exceeds the maximum limit of 400 kg/STT",
          weightAbove: "Weights above",
          prohibitedOnePiece: "are allowed only for one item.",
          changeWeightOrNewBooking:
            "Change the weight or create a new booking.",
          prohibitedChangeWeight: "Item weight adjustments are not allowed."
        },
        tooltip: {
          title: "",
          message:
            "Dimension weight calculation follow applicable terms and conditions."
        },
        uploadWeightProofPhoto: "Upload photo proof to change weight",
        uploadProofPhotoInstruction:
          "You must upload photo proof of the item to adjust weight & dimension.",
        photoGuideTitle: "Photo guide:",
        photoGuideGoodResolution: "Photo must have good resolution.",
        photoGuideScaleReadable:
          "The scale/volume measurement must be clearly readable.",
        photoGuideLabelVisible:
          "The item photo with STT/shipment label must be clearly visible.",
        photoGuidePackageVisible: "The entire package must be visible.",
        photoScale: "Scale photo",
        photoItemIdentity: "Item photo with <br/> identity label",
        additionalPhoto: "Additional photo"
      },
      modal: {
        skipBooking: "Skip booking",
        leaveTitle: "Are you sure you want to leave?",
        leaveMessage: "Booking data changes will not be saved.",
        leave: "Leave",
        stayHere: "Stay here",
        createSuccessTitle: "New Booking Created Successfully!",
        deletePhotoFailed: "Failed to delete photo from storage!"
      }
    },
    bookButton: {
      printLater: "Booking, print later ",
      printThermal: "Booking, print thermal receipt",
      printThermalPdf: "Booking, print PDF thermal receipt",
      printBasic: "Booking, print basic/save to PDF",
      failedBook: "Booking Failed !",
      printA4Pdf: "Booking, print A4 receipt (PDF)"
    },
    filterClient: {
      title: "Client",
      clientPlaceholder: "Enter or select branch client name/code",
      clientMandatory: "Client name/code is required.",
      filter: {
        title: "Client search filters",
        originLabel: "Client origin (3LC)",
        originPlaceholder: "Enter & selecet client origin (3LC)",
        serviceTypeLabel: "Service type",
        serviceTypePlaceholder: "Select service type"
      },
      list: {
        title: "Client list",
        searchPlaceholder: "Enter or select branch client name/code",
        clientName: "Client name",
        clientAlias: "Alias",
        clientOrigin: "Origin",
        clientType: "Client type",
        clientServiceType: "Service type",
        clientCode: "Client code"
      },
      notFound: {
        title: "Client not found",
        subTitle: "Check the word and try again."
      }
    },
    goodsCategory: "Goods category",
    product: {
      minipack: "Small package",
      bosspack: "Priority",
      regpack: "Regular"
    }
  },
  deliveryManifest: {
    title: "Delivery Manifest",
    menuName: "Delivery Manifest",
    createManifest: "Create Manifest",
    printManifest: "Print Manifest",
    printLabel: "Print Label",
    needRelabel: "Need Relabel",
    lastSevenDays: "Last 7 Days",
    searchPlaceholder: "Search Manifest No./STT No.",
    update: {
      title: "Create Manifest"
    },
    form: {
      partnerName: "Partner Name",
      userType: "User Type",
      destinationCity: "Destination City",
      createdAt: "Created Date",
      sttNo: "STT No.",
      sttExample: "Example: 99LP1234567890123/88-22-12345678",
      sttPlaceholder: "Enter STT No. or Scan Barcode/QR Code",
      sttOverweightError:
        "Overweight detected, status cannot be updated to Delivery Manifest",
      maxStt: "Max. {max} STT"
    },
    pdf: {
      consolidatorCity: "Consolidator City",
      destinationCity: "Destination City",
      createdBy: "Created By",
      manifestNo: "No. Delivery Manifest",
      createdAt: "Created Date",
      totalStt: "Total STT",
      totalPiece: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      recipient: "Recipient",
      CODAmount: "COD Amount",
      nameAndSignature: "Name and Signature",
      courier: "Courier",
      koli: "Pieces",
      totalWeight: "Total Weight",
      manifestDate: "Manifest date",
      totalSTTPieces: "Total STT/Pieces"
    },
    column: {
      no: "No.",
      manifestNo: "Delivery Manifest No.",
      totalStt: "Total STT",
      totalPiece: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight",
      chargeableWeight: "Chargeable Weight",
      createdAt: "Created Date",
      action: "Action",
      sttNo: "STT No.",
      referenceNo: "Reference No.",
      product: "Product",
      commodity: "Commodity",
      deliveryCount: "Delivery Attempt",
      codFee: "COD Fee",
      deliveryType: "Service",
      piecesWeigght: "Pieces/Weight",
      demNo: "DEM Number"
    },
    button: {
      add: "Add",
      delete: "Delete",
      process: "Process",
      cancel: "Cancel",
      createAndPrint: "Create & Print PDF"
    },
    error: {
      sttNotFound: "STT No. not found or already deleted",
      sttNotFoundScan: "STT No. not found",
      sttAlreadyAdded: "STT No. already entered",
      adjustmentTitle: "STT requires weight adjustment confirmation",
      adjustmentMessage:
        "Scan failed because STT adjustment has not been approved by Lion Parcel, please wait to be contacted by CS."
    },
    modal: {
      ok: "OK",
      download: "Download",
      understood: "Ok, understood",
      back: "Back",
      leave: "Leave",
      leaveTitle: "Are you sure you want to leave?",
      leaveMessage:
        "Please note, you will lose all data if you leave this page.",
      confirmCreateTitle: "Creation Confirmation",
      confirmMessage:
        "Please double-check, all STT details are correct and accurate.",
      scanFailedTitle: "Scan STT No. Failed",
      addSttFailedTitle: "Add STT No. Failed",
      packagePickupTitle: "Package to be picked up by recipient",
      rtsHalMessage: "This STT has been marked as RTS/HAL",
      createSuccessTitle: "Creation Successful!",
      createSuccessMessage: "Delivery Manifest has been successfully created.",
      partialMessage:
        "Some STT No. were successfully created as Delivery Manifest,\nhowever some STTs failed.\nPlease download to find out the errors.",
      createFailedTitle: "Creation Failed!",
      createFailedMessage: "Delivery Manifest failed to be created.",
      countSuccess: "{count} STT No. Successful",
      countFailed: "{count} STT No. Failed"
    },
    deleteDialog: {
      title: "Delete Item",
      description:
        "Enter STT No. or Scan Barcode/QR Code\nfor items you want to remove from the DEL list.",
      deleted: "Deleted"
    }
  },
  updateDelivery: {
    title: "Update DEL",
    menuName: "Delivery",
    emptyState: "Delivery",
    createButton: "Update DEL",
    printButton: "Print",
    timeRangeOptions: "custom, today, last 7 days, last 14 days",
    columns: {
      no: "No.",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      driverName: "Courier name",
      driverPhone: "Courier phone no.",
      deliveredBy: "Delivered by",
      createdAt: "Created at",
      action: "Action"
    },
    form: {
      title: "Update DEL",
      partnerName: "Partner name",
      userType: "User type",
      originCity: "Origin city",
      dateCreated: "Created at",
      datePlaceholder: "Select or enter vehicle plate number",
      deliveredBy: "Delivered by",
      driverUsesApp: "Does the courier use the Driver app?",
      driverName: "Courier name",
      selectDriver: "Select courier",
      selectClientPartner: "Type or select client/partner",
      deliveryNote:
        "Delivery data from this courier will not be recorded in reconciliation.",
      noStt: "No. STT",
      noSttLabel: "Example: 99LP1234567890123/88-22-12345678",
      noSttPlaceholder: "Enter STT No. or Scan Barcode/QR Code",
      weightExcessError:
        "Weight excess occurred; status cannot be updated to DEL",
      failedGetDriver: "Failed to get courier data",
      add: "Add",
      confirmationTitle: "Confirm update",
      confirmationMessage: "Please ensure all STT details are correct.",
      textCancel: "Back",
      textSuccess: "Process",
      successTitle: "Update successful",
      successMessage: "STT status has been successfully updated to DEL.",
      partialMessage:
        "Some STT statuses have been updated to DEL,<br />but some failed.<br />Please download to view errors.",
      failedTitle: "Update failed",
      failedMessage: "DEL status failed to update.",
      download: "Download",
      ok: "OK",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total dimension weight",
      delete: "Delete",
      process: "Process",
      updateDel: "Update DEL",
      updateAndPrintPdf: "Update & Print PDF",
      no: "No.",
      noSttCol: "No. STT",
      needRelabel: "Need relabel",
      urgentRts: "Urgent RTS",
      noRef: "No. Reference",
      deliveryTo: "Delivery Attempt",
      codFee: "COD fee",
      dest: "Dest.",
      product: "Product",
      commodity: "Commodity",
      koli: "Pieces",
      grossWeight: "Gross weight",
      volumeWeight: "Dimension weight",
      chargeableWeight: "Chargeable weight",
      selectPartner: "Select partner",
      selectConsole: "Select consolidator",
      selectSubConsole: "Select subconsolidator",
      selectVendor: "Select vendor",
      addVendor: "Add vendor",
      placeholderAdd: "Add new vendor"
    },
    deleteStt: {
      title: "Remove item",
      message:
        "Enter STT number or scan barcode/QR<br />to remove item from DEL list.",
      removed: "Removed",
      cancel: "Cancel",
      delete: "Delete",
      errorNotFound: "STT number not found or already removed"
    },
    pdf: {
      title: "Delivery Manifest",
      consolidatorCity: "Consolidator city",
      createdBy: "Created by",
      totalWeight: "Total weight",
      totalSttKoli: "Total STT/pieces",
      manifestDate: "Manifest date",
      courier: "Courier",
      no: "No.",
      sttNo: "STT number",
      refNo: "Reference number",
      productType: "Product type",
      service: "Service",
      pieceWeight: "Pieces/weight",
      demNo: "DEM number",
      ursaCode: "Ursa code",
      courierSignature: "Courier",
      supervisorSignature: "Operations Supervisor"
    }
  },
  dispatch: {
    searchPlaceholder: "Search dispatch number",
    createDispatch: "Create dispatch",
    last7Days: "Last 7 days",
    reload: "Reload",
    errorSystem: "System error occurred",
    errorSystemMessage: 'Click "Reload" or try again later.',
    errorInternet: "Internet connection lost",
    errorInternetMessage: 'Check your network then click "Reload".',
    no: "No",
    noDispatch: "Dispatch No.",
    jumlahSttKoli: "STT count (pcs)",
    totalWeight: "Total weight",
    createdAt: "Created at",
    courierShuttle: "Courier/Shuttle",
    atur: "Actions",
    downloadData: "Download data",
    printPdf: "Print PDF",
    filterCreatedBy: "Filter created by",
    all: "All",
    checker: "Checker",
    shuttle: "Shuttle",
    detail: "Detail",
    totalSttKoli: "Total STT (pcs)",
    courier: "Courier",
    courierNotFound: "Courier not found",
    shuttleNotFound: "Shuttle not found",
    courierOrShuttle: "Courier/shuttle",
    dispatchDate: "Dispatch date",
    searchSttDem: "Search STT/DEM number",
    printManifest: "Print manifest",
    jenisPengiriman: "Service type",
    deliveryType: "Delivery type",
    noReferensi: "Ref. No.",
    koli: "pcs",
    ursaCode: "Ursa code",
    noDem: "DEM No.",
    noStt: "STT No.",
    totalBerat: "Total weight",
    dispatchDelivery: "Dispatch delivery",
    manifestSuccess: "Manifest {dispatchNo} created successfully",
    processFailed: "Failed to create manifest",
    totalSttKoliShort: "Total STT/pcs",
    piecesGrossWeight: "Pieces/weight",
    weight: "Weight",
    process: "Process",
    searchPlaceholderUpdate: "Shipment/STT/DEM No.",
    allStatus: "All",
    success: "Success",
    failed: "Failed",
    ok: "OK",
    scanErrorAlreadyExists: "already exists in the list.",
    scanErrorAlreadyBookedLabel: "Shipment already booked",
    scanErrorAlreadyBooked: "Shipment was already booked on ",
    scanErrorSomeAlreadyBooked: "Some shipments were already booked on ",
    scanErrorInvalid: "invalid, check & modify.",
    scanErrorServer: "update failed due to system error. Check & try again.",
    scanErrorInternet:
      "update failed due to lost internet connection. Check & try again.",
    updatePrompt: "Let's update status to dispatch!",
    scanFailedListTitle: "Failed scan list",
    scanExample: "Example: DEM1234567894/88LP1234567890",
    scanPlaceholder: "Scan/input Shipment/STT/DEM No.",
    scanMessageDemSuccess: "updated successfully.",
    scanMessageDemPartial: "some STTs updated successfully.",
    scanMessageDemFailed: "failed to update.",
    scanMessageSttSuccess: "updated successfully.",
    scanMessageSttPartial: "some STTs updated successfully.",
    scanMessageSttFailed: "failed to update.",
    scanMessageSttFailedUnpaid: "failed to update because unpaid.",
    scanMessageSttFailedDestination:
      "failed to update due to destination city mismatch.",
    scanMessageSttFailedInHub:
      "STT failed to update because status is not yet In Hub",
    scanMessageSttFailedStatusMismatch:
      "failed to update due to status mismatch ({lastStatus}).",
    noPackageDispatch: "No packages dispatched yet",
    sttDemNotFound: "STT/DEM number not found",
    sttDemNotFoundHint: "Check again or search for another STT/DEM number.",
    pdf: {
      consolidatorCity: "Consolidator city",
      manifestDate: "Manifest date",
      createdBy: "Created by",
      totalSttKoli: "Total STT/pcs",
      totalBerat: "Total weight"
    },
    pdfFailed: {
      listTitle: "Failed dispatch list",
      consolidatorName: "Consolidator name",
      consolidatorCity: "Consolidator city",
      createdBy: "Created by",
      unpaid: "Unpaid",
      wrongDestination: "Destination city mismatch",
      wrongStatus: "Status mismatch ({lastStatus})"
    },
    selectCourierOrShuttle: "Select courier/shuttle",
    selectCourier: "Select courier",
    searchCourierOrShuttle: "Search courier or shuttle",
    searchCourier: "Search courier",
    referenceNo: "No. Reference",
    totalPieces: "Total Pieces",
    minimalCharacter: "Minimal {remaining} characters more",
    loading: "Loading data...",
    loadingMore: "Loading more data"
  },
  edit: "Edit",
  "Station admin": "Admin",
  handover: {
    menuTitle: "Handover",
    manifest: {
      destinationCity: "Destination city",
      consolidatorName: "Consolidator name",
      handoverTo: "Handover to",
      handoverDate: "Handover date",
      totalStt: "Total STT",
      totalPieces: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalDimensionWeight: "Total dimension weight",
      admin: "Admin",
      courier: "Courier",
      operationSupervisor: "Operation supervisor",
      totalSTT: "Total STT",
      pieces: "Total\npieces",
      serviceType: "Service type",
      commodity: "Commodity",
      grossWeight: "Gross\nweight",
      dimensionWeight: "Dimension\nweight",
      origin: "Origin",
      dest: "Dest.",
      note: "Note",
      stationAdmin: "Station Admin",
      operationsSupervisor: "Operations Supervisor"
    },
    update: {
      pageTitle: "Update handover",
      metaTitle: "Handover | Update handover",
      errorWeightExceeded:
        "Weight exceeded. Status cannot be updated to handover.",
      handoverTo: {
        title: "Handover to partner",
        placeholder: "Select vendor or partner"
      },
      vendorName: {
        title: "Internal Vendor",
        placeholder: "Input vendor name..."
      },
      sttNumber: {
        title: "No. STT",
        label: "Example : 99LP1234567890123/88-22-12345678",
        placeholder: "Input No. STT or Scan Barcode/QR Code"
      },
      add: "Add",
      sttInfo: {
        totalStt: "Total STT",
        totalPieces: "Total pieces",
        totalGrossWeight: "Total gross weight",
        totalDimensionWeight: "Total dimension weight",
        delete: "Delete",
        process: "Process"
      },
      table: {
        noRef: "No. Reference",
        product: "Service type",
        commodity: "Commodity",
        pieces: "Pieces",
        weight: "Gross weight",
        dimension: "Dimension weight"
      },
      onUpdate: {
        titleSuccess: "Update successful",
        titleFailed: "Update failed",
        messageSuccess: "STT status has been successfully updated to handover.",
        messagePartial:
          "Partial update to handover status. Check details & download STT:",
        messageFailed:
          "Failed to update status handover. Please download STT & reinput STT",
        noSttSuccess: "STT updated successfully.",
        noSttFailed: "STT failed to update."
      },
      leave: {
        title: "Leave this page?",
        message: "Your data will not be processed if you leave this page",
        textSuccess: "Leave",
        textCancel: "Keep here"
      },
      confirmation: {
        title: "Process to update status?",
        message: "Please make sure all STT details are correct.",
        textSuccess: "Proceed",
        textCancel: "Cancel"
      },
      removePieces: {
        title: "Delete item",
        message:
          "Enter STT number or scan barcode/QR to remove item <br />from handover list",
        errorCaption: "STT number not found or already removed",
        removed: "Removed",
        delete: "Delete",
        cancel: "Cancel"
      },
      process: {
        update: "Update handover",
        print: "Update & print PDF"
      }
    },
    list: {
      title: "Vendor Handover (HND)",
      detail: {
        title: "Handover Manifest - {id}",
        shipmentDetails: "Shipment Details",
        sttDetails: "STT Details",
        partnerName: "Partner Name",
        userType: "User Type",
        totalStt: "Total STT",
        totalPieces: "Total Pieces",
        totalGrossWeight: "Total Gross Weight",
        totalVolumeWeight: "Total Volume Weight",
        handoverStatus: "Handover status",
        createdAt: "Created At",
        printHandover: "Print Handover",
        printSummary: "Print Summary",
        printPdf: "Print PDF",
        number: "No.",
        sttNo: "No. STT/Shipment.",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Vol. Weight",
        origin: "Origin",
        destination: "Destination",
        reason: "Reason",
        viewReason: "View reason",
        successTab: "Successful handover ({n})",
        failedTab: "Failed handover ({n})"
      },
      searchId: "Search Manifest ID",
      searchSubConsole: "Search Sub Consolidator",
      update: "Update handover",
      statusHandover: {
        SUCCESS: "Success",
        FAILED: "Failed",
        PARTIAL_SUCCESS: "Partial Success"
      },
      statusHitApi: {
        SUCCESS: "Response Success",
        FAILED: "Response Failed",
        PARTIAL_SUCCESS: "Partial Success",
        UNPROCESSED: "No Call API",
        IN_PROGRESS: "Process",
        NON_API: "No API"
      },
      table: {
        no: "No.",
        idManifest: "ID Manifest",
        handoverTo: "Destination vendor",
        stt: "Total STT",
        pieces: "Total Pcs",
        weight: "Total gross weight",
        dimension: "Total volume weight",
        date: "Handover date",
        printSummary: "Print summary",
        printPdf: "Print PDF",
        download: "Download excel",
        printResiVendor: "Print Resi Vendor",
        action: "Manage",
        statusHandover: "Handover status",
        statusHitApi: "API Response Status",
        viewDetail: "View detail"
      },
      failedVendorModal: {
        title: "{n} STTs with Failed API Requests",
        sttNo: "STT/Shipment No.",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pieces",
        grossWeight: "Gross weight",
        volumeWeight: "Dim. weight",
        reason: "Reason",
        defaultReason: "No response from vendor",
        copiedReason: "Reason copied to clipboard",
        close: "Close"
      },
      retry: {
        menu: "Retry process",
        confirmTitle: "Retry handover process?",
        confirmBody:
          "The system will try to resend {n} failed STTs to the vendor.",
        confirmCancel: "Back",
        confirmSubmit: "Yes, retry",
        successTitle: "Handover processed successfully",
        successBody: "{n} STTs have finished the handover process.",
        successPrint: "Print manifest",
        successOk: "Okay",
        failedPrefix: "Failed to retry:",
        processTitle: "API Retry in Progress",
        processBody:
          "<strong>{n} STT</strong> are being reprocessed. Please wait until the process is complete.",
        processOk: "Ok",
        failedToast: "Failed to process API recall"
      },
      eligibilityModal: {
        title: "{n} STTs with Failed Handovers",
        sttNo: "No. STT/Shipment",
        product: "Product",
        commodity: "Commodity",
        pieces: "Pcs",
        grossWeight: "Gross weight",
        volumeWeight: "Dim. weight",
        reason: "Reason",
        close: "Close"
      }
    },
    detail: {
      pageTitle: "Handover | Detail",
      sectionDelivery: "Delivery detail",
      sectionStt: "STT detail",
      partnerName: "Partner name",
      userType: "User type",
      destinationCity: "Destination city",
      totalStt: "Total STT",
      totalPieces: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total volume weight",
      createdAt: "Created at",
      printHandover: "Print handover",
      printSummary: "Print summary",
      printPdf: "Print PDF",
      printResiVendor: "Print Resi Vendor",
      table: {
        no: "No.",
        stt: "STT No.",
        product: "Product",
        commodityName: "Commodity name",
        pieces: "Total pieces",
        grossWeight: "Gross weight",
        volumeWeight: "Volume weight",
        origin: "Origin",
        dest: "Dest.",
        download: "Download excel"
      }
    },
    failedVendorModal: {
      title: "List of {n} STT Failed to Hit API",
      sttNo: "STT No.",
      product: "Product",
      commodity: "Commodity",
      pieces: "Pieces",
      grossWeight: "Gross weight",
      volumeWeight: "Volume weight",
      close: "Close"
    },
    retry: {
      menu: "Retry process",
      confirmTitle: "Retry handover process?",
      confirmBody:
        "The system will try to resend {n} failed STTs to the vendor.",
      confirmCancel: "Back",
      confirmSubmit: "Yes, retry",
      successTitle: "Handover processed successfully",
      successBody: "{n} STTs have finished the handover process.",
      successPrint: "Print manifest",
      successOk: "Okay",
      failedPrefix: "Failed to retry:"
    },
    eligibilityModal: {
      title: "List of {n} STT Failed Handover",
      sttNo: "STT No./Shipment",
      product: "Product",
      commodity: "Commodity",
      pieces: "Pieces",
      grossWeight: "Gross weight",
      volumeWeight: "Volume weight",
      reason: "Reason",
      close: "Close"
    }
  },
  handoverV2: {
    update: {
      common: {
        successScan: "Scan successful.",
        failedScan: "Scan failed.",
        failedApi: "Failed to scan STT/Shipment ID barcode.",
        failedScanDownloadTitle: "Failed scan list",
        failedNotFound: "STT not found",
        failedExist: "STT already exist",
        failedUnpaid: "STT not paid yet",
        sttNo: "STT Number",
        reason: "Reason",
        product: "Product",
        commodity: "Commodity",
        all: "All",
        back: "Cancel",
        save: "Save",
        ok: "Ok",
        printManifest: "Print manifest"
      },
      scan: {
        placeholder: "Enter or scan STT barcode/shipment ID",
        example: "Example: 99LP1234567890123/88-22-12345678",
        errorMax: "Maximum of {max} STTs can be scanned"
      },
      filter: {
        search: "Search No. STT/Shipment "
      },
      table: {
        sttNo: "No. STT/Shipment",
        piece: "Pieces",
        grossWeight: "Gross Weight",
        volumeWeight: "Volume Weight",
        action: "Action",
        remove: {
          confirmTitle: "Delete STT {sttNo}?",
          confirmMessage: "Make sure you've selected the correct STT.",
          confirmButtonText: "Yes, delete",
          success: "STT {sttNo} successfully deleted."
        }
      },
      sidebar: {
        empty: {
          title: "No STT handed over yet",
          message: "Scan the STT barcode or Shipment ID to view vendor info."
        },
        changeVendor: "Change",
        placeholderInputVendorNameInternal: "Enter vendor name",
        totalStt: "Total STT",
        totalPieces: "Total Pieces",
        totalGrossWeight: "Total Gross Weight",
        totalVolumeWeight: "Total Volume Weight",
        processHandover: "Handover",
        cancel: "Cancel"
      },
      changeVendor: {
        title: "Change vendor",
        label: "Select vendor",
        placeholder: "Select vendor",
        success: "Vendor successfuly changed."
      },
      process: {
        confirmTitle: "Confirm handover process?",
        confirmMessage:
          "All scanned STT will be handed over to the destination vendor.",
        confirmButtonText: "Yes, process"
      },
      cancelProcess: {
        confirmTitle: "Cancel handover?",
        confirmMessage:
          "This will cancel the handover process for all scanned STT.",
        confirmButtonText: "Yes, next",
        success: "All STTs/shipments have been canceled for handover."
      },
      successProcess: {
        title: "Handover successful",
        message: "have been successfully handed over."
      },
      partialSuccessProcess: {
        title: "Handover partially successful",
        total: "Total",
        success: "Success",
        failed: "Failed"
      },
      errorProcess: {
        title: "Handover failed",
        message: "All STT failed to be handover."
      }
    }
  },
  "Shipment id tidak dapat digunakan": "Shipment ID cannot be used",
  podDex: {
    menuTitle: "POD/DEX",
    menuName: "POD/DEX",
    tabDelDex: "DEL/DEX",
    tabCodrej: "CODREJ",
    tabPod: "POD",
    searchPlaceholder: "Search STT No.",
    timeRangeDefault: "today",
    emptyStateHeader: "No POD/DEX data yet",
    emptyStateMessage:
      "All POD/DEX data (DEL/DEX, CODREJ, POD) will be listed here.",
    updateButton: "Update POD/DEX",
    downloadButton: "Download Data",
    columns: {
      no: "No.",
      noStt: "No. STT",
      noReferensi: "No. Reference",
      totalKoli: "Total pieces",
      beratDikenakanBiaya: "Chargeable weight",
      produk: "Product",
      statusTerakhir: "Latest status",
      komoditas: "Commodity",
      biayaCod: "COD fee",
      tipePembayaranCod: "COD payment type",
      tanggalDel: "DEL date",
      namaKurir: "Courier name",
      noTelpKurir: "Courier phone no.",
      dikirimOleh: "Delivered by",
      pengirimanKe: "Delivery Attempt",
      action: "Action"
    },
    statusLatest: "Latest Status",
    statusDel: "DEL",
    statusDex: "DEX",
    updateModalTitle: "Update POD/DEX",
    update: {
      noStt: "No. STT",
      totalKoli: "Total pieces",
      beratDikenakanBiaya: "Chargeable weight",
      biayaCod: "COD fee",
      produk: "Product",
      komoditas: "Commodity",
      namaPenerima: "Recipient name",
      alamatPenerima: "Recipient address",
      noTelpPenerima: "Recipient phone no.",
      infoKurir: "Courier info",
      terkirim: "Delivered",
      pilih: "Select",
      ya: "Yes",
      tidak: "No",
      placeholderNamaPenerima: "Enter recipient name",
      konfirmasiPerubahan: "Confirm change",
      confirmMessagePod:
        "Enter recipient name and attach delivery proof to update status to POD.",
      confirmMessageDex:
        "Select reason for undelivered parcel and attach proof for status change to DEX.",
      pilihRelasi: "Select relation",
      alasanTidakTerkirim: "Reason not delivered",
      alasanKendala: "Reason / constraint",
      placeholderAlasan: "Briefly describe the constraint...",
      buktiPengiriman: "Delivery proof",
      kembali: "Back",
      update: "Update",
      successTitle: "Status updated successfully",
      successMessagePod:
        "STT status has been updated to POD. Recipient name will appear in shipment status detail.",
      successMessageDex:
        "STT status has been updated to DEX. Undelivered reason will appear in shipment status detail.",
      inginPodDex: "POD/DEX this parcel?",
      sttRtsHal: "This STT is already marked as RTS/HAL",
      pilihAlasan: "Select reason",
      ok: "OK"
    },
    advanceFilter: {
      filter: "Filter",
      reset: "Reset",
      tipeStt: "STT type",
      placeholderTipeStt: "Select STT type",
      tipePembayaranCod: "COD payment type",
      placeholderTipePembayaranCod: "Select COD payment type",
      semua: "All",
      cod: "COD",
      nonCod: "Non COD",
      cash: "Cash",
      qris: "QRIS",
      gratis: "FREE"
    },
    download: {
      modalTitle: "Download Report",
      tanggal: "Date",
      timeRangeDefault: "today",
      searchButton: "Search",
      errorMessage: "Download failed"
    },
    unpaidModal: {
      title: "Ensure STT is paid",
      message:
        "Check that adjusted or overweight STT numbers have been fully paid.",
      ok: "OK"
    },
    proofButton: "Proof",
    filter: {
      filter: "Filter",
      reset: "Reset",
      sttType: "STT Type",
      selectSttType: "Select STT type",
      codPaymentMethod: "COD Payment Method",
      selectCodPaymentMethod: "Select COD payment method",
      all: "All",
      free: "FREE"
    }
  },
  verificationAccount: {
    passwordExpired: {
      title: "Password Has Expired",
      message: "Please reset your password to keep your account secure.",
      button: "Set password"
    },
    title: "Account Verification",
    description:
      "For account security, verify your {method} to reset your password",
    send: "Send",
    useOtherMethod: "Use another verification method",
    useMethodWith: "Use verification method with",
    email: "email",
    phoneNumber: "phone number",
    helpWhatsApp: "Need help? Contact via WhatsApp",
    orEmailTo: "or email to",
    chooseMethodTitle: "Choose Verification Method",
    methods: {
      partnerClientCode: "Partner/Client Code",
      partnerClientId: "Partner/Client ID",
      userEmail: "User Email",
      userPhone: "User Phone Number",
      partnerClientEmail: "Partner/Client Email",
      partnerClientPhone: "Partner/Client Phone Number"
    },
    captions: {
      partnerClientEmail: "partner/client email",
      partnerClientPhone: "partner/client phone number"
    },
    placeholders: {
      email: "e.g email{'@'}gmail.com",
      partnerClientCode: "Enter Partner/Client Code",
      partnerClientId: "Enter Partner/Client ID",
      yourPhoneNumber: "Enter your phone number"
    },
    otp: {
      title: "OTP Code Verification",
      description: "Enter the verification code sent via",
      userEmail: "User email",
      partnerClientEmail: "Partner/client email",
      partnerClientPhone: "Partner/client phone number",
      verify: "Verify",
      resendIn: "Resend OTP code in {countDown}",
      notReceivedCode: "Haven't received the code?",
      resend: "Resend",
      wrongCode: "The code entered is incorrect. Please check and try again."
    },
    changeAccount: "Change Account",
    haveNoHub: "Don't have a Hub?",
    clickHere: "Click here"
  },
  resetPasswordPage: {
    logoAlt: "logo",
    errorIconAlt: "warning icon",
    title: "Reset Password",
    newPasswordLabel: "New Password",
    newPasswordPlaceholder: "Enter password",
    confirmNewPasswordLabel: "Confirm New Password",
    confirmNewPasswordPlaceholder: "Enter password confirmation",
    passwordReuseError:
      "Password must not be the same as the previous password",
    submitButton: "Reset Password",
    back: "Back",
    tryAgain: "Try Again",
    ok: "OK",
    successModal: {
      title: "Password Changed!",
      message: "Your password has been changed"
    },
    rules: {
      minEightChars: "Password must be at least 8 characters",
      containsNumber: "Password contains a number",
      containsUppercase: "Password contains an uppercase letter",
      confirmPassword: "Confirm new password"
    }
  },
  setupPassword: {
    title: "Set Up New Account Password",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    submitButton: "Set password",
    rules: {
      eightChars: "Password must be at least 8 characters",
      containsNumber: "Password must contain a number",
      containsUppercase: "Password must contain an uppercase letter",
      noGenesis: "Must not contain the word 'genesis'",
      passwordMatch: "Confirm new password"
    },
    helpWA: "Need help? Contact via WhatsApp",
    helpEmail: "or email to",
    success: {
      title: "New Password Saved",
      message: "You can now use your new password to login to Genesis.",
      button: "Login"
    },
    loginGenesis: "Login to Genesis",
    urlUsed: "Link Has Been Used",
    messageUsed:
      "You have set a new password. Please log in to Genesis <br /> with your new password.",
    urlInvalid: "Link is no longer active",
    messageInvalid: "Please contact the helpdesk team for further assistance.",
    expired: {
      title: "Link Has Expired",
      description:
        "Please click the button below to re-request the new password <br /> setup link.",
      requestNewUrl: "Request New Link",
      success: "New link has been sent"
    },
    placeholderPassword: "Input password",
    placeholderConfirmPassword: "Input confirmation password",
    error: {
      title: "Failed to Create New Password",
      message:
        "A server error occurred while processing your request. Please try again later.",
      button: "OK"
    }
  },
  forgotPassword: {
    title: "Forgot Password",
    hint: "Don't worry! Input your email address to reset your password",
    emailPlaceholder: "Input email",
    submitButton: "Reset Password",
    backToLogin: "Back to Log In",
    errorEmptyEmail: "Input your email !",
    errorInvalidEmail: "Your email is incorrect or not registered. Try again",
    modalSuccessTitle: "Request Accepted!",
    modalSuccessMessage: "Link to reset your password has been sent to {email}",
    modalFailTitle: "Unable to Change Password",
    modalFailMessage:
      "Account with email {email} has changed password 3 times. Contact Lion Parcel for further details",
    expired: {
      title: "Expired Link",
      body: "Link to request a new password has expired…",
      backButton: "Back to Genesis"
    }
  },
  cariStt: {
    menuTitle: "Search STT",
    menuName: "Search STT Manifest",
    pageTitle: "Search STT Manifest",
    searchPlaceholder: "Search manifest ID",
    emptyState: "No data available",
    emptyStateDescription:
      "Data will appear here automatically when available.",
    searchNotFound: "Search results not found",
    searchNotFoundDescription: "Please check your keyword or filter.",
    columnNo: "No.",
    columnManifestNo: "No. Manifest",
    columnTotalStt: "Total STT",
    columnTotalKoli: "Total Koli",
    columnTotalSttHanging: "Total STT Hanging",
    columnTanggalManifest: "Manifest Date",
    columnAtur: "Actions",
    scanButton: "Search STT",
    printManifest: "Print Manifest",
    downloadCsv: "Download CSV",
    scanPageTitle: "Search STT",
    scanEmptyState: "No packages scanned yet.",
    errorProcessManifest: "Process Manifest Failed",
    errorFetchList: "Failed to fetch STT data",
    filterSearchPlaceholder: "Search STT no.",
    filterLastStatus: "Last status",
    filterLocation: "Last location",
    processManifestButton: "Process manifest",
    table: {
      hanging: "Hanging",
      nonHanging: "Non-Hanging",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      no: "No.",
      noStt: "No. STT",
      lastLocation: "Last Location",
      lastStatus: "Last Status",
      note: "Note",
      emptyState: "No data available"
    },
    pdf: {
      title: "Search STT Manifest",
      days: "days",
      partnerName: "Partner name",
      partnerCity: "Partner city",
      totalSttKoli: "Total STT /Pieces",
      totalSttHangingKoli: "Total STT Hanging /Pieces",
      manifestDateHanging: "Hanging manifest date",
      userManifest: "Manifest user",
      noRef: "Ref. no.",
      productType: "Product type",
      lastStatus: "Last Status",
      hanging: "Hanging",
      hangingType: "Hanging Type",
      originCity: "Origin City",
      destCity: "Destination City",
      staffAdmin: "Staff Admin",
      courier: "Courier",
      operationsSupervisor: "Operations Supervisor"
    },
    scan: {
      selectLocation: "Choose the scan area location",
      selectLocationDescription:
        "Please select the scan area below based on your current location",
      cancel: "Cancel",
      confirmLocation: "Confirm Location",
      others: "Others",
      othersPlaceholder: "Please input your scan area location"
    }
  },
  "Muat Lebih Banyak": "Load More",
  dexAssessmentDashboard: {
    breakdownTicketDex: "DEX Ticket Breakdown",
    breakdownTicketDexSanggahL2: "DEX Ticket Dispute L2 Breakdown",
    top20KonsolTiketDex: "Top 20 Consolidator DEX Tickets",
    top10KonsolTiketDexSanggahL2: "Top 10 Consolidator DEX Dispute L2 Tickets",
    listAgentCsL1: "CS L1 Agent List",
    listAgentCsL2: "CS L2 Agent List",
    sortOrder: "Sort",
    searchCsName: "Search CS name",
    emptyListAgentCsL1: "No CS L1 Agent List",
    emptyListAgentCsL2: "No CS L2 Agent List",
    columnNo: "No",
    columnNamaCs: "CS Name",
    columnStatus: "Status",
    columnKuotaTiket: "Ticket Quota",
    columnTiketDiassign: "Tickets Assigned",
    columnTiketSelesai: "Tickets Completed",
    columnPersentaseTiketSelesai: "Completion Percentage",
    columnRataRataWaktuSelesai: "Average Completion Time",
    columnTotalJamAktif: "Total Active Hours",
    statusActive: "Active",
    statusInactive: "Inactive",
    sortPercentageDoneHighest: "Highest completion percentage",
    sortPercentageDoneLowest: "Lowest completion percentage",
    totalTicketDexPerHari: "Total DEX Tickets Per Day",
    totalTicketDexSanggahL2PerHari: "Total DEX Dispute L2 Tickets Per Day",
    totalPercobaanTicketDex: "Total DEX Attempt Tickets",
    courierLabel: "Courier:",
    totalTicketDexLabel: "Total DEX Tickets:",
    emptyTop10Konsol: "No Top 10 Consolidators",
    emptyTop10KonsolMessage:
      "Start creating Top 10 Consolidators and check the list here",
    emptyKurir: "No Couriers",
    emptyKurirMessage: "Start creating Couriers and check the list here",
    totalCustomerService: "Total Customer Service",
    totalCsL1: "Total Customer Service L1",
    totalCsL2: "Total Customer Service L2",
    penyelesaianTercepat: "Fastest completion",
    penyelesaianTerlama: "Slowest completion",
    persentaseSelesaiTerbanyak: "Highest completion percentage",
    persentaseSelesaiTersedikit: "Lowest completion percentage",
    ringkasanDexIndikasiPalsu: "Fake DEX Indication Summary",
    totalTicketDexIndikasiPalsu: "Total Fake DEX Indication Tickets",
    ticketDexDariAlasanDex: "DEX Tickets by DEX Reason",
    totalTicketDexBerdasarkanRentangWaktu: "Total DEX Tickets by Time Range",
    backlogTicketDexAgenCsL1: "DEX Ticket Backlog for CS L1 Agents",
    backlogTicketDexAgenCsL2: "DEX Ticket Backlog for CS L2 Agents",
    titleChartByReason: "DEX Tickets by Reason",
    titleChartByReasonDispute: "DEX Dispute L2 Tickets by Reason"
  },
  posBranch: {
    pageTitle: "Branch POS & Pickup List",
    list: {
      searchPlaceholder: "Search POS name",
      createPos: "Create POS",
      emptyMessage: "No POS data to display",
      column: {
        no: "No.",
        posCode: "POS Code",
        posName: "POS Name",
        posType: "POS Type",
        districtCity: "District, City",
        lastTransaction: "Last transaction",
        balanceAvailable: "Available balance",
        partnerAreaName: "Partner area name",
        contractStatus: "Contract status",
        partnerStatus: "Partner status",
        action: "Action"
      },
      filter: {
        filter: "Filter",
        reset: "Reset",
        contractStatus: "Contract status",
        partnerStatus: "Partner status",
        posType: "POS type",
        selectStatus: "Select status",
        selectPosType: "Select type",
        originCity: "Origin city"
      },
      contractStatus: {
        active: "Active",
        waiting: "Waiting",
        nearlyExpired: "Nearly expired",
        expired: "Expired"
      },
      posType: {
        parent: "POS Parent",
        branch: "POS Child",
        pickup: "POS Pickup"
      },
      status: {
        freezed: "Freezed",
        notFreezed: "-",
        active: "Active",
        inactive: "Inactive"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze"
      }
    },
    detail: {
      pageTitle: "Branch POS & Pickup List | Detail",
      title: "Branch POS Detail",
      contractStatus: "Contract status",
      partnerStatus: "Partner status",
      balanceAvailable: "Available balance",
      tierLevel: "Tier level",
      createdAt: "Created date",
      updatedAt: "Last updated",
      qrCode: "QR code",
      tab: {
        parent: "Parent POS Detail",
        branchList: "Branch POS & Pickup List"
      },
      status: {
        freezed: "Freezed"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze",
        edit: "Edit",
        downloadQr: "Download QR Code"
      },
      contact: {
        title: "Contact Information",
        name: "Name",
        phone: "Phone number",
        jobTitle: "Job title",
        email: "Email"
      }
    }
  },
  userManagement: {
    pageTitle: "User Management",
    list: {
      title: "User Management",
      searchPlaceholder: "Search username or user ID",
      createUser: "Create User",
      emptyData: "user data",
      filter: {
        filter: "Filter",
        reset: "Reset",
        accountType: "Account Type",
        reference: "Reference",
        hub: "Hub",
        division: "Division",
        status: "Status",
        selectAccountType: "Select account type",
        selectReference: "Select reference",
        selectHub: "Select hub",
        selectDivision: "Select division",
        selectStatus: "Select status"
      },
      column: {
        userId: "User ID",
        username: "Username",
        email: "Email",
        phoneNumber: "Phone Number",
        accountType: "Account Type",
        division: "Division",
        reference: "Reference",
        role: "Role",
        hub: "Hub",
        shuttle: "Shuttle",
        accountStatus: "Account Status"
      }
    },
    detail: {
      userId: "User ID",
      username: "Username",
      accountType: "Account Type",
      division: "Division",
      role: "Role",
      assignedTo3lc: "Assigned to 3LC",
      all3lc: "All",
      phoneNumber: "Phone Number",
      email: "Email",
      reference: "Reference",
      shuttle: "Shuttle",
      hub: "Hub",
      hubCode: "Hub Code",
      hubName: "Hub Name",
      createdAt: "Created Date",
      updatedAt: "Last Updated",
      accountStatus: "Account Status",
      edit: "Edit",
      resetPassword: "Reset Password",
      noHub: "No hub",
      deviceInfo: "Your Device Information",
      confirmed: "Confirmed"
    },
    edit: {
      title: "Edit User",
      save: "Save",
      username: "Username",
      email: "Email",
      phoneNumber: "Phone Number",
      accountType: "Account Type",
      role: "Role",
      reference: "Reference",
      accountStatus: "Account Status",
      accountStatusDescription:
        "Accounts with active status can be used for login. You can activate or deactivate the account at any time.",
      accountActive: "Active",
      accountInactive: "Inactive",
      statusUser: "User Status",
      createdAt: "Created Date",
      lastUpdated: "Last Updated",
      modalDeactivateTitle: "Deactivate Account",
      modalDeactivateMessage:
        "While the user is inactive, the account cannot be used for login",
      modalActivateTitle: "Activate Account",
      modalActivateMessage:
        "While the user is active, the account can be used for login",
      modalDeactivate: "Deactivate",
      modalActivate: "Activate",
      back: "Back",
      modalSuccessTitle: "Changes Saved",
      modalConfirmTitle: "Confirm Account Changes",
      modalConfirmMessage:
        "Are you sure you want to save account changes for {name}?",
      modalLeaveTitle: "Are you sure you want to leave?",
      modalLeaveMessage:
        "Please confirm. You will lose all data if you leave this page.",
      leave: "Leave",
      ok: "OK",
      modalSuccessMessage: "User {name} has been updated successfully"
    },
    modalEditDetail: {
      oldEmail: "Old Email",
      newEmail: "New Email",
      placeholderNewEmail: "Enter new email",
      active: "Active",
      inactive: "Inactive",
      statusInfo:
        "Inactive accounts cannot perform any activities until reactivated. You can change status at any time.",
      selectRole: "Select Role",
      modal3lcTitle: "Selected 3LC Origin",
      cityOptionName: "city",
      all: "All",
      searchOrSelect3lc: "Search or select 3LC",
      selectHub: "Select hub",
      selectDivision: "Select division",
      selectShuttle: "Select shuttle",
      save: "Save",
      noShuttle: "No shuttle",
      titleStatus: "Change Account Status",
      titleEmail: "Change Email",
      titleRole: "Change Role",
      title3lc: "Change assigned 3LC",
      titleDefault: "Change",
      confirmStatusTitle: "Confirm {action}",
      activation: "Activation",
      deactivation: "Deactivation",
      statusInactiveMessage:
        "Inactive accounts cannot perform any activities until reactivated.",
      back: "Back",
      activate: "Activate",
      deactivate: "Deactivate",
      payloadTypeStatusAccount: "Account Status",
      statusSuccess: "{action} status updated successfully!",
      payloadTypeEmail: "Email",
      confirmChangeTitle: "Confirm Changes",
      confirmChangeMessage:
        "Are you sure you want to save account detail changes for username “{username}”?",
      confirmHubTitle: "Confirm hub data changes",
      confirmHubMessage: "Are you sure the changed hub data is correct?",
      yesSave: "Yes, save",
      confirmDivisionTitle: "Confirm division data changes",
      confirmDivisionMessage:
        "Are you sure the changed division data is correct?",
      confirmShuttleTitle: "Confirm shuttle data changes",
      confirmShuttleMessage:
        "Are you sure the changed shuttle data is correct?",
      hubUpdatedTitle: "Hub data updated successfully",
      ok: "OK",
      emailUpdatedSuccess: "Email updated successfully!",
      roleUpdatedSuccess: "Role updated successfully!",
      roleUpdateFailed: "Failed to update role!",
      assigned3lcConfirmTitle: "Change this 3LC assignment?",
      assigned3lcConfirmMessage:
        "Please make sure the user data you changed is correct.",
      assigned3lcUpdatedTitle: "Account 3LC updated successfully",
      assigned3lcUpdatedMessage:
        "Account “{accountId}” access for 3LC “{assigned3lc}” has been updated."
    },
    resetPassword: {
      modalTitle: "Confirm Change",
      modalMessage:
        'You have requested a password reset. The new password will be sent to <span class="text-blue-600 underline">{email}</span>.',
      cancel: "Back",
      submit: "Reset",
      successMessage:
        "Password reset successful. The new password has been sent to {email}",
      errorTitle: "Reset Password Failed"
    },
    add: {
      pageTitle: "Create User",
      title: "Create New User",
      save: "Save",
      accountType: "Account Type",
      selectAccountType: "Select account type",
      division: "Division",
      selectDivision: "Select division",
      reference: "Reference",
      selectReference: "Select reference",
      role: "Role",
      selectRole: "Select role",
      hub: "Hub",
      selectHub: "Select hub",
      shuttleOptional: "Shuttle (optional)",
      selectShuttle: "Select shuttle",
      assignedTo3lc: "Assigned to 3LC",
      modal3lcTitle: "Selected 3LC Origin",
      all3lc: "All 3LC",
      searchOrSelect3lc: "Search or Select 3LC",
      username: "Username",
      placeholderUsername: "Enter user name",
      usernameFormatInvalid: "Username format is invalid",
      usernameRule1: "Username may only contain letters and full stops.",
      usernameRule2: "Username will be used for login with format:",
      email: "Email",
      placeholderEmail: "e.g email{'@'}gmail.com",
      phoneNumber: "Phone Number",
      placeholderPhone: "e.g 1123451234",
      emailInvalid: "The email you entered is invalid",
      emailDomainInvalid: "Email domain is not registered and valid",
      modalSuccessTitle: "Create New User Complete",
      all: "All",
      modalSuccessMessage:
        "User with name {name} has been created successfully",
      confirmLeaveTitle: "Are you sure you want to leave?",
      confirmLeaveMessage:
        "Please confirm. You will lose all data if you leave this page.",
      leave: "Leave",
      back: "Back",
      confirmCreateTitle: "Confirm User Creation",
      confirmCreateMessage:
        "Are you sure you want to save user with name {name}?",
      ok: "OK",
      errorTitle: "Failed to create user"
    }
  },
  managementCustomer: {
    tab: {
      alamat: "Address",
      savedPackage: "Saved packages"
    },
    savedPackage: {
      detailTitle: "Item and package details",
      addButton: "Add saved package",
      empty: "No saved package yet",
      emptyTitle: "No data yet",
      emptyDescription: "No saved package data to display at this time.",
      deleteConfirmTitle: "Confirm delete",
      deleteConfirmMessage: "Are you sure you want to delete this saved package?",
      deleteConfirmSubmit: "Delete data",
      deleteConfirmCancel: "Back",
      koli: "package"
    },
    pageTitle: "Customer Management",
    addPageTitle: "Add customer",
    editPageTitle: "Edit customer",
    searchPlaceholder: "Search by name or phone number",
    filterDistrict: "District, city",
    filterZipCode: "Postal code",
    filterSort: "Sort by",
    placeholderDistrict: "Select district, city",
    placeholderZipCode: "Type & select postal code",
    column: {
      name: "Name",
      phone: "Phone no.",
      email: "Email",
      address: "Address",
      district: "District, city",
      zipCode: "Postal code",
      addressType: "Address type",
      createdAt: "Created",
      updatedAt: "Updated",
      action: "Action"
    },
    emptyTitle: "No customer data yet",
    emptyMessageSearch: "Customer name or phone number not found.",
    emptyMessageSearchFilter: "No customer found with the selected filters",
    bulkButton: "Bulk customer",
    addButton: "Customer",
    actionDetail: "Detail",
    actionEdit: "Edit",
    actionListStt: "View STT list",
    actionDelete: "Delete",
    form: {
      detailInfo: "Detail Information",
      name: "Name",
      phone: "Phone no.",
      email: "Email",
      commodity: "Commodity",
      note: "Customer note",
      address: "Address",
      district: "District, city",
      zipCode: "Postal code",
      addressType: "Address type"
    },
    placeholder: {
      name: "Enter customer name",
      email: "e.g. name{'@'}email.com",
      commodity: "Search & select commodity",
      note: "Enter customer note",
      address: "Enter customer address",
      district: "Type & select customer district, city",
      zipCode: "Type & select postal code",
      addressType: "Select address type "
    },
    validation: {
      phoneRequired: "Phone number is required",
      emailInvalid: "Invalid email",
      nameRequired: "Name is required",
      nameMin: "Name must be at least 3 characters",
      nameMax: "Name must not exceed 100 characters",
      addressRequired: "Address is required",
      addressMin: "Address must be at least 3 characters",
      addressMax: "Address must not exceed 200 characters",
      noteMin: "Note must be at least 3 characters",
      noteMax: "Note must not exceed 200 characters"
    },
    save: "Save",
    detailTitle: "Customer Detail",
    delete: "Delete",
    edit: "Edit",
    createdAt: "Created",
    updatedAt: "Updated",
    bulk: {
      title: "Upload File",
      description:
        "Ensure all data you entered is correct and matches the file to be uploaded. Learn how to fill the bulk upload template",
      descriptionLink: "here",
      activityName: "Activity Name",
      activityNamePlaceholder: "Enter upload activity name",
      uploadFile: "Upload file",
      uploadFileCaption: ".csv up to 25,000 rows",
      historyTitle: "Upload file history",
      historyEmpty: "No upload file history yet",
      cancel: "Cancel",
      submit: "Upload",
      statusSuccess: "Success",
      statusPartially: "Partially successful",
      statusFailed: "Failed",
      statusUploading: "Uploading",
      fileError: "File error",
      fileFailed: "Failed file",
      fileOriginal: "Original file",
      download: "Download"
    },
    deleteConfirmTitle: "Confirm delete",
    deleteConfirmMessage: "Are you sure you want to delete this customer data?",
    deleteConfirmSubmit: "Delete data",
    back: "Back",
    confirmEditTitle: "Confirm change",
    confirmEditMessage: "Are you sure you want to change this customer data?",
    confirmEditSubmit: "Change data",
    modalPhoneExistsTitle: "Name & phone number already registered",
    modalPhoneExistsMessage: "Check and update to save customer data.",
    modalPhoneExistsSubmit: "Edit",
    orderByNewest: "Newest",
    orderByOldest: "Oldest",
    addressTypeHome: "Home",
    addressTypeOffice: "Office",
    optionalLabel: "Optional",
    deleteSuccess: 'Customer "{name}" has been deleted successfully!',
    addSuccess: 'Customer "{name}" has been added successfully!',
    editSuccess: 'Customer "{name}" has been updated successfully!',
    deleteError: "Failed to delete customer"
  },
  Beranda: "Dashboard",
  "Pengiriman | Detail": "Shipment | Detail",
  "Lacak Pengiriman": "Track Shipment",
  "Daftar Booking": "Booking List",
  "Booking Bulk": "Bulk Booking",
  "Manual STT": "Manual STT",
  "Cetak Tagihan": "Print Invoice",
  "Cetak Resi": "Print Receipt",
  "CN Manifest": "CN Manifest",
  "Pesanan Kulioner": "Kulioner Orders",
  "STT Dalam Proses": "On Process STT",
  "Manajemen Kiriman Penting": "Urgent Delivery Management",
  "Kiriman Penting": "Urgent Delivery",
  "Request HAL": "Request HAL",
  "Proses PUP": "PUP Process",
  "Proses STI SC": "STI SC Process",
  "Proses STO SC": "STO SC Process",
  "Proses STI": "STI Process",
  "Proses BAG": "BAG Process",
  "Proses RTC": "RTC Process",
  "Proses CARGO": "CARGO Process",
  "Proses STIDEST": "STIDEST Process",
  "Delivery Manifest": "Delivery Manifest",
  Delivery: "Delivery",
  "POD/DEX": "POD/DEX",
  "Transfer Hub (IN OUT HUB)": "Hub to Hub",
  "Proses DISPATCH": "Dispatch Process",
  "Handover Vendor (HND)": "Vendor Handover (HND)",
  "STT Shortland": "Shortland Cargo",
  "Proses Custom Status": "Custom Status Process",
  "Performa DEX Asesmen": "DEX Assessment Performance",
  "DEX Asesmen": "DEX Assessment",
  "Daftar DEX Asesmen": "DEX Assessment List",
  "Rekon Delivery": "Delivery Reconciliation",
  "Manajemen Pelanggan": "Customer Management",
  "POS Langganan": "POS Subscription",
  "Manajemen Kurir": "Courier Management",
  "Manajemen POS Cabang & Di-Pickup": "Branch POS & Pickup Management",
  "Manajemen Korporat": "Corporate Management",
  "Manajemen Partner": "Partner Management",
  "Manajemen User": "User Management",
  "Pusat Resolusi": "Resolution Center",
  "Base Rate": "Base Rate",
  "Konversi Mata Uang": "Currency Conversion",
  "Konfigurasi Harga": "Price Configuration",
  "Tarif Komoditas": "Commodity Tariff",
  "Pajak Barang": "Goods Tax",
  "Konfigurasi Komisi": "Commission Configuration",
  "Promo Diskon": "Promo Discount",
  "Konfigurasi COD": "COD Configuration",
  "Jenis Pengiriman": "Product",
  Embargo: "Embargo",
  "Area Cakupan": "Location Coverage",
  "Manajemen Leg": "Leg Management",
  "Manajemen Rute": "Route Management",
  "Manajemen Vendor": "Vendor Management",
  "Manajemen Moda": "Transport Management",
  "Bagging Grouping": "Bagging Grouping",
  "Konfigurasi Kargo": "Cargo Configuration",
  "Area Keterlambatan": "Delay Area",
  "Dokumen Internasional": "International Document",
  "Verifikasi Top Up": "Top Up Verification",
  "Approval Top Up": "Top Up Approval",
  "Manual Transaksi": "Manual Transaction",
  "Konfigurasi Batas Saldo": "Balance Limit Configuration",
  "Saldo Terakhir": "Last Balance",
  "Transaksi Saldo Nett": "Net Balance Transaction",
  "Konfigurasi Denda Saldo Minus": "Minus Balance Penalty Configuration",
  "Konfigurasi Top Up & Cashback": "Top Up & Cashback Configuration",
  "Konfigurasi Kuota Tiket CS": "CS Ticket Quota Configuration",
  "Automasi Indikasi DEX Palsu": "Fake DEX Indication",
  "Incoming & Outgoing": "Incoming & Outgoing",
  Pengumuman: "Announcement",
  "Konfigurasi Pesan": "Message Configuration",
  "Monitoring Integrasi API": "API Integration Monitoring",
  Middleware: "Middleware",
  "Konfigurasi Banner": "Banner Configuration",
  "Daftar Pick Up": "Pickup List",
  "Konfigurasi Jadwal Pick up": "Pickup Schedule Configuration",
  "Integrasi API": "API Integration",
  "report.title": "Report",
  "Unggah Data": "Upload Data",
  "Unduh Format & Data": "Download Format & Data",
  "Masukan & Saran": "Feedback",
  Notifikasi: "Notification",
  Profil: "Profile",
  "Proses STIDEST SC": "STI DEST-SC Process",
  "DEX Asesmen L2": "Customer Service L2",
  "DEX Asesmen L1": "Customer Service L1",
  "Cari STT": "Search STT",
  "Manifest cari STT": "Search STT Manifest",
  "Manifest cari STT | Scan": "Search STT Manifest | Scan",
  sttPaidUnpaid: {
    labelSearch: "Search",
    placeholderSearch: "Search STT No.",
    labelPaymentStatus: "Payment Status",
    placeholderPaymentStatus: "Select payment status",
    labelProcessStatus: "Process Status",
    placeholderProcessStatus: "Select process status",
    labelCityOrigin: "Origin City",
    placeholderCityOrigin: "Select origin city",
    labelCityDestination: "Destination City",
    placeholderCityDestination: "Select destination city",
    labelDateModified: "Date Modified",
    titleDateRange: "Payment Date",
    defaultDateRange: "Last 7 days",
    downloadStt: "Download STT",
    emptyData: "STT Paid/Unpaid data",
    colNoStt: "No. STT",
    colLastStatus: "Last Status",
    colPaymentStatus: "Payment Status",
    colPaymentDate: "Payment Date",
    colBookingDate: "Booking Date",
    colProcessStatus: "Process Status",
    colOriginCity: "Origin City",
    colDestinationCity: "Destination City",
    colDateModified: "Date Modified",
    statusPaid: "Paid",
    statusUnpaid: "Unpaid",
    statusCodPayment: "COD Payment",
    processStateProcessed: "Processed",
    processStateNotProcessed: "Not Processed",
    processStateNeedToPay: "Need to Pay",
    processStateNeedToCancel: "Need to Cancel",
    downloadFailed: "Download STT Failed!",
    totalNotification: "{total} new paid STTs"
  },
  sti: {
    pageTitle: "Station Transit In",
    searchPlaceholder: "Search Manifest ID",
    searchPlaceholderReverseScan: "Search Manifest ID",
    timeRangeDefault: "Last 7 days",
    updateButton: "Update STI",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    manifestId: "Manifest ID",
    no: "No.",
    action: "Action",
    actionArrange: "Arrange",
    detailTitle: "STI Manifest - {id}",
    printSti: "Print STI",
    dataUpdatedEvery10Min: "Data is updated every 10 minutes",
    refresh: "Refresh",
    totalUnprocessedSti: "Total unprocessed STI",
    partner: "Partner",
    stiCurrent: "Current STI",
    stiOverdue: "STI Overdue",
    unitStt: "STT",
    printSttNeedSti: "Print STT Pending STI",
    downloadSttNeedSti: "Download STT Pending STI",
    printRingkasan: "Print Summary",
    downloadExcelLower: "Download Excel",
    tanggalManifest: "Manifest Date",
    noStt: "No. STT",
    origin: "Origin",
    sttLabel: "STT",
    datePlaceholder: "Select date",
    listFailedTitle: "Scan Failed List",
    reasonFailed: "Reason Failed",
    nomorStt: "STT Number",
    sttFailedScan: "STT Failed Scan",
    needToSti: {
      pageTitle: "STT Pending STI",
      searchPlaceholder: "Search STT/bag/shipment no.",
      allPartner: "All Partner",
      filterNow: "Current",
      filterOverdue: "Overdue",
      download: "Download",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      noReferensi: "Reference No.",
      lastStatus: "Last Status",
      productType: "Product Type",
      totalPieces: "Total Pieces",
      totalWeight: "Total Weight",
      destinationCity: "Destination City",
      bookingDate: "Booking Date",
      partnerName: "Partner Name",
      deadline: "Deadline",
      overdue: "Overdue"
    },
    updateSti: {
      scanPromptEmpty: "Start entering/scanning STT numbers now.",
      searchPlaceholderBagStt: "Search Bag/STT no.",
      allPartner: "All Partner",
      packageMarker: "Package Marker",
      processManifest: "Process manifest",
      totalSttKoli: "Total STT/pieces",
      grossWeight: "Gross Weight",
      notFoundFilter: "Bag/STT number not found.",
      noPackageScanned: "No packages scanned yet.",
      modalConfirmMessage:
        "Some STT are not yet in STI. Continue process manifest?",
      modalConfirmSubtext:
        "If you continue, STT not yet in STI will be marked as STI overdue.",
      modalConfirmButton: "Yes, continue manifest",
      productType: "Product Type",
      partnerName: "Partner Name",
      podDeadline: "POD Deadline",
      seeMore: "See more"
    },
    pdf: {
      listSttNeedToSTI: "List STT must STI",
      manifestTitle: "STI-DEST Manifest",
      consolidatorName: "Consolidator Name",
      arrivalCity: "Arrival City",
      tanggalStiDest: "STI-DEST Date",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      produk: "Product",
      komoditas: "Commodity",
      totalKoliShort: "Total\nPieces",
      beratKotor: "Gross\nWeight",
      beratDimensi: "Volume\nWeight",
      origin: "Origin",
      dest: "Dest.",
      catatan: "Notes",
      kotaConsolidator: "Consolidator City",
      totalSttKoli: "Total STT/Pieces",
      beratKotorShort: "Gross Weight",
      tanggalManifest: "Manifest Date",
      noReferensi: "Ref. No.",
      jenisPengiriman: "Service Type",
      kotaAsal: "Origin City",
      penandaPaket: "Package Marker",
      prosesManifest: "Manifest Process",
      sttNoAlreadyInput: "STT/Bag No. has been inputted",
      batasPod: "POD Limit",
      kotaTujuan: "Destination City",
      consolidatorCity: "Consolidator City",
      totalSttPieces: "Total STT/pieces",
      grossWeight: "Gross Weight",
      manifestDate: "Manifest Date",
      totalSttNotReceived: "Total STT not received",
      referenceNo: "No. Reference",
      totalPieces: "Total Pieces",
      destinationCity: "Destination City",
      region: "Region",
      packageMarker: "Package Marker",
      courier: "Courier",
      adminStaff: "Admin Staff",
      yes: "Yes",
      No: "No",
      PODSoon: "POD Soon",
      RTSSoon: "RTS Soon",
      HALSoon: "HAL Soon",
      notSTIOnTime: "Not STI on time",
      timeLimit: "Time Limit",
      weight: "Weight"
    }
  },
  stiDest: {
    searchPlaceholder: "Search Manifest ID",
    menuName: "STIDEST Process",
    defaultTimeRange: "Last 7 days",
    updateStiDest: "Update STI-DEST",
    emptyData: "Station transit in destination",
    printRingkasan: "Print Summary",
    emptyScan: {
      title: "Let’s start entering/scanning the STT number now."
    },
    print: "Print",
    table: {
      no: "No.",
      manifestId: "Manifest ID",
      arrivalCity: "Arrival City",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      tanggalStiDest: "STI-DEST Date",
      action: "Action",
      noBag: "No. Bag",
      noStt: "No. STT",
      productName: "Product Name",
      commodityName: "Commodity Name",
      totalKoliShort: "Total Pieces",
      beratKotor: "Gross Weight",
      beratDimensi: "Volume Weight",
      origin: "Origin",
      dest: "Dest.",
      transit: "Transit",
      misroute: "Misroute",
      noReferensi: "Ref. No.",
      tanggalManifest: "Manifest Date",
      segeraPod: "Urgent POD",
      segeraRts: "Urgent RTS",
      segeraHal: "Urgent HAL",
      atur: "Actions",
      jenisPengiriman: "Delivery Type",
      komoditas: "Commodity",
      originCity: "Origin City",
      destCity: "Destination City",
      statusReturn: "Status Return"
    },
    not: "No",
    tooltipArrivalCity:
      "Arrival city is where goods/STT arrive when processed in STI-DEST feature.",
    dataUpdatedEvery10Min: "Data updated every 10 minutes",
    dashboard: {
      headerBeforeStiDest: "Not yet STI-DEST, process now!",
      cargoPlaneTruckShip: "Cargo Plane {'|'} Truck {'|'} Ship",
      headerSttNowDel: "DEL due now!",
      headerSttOverdueDel: "DEL overdue, process now!",
      headerSttBar: "Priority to process today!",
      totalStt: "Total STT",
      tooltipSttAtConsolidator:
        "STT has arrived at Consolidator (STI DEST). Deliver now!",
      segeraPod: "Urgent POD",
      segeraRts: "Urgent RTS",
      segeraHal: "Urgent HAL",
      intracityIntercity: "Intracity / Intercity"
    },
    detail: {
      title: "Delivery Detail",
      partnerName: "Partner Name",
      userType: "User Type",
      arrivalCity: "Arrival City",
      detailStt: "STT Detail",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      tanggalDibuat: "Created Date",
      printStiDest: "Print STI-DEST",
      printSummary: "Print Summary",
      printPdf: "Print PDF",
      downloadExcel: "Download Excel"
    },
    update: {
      title: "Update STI-DEST",
      consolidatorName: "Consolidator Name",
      arrivalCity: "Arrival City",
      tooltipArrivalCity:
        "Arrival city is where goods/STT arrive when processed in STI-DEST feature.",
      tanggalStiDest: "STI-DEST Date",
      noStt: "No. STT",
      placeholderDate: "Select or enter vehicle serial no.",
      placeholderStt: "Enter STT No. or Scan Barcode/QR Code",
      labelStackedStt: "Example: 99LP1234567890123/88-22-12345678",
      add: "Add",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      process: "Process",
      updateStiDestAndPrintPdf: "Update STI-DEST & Print PDF",
      statusStiDest: "STI-DEST",
      statusMisroute: "MIS-ROUTE",
      statusTransit: "Transit",
      hapus: "Delete",
      hapusBarang: "Delete Item",
      deleteSttHint:
        "Enter STT No. or Scan Barcode/QR Code for item to remove from STI-DEST list.",
      terhapus: "Deleted",
      batal: "Cancel",
      sttNotFound: "STT number not found or already removed",
      sttAlreadyInput: "STT number already added",
      popUpAlert: {
        success: "STT status successfully updated to STI-DEST.",
        partial:
          "Some STT statuses were successfully updated to STI-DEST, but some failed. Please download to identify the errors.",
        failed: "STI-DEST status change failed to be made."
      },
      lastStt: "Last STT",
      lastBag: "Last BAG",
      manifest: {
        consolidatorName: "Consolidator Name",
        arrivalCity: "Arrival City",
        tanggalManifest: "Manifest Date",
        totalSttKoli: "Total STT/Pieces",
        GrossWeight: "Gross Weight",
        referenceNo: "No. Reference",
        productType: "Product Type",
        totalPieces: "Total Pieces",
        originCity: "Origin City",
        notes: "Notes",
        adminStaff: "Admin Staff",
        courier: "Courier"
      }
    },
    needToStiDestDel: {
      title: "List must STI DEST & DEL",
      searchPlaceholder: "Search cargo & STT/shipment no.",
      cargoType: "Cargo Type",
      status: "Status",
      pilihStatus: "Select Status",
      reset: "Reset",
      terapkan: "Apply",
      saatIni: "Now",
      telat: "Overdue",
      download: "Download",
      noKargo: "Cargo No.",
      noStt: "No. STT",
      noReferensi: "Ref. No.",
      statusTerakhir: "Last Status",
      jenisPengiriman: "Service Type",
      totalKoli: "Total Pieces",
      totalBerat: "Total Weight",
      kotaAsal: "Origin City",
      tanggalUpdateStatus: "Status Update Date",
      batasWaktu: "Deadline",
      pilihTipeKargo: "Select Cargo Type",
      pesawat: "Plane",
      truk: "Truck",
      kapal: "Ship"
    },
    pdf: {
      listSttNeedToSTI: "List STT must STI",
      manifestTitle: "STI-DEST Manifest",
      consolidatorName: "Consolidator Name",
      arrivalCity: "Arrival City",
      tanggalStiDest: "STI-DEST Date",
      totalStt: "Total STT",
      totalKoli: "Total Pieces",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      produk: "Product",
      komoditas: "Commodity",
      totalKoliShort: "Total\nPieces",
      beratKotor: "Gross\nWeight",
      beratDimensi: "Volume\nWeight",
      origin: "Origin",
      dest: "Dest.",
      catatan: "Notes",
      kotaConsolidator: "Consolidator City",
      totalSttKoli: "Total STT/Pieces",
      beratKotorShort: "Gross Weight",
      tanggalManifest: "Manifest Date",
      noReferensi: "Ref. No.",
      jenisPengiriman: "Service Type",
      kotaAsal: "Origin City",
      penandaPaket: "Package Marker",
      prosesManifest: "Manifest Process",
      sttNoAlreadyInput: "STT/Bag No. has been inputted",
      batasPod: "POD Limit",
      kotaTujuan: "Destination City",
      consolidatorCity: "Consolidator City",
      totalSttPieces: "Total STT/pieces",
      grossWeight: "Gross Weight",
      manifestDate: "Manifest Date",
      totalSttNotReceived: "Total STT not received",
      referenceNo: "No. Reference",
      totalPieces: "Total Pieces",
      destinationCity: "Destination City",
      region: "Region",
      packageMarker: "Package Marker",
      courier: "Courier",
      adminStaff: "Admin Staff",
      yes: "Yes",
      No: "No",
      PODSoon: "POD Soon",
      RTSSoon: "RTS Soon",
      HALSoon: "HAL Soon",
      notSTIOnTime: "Not STI on time",
      timeLimit: "Time Limit",
      weight: "Weight"
    },
    updateNotification: {
      sttPieces: "No. STT Pieces",
      success: "success",
      failed: "Failed"
    },
    downloadCsv: {
      columnBagNo: "Bag No.",
      columnSttNo: "STT No.",
      columnReferenceNo: "Reference No.",
      columnProductName: "Product Name",
      columnPodLimit: "POD Limit",
      columnTotalPieces: "Total Pieces",
      columnTotalGrossWeight: "Total Gross Weight",
      columnOriginCity: "Origin City",
      columnDestinationCity: "Destination City",
      columnTransit: "Transit",
      columnMisroute: "Misroute",
      columnSttMarker: "STT Marker",
      columnManifestDate: "Manifest Date",
      yes: "Yes",
      no: "No"
    }
  },
  hubToHub: {
    menuTitle: "Hub to Hub",
    inHub: "In Hub",
    outHub: "Out Hub",
    updateInHub: "Update In Hub",
    updateOutHub: "Update Out Hub",
    searchManifestPlaceholder: "Search manifest number",
    last30Days: "Last 30 days",
    no: "No",
    noManifest: "No. Manifest",
    totalStt: "Total STT",
    totalKoli: "Total koli",
    totalGrossWeight: "Total gross weight",
    manifestDate: "Manifest date",
    plateNumber: "Plate number",
    hubOrigin: "Origin hub",
    hubDestination: "Destination hub",
    actions: "Actions",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    hubLocation: "Hub location",
    consolidatorLocation: "Consolidator location",
    totalSttKoli: "Total STT/pcs",
    totalWeight: "Total weight",
    createdBy: "Created by",
    scanEmptyCta: "Start entering/scanning STT number now.",
    searchBagSttPlaceholder: "Search Bag/STT number",
    totalSttKoliLabel: "Total STT/pcs",
    grossWeight: "Gross weight",
    processManifest: "Process manifest",
    bagSttNotFound: "Bag/STT number not found.",
    noPackagesScanned: "No packages scanned yet.",
    partiallyUpdated: "Some STTs were updated successfully.",
    confirmProcessManifest: "Confirm Process Manifest",
    plateNumberPlaceholder: "Enter plate number",
    destinationHub: "Destination hub",
    back: "Back",
    process: "Process",
    manifestInhub: "Manifest INHUB",
    manifestOuthub: "Manifest OUTHUB",
    inhubManifestTitle: "Inhub Manifest",
    outhubManifestTitle: "Outhub Manifest",
    noBagDem: "No. Bag/DEM",
    noStt: "No. STT",
    refNo: "Ref. No.",
    koli: "Pcs",
    weight: "Weight",
    product: "Product",
    invalidPlate: "Invalid plate number, please try again",
    manifest: {
      hubOriginDestination: "Hub Origin - Hub Dest.",
      hubLocation: "Hub location",
      consoleLocation: "Console location",
      totalSttPieces: "Total STT/Pieces",
      weight: "Weight",
      manifestDate: "Manifest date",
      createdBy: "Created by",
      noReff: "No. Reference",
      totalPieces: "Total pieces",
      product: "Product"
    },
    adminStaff: "Admin Staff",
    courier: "Courier",
    operationsSupervisor: "Operations\nSupervisor",
    berhasil: "successfully processed",
    gagal: "failed to process"
  },
  urgentDeliveryManagement: {
    pageTitle: "Urgent Delivery Management",
    tabPod: "Urgent POD",
    tabRts: "Urgent RTS",
    tabHal: "Urgent HAL",
    tabTakenByRecipient: "Taken by Recipient",
    tabUrgentSearch: "Urgent Search",
    tabMonitorRelabel: "Monitor Relabel",
    searchPlaceholder: "Search STT no.",
    download: "Download",
    downloadData: "Download data",
    sortLatest: "Sort latest",
    pod: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnDeliveryType: "Delivery Service",
      columnReason: "Reason",
      columnUnprocessed: "Unprocessed",
      columnLastStatus: "Last Status",
      columnProductType: "Product Type",
      columnDexAttempt: "DEX Attempts (Customer)",
      columnRequestDate: "Request Date",
      columnBkdDate: "BKD Date",
      columnLastLocation: "Last Location",
      filterUrgent: "Urgent delivery",
      filterOverSla: "Over SLA limit",
      filterRedelivery: "Redelivery",
      flagUrgentDelivery: "urgent delivery",
      flagOverSlaLimit: "over SLA limit"
    },
    filter: {
      filter: "Filter",
      deliveryType: "Delivery type",
      selectDeliveryType: "Select delivery type",
      flaggingDate: "Flagging Date",
      reset: "Reset",
      apply: "Apply",
      caseType: "Case Type",
      selectCaseType: "Select case type",
      sttType: "STT Type",
      selectSttType: "Select STT type",
      customerRequest: "Customer Request",
      lastLocation: "Last location",
      lastLocationPlaceholder: "Select last location",
      selectedLastLocation: "{num} Location"
    },
    empty: {
      header: "No urgent deliveries yet",
      message: "Start entering/scanning STT numbers in the STI DEST menu.",
      filterNotFound: "No results found",
      filterNotFoundMessage: "Check and reset your filters."
    },
    rts: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnCaseType: "Case Type",
      columnReason: "Reason",
      columnSttType: "STT Type",
      columnOriginCity: "Origin City",
      columnLastStatus: "Last Status",
      columnProductType: "Product Type",
      columnDexAttempt: "DEX Attempts (Customer)",
      columnRequestDate: "Request Date",
      columnBkdDate: "BKD Date",
      columnLastLocation: "Last Location",
      requestDatePlaceholder: "Request Date",
      aggregator: "Aggregator",
      nonAggregator: "Non Aggregator"
    },
    urgentTakenByRecipient: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnProductType: "Product Type",
      columnLastStatus: "Last Status",
      columnAction: "Action"
    },
    hal: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnReason: "Reason",
      columnOriginCity: "Origin City",
      columnLastStatus: "Last Status",
      columnRequestTime: "Request Time",
      columnLastLocation: "Last Location",
      flagToday: "today",
      flagOverdue: "overdue"
    },
    detail: {
      requestType: "Request Type",
      lastStatus: "Last Status",
      reason: "Reason",
      requestDate: "Request Date",
      bkdDate: "BKD Date",
      destination: "Destination",
      supportingLink: "Supporting Data Link",
      notes: "Notes",
      proofPhoto: "Proof Photo",
      productType: "Product Type",
      weight: "Weight",
      detailReceiver: "Detail Recipient",
      recipientName: "Recipient Name",
      recipientPhone: "Recipient Phone Number",
      recipientAddress: "Recipient Address"
    },
    error: {
      getDetailFailed: "Failed to get detail!",
      getPODSummaryFailed: "Failed to get POD summary!"
    },
    formatAgingDays: {
      days: "days",
      today: "Today"
    },
    photo: {
      title: "Update status to POD with proof of delivery!",
      subtitle:
        "You must enter recipient name & upload proof photo of delivery.",
      exampleGuideTitle: "Example of proof photo guide",
      photoTypeKtp: "ID card photo.",
      photoTypeProxyLetter: "Power of attorney letter photo if represented.",
      photoTypeRecipientAndPackage: "Recipient & package photo."
    },
    upload: {
      recipientName: "Recipient Name",
      placeholderRecipientName: "Enter recipient name",
      relation: "Relation",
      proofPhoto: "Proof Photo",
      photoSizeRequirement:
        "Max. size: 5 MB, Format: jpg, png. Recommended Dimension 2:4, (example: 200px X 800px).",
      updatePod: "Update POD",
      successTitle: "Update POD successful!",
      successMessage: "Package has been successfully updated to POD.",
      buttonOk: "OK",
      confirmationTitle: "Update status to POD?",
      confirmationMessage:
        "Please double-check, the package to be POD to the recipient must be correct.",
      buttonCheckAgain: "Check Again",
      buttonYesUpdate: "Yes, Update",
      errorTitle: "Update POD Failed!",
      errorDeletePhoto: "Failed to delete photo from storage!"
    }
  },
  dexAssessment: {
    menuTitle: "DEX Assessment",
    listTicketTitle: "DEX Ticket List",
    detailTitle: "DEX Ticket List | Detail",
    downloadData: "Download Data",
    searchPlaceholder: "Search Ticket / STT No.",
    timeRangeDefault: "Today",
    filterReasonDex: "DEX Reason",
    placeholderReasonDex: "Select DEX Reason",
    statusDexAsesmen: "DEX Assessment Status",
    placeholderStatusDex: "Select DEX Status",
    statusDisputeConsolidator: "Consolidator Dispute Status",
    placeholderStatusDispute: "Select Dispute Status",
    searchCsName: "Search CS Name",
    placeholderCsName: "Type or select CS name",
    consolidator: "Consolidator",
    placeholderConsolidator: "Type or select 3LC",
    totalReasonFormat: "{count} DEX Reasons",
    statusValid: "Valid",
    statusInvalid: "Invalid",
    statusNoStatus: "No Status Yet",
    statusDisputeRequested: "Dispute Requested",
    statusDisputeRejected: "Dispute Rejected",
    statusDisputeApproved: "Dispute Approved",
    columnTicketId: "Ticket ID",
    columnNoStt: "STT No.",
    columnTanggalDex: "DEX Date",
    columnAlasanDex: "DEX Reason",
    columnStatusDexAsesmen: "DEX Assessment Status",
    columnStatusDitentukanOleh: "Status Determined By",
    columnStatusSanggah: "Dispute Status",
    columnNamaCsL1: "CS L1 Name",
    columnTanggalDitugaskanCsL1: "CS L1 Assignment Date",
    columnTanggalDiselesaikanCsL1: "CS L1 Completion Date",
    columnNamaCsL2: "CS L2 Name",
    columnTanggalDitugaskanCsL2: "CS L2 Assignment Date",
    columnTanggalDiselesaikanCsL2: "CS L2 Completion Date",
    columnNamaKonsolidator: "Consolidator Name",
    columnTanggalDitugaskanKonsolidator: "Consolidator Assignment Date",
    columnTanggalDiselesaikanKonsolidator: "Consolidator Completion Date",
    columnNamaCsL2Sanggah: "CS L2 Dispute Name",
    columnTanggalDitugaskanCsL2Sanggah: "CS L2 Dispute Assignment Date",
    columnTanggalDiselesaikanCsL2Sanggah: "CS L2 Dispute Completion Date",
    emptyHeaderMessage: "No DEX Ticket List",
    emptyMessage: "Start creating DEX Ticket List and check it here",
    infoSanggahanKonsol: "Console Dispute Information",
    fotoSanggahanKonsol: "Console Dispute Photo",
    catatanDariKonsol: "Note from Console",
    fotoDex: "DEX Photo",
    lampirkanFotoSanggahan: "Attach Dispute Photo",
    lampirkanFoto: "Attach Photo",
    komentarSanggahan: "Dispute Comment",
    placeholderSanggahan: "Enter Your Dispute Here",
    proofPhoto: "Proof Photo",
    automaticBySystem: "Automatic by System",
    buttonSanggah: "Dispute",
    buttonTerima: "Accept",
    disputeBefore: "Dispute before {timeLeft}",
    timeOverDispute: "Your time to dispute has expired",
    submitFailed: "DEX Assessment Submission Failed!",
    statusSanggah: "Dispute Status",
    statusFinalAsesment: "Final Assessment Status",
    lihatDetail: "View Detail",
    summaryTicketInvalid: "Mismatched Ticket",
    summaryDisputeRequested: "Dispute Requested",
    summaryDisputeApproved: "Dispute Approved",
    summaryDisputeRejected: "Dispute Rejected",
    summaryAcceptDex: "Accept DEX",
    summaryTotalTicket: "Total Ticket",
    summaryTicketQuota: "Ticket/Quota",
    summaryTicketFinished: "Completed Ticket",
    summaryTicketValid: "Matching Ticket",
    summaryTicketL1Finished: "L1 Completed Ticket",
    summaryTicketDisputeFinished: "Dispute Completed Ticket",
    component: {
      informationDex: "DEX Information",
      informationDetailTicketDex: "DEX Ticket Information",
      statusFinalAssesmen: "Final Assessment Status",
      statusSanggah: "Dispute Status",
      informationDetailStt: "STT Detail Information",
      noStt: "STT No.",
      addressType: "Address Type",
      timeDex: "DEX Time",
      route: "Route",
      productType: "Product Type",
      dexAttempt: "DEX Attempt",
      slaLimit: "SLA Limit",
      customerDispute: "Customer Dispute",
      partnerInformation: "Partner Information",
      contactInformation: "Contact Information",
      filterSelectReason: "Select Reason",
      disputeCheckbox: "Dispute"
    },
    dashboard: {
      breakdownTicketDex: "Breakdown DEX Ticket",
      top20Console: "Top 20 Console DEX Tickets",
      selectReason: "Select DEX Reason",
      breakdownTicketDexDispute: "Breakdown DEX Dispute Ticket L2",
      top10ConsoleDispute: "Top 10 Console DEX Dispute Tickets L2",
      totalTicketByTimeRange: "Total DEX Ticket by Time Range",
      failedGetTotalTicket: "Failed to Get Total DEX Ticket by Time Range",
      totalCsDexAssessment: "Total CS DEX Assessment",
      summaryConsolidator: "Consolidator Summary"
    },
    listTicketDex: {
      downloadReport: "Download Report",
      dateRangeDex: "DEX Date",
      searchButton: "Search",
      selectStatus: "Select Status",
      selectReason: "Select Reason",
      selectDealWith: "Select Handled By",
      emptyMessageNoData: "No data available",
      noData: "No data yet"
    },
    notificationFinished:
      "Ticket ID {ticketId} has been successfully completed",
    notificationDisputeFinished:
      "Ticket ID {ticketId} has been completed with dispute status {status}",
    notificationConsoleAction:
      "Ticket ID {ticketId} has been successfully {action}",
    notificationStatusResult:
      "Ticket ID {ticketId} has been completed with status {status}",
    disputeApproved: "Approved",
    disputeRejected: "Rejected",
    accepted: "accepted",
    disputed: "disputed",
    reasonDex: "DEX Reason",
    locationDex: "DEX Location",
    sourceDex: "DEX Source",
    recipientAddress: "Recipient Address",
    automaticFromSystem: "Automatically from system",
    finish: "Finish",
    notesFromCS: "Notes From CS",
    disputeNotesFromCS: "Dispute Notes From CS",
    enterNotes: "Enter Notes",
    processToRTS: "Process to RTS",
    processRTS: "RTS Process",
    recipient: "Recipient",
    sender: "Sender",
    courier: "Courier",
    courierCaptain: "Courier Captain",
    ticketId: "Ticket ID",
    viewDetail: "View Detail",
    sttNumber: "STT Number",
    route: "Route",
    addressType: "Address Type",
    dexAttempt: "DEX Attempt",
    productType: "Product Type",
    sla: "SLA",
    customerDispute: "Customer Dispute",
    yes: "Yes",
    no: "No",
    dexTime: "DEX Time",
    agree: "Approve",
    disagree: "Reject",
    accept: "Accept",
    dispute: "Dispute",
    assessedBy: "Assessed by",
    contactInformation: "Contact Information",
    name: "Name",
    contact: "Contact",
    console: "Console",
    statusMatch: "Match",
    statusNotMatch: "Not Match",
    assessByAI: "Assess by AI",
    consoleDisputeInformation: "Console Dispute Information",
    dexPhoto: "DEX Photo",
    notesFromConsole: "Notes From Console",
    disputeRejectNotesFromCS: "Dispute Rejection Notes From CS",
    csL1Name: "CS L1 Name",
    assignedToL1: "Assigned to L1",
    finishedByL1: "Finished by L1",
    csL2Name: "CS L2 Name",
    assignedToL2: "Assigned to L2",
    finishedByL2: "Finished by L2",
    consoleName: "Console Name",
    consoleDispute: "Console Dispute",
    csL2DisputeName: "CS L2 Dispute Name",
    assignedToL2Dispute: "Assigned to L2 Dispute",
    finishedByL2Dispute: "Finished by L2 Dispute",
    "Ditentukan oleh L1": "Determined by L1",
    "Ditentukan oleh L2": "Determined by L2",
    "Otomatis dari sistem": "Automatically from system",
    home: "Home",
    office: "Office"
  },
  dexAssessmentConsolidator: {
    pageTitle: "DEX Assessment Dashboard",
    summaryDex: "DEX Summary",
    summaryDexDetail: {
      sttDex: "STT DEX",
      sttDexDetail: {
        totalSttIncoming: "Total STT Incoming",
        totalDex: "Total DEX",
        totalDexInvalid: "Total DEX Invalid",
        totalDexValid: "Total DEX Valid"
      },
      dexDispute: "DEX Dispute",
      dexDisputeDetail: {
        totalDexInvalid: "Total DEX Invalid",
        totalDexRequested: "Total DEX dispute requested",
        totalDexApproved: "Total DEX Invalid dispute approved",
        totalDexRejected: "Total DEX Invalid dispute rejected",
        totalDexAccepted: "Total DEX Invalid accepted"
      }
    },
    ticket: "Ticket",
    downloadData: "Download Data",
    downloadFailed: "Download Failed!",
    sectionSttDex: "STT DEX",
    sectionDexDispute: "DEX Dispute",
    sectionTotalDexByReason: "Total DEX by reason",
    placeholderStatusDex: "Select DEX status",
    sectionTotalDexByTimeRange: "Total DEX by time range",
    sectionTotalCourierInvalidDex: "Total invalid DEX courier",
    placeholderStatus: "Select status",
    sectionPercentageDexAttempt: "DEX attempt percentage",
    sectionDexFromSourceDex: "DEX from DEX source percentage",
    sectionPercentageRtsDex: "DEX percentage requiring RTS",
    sectionTotalDexPerDay: "Total DEX per day",
    sectionCourierDex: "Courier DEX",
    sortOrder: "Sort",
    searchCourierName: "Search courier name",
    emptyNoCourierDex: "No Courier DEX",
    emptyMessageCourierDex:
      "Start creating Courier DEX and check the list here",
    emptyNoReasonDex: "No DEX Reason",
    emptyMessageReasonDex: "Start creating DEX Reason and check the list here",
    columnNo: "No",
    columnCourierName: "Courier Name",
    columnTotalDel: "Total DEL",
    columnTotalDex: "Total DEX",
    columnPercentageDex: "DEX Percentage",
    columnTotalDexMismatch: "Total DEX mismatch",
    columnPercentageDexMismatch: "DEX mismatch percentage",
    columnTotalDexMatch: "Total DEX match",
    columnPercentageDexMatch: "DEX match percentage",
    columnReasonDex: "DEX Reason",
    sortTotalDexHighest: "Total DEX highest",
    sortTotalDexLowest: "Total DEX lowest",
    sortTotalInvalidHighest: "Total invalid DEX highest",
    sortTotalInvalidLowest: "Total invalid DEX lowest",
    sortTotalRejectedHighest: "Total DEX invalid dispute rejected highest",
    sortTotalRejectedLowest: "Total DEX invalid dispute rejected lowest",
    sortCourierRejectedHighest: "Total dispute rejected highest",
    sortCourierRejectedLowest: "Total dispute rejected lowest",
    sortPercentageDexHighest: "DEX percentage highest",
    sortPercentageDexLowest: "DEX percentage lowest",
    sortPercentageInvalidHighest: "Invalid DEX percentage highest",
    sortPercentageInvalidLowest: "Invalid DEX percentage lowest",
    statusAll: "All Status",
    statusDexValid: "DEX Valid",
    statusDexInvalid: "DEX Invalid",
    statusDexRequested: "DEX Invalid disputed",
    statusDexApproved: "DEX Invalid dispute approved",
    statusDexRejected: "DEX Invalid dispute rejected",
    statusDexAccepted: "DEX Invalid accepted",
    suffixDex: "DEX",
    suffixCourier: "courier",
    ticketCount: "ticket(s)",
    sourceDriverApp: "Driver Apps",
    sourceGenesis: "Genesis",
    attemptOne: "1 Time",
    attemptTwo: "2 Times",
    attemptThreePlus: ">= 3 Times"
  },
  processSti: {
    title: "Station Transit In",
    updateSti: "Update STI",
    synchSti: "Data is updated every 10 minutes",
    refresh: "Refresh",
    unprocessedSti: "Total Unprocessed STI",
    partner: "Partner",
    stiNow: "Current STI",
    lateSti: "Late STI",
    manifestId: "Manifest ID",
    totalStt: "Total STT",
    totalKoli: "Total Pieces",
    manifestDate: "Manifest Date",
    stiDestination: "STI - DEST",
    podSoon: "POD Soon",
    halSoon: "HAL Soon",
    rtsSoon: "RTS Soon",
    action: "Action",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    printSttNotSti: "Print STT Not Yet STI",
    downloadSttNotSti: "Download STT Not Yet STI",
    shippingDetail: "Shipping Detail",
    originCity: "Origin City",

    sttDetail: "STT Detail",
    totalGrossWeight: "Total Gross Weight",
    totalVolumeWeight: "Total Volume Weight",

    createdDate: "Created At",
    printStiDest: "Print STI Dest",

    no: "No.",
    bagNumber: "Bag No.",
    sttNumber: "STT No.",
    referenceNumber: "Reference No.",
    productType: "Product Type",
    commodity: "Commodity",
    destinationCity: "Destination City",

    scanStartMessage: "Start entering or scanning STT numbers now.",
    scanExample: "Example: 99LP1234567890123/88-22-12345678",
    scanPlaceholder: "Enter STT number or scan barcode/QR code",
    searchBagStt: "Search Bag/STT number",
    allPartners: "All Partners",
    processManifest: "Process Manifest",
    totalSttKoli: "Total STT/Pieces",
    grossWeight: "Gross Weight",
    packageMarker: "Package Marker",
    noPackageScanned: "No package has been scanned yet",

    confirmManifestTitle:
      "Some STT have not been STI processed. Continue manifest?",
    confirmManifestDesc:
      "If you continue, STT that have not been STI processed will be marked as late STI.",
    confirmManifestButton: "Yes, continue manifest",
    yes: "YES",
    noValue: "NO",
    all: "All",
    needRelabel: "Need Relabel",
    underpaid: "Underpaid",
    sttNeedAdjust: "STT Needs Adjustment",

    partnerName: "Partner Name",
    productName: "Product Name",
    podDeadline: "POD Deadline",
    region: "Region",

    stiManifest: "STI Manifest",

    updateSuccessTitle: "Status Updated Successfully!",
    updateSuccessMessage: "STT status has been updated to STI.",
    updateFailed: "Failed to Update Status!",
    ok: "OK",

    stiRequiredList: "STI Required List",
    searchSttBagShipment: "Search STT/Bag/Shipment No.",
    allPartner: "All Partners",
    now: "Current",
    overdue: "Overdue",
    download: "Download",

    lastStatus: "Last Status",
    shippingType: "Shipping Type",
    totalWeight: "Total Weight",
    bookingDate: "Booking Date",
    deadline: "Deadline",
    penandaPaket: "Package Marker"
  },
  "Belum ada Dex Assessment yang dapat ditampilkan":
    "No Dex Assessment available to display",
  "Dex Asesmen": "Dex Assessment",
  "Buat STT baru untuk pengembalian paket":
    "Create a new STT for package return",
  "Ubah Data Alamat": "Change Address Data",
  trackDelivery: {
    tabPengiriman: "Shipment",
    tabLacakStt: "Track STT",
    tabPengirimanAktif: "Active Shipments",
    tabRiwayatPengiriman: "Shipment History",
    tabPaketKirimanAnda: "Your Shipments",
    tabPaketUntukAnda: "Packages For You",
    searchPlaceholderResi: "Search Tracking No.",
    emptyPackages: "your shipments",
    pageTitleDetail: "Shipment | Detail",
    dataNotAvailableTitle: "Data Not Available",
    dataNotAvailableMessage:
      "This data can only be accessed when the parcel status has an issue or requires further action.",
    understood: "Understood",
    partyRequest: "Party submitting claim",
    chooseClaimer: "Select claimer",
    cliamType: "Claim Type",
    chooseClaimType: "Select claim type",
    changePhoto: "Change Photo",
    itemPhoto: "Item Photo",
    itemPhotoDesc:
      "Upload a photo of the item with 6 sides (right, left, top, bottom, front, back)",
    isDataValid:
      "Is the submitted data correct? Make sure the data you submitted is correct and follows the claim terms and conditions",
    codeInvalid:
      "The code you entered is incorrect. Please reload or re-enter the code",
    claimSuccess: "Claim Submission Successful!",
    claimMessage:
      "To track the status of your claim, you can check it in the claims menu",
    claimFailed: "Claim Submission Failed!",
    reportIssue: "Report a Problem",
    sttHistory: "STT Delivery History",
    before: "Previous",
    replacement: "Replacement",
    columns: {
      colSttNoResi: "STT/Tracking No.",
      colShipmentId: "Shipment ID",
      colPackageWeight: "Package Weight",
      colShippingCost: "Shipping Cost",
      colRecipientDetail: "Recipient Detail",
      colPackageStatus: "Package Status",
      colDeliveryPerformance: "Delivery Performance",
      colClaimNo: "Claim No.",
      colClaimPackage: "Claim Package",
      statusLate: "Late",
      statusOnTime: "On Time",
      submitClaim: "Submit Claim",
      claimSubmitted: "Claim submitted",
      claimStatusTip:
        "Check claim status in Claim menu <br /> or Track Claim at Lion Parcel"
    },
    claim: "Submit a Claim",
    claimer: "Claimer",
    claimType: "Claim Type",
    dataSentQuestion:
      "Is the data sent correct? Make sure the data you sent is correct and follows the claim terms & conditions",
    success: "Claim Submission Successful!",
    failed: "Claim Submission Failed!",
    checkDetail: "Check the claim status details in the claim menu,",
    yourClaimFailed: "Your claim failed.",
    sender: "Sender",
    receiver: "Recipient",
    late: "Delay",
    product: "Product",
    deliveryStatus: "Delivery Status",
    deliveryType: "Delivery Type",
    performDelivery: "Delivery Performance",
    apply: "Apply"
  },
  feedback: {
    title: "Give your rating",
    subtitle: "Your feedback is valuable to us",
    titleV2: "Give your rating",
    subtitleV2: "Your feedback is very valuable for improvement",
    rate: "Rate",
    modal: {
      title: "Give rating",
      subtitle: "Please give your rating for Genesis",
      rating: "(1 disappointing, 5 very satisfying)",
      disappointing: "(Disappointing)",
      slightlyDisappointing: "(Slightly disappointing)",
      okay: "(Okay)",
      satisfying: "(Satisfying)",
      excellent: "(Excellent)",
      reviewTitle: "Write a review",
      reviewPlaceholder: "Leave a review about your experience with Genesis",
      cancel: "Cancel",
      send: "Send",
      success: {
        title: "Thank you for your feedback",
        message: "Lion Parcel will continue to provide the best for you",
        done: "Done"
      },
      exit: {
        title: "You haven't given a rating yet",
        message:
          "Please provide your rating and review regarding your experience using the Genesis system",
        close: "Exit",
        review: "Give Feedback"
      }
    }
  },
  bulkPrintReceipt: {
    title: "Print Receipt",
    listStt: "STT Number List",
    maxStt: "The maximum number that can be processed is {maxStt} STT.",
    placeholder: "Enter STT number or scan barcode",
    sttNotFound: "STT data not found",
    showStt: "Show STT Number",
    deleteAll: "Delete All",
    showDetailStt: "Showing {count} STT details",
    duplicated: "{removedCount} duplicate STT(s) have been removed.",
    overlimitStt:
      "The number of STTs exceeds the maximum limit of {maxSttInput}. Please remove {excessSttCount} excess STT(s).",
    printReceipt: "Print Receipt/STT",
    printA4: "Print A4",
    printA6: "Print A6",
    table: {
      title: "STT Print List",
      name: "Client / Partner Name",
      totalCost: "Total Cost",
      noRef: "Reference No.",
      totalPieces: "Total Pieces",
      totalChargeableWeight: "Total Chargeable Weight",
      destinationAddress: "3LC Destination",
      sender: "Sender Name",
      recipient: "Recipient Name",
      insurance: "Insurance",
      shippingCost: "Shipping Cost",
      insuranceCost: "Insurance Cost",
      totalTarif: "Total Cost",
      shipmentNo: "Shipment No."
    }
  },
  claim: {
    title: "Claim",
    detailTitle: "Tracking No {stt}",
    pageTitle: "Claim | Detail",
    searchPlaceholderResi: "Search Tracking No.",
    claimStatus: "Claim Status",
    apply: "Apply",
    submitted: "Submitted",
    approved: "Approved",
    rejected: "Rejected",
    finished: "Finished",
    missing: "Missing",
    damaged: "Damaged",
    overdue: "Overdue",
    emptyPackages: "your shipments",
    pageTitleDetail: "Shipment | Detail",
    dataNotAvailableTitle: "Data Not Available",
    dataNotAvailableMessage:
      "This data can only be accessed when the parcel status has an issue or requires further action.",
    understood: "Understood",
    filter: {
      filter: "Filter",
      reset: "Reset",
      selectStatusClaim: "Select claim status",
      selectCategory: "Select category"
    },
    columns: {
      colSttNoResi: "Tracking No.",
      colShipmentId: "Shipment ID",
      colProduct: "Product",
      colCategory: "Category",
      colClaimStatus: "Claim Status",
      colUpdatedStatus: "Status Update Date"
    },
    detail: {
      createdAt: "Created Date",
      updatedAt: "Last Updated",
      deliveryDetail: "Shipment Details",
      itemDetail: "Item Details",
      noSTTGenesis: "No. STT Genesis",
      shipmentID: "Shipment ID",
      externalRefNumber: "External Reference Number",
      districtOriginCity: "District, Origin City",
      districtDestinationCity: "District, destination city ",
      bookedFor: "Booked for",
      shipperName: "Shipper Name",
      recipientName: "Recipient Name",
      shipperPhoneNumber: "Shipper Phone Number",
      recipientPhoneNumber: "Recipient Phone Number",
      shipperAddress: "Address",
      recipientAddress: "Address",
      addressType: "Address Type",
      home: "Home",
      office: "Office",
      commodity: "Commodity",
      product: "Product",
      totalItemsPiecesKoli: "Total Items (Pieces/Parcels)",
      totalChargeableWeight: "Total Chargeable Weight",
      itemPriceEstimate: "Item Price Estimate",
      taxRegistrationNumber: "Tax Identification Number (TIN)",
      insurance: "Insurance",
      createdBy: "Waybill Created By",
      billedTo: "Billed to",
      source: "Source",
      cod: "COD",
      returnDO: "Return DO",
      yes: "Yes",
      no: "No",
      dimensionLwh: "Dimensions (L x W x H)",
      paymentDetail: "Payment Details",
      shippingCost: "Shipping Cost",
      cityRate: "City Rate",
      forwardRate: "Forward Rate",
      commoditySurcharge: "Commodity Surcharge",
      weightAdditionalCharge: "Weight Additional Charge",
      additionalDocumentCost: "Additional Document Cost",
      taxEstimate: "Tax Estimate",
      totalTarif: "Total Cost"
    }
  },
  requestHal: {
    title: "Important Shipment Request",
    createRequest: "Create request",
    download: "Download",
    sort: "Sort",

    searchStt: "Search STT number",
    last7Days: "Last 7 days",
    createdDate: "Created date",

    emptyRequestHeader: "No requests yet",
    emptyRequestMessage: "Start creating requests and check the status here.",

    importantShipmentRequest: "Important shipment request",

    sttNumber: "STT number",
    enterSttNumber: "Enter STT number",

    requestType: "Request type",
    lastStatus: "Last status",
    requestStatus: "Request status",
    requestBy: "Requested by",

    selectRequestType: "Select request type",
    selectLastStatus: "Select last status",
    selectRequestStatus: "Select request status",
    selectRequestBy: "Select requester",

    number: "No",
    deadline: "Deadline",
    destination: "Destination",
    createdAt: "Created date",
    updatedAt: "Updated date",

    reason: "Reason",
    selectReason: "Select reason",

    notes: "Notes",
    enterNotes: "Enter notes",

    proof: "Proof",

    supportingLink: "Supporting link",
    enterSupportingLink: "Press enter or space to add supporting link",
    enterLinks: "Enter link, separate with space if more than one",

    uploadProof: "Upload proof",

    cancel: "Cancel",
    save: "Save",
    confirmCancel: "Yes, cancel",
    back: "Back",
    ok: "OK",

    importantShipment: "Important shipment",
    redelivery: "Redelivery",
    rts: "RTS",
    hal: "HAL",

    all: "All",
    pos: "POS",
    internal: "Internal",

    success: "Success",
    cancelled: "Canceled",

    failedGetDetail: "Failed to get detail",
    requestCreated: "Request created successfully",
    requestCreateFailed: "Failed to create request",

    cancelSuccess: "HAL request canceled successfully",
    cancelFailed: "Failed to cancel shipment",

    cancelHalRequestTitle: "Cancel HAL request for this STT?",
    cancelHalRequestMessage:
      "If the HAL request is canceled, POS will still receive a penalty.",

    cancelHalSuccessMessage:
      "HAL request for this STT has been canceled and POS will still receive a penalty.",

    invalidSttNumber: "Invalid STT number, please check again.",
    jumboPackPickup: "JumboPack package will be picked up by the receiver",

    retailOnly: "Only for retail booking STT",
    invalidRetailStt:
      "STT number <b>“{stt}”</b> is not allowed. Please use retail booking STT.",

    requestCreatedMessage:
      "Important shipment request <b>“STT {stt}”</b> created successfully.",

    reasonHoldAtHub: "Customer requested package to be held at hub",
    reasonReturnCustomer: "Return requested by customer",

    specialEvent: "Special event",
    food: "Food",
    medicineShipment: "Medicine shipment",
    livePlants: "Live plants",

    doubleStt: "Duplicate STT",
    lessPackage: "Missing package",
    receiverPickup: "Receiver will pick up the package",
    senderUnderpaid: "Sender underpaid via customer apps",
    changeAddressRequest: "Address change request",
    returnRequestCustomer: "Customer return request",

    posPenaltyMessagePercentage:
      "POS will receive a penalty of {amount}% of the shipping fee (min. {min} & max. {max}).",

    posPenaltyMessageFlat:
      "POS will receive a penalty of {amount} from the shipping fee.",

    maxUploadPhoto: "Maximum upload {max} proof photos. You cannot upload more",

    uploadSuccess: "Upload success",

    uploadFailed: "Upload failed",

    deletePhotoFailed: "Failed to delete photo from storage!"
  },
  posFavourite: {
    title: "POS Subscription",
    member: "Member",
    outstandingMember: "Member Billing",
    searchPlaceholder: "Search",
    invoiceStatus: {
      filter: "Filter",
      unpaid: "Unpaid",
      paid: "Paid"
    },
    table: {
      no: "No.",
      invoiceId: "Invoice ID",
      createdAt: "Created At",
      totalInvoice: "Total Invoice",
      invoiceStatus: "Invoice Status",
      totalStt: "Total STT",
      memberName: "Member Name",
      address: "Address",
      phoneNumber: "Phone Number"
    },
    defaultDiscountSettings: {
      title: "Default Discount Settings",
      discount: "Discount",
      maxDiscount: "Max. 25 %",
      lastUpdated: "Last Updated",
      cancel: "Cancel",
      save: "Save",
      confirmTitle: "Confirm Changes",
      confirmMessage:
        "Are you sure you want to save the default discount changes?",
      successTitle: "Changes Saved",
      successMessage:
        "Default discount details have been updated successfully.",
      ok: "OK",
      back: "Back",
      select: "Select",
      shippingSurcharge: "Shipping Surcharge",
      publishRate: "Publish Rate",
      shippingAndPublish: "Shipping Surcharge + Publish Rate"
    },
    editMemberModal: {
      title: "Edit Member",
      name: "Member Name",
      address: "Address",
      phone: "Phone Number",
      discount: "Discount",
      cancelButton: "Cancel",
      saveButton: "Save",
      backButton: "Back",
      confirmTitle: "Confirm Changes",
      confirmMessage:
        "Are you sure you want to save changes to Member “{name}” discount?",
      successTitle: "Changes Saved Successfully!",
      successMessage: "Member “{name}” details have been updated.",
      exitConfirmTitle: "Are you sure you want to leave?",
      exitConfirmMessage:
        "Please be aware, you will lose all unsaved data if you leave this page.",
      exitButton: "Exit",
      select: "Select",
      maxDiscount: "Max. 25 %"
    },
    memberTabs: {
      searchPlaceholder: "Search phone number",
      defaultDiscountSettings: "Default Discount Settings",
      emptyStateLabel: "Pos Favorite",
      tableHeaders: {
        no: "No.",
        memberName: "Member Name",
        address: "Address",
        phone: "Phone",
        discount: "Discount",
        subscriptionDate: "Subscription Date",
        updatedAt: "Updated at",
        spending: "Spending",
        action: "Action"
      }
    }
  },
  clientManagement: {
    tabs: {
      clientRegistration: "Client registration",
      clientManagement: "Client management"
    },
    managementList: {
      searchPlaceholder: "Search client name / alias / code",
      filterClientType: "Client type",
      filterPriceStatus: "Price status",
      filterClientStatus: "Client status",
      emptyData: "Client data",
      allPrices: "All Prices",
      allClientStatuses: "All Client Statuses",
      frozen: "Frozen",
      allClientTypes: "All client types",
      parentClient: "Parent client",
      branchClient: "Branch client",
      freeze: "Freeze",
      unfreeze: "Unfreeze",
      columns: {
        clientId: "Client ID",
        clientName: "Client name",
        alias: "Alias",
        clientCode: "Client code",
        clientType: "Client type",
        pricePeriod: "Price period",
        contractStatus: "Contract status",
        priceStatus: "Price status",
        updateStatus: "Update status",
        action: "Action",
        pricePeriodStart: "Price period start",
        pricePeriodEnd: "Price period end",
      }
    },
    registrationList: {
      searchPlaceholder: "Search client name / alias / code",
      createNewClient: "Create new client",
      emptyData: "Client data",
      allStatuses: "All statuses",
      parentClient: "Parent client",
      branchClient: "Branch client",
      columns: {
        clientId: "Client ID",
        clientName: "Client name",
        alias: "Alias",
        clientCode: "Client code",
        clientType: "Client type",
        contractStatus: "Contract status",
        pricePeriodStart: "Price period start",
        pricePeriodEnd: "Price period end",
        priceStatus: "Price status",
      }
    },
    registrationForm: {
      parent: {
        title: "Parent client detail",
        parentClientName: "Parent client name",
        enterClientName: "Enter client name",
        enterAlias: "Enter alias",
        max100Characters: "Maximum 100 characters",
        min3Characters: "Minimum 3 characters",
        selectParentClientCategory: "Select parent client category",
        selectParentCompanySize: "Select parent client company size",
        enterParentClientAddress: "Enter parent client address",
        typeAndSelectDistrictCityParent:
          "Type & select parent client district, city"
      },
      contact: {
        title: "Contact information",
        name: "Name",
        enterName: "Enter name",
        position: "Position",
        enterPosition: "Enter position",
        phone: "Phone number",
        phoneExample: "Example: 8123456789012",
        invalidPhone: "Please enter a valid phone number",
        emailExample: "Example: name{'@'}email.com",
        invalidEmail: "Please enter a valid email"
      },
      payment: {
        title: "Payment information",
        selectPaymentMethod: "Select payment method",
        invoice: "Invoice",
        splitBill: "Split Bill"
      },
      billing: {
        title: "Billing information",
        invalidWhatsapp: "Please enter a valid WhatsApp number",
        selectBillingSchedule: "Select billing schedule",
        selectPaymentTerm: "Select payment term",
        pressEnterToAddEmail: "Press enter to add Email",
        enterEmail: "Enter Email",
        emailAlreadyAdded: "This email has already been added",
        multipleEmailHint: "*You can add more than one email."
      },
      tax: {
        taxpayerUsesIdCard: "Taxpayer uses ID card",
        enterNikNumber: "Enter ID card number",
        enterNameAsIdCard: "Enter name as in ID card",
        enterAddressAsIdCard: "Enter address as in ID card",
        enterNpwpNumber: "Enter NPWP number",
        nameAsNpwp: "Name as in NPWP",
        enterNameAsNpwp: "Enter name as in NPWP",
        enterAddressAsNpwp: "Enter address as in NPWP",
        selectTaxTransactionCode: "Select transaction code",
        changeFile: "Change File"
      },
      agreement: {
        selectStartDate: "Select start date",
        invalidDate: "Start date cannot be later than end date",
        selectEndDate: "Select end date",
        changeFile: "Change file"
      },
      bank: {
        optionalHint: "(Optional)",
        delete: "Delete",
        bankAccountInfo: "Bank account information",
        noBankAccountSaved: "No saved bank account yet.",
        addBankAccount: "Add Bank account",
        deleteConfirmationTitle: "Delete Confirmation",
        deleteConfirmationMessage:
          "Please make sure, deleted bank account data cannot be restored."
      }
    },
    registrationBranchForm: {
      clientBranch: {
        title: "Branch client detail",
        branchClientName: "Branch client name",
        enterClientName: "Enter client name",
        enterBranchAddress: "Enter branch client address",
        enterAndSelectDistrictCity: "Enter & select district, city",
        enterNpwp16Digits: "Enter 16 digits according to NPWP",
        invalidNpwp: "Please enter a valid NPWP number"
      },
      parentClientDetail: {
        enterOrSelectParentClient: "Enter or select parent client",
        partnerPosName: "POS partner name",
        selectPartnerPos: "Select POS partner",
        commissionNumerator: "Commission Numerator",
        selectCommissionNumerator: "Select commission numerator",
        clientPrice: "Client Price",
        commissionType: "Commission Type",
        posCommission: "POS Commission",
        commissionCannotBeZeroEmpty: "Commission cannot be zero/empty",
        commissionCannotExceed100: "Commission cannot exceed 100%",
        selectCommissionType: "Select commission type",
        shippingSurcharge: "Shipping surcharge",
        publishRate: "Publish Rate",
        publishRateShippingSurcharge: "Publish Rate + Shipping Surcharge"
      },
      deliveryService: {
        title: "Delivery service",
        description:
          "Every item booked by the client will follow the selected service.",
        cashOnDelivery: "Cash on Delivery",
        deliveryOrder: "Delivery Order"
      },
      codType: {
        title: "COD Type",
        goodsPrice: "Goods Price",
        goodsPricePlusClientShipping: "Goods Price + client shipping",
        deliveryFeeOnDelivery: "Delivery Fee on Delivery",
        codFee: "COD Fee",
        howCodFeeCalculated: "How is COD fee calculated?",
        codFeeCalculatedFromTotalCodAmount:
          "COD fee is calculated from the total COD amount percentage",
        codDiscountPercentage: "COD Discount Percentage",
        codDiscountPercentageInfo: "COD Discount Percentage Info",
        enterCodDiscountPercentage: "Enter COD discount percentage",
        tooltipCodShipmentDiscount:
          '<ol style="list-style: number; padding-left: 15px;"><li>The client will be charged COD STT booking fee based on <strong>client shipping fee after <br />discount.</strong></li><li>COD amount type (goods price + shipping) will use <strong>client shipping fee <br/>before discount</strong></li></ol>',
        codFeeCannotBeZeroEmpty: "COD fee cannot be zero/empty",
        codFeeCannotExceed100: "COD fee cannot exceed 100%",
        codDiscountCannotExceed100: "COD discount percentage cannot exceed 100%"
      },
      sttReturn: {
        title: "STT return",
        sameAsBranchClientDetail: "Same as branch client detail",
        receiverName: "Receiver name",
        phoneNumber: "Phone number",
        address: "Address",
        districtCity: "District, city"
      },
      deliveryOrderReturn: {
        title: "Delivery Order Return",
        paymentType: "Delivery Order payment type",
        selectType: "Select DO Type",
        free: "Free",
        paid: "Paid"
      },
      returnConfig: {
        title: "Return configuration",
        confirmationLimit: "Return confirmation limit",
        enterConfirmationLimit: "Enter return confirmation limit",
        reasonNeedsConfirmation: "Return reasons that need confirmation",
        returnReasonList: "Return Reason List",
        selectReason: "Select reason",
        allReasons: "All reasons",
        noConfiguration: "No configuration"
      }
    },
    registrationFlow: {
      next: "Next",
      priceCustomization: "Price customization",
      parentRegisterConfirmationTitle: "Confirm parent client registration?",
      exitPageTitle: "Exit this page?",
      exitPageMessage:
        "You have not finished filling the form. Your request will not be processed if you leave this page.",
      exit: "Exit",
      yesRegister: "Yes, register",
      creationFailed: "Creation Failed!",
      invalidCustomRatesFileMessage:
        "Custom Rates file is invalid or does not match.\nPlease click Change File to fix it.",
      ok: "OK",
      branchRegisterConfirmationTitle: "Confirm Branch Client Registration?",
      branchRegisterConfirmationMessage:
        "Please make sure the submitted data is correct.",
      branchCreationSuccess:
        "Branch client creation “{clientName}” succeeded! Wait for Admin approval.",
      parentCreationSuccess:
        "Parent client creation “{clientName}” succeeded! Wait for Admin approval.",
      branchEditSuccess: "Branch client data update “{clientName}” succeeded!",
      parentEditSuccess: "Parent client data update “{clientName}” succeeded!",
      editFailed: "Update Failed!",
      editBranchDetailQuestion: "Edit Branch Client Detail?",
      editBranchDetailMessage:
        "Please make sure your changes are correct to avoid rejection.",
      editParentDetailQuestion: "Edit Parent Client Detail?",
      editParentDetailMessage:
        "Please make sure your changes are correct to avoid rejection.",
      yesChange: "Yes, Change",
      uploaded: "Uploaded",
      free: "Free",
      clientPrice: "Client Price"
    },
    approval: {
      confirmClientSubmission: "Confirm {clientType} client submission?",
      ensureClientAndPriceDataCorrect:
        "Please make sure all client data and price submissions are correct.",
      reject: "Reject",
      approve: "Approve",
      accept: "Accept",
      rejectClientSubmissionQuestion: "Reject {clientType} client submission?",
      selectRejectReasonForFixingSubmission:
        "Choose a rejection reason to simplify client price submission improvement.",
      yesReject: "Yes, Reject",
      enterRejectReason: "Enter rejection reason",
      acceptClientSubmissionQuestion: "Accept {clientType} client submission?",
      ensureClientDetailCorrectBeforeApproval:
        "Before approving this request, make sure all client details are correct.",
      yesAccept: "Yes, Accept",
      selectRejectReason: "Select rejection reason",
      discountNotApproved: "Discount Not Approved",
      customRatesNotApproved: "Custom Rates Not Approved",
      discountAndCustomRateNotApproved: "Discount & Custom Rate Not Approved",
      insuranceRejected: "Insurance Rejected",
      confirmPriceChange: "Confirm price change",
      renewalApprovalSuccess:
        "Price update approval for {clientType} “{clientName}” was accepted!",
      clientRequestApprovalSuccess:
        "Client {clientType} submission for “{clientName}” was accepted!",
      renewalRejectionSuccess:
        "Client {clientType} price update rejection for “{clientName}” was successful!",
      clientRequestRejectionSuccess:
        "Client {clientType} request for “{clientName}” was successfully rejected!",
      confirmClientPeriodPriceSubmission: "Approve period price change request?",
      confirmClientPeriodPriceSubmissionDesc: "Period price change request",
      rejectClientPeriodPriceSubmission: "Reject period price change request?",
      rejectClientPeriodPriceSubmissionSelect: "Please select a rejection reason for the period price change request",
      acceptClientPeriodSubmissionQuestion: "Approve the period price change?",
      acceptClientPeriodSubmissionQuestionDesc: "Please ensure the period price change is correct and appropriate.",
      clientPeriodPriceSubmissionSuccess: "The period price change request has been approved successfully!",
      clientPeriodPriceSubmissionRejected: "The period price change request has been rejected successfully!",
    },
    discountProduct: {
      no: "No",
      shippingType: "Shipping Type",
      percentage: "Percentage",
      selectShippingType: "Select shipping type",
      discountRangeError: "Enter discount from 0 to 30",
      addDiscount: "Add discount"
    },
    priceTypeForm: {
      insurance: "Insurance",
      insuranceHint: "If unchecked, insurance will follow retail (Tiering).",
      tiering: "Tiering",
      customRatesPlaceholder: "e.g 20",
      normalPriceVersion: "Normal Price Version",
      selectPriceVersion: "Select Price Version",
      origin3lc: "3LC Origin",
      selectedOrigin3lc: "Selected 3LC Origin",
      all3lc: "All 3LC",
      select3lcByClientNeed: "Select 3LC according to your client needs",
      discount: "Discount",
      customPriceVersion: "Custom Price Version",
      enterPriceVersion: "Enter price version",
      enterCustomPriceVersionName: "Enter custom price version name",
      versionNameAlreadyExists: "Version name already exists",
      price: "Price",
      uploadDistrictCityByRouteRequest:
        "Upload district/city according to route request.",
      attachmentFile: "Attachment File",
      templateFile: "Template File",
      rateBasedOnDistrict: "Rate Based on District",
      enableToAddDistrictsFromRetailCities:
        "Enable to add districts from cities available in retail system.",
      normalPrice: "Normal Price",
      updatePriceEffectiveOn: "Price update effective on",
      startDate: "Start date",
      startedFrom: "Started from",
      endDate: "End date",
      until: "Until",
      startDateCannotBeLaterOrEqualEndDate:
        "Start date cannot be later than or equal to end date",
      endDateCannotBeLessOrEqualStartDate:
        "End date cannot be earlier than or equal to start date",
      selectInsuranceType: "Select insurance type",
      custom: "Custom",
      customRates: "Custom Rates",
      bundlingNoInsuranceFee: "Bundling (No Insurance Fee)",
      customRatesMin: "Custom rates minimum is 0.2%, please check and update.",
      customRatesMax: "Custom rates maximum is 0.99%, please check and update.",
      configurePriceTypePriceWeightAndInsuranceByClientNeed:
        "Set price type, price, weight, and insurance according to your client needs.",
      priceFollowsRetailPrice: "Price will follow retail price.",
      insuranceCalculationFollowsRetailTiering:
        "Insurance calculation will follow retail (Tiering).",
      priceAppliesBasedOnSelectedPeriodDate:
        "Price will apply based on the selected period date.",
      retailPriceDescription: "Price will follow retail price.",
      normalPriceDescription:
        "Price will be locked during the selected price period.",
      customPriceDescription:
        "Price will follow uploaded district/city pricing.",
      combinationPriceDescription:
        "Price will follow uploaded district/city pricing and retail pricing.",
      priceChangeEffective: "Price change effective on",
      selectDateTime: `Select date and time`,
      startDateTime: "Start date and time",
      selectStartDateTime: "Select a start date and time",
      endDateTime: "End date and time",
      selectEndDateTime: "Select an end date and time",
      insuranceSelect: "Select insurance type",
      insuranceCustomRates: "Custom Rates",
      insuranceBundling: "Bundling (No Insurance Fee)",
      discountToggle: "Discount client",
      discountToggleDescription: "Enable to use the client's discount configuration",
    },
    renewalRateCard: {
      updatePrice: "Price update",
      changePrice: "Change price",
      changeInsurance: "Change insurance",
      newPrice: "New price",
      accepted: "Accepted",
      requested: "Requested",
      rejected: "Rejected",
      ensurePriceInfoMatches: "Please make sure price information is correct",
      ensurePriceInfoMatchesWithExclamation:
        "Please make sure price information is correct!",
      downloadAttachmentFile: "Download attachment file",
      clientRequestAcceptedMessage:
        "Client request accepted. Price, weight, & insurance already meet the requirements.",
      acceptedDate: "Accepted date:",
      acceptedBy: "Accepted by",
      downloadFailedFile: "Download file failed",
      rejectedDate: "Rejected date:",
      rejectedBy: "Rejected by",
      lastProcessed: "Last processed",
      tryAgain: "Try again",
      pricePeriod: "Price period",
      priceCustomizationType: "Price customization type",
      customPrice: "Custom price",
      price: "Price",
      weightCalculation: "Weight calculation",
      chargeableWeightRoundingActive: "Chargeable Weight (Rounding active)",
      insuranceCalculation: "Insurance calculation",
      origin3lc: "3LC Origin",
      viewAll: "View All",
      all3lcs: "All 3LCs",
      priceTypeRetail: "Retail Price",
      priceTypeNormal: "Normal Price",
      priceTypeCombination: "Combination Price",
      priceTypeCustom: "Custom Price",
      downloadFailed: "Download file failed!!",
      retailTiering: "Retail (Tiering)",
      bundlingNoInsuranceFee: "Bundling(No Insurance Fee)",
      customRates: "Custom Rates",
      retryProcessDataTitle: "Continue retrying the data process?",
      retryProcessDataMessage:
        "The uploaded price will be processed again and the update will continue.",
      yesContinue: "Yes, continue",
      cancel: "Cancel",
      normalPrice: "Normal price",
      uploaded: "Uploaded",
      cancelled: "Cancelled",
      updatePeriode: "Update period",
      updatePeriodPrice: "Update period price",
      downloadAttachmentEmail: "File will be sent via email",
      downloadAttachmentFailed: "Fail to download attached file",
      downloadAttachmentFailedError: "Download file failed",
      cancelProcessMessage: "Cancel the upload process?",
      cancelProcessMessageConfirm: "Your data will be lost and cannot be recovered.",
      cancelProcessFailed: "Failed to cancel the upload process!",
      yesCancel: "Yes, cancel",
      back: "Back",
      start: "Start",
      end: "End",
    },
    changeInsuranceModal: {
      title: "Change parent client insurance",
      periodHint: "Insurance period follows the saved price period dates.",
      selectInsuranceType: "Select insurance type",
      customRatesPlaceholder: "e.g 20",
      customRates: "Custom Rates",
      bundlingNoInsuranceFee: "Bundling (No Insurance Fee)",
      tieringRetail: "Retail tiering",
      customRatesMin: "Custom rates minimum is 0.2%, please check and update.",
      customRatesMax: "Custom rates maximum is 0.99%, please check and update.",
      success: "Parent client insurance change “{clientName}” succeeded!",
      failed: "Parent client insurance change “{clientName}” failed!",
      serverError: "Server Error"
    },
    changePeriodModal: {
      periodPrice: "Price period",
      selectDateRangeDesc: "Specify the start and end date range for when the custom price will be effective.",
      dateAndTimeStart: "Start date and time",
      dateAndTimeEnd: "End date and time",
      selectDateAndTime: "Select date and time",
      changePeriodPriceFailed: "Failed to change the price period!",
    },
    ratePopup: {
      addNewParentPrice: "Add new parent client price",
      addPriceSuccess: "Adding parent client price “{clientName}” succeeded!"
    },
    infoDetailClient: {
      parentClient: "Parent client",
      branchClient: "Branch client",
      editDetail: "Edit detail",
      freeze: "Freeze",
      availableBalance: "Available balance",
      freezeReason: "Freeze reason",
      createdDate: "Created date",
      updatedDate: "Updated date",
      price: "Price",
      detail: "Detail",
      updatedBy: "Updated by"
    },
    managementDetail: {
      parentDetailTitle: "Parent client detail",
      branchDetailTitle: "Branch client detail",
      tabs: {
        client: "Client",
        tax: "Tax",
        contact: "Contact",
        payment: "Payment",
        billing: "Billing",
        cooperationAgreement: "Cooperation agreement",
        bank: "Bank",
        bankSettlement: "Bank settlement"
      },
      paymentInfoTitle: "Payment information",
      paymentMethod: "Payment method",
      clientInfoTitle: "Client information",
      clientType: "Client type",
      clientId: "Client ID",
      clientCode: "Client code",
      parentClientName: "Parent client name",
      clientCategory: "Client category",
      companySize: "Company size",
      address: "Address",
      districtCity: "District, City",
      email: "Email",
      phone: "Phone number",
      needAssessmentChange: "Need change assessment?",
      yes: "Yes",
      no: "No",
      contactInfoTitle: "Contact information",
      name: "Name",
      position: "Position",
      billingInfoTitle: "Billing information",
      whatsappNumber: "WhatsApp number",
      billingSchedule: "Billing schedule",
      paymentTerm: "Payment term",
      day: "Day",
      taxInfoTitle: "Tax information",
      taxRegistrationNumber: "Tax registration number (NPWP)",
      taxPayerName: "Taxpayer name",
      addressAsTaxId: "Address as in NPWP",
      taxInvoiceTransactionCode: "Tax invoice transaction code",
      nikNumber: "ID number (NIK)",
      nameAsIdCard: "Name as in ID card",
      addressAsIdCard: "Address as in ID card",
      taxIdOrIdCardPhoto: "NPWP/ID card photo",
      startedFrom: "Start date",
      until: "End date",
      frpDocument: "FRP document (Customer Registration Form)",
      pksDocument: "PKS document (Cooperation Agreement)",
      bankInfoTitle: "Bank information",
      bankSettlementInfoTitle: "Settlement bank information",
      accountNameAbbr: "a.n",
      return: "Return",
      cod: "COD",
      parentClientDetail: "Parent client detail",
      requiresSOSplit: "Requires SO Split?",
    },
    infoPriceClient: {
      origin3lc: "3LC Origin",
      changeParentClientPriceQuestion: "Change parent client price?",
      changeParentClientPriceMessage:
        "The currently proposed price will be replaced based on the latest request.",
      yesChange: "Yes, change",
      back: "Back",
      changeParentClientPrice: "Change parent client price",
      save: "Save",
      priceChange: "Price Change",
      renew: "Renew",
      submittedBy: "Submitted by",
      submissionDate: "Submission date",
      activeDate: "Active date",
      customPriceType: "Custom price type",
      price: "Price",
      insurance: "Insurance",
      discount: "Discount",
      allDiscount: "All Discounts",
      deliveryType: "Delivery type",
      percentage: "Percentage",
      all3lcs: "All 3LCs",
      currentPrice: "Current price",
      freeze: "Freeze",
      ensurePriceInfo: "Make sure the price information is correct!",
      clientRequestAccepted:
        "Client request is accepted. Price, weight, and insurance already meet the requirements.",
      downloadFailedFile: "Download failed file",
      date: "Date",
      accepted: "Accepted",
      rejected: "Rejected",
      cancelled: "Cancelled",
      by: "by",
      changeInsurance: "Change Insurance",
      changePrice: "Change price",
      downloadAttachmentFile: "Download attachment file",
      updatePrice: "Update price",
      lastProcessed: "Last processed {date}",
      retry: "Retry",
      pricePeriod: "Price period",
      specialPrice: "Special price",
      weightCalculation: "Weight calculation",
      chargeableWeight: "Chargeable Weight (Rounding enabled)",
      insuranceCalculation: "Insurance calculation",
      seeAll: "See All",
      seeDiscount: "See Discount",
      priceRetail: "Retail price",
      priceRetailDescription: "Price will follow retail price",
      priceNormal: "Normal price",
      priceNormalDescription: "Price will be fixed during the selected period.",
      priceSpecial: "Special price",
      priceSpecialDescription:
        "Price will follow district/city rates from your uploaded file.",
      priceCombination: "Combination price",
      priceCombinationDescription:
        "Price will follow uploaded district/city rates & retail price.",
      viewPriceChange: "View Price Change",
      waitingApprovalPriceChange: "Waiting for price change approval",
      uploadingPriceFile:
        "Price change file is being uploaded ({process}/{total})",
      failed: "Failed",
      customRatesFailedBySystem:
        "Custom rates price change failed to be updated by the system",
      customRatesNotApproved: "Custom rates price change is not approved",
      customRatesCancelled: "Custom rates price change is cancelled",
      priceFileFailedUpload: "Price change file upload failed",
      priceChangeAccepted: "Price change accepted",
      priceChangeAcceptedPartially: "Price change partially accepted",
      active: "Active",
      waiting: "Waiting",
      nearlyExpired: "Nearly Expired",
      expired: "Expired",
      pending: "Pending",
      uploadStatus: "upload {progress}",
      retailTiering: "Retail (Tiering)",
      bundlingNoInsuranceFee: "Bundling(No Insurance Fee)",
      customRatesPercent: "Custom Rates {percentage}%",
      downloadFailedError: "Download file failed!!!",
      parentClientPriceChangeSuccess:
        "Parent client price change “{clientName}” succeeded!",
      parentClientPriceChangeFailed:
        "Parent client price change “{clientName}” failed!",
      continueRetryProcess: "Continue retrying data process?",
      retryProcessMessage:
        "Your uploaded price will be processed again and the update will continue.",
      yesContinue: "Yes, continue",
      cancel: "Cancel",
      districtRetailPrice: "District retail price",
      startDate: "Start date",
      endDate: "End date",
      customPrice: "Custom price",
      customPriceName: "Custom price name",
      uploaded: "Uploaded",
      cancelProcess: "Cancel Process",
      start: "Start",
      end: "End",
      downloadAttachmentEmail: "File will be sent via email",
      downloadAttachmentFailed: "Fail to download attached file",
      downloadAttachmentFailedError: "Download file failed",
      priceUnknown: "Unknown",
      yesCancel: "Yes, cancel",
      cancelProcessMessage: "Cancel the upload process?",
      cancelProcessMessageConfirm: "Your data will be lost and cannot be recovered.",
      cancelProcessFailed: "Failed to cancel the upload process!",
      generate: "Generate",
      dataNotFound: "Data not found",
      download: "Download",
      bulkDownloadList: "Bulk download list",
      updatedBy: "Updated by"
    },
    clientRateHistory: {
      waiting: "Waiting",
      requested: "Requested",
      rejected: "Rejected",
      cancelled: "Cancelled",
      rejectedPartial: "Rejected - <span class='font-normal'>Partial</span>",
      active: "Active",
      approved: "Approved",
      approvedPartial: "Approved - <span class='font-normal'>Partial</span>",
      nearlyExpired: "Nearly Expired",
      expired: "Expired",
      pending: "Pending",
      uploading: "Uploading",
      history: "History",
      all: "All",
      status: "Status",
      type: "Type",
      reset: "Reset",
      apply: "Apply",
      noHistory: "No history available",
      failHistory: "Failed to retrieve history data",
    }
  },
  Aktif: "Active",
  "Tidak Aktif": "Inactive",
  kulioner: {
    merchant: {
      title: "Merchant Order List",
      cycleName: "Cycle {index} - {time}",
      emptyHeader: "No orders yet",
      emptyMessage:
        "Once there are orders, they will appear here automatically.",
      processAriaLabel: "Processing Progress",
      table: {
        no: "No",
        merchant: "Merchant",
        totalProduct: "Total products",
        totalItem: "Total items",
        status: "Status",
        subtotal: "Subtotal"
      },
      viewMoreMerchant: "View {count} more merchants",
      viewLess: "View less",
      acceptOrder: "Accept order",
      processShipment: "Process shipment",
      trackShipment: "Track shipment",
      seeLocation: "See location",
      tabs: {
        processed: "Processed",
        unprocessed: "Not processed yet"
      },
      summary: {
        totalTransaction: "Total transactions",
        totalMerchant: "Total merchants",
        totalProduct: "Total products",
        totalItem: "Total items"
      }
    },
    customer: {
      title: "Customer Order List",
      searchBy: {
        merchantName: "Merchant name",
        customerName: "Customer name",
        merchantPhone: "Merchant phone number",
        orderId: "Order ID",
        sttNumber: "STT number"
      },
      emptyHeader: "No orders yet",
      emptyMessage:
        "Check the status of Kulioner customer orders from start to finish here.",
      systemErrorHeader: "System error occurred",
      systemErrorMessage: 'Click "Reload" or try again in a moment.',
      searchNotFoundHeader: "Search not found",
      searchNotFoundMessage:
        "Make sure the keyword is correct, then check and change it again.",
      internetErrorHeader: "Internet connection lost",
      internetErrorMessage:
        'Check your internet connection and click "Reload".',
      reload: "Reload"
    }
  },
  chips: {
    active: "Active",
    inactive: "Inactive",
    crrnfd: "Finding Courier",
    crrotw: "Courier Assigned",
    crrpic: "Picked Up",
    crrdon: "Done",
    crrcnc: "Cancelled by Courier",
    cstcnc: "Cancelled by Client",
    admcnc: "Cancelled by Admin"
  },
  banner: {
    main: "I have read and understood the information provided above.",
    submain:
      "For further information, please contact WhatsApp at +62 811-1956-1000 or email help{'@'}thelionparcel.com"
  },
  tableV2: {
    tooltips: {
      isCargo: "Cargo number has been assigned",
      isRtcProcess: "Preparing for cargo",
      isAlreadyRTC: "Ready for cargo",
      isAbleRTC: "Select to process as ready to cargo"
    }
  },
  "Tipe COD": "COD Type",
  "STT tidak valid": "Invalid STT",

  stiSc: {
    router: {
      menuTitle: "Process STI SC",
      updatePageTitle: "STI-SC | Update",
      updatePageName: "Update STI SC",
      needToStiScPageName: "Must STI SC list"
    },
    update: {
      pageTitle: "Update STI-SC",
      emptyStatePrompt: "Come on! Enter or scan STT number now.",
      sttExampleLabel: "Example: 99LP1234567890123/88-22-12345678",
      sttInputPlaceholder: "Enter STT no. or scan barcode/QR code",
      searchSttShipmentPlaceholder: "Search STT/shipment no.",
      allPosClient: "All POS/clients",
      processManifest: "Process manifest",
      totalSttPieces: "Total STT/pieces",
      grossWeight: "Gross weight",
      notFoundFilter: "Bag/STT number not found.",
      noPackageScanned: "No packages scanned yet.",
      modalConfirmManifestTitle:
        "Some STTs are not yet STI-SC. Continue manifest?",
      modalConfirmManifestBody:
        "If you continue, STTs not yet STI-SC will be treated as not handed over.",
      modalConfirmButton: "Yes, continue manifest",
      manifestSuccessTitle: "Manifest created successfully!",
      statusChangeFailed: "Status change failed!"
    },
    list: {
      buttonUpdate: "Update STI-SC",
      dataRefreshNote: "Data refreshes every 10 minutes",
      refresh: "Refresh",
      bannerTotalPending: "Total pending STI-SC processing",
      posPerClient: "POS/client",
      bannerCurrentStiSc: "Current STI-SC!",
      searchManifestIdPlaceholder: "Search manifest ID",
      last7Days: "Last 7 days",
      actionPrintPdfDoneStiSc: "Print PDF (STI-SC completed)",
      actionDownloadSttNotYetStiSc: "Download STT (not yet STI-SC)"
    },
    listV1: {
      last7Days: "Last 7 days",
      buttonUpdate: "Update STI-SC",
      print: "Print"
    },
    table: {
      columnNo: "No.",
      manifestId: "Manifest ID",
      totalStt: "Total STT",
      totalWeight: "Total weight",
      totalPieces: "Total pieces",
      manifestDate: "Manifest date",
      actions: "Actions",
      productType: "Shipping type",
      posClientName: "POS/Client name",
      destinationCity: "Destination city",
      podDeadline: "POD deadline",
      sttNo: "STT no.",
      underpaid: "Underpaid",
      referenceNo: "Reference no.",
      lastStatus: "Last status",
      bookingDate: "Booking date",
      subConsolidatorName: "Sub-consolidator name",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total volume weight",
      stiScDate: "STI-SC date",
      action: "Action",
      product: "Product",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight",
      destination: "Destination",
      status: "Status"
    },
    pdf: {
      featureNameStiSc: "STI-SC",
      subConsolidatorName: "Sub-consolidator name",
      subConsolidatorCity: "Sub-consolidator city",
      totalSttKoli: "Total STT/Pieces",
      totalGrossWeight: "Total gross weight",
      manifestDate: "Manifest date",
      totalSttNotReceived: "Total STT not received",
      columnNo: "No.",
      sttNo: "STT No.",
      referenceNo: "Reference no.",
      destinationCity: "Destination city",
      totalKoli: "Total pieces",
      totalWeight: "Total weight",
      signatoryStationAdmin: "Station Admin",
      signatoryCourier: "Courier",
      signatoryOpsSupervisor: "Operation Supervisor"
    },
    needToList: {
      pageTitle: "Must STI-SC list",
      searchPlaceholder: "Search STT/shipment no.",
      allPosClient: "All POS/clients",
      download: "Download"
    },
    scanFailed: {
      title: "Failed scan list",
      excelColSttNo: "STT number",
      excelColReason: "Scan failure reason",
      excelSheetName: "Failed STT scans",
      excelFileName: "Failed STT scans.xlsx"
    },
    updateV2: {
      pageTitle: "Update STI-SC",
      partnerName: "Partner Name",
      userType: "User Type",
      stiScDate: "STI-SC Date",
      vehicleSerialPlaceholder: "Select or enter vehicle serial number",
      sttPlaceholder: "Enter STT No. or Scan Barcode/QR Code",
      sttLabel: "Example: 99LP1234567890123/88-22-12345678",
      processManifest: "Process Manifest",
      processAndPrintManifest: "Process & Print Manifest",
      leaveTitle: "Want to leave?",
      leaveBody:
        "Make sure to go back, you will lose all data if you leave this page.",
      leaveExit: "Exit",
      leaveBack: "Go Back",
      badgeUpdatedOk: "Successfully updated to STI-SC",
      badgeUpdatedFail: "Failed to update to STI-SC",
      badgeNotFound: "Failed to update to STI-SC",
      badgeExist: "Failed to update to STI-SC",
      toastManifestCreated: "Successfully created new STI-SC Manifest",
      addSttFailed: "Add STT No. Failed!",
      getSessionFailed: "Failed to get session list!",
      summaryTotalStt: "Total STT",
      summaryTotalPieces: "Total Pieces",
      summaryTotalGrossWeight: "Total Gross Weight",
      summaryTotalVolumeWeight: "Total Volume Weight"
    },
    common: {
      unitStt: "STT",
      unitKg: "kg",
      userFallback: "User",
      ok: "OK"
    }
  },
  stoSc: {
    router: {
      menuTitle: "STO-SC"
    },
    shell: {
      last7Days: "7 hari terakhir",
      tabProcessToStoSc: "Process to STO-SC",
      tabListStoSc: "STO-SC",
      tooltipVariantA: "Packages with STI-SC status ready to process to STO-SC",
      tooltipVariantB:
        "Packages handed over by Main Branch POS/Sub-consolidator to Shuttle"
    },
    list: {
      searchPlaceholder: "Search by manifest ID",
      empty: "No STO-SC to display",
      printLabel: "Print label",
      printManifest: "Print manifest"
    },
    table: {
      columnNo: "No.",
      manifestId: "Manifest ID",
      subConsolidatorName: "Sub-consolidator name",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total volume weight",
      stoScDate: "STO-SC date",
      action: "Action"
    },
    common: {
      unitKg: "kg",
      userFallback: "User"
    },
    process: {
      emptyStiScList: "No STI-SC to display",
      bulkBannerDataWord: "records",
      bulkBannerMiddle: "will be updated & labels printed to status",
      bulkBannerStatusLabel: "STO-SC",
      buttonSubmit: "Process to STO-SC",
      errorUpdateFailed: "Failed to update to STO-SC!"
    },
    pdf: {
      nameLabel: "Name",
      dateLabel: "Date",
      originCity: "Origin City",
      totalStt: "Total STT",
      sttNo: "STT No",
      totalKoli: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalWeight: "Total weight",
      totalVolumeWeight: "Total volume weight",
      stoScDate: "STO-SC date",
      updatedAt: "Update Date",
      updatedBy: "Updated by",
      summaryTitle: "STO-SC{id}",
      signatoryStationAdmin: "Station Admin",
      signatoryCourier: "Courier",
      signatoryOpsSupervisor: "Operations Supervisor"
    },
    manifest: {
      featureName: "STO-SC{id}"
    },
    error: {
      printFailed: "Print failed!",
      detailFailed: "Failed to get STO-SC detail!"
    }
  },
  stiDestSc: {
    router: {
      pageTitle: "Station Transit In Destination Sub Consolidator",
      menuName: "STI DEST-SC",
      updatePageTitle:
        "Update STI DEST-SC | Station Transit In Destination Sub Consolidator",
      updatePageName: "Update STI DEST-SC",
      parentBreadcrumb: "STI DEST-SC"
    },
    list: {
      searchCargoPlaceholder: "Search cargo no.",
      last7Days: "Last 7 days",
      buttonUpdate: "Update STI DEST-SC",
      emptyEntityNoun: "station transit in destination sub-consolidator",
      emptyMessage:
        "No station transit in destination sub-consolidator data to display",
      print: "Print"
    },
    table: {
      columnNo: "No.",
      arrivalCity: "Arrival city",
      arrivalCityTooltipTitle: "Arrival city",
      arrivalCityTooltipBody: "City where package arrived",
      totalStt: "Total STT",
      totalPieces: "Total pieces",
      totalGrossWeight: "Total gross weight",
      totalVolumeWeight: "Total volume weight",
      stiDestScDate: "STI-DEST-SC date",
      action: "Action"
    },
    common: {
      unitKg: "kg",
      ok: "OK",
      cancel: "Cancel",
      yes: "Yes",
      no: "No"
    },
    update: {
      pageTitle: "Update STI DEST-SC",
      subConsolidatorName: "Sub-consolidator name",
      arrivalCity: "Arrival city",
      arrivalCityTooltipTitle: "Arrival city",
      arrivalCityTooltipDescription:
        "City where package arrived when processed in STI-DEST feature.",
      stiDestScDateLabel: "STI DEST-SC date",
      datePlaceholder: "Select or enter vehicle serial no.",
      sttNumberLabel: "STT no.",
      sttExampleLabel: "Example: 99LP1234567890123/88-22-12345678",
      sttInputPlaceholder: "Enter STT no. or scan barcode/QR code",
      overweightCannotUpdate:
        "Overweight; status cannot be updated to STI-DEST-SC",
      badgeMisRoute: "MIS-ROUTE",
      badgeTransit: "Transit",
      badgeStiDestSc: "STI DEST-SC",
      add: "Add",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Gross weight",
      totalDimWeight: "Dimensional weight",
      delete: "Delete",
      process: "Process",
      updateOnly: "Update STI DEST-SC",
      updateAndPrintPdf: "Update STI DEST-SC & Print PDF",
      modalDownload: "Download",
      partialSuccessCount: "{count} STT succeeded",
      partialFailCount: "{count} STT failed",
      leaveTitle: "Sure you want to leave?",
      leaveBody:
        "Make sure to go back, you will lose all data if you leave this page.",
      leaveConfirm: "Leave",
      leaveBack: "Back",
      confirmCreateTitle: "Confirm creation",
      confirmCreateBody:
        "Make sure to go back, all STT details are correct and appropriate.",
      confirmProcess: "Process",
      deleteGoodsTitle: "Remove goods",
      deleteGoodsBody:
        "Enter STT no. or scan barcode/QR to remove from STI-DEST-SC list.",
      deletedSection: "Removed",
      sttNotFoundOrRemoved: "STT no. not found or already removed",
      sttAlreadyEntered: "STT no. already entered",
      statusChangeSuccessTitle: "STT status updated",
      statusChangeSuccessBody: "Updated to STI-DEST-SC.",
      addSttFailedTitle: "Add STT failed",
      scanSttFailedTitle: "STT scan failed",
      partialSuccessTitle: "Partial success",
      partialSuccessBody: "Please download the results",
      statusChangeFailedTitle: "Status change failed",
      statusChangeFailedBody: "STI-DEST-SC update failed.",
      table: {
        columnNoBag: "Bag No.",
        columnNoStt: "STT No.",
        columnNoRef: "Reference No.",
        columnProduct: "Product",
        columnKomoditas: "Commodity",
        columnTotalKoli: "Total Pcs",
        columnGrossWeight: "Gross Weight",
        columnDimWeight: "Dimensional Weight",
        columnDestination: "Dest.",
        columnTransit: "Transit",
        columnMisroute: "Misroute"
      },
      errors: {
        addSttFailed: "Add STT failed!",
        updateFailed: "Update failed!"
      }
    },
    pdf: {
      manifestTitle: "STI DEST-SC manifest",
      subConsolidatorName: "Sub-consolidator name",
      arrivalCity: "Arrival city",
      stiDestScDate: "STI-DEST-SC date",
      totalStt: "Total STT",
      totalKoli: "Total pieces",
      totalGrossWeight: "Gross weight",
      totalDimWeight: "Dimensional weight",
      colNo: "No.",
      colNoBag: "Bag no.",
      colNoStt: "STT no.",
      colNoRef: "Reference no.",
      colProduct: "Product",
      colKomoditas: "Commodity",
      colTotalKoli: "Total pieces",
      colGrossWeight: "Gross weight",
      colDimWeight: "Dimensional weight",
      colDestination: "Dest.",
      colTransit: "Transit",
      colMisroute: "Misroute",
      colNotes: "Notes",
      colOrigin: "Origin",
      signatoryStationAdmin: "Station admin",
      signatoryCourier: "Courier",
      signatoryOpsSupervisor: "Operations supervisor"
    }
  },
  notFoundPage: {
    title: "Page Not Found",
    subtitle:
      "The page you requested was not found. Please return to the home page or contact us at",
    button: "Back to Dashboard"
  },
  authenticator: {
    alert: {
      title: "OTP Verification not enabled",
      message:
        "Enable OTP verification to secure your account when changing email address.",
      buttonText: "Enable Now"
    },
    alertChangePassword: {
      title: "Password will expire!",
      titleWithDiff: "Password will expire in {day} days!",
      titleToday: "Password will expire today!",
      message: "Update your password to keep your account secure",
      buttonText: "Update Now"
    },
    profile: {
      title: "OTP Verification code",
      statusActive: "Active",
      statusNotActive: "Inactive",
      notEnrolled: `Provide additional security by enabling OTP code verification via <span class="font-bold">email</span>. The OTP code will be requested every time you log in.`,
      enrolled: `Verification OTP code will be sent via <span class="font-bold">email</span>. The OTP code will be requested every time you log in.`,
      buttonText: "Activate now"
    },
    login: {
      modalTitle: "Enable OTP verification",
      modalMesssage:
        "Provide additional security by enabling OTP code verification for your account.",
      modalButton: "Activate now"
    },
    verifyOtp: {
      title: "Verify OTP code",
      message: "Enter the OTP code sent via email to",
      verification: "Verify",
      resendTime: "Resend in",
      notGetCode: "Didn't receive the code?",
      resend: "Resend",
      helpWhatsApp: "Need help? Contact via WhatsApp",
      orEmailTo: "or email to"
    }
  },
  cargoV2: {
    create: {
      index: {
        title: "CARGO Booking",
        manualBookingBtn: "Manual Booking",
        tab: {
          plane: "Plane",
          truck: "Truck",
          ship: "Ship"
        }
      },
      common: {
        backAlt: "back",
        selectSchedule: "Select Schedule",
        selectScheduleLower: "Select schedule",
        booking: "Booking",
        ok: "Ok",
        okUpper: "OK",
        kg: "kg",
        othersMode: "Other modes"
      },
      nonRtcLayout: {
        title: "Manual booking"
      },
      rtc: {
        error: {
          getDetailRtc: "Failed to fetch RTC details",
          bookingFailed: "Cargo booking failed"
        }
      },
      rtcList: {
        emptyTitle: "Ready to Cargo List",
        notFound: {
          title: "No results found",
          message: "Check and reset your filters."
        }
      },
      cargoType: {
        error: {
          getListCargoType: {
            title: "Error to get cargo type data."
          }
        }
      },
      searchFlightHeader: {
        totalKoli: "Total Pieces",
        grossVolume: "Gross w./ Volume w.",
        alt: {
          plane: "Plane",
          briefcase: "Briefcase",
          box: "Box"
        }
      },
      searchFlight: {
        title: "Select schedule",
        reload: "Reload",
        status: {
          loading: {
            header: "Loading flight schedules",
            body: "We are looking for the best schedule for you."
          },
          server: {
            header: "System issue occurred",
            body: "Please try again later"
          },
          internet: {
            header: "Internet connection lost",
            body: "Please check your internet connection"
          },
          filteredEmpty: {
            header: "No results found",
            body: "Check and reset your filters."
          },
          empty: {
            header: "No flight schedules available",
            body: "Change date or filters to find other flight schedules"
          }
        },
        error: {
          networkTitle: "Booking failed!",
          bookingFailed: "Booking failed"
        }
      },
      modal: {
        bookingProcessing: {
          title: "Cargo booking {bookingRequestId} <br/> Is being processed",
          message:
            "You will receive a notification when the cargo booking is successful"
        },
        bookingFailed: {
          title: "Booking failed",
          message:
            "Cargo with <b>route {origin} - {destination}</b> failed to book because {reason}. Please try again later!"
        }
      },
      snackbar: {
        booked:
          "Cargo <b>{cargoNo}</b> to {destination} has been booked successfully."
      },
      error: {
        failedToCargoBooking: "Failed to Cargo Booking !",
        creationFailed: "Creation Failed !",
        bookingFailedTitle: "Booking Failed !"
      }
    },
    components: {
      common: {
        backAlt: "back",
        closeAlt: "close",
        transportAlt: "transport",
        infoAlt: "info",
        save: "Save",
        cancel: "Cancel",
        reset: "Reset",
        apply: "Apply",
        booking: "Booking",
        all: "All",
        process: "Process",
        back: "Back",
        completeBookingData: "Complete booking data",
        destinationCity: "Destination city",
        destinationCityTitle: "Destination City",
        selectDestinationCity: "Select destination city",
        transportMode: "Mode",
        selectMode: "Select mode",
        dangerousGoods: "Dangerous Goods",
        quarantine: "Quarantine",
        kg: "kg",
        kgCapital: "Kg",
        vehicleSerialNumber: "Vehicle serial number",
        searchVehicleSerialNumber: "Search vehicle serial number",
        commodity: "Commodity",
        selectCommodity: "Select commodity",
        product: "Product",
        selectCargoProductType: "Select cargo product type",
        cargoNumber: "Cargo Number",
        nog: "NOG",
        inputNog: "Input NOG",
        nogTooltip: "Fill NOG according to the cargo commodity.",
        shc: "SHC",
        selectShc: "Select shc",
        shcTooltip:
          "SHC will be filled automatically based on the selected cargo commodity.",
        other: "Other",
        errorGetData: "Failed to get data!",
        plane: "Plane",
        truck: "Truck",
        ship: "Ship",
        train: "Train",
        confirmCreationTitle: "Creation Confirmation",
        confirmCreationMessage:
          "Please make sure all STT details are correct and appropriate.",
        sttBagCannotUpdateTitle:
          "There are STT/Bag items that cannot be updated to Cargo.",
        sttBagCannotUpdateMessage:
          "There are STT/bag items that cannot be processed as cargo. Please check again.",
        errorCheckEligible: "An error occurred while checking eligibility",
        confirmEditCargoTitle: "Confirm Cargo Update",
        confirmEditCargoMessage:
          "Please confirm. You are about to update cargo <b>{cargoNo}</b>.",
        errorEditCargo: "Failed to Update Cargo",
        successEditCargo:
          "Cargo <b>{cargoNo}</b> has been updated successfully.",
        susccessDeleteDataTitle: "Data Deleted Successfully",
        susccessDeleteDataMessage: "Cargo No. {cargoNo} has been deleted.",
        failedGetData: "Failed to get data!"
      },
      editLayout: {
        title: "Edit cargo"
      },
      sectionSelectDestCargoType: {
        error: {
          getCity: "Failed to get city data",
          getCargoType: "Failed to get cargo type data"
        }
      },
      cardRtc: {
        minimumPiecesWeight: "Minimum pieces & weight",
        minimumPieces: "Minimum pieces",
        minimumWeight: "Minimum weight",
        bosspackProduct: "Bosspack cargo product",
        departurePlusTwoDays: "Departure +2 days",
        departurePlusTwoDaysTooltip:
          "Departure estimation has not been configured for the next 2 days. Please select a schedule",
        departureStart: "Departure starts:",
        totalPieces: "Total Pieces",
        totalPiecesTooltip: "Total cargo pieces (STT and bag)",
        grossWeight: "Gross w.",
        grossWeightTooltip: "Total cargo gross weight (STT and bag)"
      },
      searchFlightFilter: {
        airport: "Airport",
        selectAirport: "Select airport",
        originAirport: "Origin airport",
        destinationAirport: "Destination airport",
        transitCount: "Transit count",
        selectTransitCount: "Select transit count",
        sort: "Sort",
        sortFrom: "Sort from",
        searchTimeLimit: "Search time limit",
        timeLimit: "Time limit",
        origin: "origin",
        destination: "destination",
        legs: {
          direct: "Direct",
          oneTransit: "1 transit",
          twoTransit: "2 transits",
          moreThanThreeTransit: ">3 transits"
        },
        sortOption: {
          etaFastest: "Fastest ETA",
          etdFastest: "Fastest ETD"
        },
        threshold: {
          twelveHours: "12 hours from now",
          twentyFourHours: "24 hours from now"
        }
      },
      modalDelayConfirmation: {
        title: "Make sure the selected schedule is correct",
        transit: "{count} Transit",
        flightRoute: "FLIGHT ROUTE",
        estimatedDeparture: "ESTIMATED DEPARTURE",
        body:
          'This flight schedule has <span class="font-bold">potential delay</span>, do you want<br />to continue booking?',
        changeSchedule: "Change schedule",
        confirmBooking: "Yes, Book"
      },
      cardFlight: {
        arrivalDayDiff: "+{count} day",
        volumeUnavailable: "Aircraft volume is insufficient",
        dimensionUnavailable: "Aircraft dimension is insufficient",
        capacityUnavailable: "Aircraft capacity is insufficient",
        embargoRoute: "Embargo Route",
        dgNotAllowed: "Cannot send DG goods",
        potentialDelay: "Potential delay",
        onTime: "On-time",
        availableCapacity: "Available capacity",
        flyIn: "Fly in",
        flyInValue: "{hours} hours {minutes} minutes",
        viewTransitDetail: "View transit details",
        close: "Close",
        direct: "Direct",
        originCity: "Origin city",
        destinationCity: "Destination city",
        transit: "Transit {count}",
        capacity: "Capacity"
      },
      modalPlaneAuto: {
        commodityGroup: "Commodity Group (Cargo)",
        productType: "Cargo product type"
      },
      modalBookingTruck: {
        error: {
          getCourierData: "Failed to get courier data"
        }
      },
      modalBookingShip: {
        inputCargo: "Input cargo"
      },
      manualInput: {
        cargoNumberManual: "Manual cargo/SMU number",
        inputCargoNumberManual: "Input manual cargo/SMU number",
        track: "Track",
        cargoNumberTooltip:
          "SMU number is required if booking is done in an external system. The SMU number contains the airline code and a unique number",
        checkInternet: "Please check your internet connection!",
        selectProduct: "Select Product",
        errorGetCourierData: "Failed to get courier data",
        flightDuration: {
          minutes: "{count} minutes",
          hours: "{count} hours",
          hoursMinutes: "{hours} hours {minutes} minutes"
        }
      },
      inputVehicleNo: {
        placeholder: "ABCD 123",
        invalidFormat: "Invalid format"
      },
      photoDispute: {
        infoAlt: "Info",
        title: "PHOTO PROOF IS REQUIRED",
        viewPhoto: "View photo",
        guide: {
          clearPhoto: "Photo must be clear and not blurry.",
          readableWeightVolume:
            "Weight/volume numbers must be clearly readable.",
          fullCargoFrame: "All cargo must be visible in one frame."
        },
        photoType: {
          weighingAndCargo: "Scale + Cargo",
          additionalPhoto: "Additional photo"
        },
        error: {
          upload: "Failed to upload dispute photo",
          delete: "Failed to delete dispute photo"
        }
      },
      cargoDisputeForm: {
        pieces: "Pieces",
        stt: "STT",
        bag: "bag",
        reweighTitle: "Reweigh",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w.",
        chargeableWeight: "Chargeable w.",
        grossWeightCargo: "Cargo gross w.",
        maxGrossWeightCargoTooltip:
          "Max cargo gross w. {cargoType} {maxWeight} kg",
        maxWeight: "Max {maxWeight} kg",
        cargoPieces: "Cargo pieces",
        maxCargoPiecesTooltip: "Max cargo pieces {cargoType}: {maxPieces}",
        maxPieces: "Maximum {maxPieces} pieces",
        cargoDimension: "Cargo dimensions",
        dimension: "L x W x H",
        editIfDimensionChanged: "Edit if dimensions change",
        cargoVolumeWeight: "Cargo volume w.",
        maxCargoVolumeWeightTooltip:
          "Maximum cargo volume w. for {cargoType}: {maxWeight} kg",
        calculating: "Calculating ...",
        cargoChargeableWeight: "Cargo chargeable w.",
        cargoType: {
          plane: "plane",
          truck: "truck",
          ship: "ship"
        },
        error: {
          baggingWeightLocked: "Weight cannot exceed reweigh result",
          baggingWeightLockedTooltip:
            "Weight cannot be changed because it follows the bagging result.",
          maxCargoChargeableWeightDiff:
            "Max cargo CW difference {maxWeight} kg per STT",
          chargeableWeightDifference: "Cargo CW difference >= 1 kg"
        }
      },
      scanTableList: {
        emptyStateAlt: "Empty State",
        empty: "No scanned packages yet.",
        delete: "Delete",
        column: {
          no: "No.",
          bagNo: "Bag No.",
          chargeableBag: "Chargeable w. bag",
          sttNo: "STT No.",
          chargeableStt: "Chargeable w. STT",
          shippingType: "Shipping type",
          commodity: "Commodity",
          destinationCity: "Destination city",
          action: "Action"
        }
      },
      scanTableSection: {
        inputPlaceholder: "Input shipment/STT/bag",
        invalidSttTitle: "Invalid STT",
        total: "Total {count}",
        scanProcessFailed: "Failed to process scan",
        bagAlreadyExists: "Bag already exists in the table",
        sttAlreadyExists: "STT already exists in the table",
        weightExcess:
          "Excess weight occurred so the status cannot be updated to Cargo.",
        export: {
          sttNumber: "STT Number",
          failedReason: "Failure Reason"
        },
        deleteModal: {
          title: "Are you sure you want to delete the data?",
          message:
            "The data will automatically be removed from the table list.",
          confirm: "Yes, Delete"
        }
      },
      detailHistory: {
        title: "Cargo status history",
        empty: "Oops.. No data to display yet",
        proofOfDelivery: "View proof of delivery",
        proofWeightAdjustment: "View proof photo of weight adjustment",
        totalPieces: "Total pieces",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w."
      },
      detailInfo: {
        bookingDate: "Booking date",
        lastUpdated: "Last updated",
        inProcessBooking: "Booking in process",
        cancelledOrFailedBooking: "Cancelled/booking failed",
        printStatus: "Print Status",
        weightDispute: "Weight dispute",
        manualCargoNumber: "Manual cargo/SMU number",
        sttWeight: "STT weight",
        reweighWeight: "Reweigh weight",
        cargoWeight: "Cargo weight",
        grossWeight: "Gross W.",
        volumeWeight: "Volume W.",
        chargeableWeight: "Chargeable W.",
        grossWeightCargo: "Cargo Gross W.",
        cargoPieces: "Cargo pieces",
        volumeWeightCargo: "Cargo Volume W.",
        totalSttBag: "Total STT/Bag",
        chargeableWeightCargo: "Cargo Chargeable W.",
        weightDisputeBag: "Weight dispute bag",
        pieces: "pieces",
        stt: "STT",
        bag: "bag",
        photoProofAlt: "Weight adjustment proof photo piece {index}",
        viewMorePhotoProof: "View {count} more proof photos",
        sttBagList: "STT/bag list",
        emptySttBag: "There are no STT or bagging items in this cargo",
        disputeBagTooltip: "Bag with weight dispute",
        viewProofPhoto: "View proof photo",
        processedByBagging: "Processed by bagging",
        processedByCargo: "Processed by cargo",
        print: {
          labelCargo: "Cargo label",
          awbLionCargo: "Lion Cargo AWB",
          manifestCargo: "Cargo manifest"
        }
      },
      disputeSummary: {
        withWeightDispute: "with weight dispute",
        dataRange: "Data {dateRange}",
        download: "Download",
        minimumWeightPerPiece: "SMU with minimum weight per piece",
        error: {
          downloadSummary: "Failed to download dispute summary data!",
          downloadMinimumWeight: "Failed to download minimum weight data!"
        }
      },
      filterSection: {
        searchPlaceholder: "Cargo no./SMU",
        destinationAirportCode: "Destination airport code",
        hubLocation: "HUB Location",
        filter: "Filter",
        selectDate: "Select date"
      },
      downloadList: {
        title: "Create cargo list",
        startBookingDate: "Booking start date",
        inputStartDate: "Input start date",
        endBookingDate: "Booking end date",
        inputEndDate: "Input end date",
        hubLocation: "Hub location",
        selectHubLocation: "Select hub location",
        bookingUser: "Booking user",
        selectBookingUser: "Select booking user",
        downloadFailed: "Download Failed!"
      },
      searchFlightDatePicker: {
        selectOtherDate: "Select another date"
      },
      buttonLoadMore: {
        label: "View more"
      },
      filterRtc: {
        client: "Client",
        selectDestinationCity: "Select destination city",
        searchDestinationCityHere: "Search destination city here",
        notFound: "What you are looking for was not found or does not exist.",
        selectClient: "Select client",
        searchClientHere: "Search client here",
        selectMinimumLimit: "Select minimum limit",
        minimumWeight: "Minimum weight",
        minimumPieces: "Minimum pieces",
        minimumWeightAndPieces: "Minimum weight & pieces",
        destinationCitiesSelected: "destination cities selected",
        clientsSelected: "clients selected",
        cotNearest: "Nearest COT",
        cotLongest: "Longest COT"
      },
      change: "Change",
      validationChars: "characters",
      templateRetail: "Retail booking template",
      templateClient: "Client booking template",
      dataCommodity: "Commodity data",
      dataDistrict: "District data",
      downloadTemplate: "Download Template",
      downloadTemplateDescription:
        "Start downloading template, fill in the data columns, check the fill format, & upload here!",
      checkFormat: "Check data fill format in each column",
      checkFormatDescription:
        "Make sure before uploading bulk booking, all column data you fill matches the data below!",
      modalProcessingTitle: "Bulk booking is being processed!",
      modalProcessingMessage:
        'Booking "{name}" is in progress. Please wait a moment.',
      modalSuccessTitle: "OK",
      uploadSuccessTitle: "Bulk booking uploaded successfully",
      modalErrorRowEmpty: "Some rows are empty!",
      modalErrorDataExceed: "Booking data exceeds limit!",
      modalErrorHeaderInvalid: "File header is invalid!",
      modalErrorRowEmptyAlt: "Some rows are empty!",
      modalErrorQueueFull: "Bulk booking queue is full",
      modalErrorFileSize: "Bulk booking file size exceeds {size} MB",
      modalErrorSystem: "System error occurred",
      modalSubtitleRowEmpty: "Check file, complete all rows & upload again.",
      modalSubtitleDataExceed:
        "Maximum {maxStt} rows. Please remove some uploaded data.",
      modalSubtitleHeaderInvalid:
        "Check file & upload again according to template format",
      modalSubtitleRowEmptyAlt: "Check file, complete all rows & upload again.",
      modalSubtitleQueueFull: "Please wait a moment and try again.",
      modalSubtitleFileSize: "Change file and upload your file again.",
      modalSubtitleSystem: 'Click "Reload" or wait a moment.',
      btnUploadAgain: "Upload again",
      btnReload: "Reload",
      btnUnderstand: "OK, got it",
      btnBack: "Back",
      uploadFileCaption:
        "Format .xlsx. Maximum {maxStt} STT and file {maxMb} MB.<br/>Only the first 500 data rows will be processed.",
      uploadFileErrorFormat: "File format is invalid",
      searchPlaceholder: "Search Upload ID/Activity Name",
      selectPlaceholder: "Select client/partner/Internal",
      clientNameTitle: "Client / Partner Name",
      clientNamePlaceholder: "Search client / partner",
      templatePlaceholder: "Select template format",
      attachment: "Attachment",
      hintSection1:
        "Make sure all the data you enter is correct and appropriate",
      hintSection2:
        "with the file to be uploaded. Learn how to fill out the template",
      hintSection3: "here",
      errorClient: "Partner or Client is currently inactive",
      successBookingTitle: "File Upload Successful",
      successBookingMessage:
        "The data in the shipment file has been successfully booked.",
      errorPartial:
        "Some shipment records were successfully booked as STTs, but failures occurred with others. Please download the file to identify the errors.",
      failedBookingTitle: "File Upload Failed",
      failedBookingMessage: "The data in the shipment file failed to book"
    },
    common: {
      retailInternational: "Retail International",
      retailDomestic: "Retail Domestic",
      clientInternational: "Client International",
      clientDomestic: "Client Domestic",
      bookingInternational: "International booking",
      bookingDomestic: "Domestic booking",
      commodityData: "Commodity data",
      districtData: "District data"
    }
  },
  pickupV2: {
    list: {
      title: "Pick Up List",
      createConfig: "Set Schedule Pick Up",
      wood: "WOOD",
      piece: "pcs",
      additional: "Additional",
      table: {
        orderId: "Order ID",
        status: "Status",
        totalRequest: "Total requested",
        totalRequestTooltip: "Total number of pieces requested for pickup.",
        totalPickup: "Total Pick Up",
        totalPickupTooltip:
          "Total number of shipments and pieces that have been picked up by the courier.",
        agentHubProcessed: "In Transit Hub",
        agentHubProcessedTooltip:
          "Total number of shipments and pieces processed by the Agent/Hub.",
        createdAt: "Created date"
      },
      emptyTitle: "No Pickup List Available",
      emptyMessage: "All pickup requests will appear on this page.",
      notFountTitle: "Result not found",
      notFountMessage: "Check the keyword or use other keywords.",
      summary: {
        pickUp: "Pick Up",
        waitingCourier: "Waiting for Courier",
        pickUpPackage: "Process Pick Up",
        mergedPickUp: "Merged Pick Up",
        pickUpCompleted: "Done",
        processedAgentHub: "In Transit Hub"
      },
      filter: {
        searchPlaceholder: "Search Order ID",
        pickupSchedule: "Pick Up schedule",
        vehicleType: "Vehicle Type",
        vehicleTypePlaceholder: "Select vehicle type",
        serviceType: "Shipping service",
        status: "Status",
        statusPlaceholder: "Select status",
        statusList: {
          searchingCourier: "Waiting for Courier",
          courierAssigned: "Courier Assigned",
          packagePickedUp: "Pick Up Package",
          completed: "Done",
          cancelledByCourier: "Cancelled by Courier",
          cancelledByClient: "Cancelled by Client",
          cancelledByAdmin: "Cancelled by Admin",
          packageMerged: "Pick Up Combined"
        }
      }
    },
    modalSttPickupList: {
      title: "List of STTs Available for Pickup ({bkdCount})",
      titleAwb: "List of Airway Bill ready for Pickup ({bkdCount})",
      searchPlaceholder: "Search STT",
      totalCount: "{count} STTs",
      empty: {
        title: "No STTs Available for Pickup",
        message: "There are no STTs to display."
      },
      notFound: {
        title: "No Results Found",
        message: "Check your keyword or try a different search term."
      },
      copyStt: "Copy STT Number",
      copiedStt: "STT number copied to clipboard",
      column: {
        sttNo: "STT No.",
        awbAndShipment: "AWB & Shipment No.",
        shipmentNo: "Shipment No.",
        lastStatus: "Latest Status",
        destinationCity: "Destination City",
        productType: "Shipping Service",
        chargeableWeight: "Chargeable Weight",
        createdAt: "Booking Date",
        bookedFor: "Booked For"
      }
    },
    detailSidebar: {
      statusPickUp: "Pick Up Status",
      createdAt: "Created date",
      by: "By {name}",
      courierInfo: "Courier information",
      courierNotAssigned: "Courier not yet assigned",
      proofPhotos: "Proof of photo",
      courierName: "Courier name",
      revealPhone: "Show phone number",
      sidebar: {
        merge: {
          infoMessage:
            "This shipment is a combination of <strong>{shipmentCount}</strong> with total pcs & weight calculated in its entirety.",
          shipmentUnit: "shipments",
          viewLink: "View shipments",
          listTitle: "Combination shipment list",
          listItem: "{shipmentId} ({koliCount} pcs - {weightKg} kg)",
          close: "Close"
        }
      }
    },
    detail: {
      pageTitle: "Pickup List | Detail",
      requestInfo: {
        sectionTitle: "Detail Request Pick Up",
        warehousePrefix: "Warehouse",
        coordinateLabel: "Coordinates: {coordinate}",
        courierNoteLabel: "Note for courier",
        courierNoteEmpty: "-"
      }
    }
  },
  bookingV4: {
    breadcrumb: {
      retailBooking: "Retail Booking"
    },
    pageTitle: "Create Booking",
    pageTitleEdit: "Edit Booking",
    bookingHistory: "Booking History",
    bookingHistorySuccessTitle: "Successful Booking History ({counter})",
    reset: "Reset",
    cancelVoucher: "Cancel Voucher",
    reserveVoucher: "Reserve Voucher",
    header: {
      bookingHistory: {
        button: "Print Bill & Receipt"
      },
      receiptFormat: {
        a4: "A4 Label",
        a6: "A6 Label",
        none: "No Label Print",
        title: "Receipt Format"
      },
      tabs: {
        domestic: "Domestic",
        international: "International"
      }
    },
    detailSender: "Shipper",
    detailRecipient: "Recipients",
    country: "Country",
    name: "Name",
    phoneNumber: "Phone Number",
    edit: "Edit",
    address: "Address",
    districtCity: "District, City",
    postalCode: "Postal code",
    office: "Office",
    autofill: "Copy and autofill recipient details.",
    paste: "Paste",
    sender: {
      title: "Shipper",
      country: {
        label: "Origin country",
        placeholder: "Select origin country",
        error: {
          required: "Origin country required",
          notFound: "Country not found"
        }
      },
      name: {
        placeholder: "Shipper name",
        error: {
          required: "Name required",
          minLength: "Min. 3 characters.",
          notFound: "Customer data not found"
        }
      },
      phone: {
        placeholder: "Enter phone number",
        error: {
          required: "Phone number required",
          invalid: "Invalid phone number",
          notFound: "Customer data not found",
          fraud: {
            limited1: "This number has reached the daily COD/DFOD",
            limited2: "transaction limit.",
            limited3: "",
            limitedTooltip:
              "Phone numbers are limited to a max. of 10 COD/DFOD air waybill (excluding CNX) or a total shipping cost of RM28.1",
            suspected: "This number has a high COD/DFOD return rate",
            tresholdProtection: "Shipment is covered with free protection up to"
          }
        }
      },
      address: {
        placeholder: "Enter full address",
        error: {
          required: "Address required",
          minLength: "Min. 3 characters.",
          sameAddress: "The sender and recipient addresses cannot be the same"
        }
      }
    },
    recipient: {
      title: "Recipient",
      country: {
        label: "Destination country",
        placeholder: "Select destination country",
        error: {
          required: "Destination country required",
          notFound: "Country not found"
        }
      },
      name: {
        placeholder: "Recipient name",
        error: {
          required: "Name required",
          minLength: "Min. 3 characters.",
          notFound: "Customer data not found"
        }
      },
      phone: {
        placeholder: "Enter phone number",
        error: {
          required: "Phone number required",
          invalid: "Invalid phone number",
          notFound: "Customer data not found"
        }
      },
      address: {
        placeholder: "Enter full address ",
        error: {
          required: "Address required",
          minLength: "Min. 3 characters.",
          sameAddress: "The sender and recipient addresses cannot be the same"
        }
      },
      city: {
        label: "District, City",
        labelInternational: "District, City",
        placeholder: "Select district, city",
        placeholderInternational: "Select district, city",
        labelAlternate: "City, Region",
        error: {
          required: "District, city is required",
          requiredInternational: "District, city is required",
          notFound: "District, city is not found",
          routeNotAvailable: "Route is not available"
        },
        misbookingGuidance:
          "This destination is prone to misdelivery. Make sure the selection matches the recipient's address."
      },
      postalCode: {
        placeholder: "Select code",
        error: {
          required: "Required",
          notFound: "Not found"
        }
      },
      autofill: {
        processing: "Processing data...",
        unsupportedFormat:
          "The copied format is not supported. Copy text, then try again.",
        emptyClipboard: "No data was copied. Copy recipient data first.",
        processingError: "Failed to process the data. Please try again.",
        success: "Recipient data filled successfully"
      }
    },
    optional: "Optional",
    additionalPhoto: "Supporting Photos",
    beforeAfterPackingPhoto: "Photos before & after packing",
    packageBeforePacking: "Package before packing",
    packageAfterPacking: "Package after packing",
    recipientIdNumber: "Receiver ID number",
    recipientIdPhoto: "Receiver ID Photo",
    recipientTaxIdNumber: "Receiver Tax ID number",
    recipientTaxIdPhoto: "Receiver Tax ID Photo",
    doc: {
      title: "International Shipping Supporting Documents",
      subtitle: "Supporting Documents",
      guide: {
        title: "Supporting document guide",
        expand: "Show",
        collapse: "Hide",
        content: `<ul class="custom-list">
          <li>Use <span class="font-bold">JPG, JPEG, PNG, or PDF</span> format (max. 5 MB/file).</li>
          <li>Make sure the <span class="font-bold">brand of the item</span> is clearly visible in the photo before packing.</li>
          <li>Ensure photos are <span class="font-bold">clear and complete</span> to speed up the verification process.</li>
          <li>You can add up to <span class="font-bold">5 additional supporting documents</span> (e.g., import permits, circulars, etc.). Check <a target="_blank" rel="noopener noreferrer" class="underline font-bold" href="https://lionparcel.com/sk">t&c</a> details</li>
        </ul>`
      },
      email: {
        label: "Email Recipients",
        placeholder: "Enter recipient email",
        errorRequired: "Email required",
        errorInvalid: "Invalid email"
      },
      idNumber: {
        label: "Recipient IC/SSM",
        placeholder: "Enter recipient IC/SSM",
        errorRequired: "Identity number required",
        errorInvalid: "Identity number may only contain letters and numbers"
      },
      taxNumber: {
        label: "TAX ID Recipients",
        placeholder: "Enter TAX ID",
        errorRequired: "Tax ID required",
        errorInvalid: "Tax ID may only contain letters and numbers",
        errorMin: "Recipient tax id is min 15 characters",
      },
      dutyTaxTerms: {
        label: "Customs & Tax Payment",
        dap: "Paid by Recipients (DAP)",
        ddp: "Paid by Shipper (DDP)",
        placeholder: "Select the paying party",
        infoCopy: `<ul class="custom-list">
          <li><span class="font-bold">Delivered Duty Paid (DDP):</span> The shipper will cover all customs duties and taxes.</li>
          <li><span class="font-bold">Delivery At Place (DAP):</span> The recipient will cover all customs duties and taxes when the package arrives at its destination.</li>
        </ul>`,
        dutyTaxTermsBannerPrefix:
          "If there are Customs Duty & Tax charges, they will be charged to",
        shipper: "Sender",
        recipient: "Receiver",
        errorRequired: "Paying party must be selected"
      },
      upload: {
        idCard: "IC/SSM",
        taxCard: "Tax ID",
        beforePacking: "Package before packing",
        afterPacking: "Package after packing",
        additional: "Add Other Supporting Document",
        additionalDocument: "Additional <br>document",
        limitMessage:
          "Maximum of 5 additional files (JPG/JPEG/PNG/PDF, max 5 MB)",
        errorRequired: "Required.",
        uploadFailed: "Failed to upload document. Please try again.",
        error:
          "Invalid file format or exceeds 5 MB. Use JPG, JPEG, PNG, or PDF."
      }
    },
    referenceNumber: {
      title: "No. Reference",
      placeholder: "Enter reference number",
      helperText:
        "Enter External ID/Airway Bill Manual/Shipment ID so the order can be tracked with that number.",
      maxLimit: "A maximum of {max} reference numbers can be added.",
      duplicateType: "External ID/Manual STT/Shipment ID has already been added.",
      type: {
        sttManual: "STT Manual",
        shipmentId: "Shipment ID",
        externalRef: "External Reference"
      },
      error: {
        externalRequired: "Reference number required",
        minimumRef: "Min. 3 characters",
        selectClientFirst:
          "Please select a Client first before entering Manual STT"
      },
      eksternalRefCanBeUsed: "The external reference number can be used."
    },
    reference: {
      error: {
        required: "Required"
      }
    },
    goods: {
      title: "Item & Pcs",
      button: {
        reset: "Reset"
      },
      itemDetails: {
        title: "Item Details"
      },
      cipl: {
        title: "Detail Goods (CIPL)",
        itemName: "Item name",
        quantity: "Quantity",
        unitPrice: "Price per item",
        totalPrice: "Total price",
        footerTotal: "Total item price",
        footerEstimated: "(Est. {currency} {amount})",
        addRow: "Add",
        deleteRow: "Delete",
        otherCommodity: "Other",
        placeholder: {
          itemName: "Select item",
          quantity: "Enter Quantity",
          unitPrice: "Enter Unit Price"
        },
        senderInfo: "Inform the sender:",
        deminimisWarning:
          "The shipment is subject to import duties and taxes because it exceeds the limit of {currency}{amount}.",
        importDocWarning:
          "The shipment require official market authorization documents, such as those from BPOM, NPRA, or equivalent bodies in the destination country.",
        selfClearanceWarning:
          "The recipient is responsible for handling the customs clearance process and import documentation in the destination country.",
        error: {
          itemDetailMandatory: "Item name must be filled in",
          quantityMandatory: "Must be filled",
          goodsPriceMandatory: "Price must be filled in"
        }
      },
      commodity: {
        title: "Commodity",
        placeholder: "Select commodity",
        viewAll: "View all",
        notFound: "Commodity not found",
        note: "Note",
        tnc: "Terms & Conditions",
        tncBody: "Fill in the commodity according to the T&C.",
        recommendationError: "Failed to load recommendations",
        errorRequired: "Commodity is required",
        errorInactive: "Commodity is inactive",
        modal: {
          searchResult: "Search Results",
          searchPlaceholder: "Enter or select commodity",
          mostUsed: "Most Used",
          emptySearch: "Result not found",
          emptySearchDescription: "Check and try other keywords",
          emptyCategory: "Enter a keyword or select a category",
          reload: "Reload"
        }
      },
      koli: {
        title: "Pcs weight",
        grossWeight: "Gross weight",
        dimensions: "Dimensions (L x W x H)",
        length: "L",
        width: "W",
        height: "H",
        volumeWeight: "Volume Weight",
        button: {
          add: "Add",
          delete: "Delete"
        },
        alert: {
          hws:
            "A surcharge will apply for weights over {minimumWeightKg} kg, and you cannot add more packages."
        },
        error: {
          hwsSecondRow:
            "Weights above {minimumWeightKg} kg are allowed only for one package.",
          districtOnePiece:
            "The destination district/city only allows a maximum of 1 package.",
          maximumWeight:
            "Total item weight exceeds the maximum limit of {maxKg} of kg/STT.",
          emptyGrossWeight: "Gross weight is required.",
          emptyVolumeWeight: "Volume weight is required.",
          adjustWeight: "Weight loss changes are not permitted"
        },
        infobarWeightComma: "(For weight < 1 kg use period. Example: 0.5 kg.)",
        tooltip: {
          title: "Dimensional weight calculation:",
          line1:
            "<strong>BOSSPACK, REGPACK, MINIPACK, INTERPACK, and INTERPACKMAXI</strong> shipping types are calculated using (Length x Width x Height)/5.000"
        }
      },
      uploadWeight: {
        title: "Required to upload photo proof of item to change weight",
        showGuide: "View guide",
        closeGuide: "Close guide",
        sampleBadge: "SAMPLE PHOTO",
        addPhoto: "Add Photo",
        guideScalePhoto: "Scale photo",
        guidePackageIdentityPhoto: "Item photo with identity",
        additionalPhoto: "Additional photo",
        guides: {
          resolutionBold: "Photo resolution",
          resolutionText: "is clear and not blurry.",
          scaleBold: "Scale",
          scaleOrText: "or",
          volumeBold: "volume measurement",
          volumeText: "is clearly visible.",
          labelSttBold: "STT label, shipment,",
          labelSttText: "or other labels can be read.",
          wholePackageBold: "Entire package",
          wholePackageText: "is visible in one photo."
        },
        error:
          "Please upload at least two photos of the weighing proof to change the weight of this STT."
      },
      savedPackage: {
        commodity: "Commodity",
        totalPieces: "Total pieces",
        grossWeight: "Gross weight",
        checkbox: {
          label: "Save (Max. 3 saved package data. New data will replace old data if limit exceeded)."
        },
        tooltip: {
          title: "Detail",
          dimensionHeader: "Dimensions (L x W x H)",
          weightHeader: "Gross weight",
          dimensionValue: "{length} x {width} x {height} cm",
          weightValue: "{weight} kg",
          totalWeight: "Total Gross Weight"
        }
      }
    },
    supportingDoc: {
      error: {
        required: "Supporting document is required"
      }
    },
    cashback: "Cashback",
    shippingEstimation: "Delivery Estimation",
    shippingProduct: "Shipping Product",
    agentDiscount: "Agent Discount",
    product: {
      discount: "Discount",
      price: "Price",
      sla: "{sla} days",
      starTooltip: "Recommended",
      title: "Shipping service",
      infoPrice: "The price does not include",
      otherPrice: "other fees",
      infoTariff: ", check total price in the summary!",
      tooltip: {
        title: "Other fees (if applicable):",
        priceMsg: `<ul class="px-2 py-4">
        <li>• Commodity surcharge</li>
        <li>• Weight surcharge</li>
        <li>• Document surcharge</li>
        <li>• Protection fee</li>
        <li>• Protection admin fee</li>
        <li>• COD fee</li>
        <li>• Woodpacking surcharge</li>
      </ul>`
      },
      infobar:
        "The price does not include other fees, check total price in the summary!",
      otherFeesDetail:
        "Other fees (if applicable): Commodity surcharge, Weight surcharge, Document surcharge, Wooden packing fee, Protection fee, Protection admin fee, COD fee",
      unavailable: "Not available",
      embargo: "Embargo",
      discountAgent: "Discount",
      discountAgentToggle: "Agent Discount",
      discountAgentPercent: "Agent Discount {percent}%",
      minWeightNote: "*Price applies to min. 10 kg",
      sectionSubtitle:
        "Total shipping cost will adjust based on selected additional services.",
      error: {
        title: "A system issue occurred",
        subtitle: 'Click "Reload" to refresh the page.',
        retry: "Reload"
      }
    },
    // GENESIS-19573 detailing's localization table lists a flat "bookingV4.vippack"
    // string alongside nested "bookingV4.vippack.badge/.discountBadge/.termsLink",
    // which can't coexist as one JS key. Nested as "label" instead — use
    // $t("bookingV4.vippack.label"), not $t("bookingV4.vippack").
    vippack: {
      label: "VIPPACK",
      badge: "VIPPACK Active",
      discountBadge: "Agent Discount {discount}%",
      termsLink: "Terms & Conditions"
    },
    formCompletion: {
      title: "Form status",
      sender: "Shipper",
      recipient: "Recipient",
      referenceNumber: "No. Reference",
      product: "Shipping Service",
      doc: "Supporting Documents",
      goods: "Package & Pcs",
      status: {
        complete: "Complete",
        incomplete: "Incomplete"
      },
      field: {
        required: "Required",
        optional: "Optional"
      },
      email: "Email",
      idNumber: "ID Number",
      taxNumber: "Tax ID",
      upload: {
        idCard: "Identity Card Photo",
        taxCard: "Tax ID Photo",
        beforePacking: "Photo Before Packing",
        afterPacking: "Photo After Packing",
        packing: "Package Photo"
      }
    },
    otpCode: "OTP Code",
    sendOtp: "Send OTP",
    verify: "Verify",
    voucher: {
      apply: "Claim",
      sectionTitle: "Voucher",
      inputTitle: "Voucher code",
      seeMore: "View more",
      placeholder: "Enter voucher code",
      bannerOtp: "OTP required for this voucher.",
      tnc: "t&c",
      modalTitle: "Voucher",
      clearCode: "Clear voucher code",
      close: "Close",
      loading: "Loading vouchers...",
      emptyTitle: "Voucher not available",
      emptyDescription: "Voucher will be shown in here",
      completeRequired: "Complete the booking details to view vouchers",
      appliedSuccess: "Claim voucher successfully.",
      card: {
        percentage: "{value}% Discount Up to {max}",
        nominal: "{amount} Discount",
        description: "Min. transaction {minimum} until {endDate}",
        thousand: "{value}K",
        million: "{value}M"
      },
      terms: {
        title: "Terms & conditions:",
        minimum: "Minimum transaction {amount}.",
        productTypes: "Valid for shipment types: {types}.",
        serviceTypes: "Valid for delivery services: {types}.",
        usageLimit: "The voucher can be used up to {count} times per customer.",
        validUntil: "Voucher is valid until {date}.",
        percentageDiscount: "Enjoy a {value}% discount up to {maximum}.",
        nominalDiscount: "Enjoy a discount of {amount}."
      },
      otp: {
        title: "Enter OTP code",
        description:
          "Please check the OTP code sent via SMS to the shipper's number.",
        resend: "Resend OTP",
        resendCountdown: "Resend OTP code in {countdown}",
        notReceived: "Didn't receive the code?",
        continueWithoutVoucher: "Continue without voucher",
        error: {
          invalid: "Invalid OTP code. Please try again."
        }
      },
      error: {
        minTransaction: "Minimum transaction {amount}",
        invalid: "The voucher unavailable.",
        expired: "Voucher code expired",
        quotaExhausted: "Voucher limit reached."
      }
    },
    payment: {
      title: "Select payment",
      cash: "Cash",
      cod: "COD",
      dfod: "DFOD",
      invoiceLimit: "Invoice limit",
      tooltip: {
        cod: "COD is only available for domestic shipments in select areas.",
        dfod:
          "DFOD is only available for corporate shippers or authorized agents."
      },
      disable: {
        destination: "COD/DFOD not available at destination city.",
        partner: "COD/DFOD not available for partner.",
        client: "COD/DFOD not available for partner.",
        dailyLimit: "Sender has reached the COD/DFOD transaction limit",
        blacklist: "Sender cannot use COD/DFOD",
        generic: "Sender cannot use COD/DFOD",
        invoiceLimitFrozen: "Billing limit is temporarily unavailable.",
        phoneNumberBlacklist: "COD/DFOD not available, contact our CS.",
        phoneNumberLimit: "Shipper exceeded COD/DFOD limit.",
        productType: "Shipping service doesn't support COD/DFOD."
      },
      warning: {
        suspected: "This number has a high COD/DFOD return rate"
      }
    },
    protection: {
      checkbox: "Protection",
      alreadyProtected: "Shipping is protected",
      agentDiscount: "Agent Discount",
      tooltip: "Shipping protection fee: Tier 1: ...",
      itemPrice: {
        title: "Item price",
        placeholder: "Enter item price",
        error: "Item price is required.",
        errorMax: "Maximum item price is {value}",
        errorMin: "Minimum item price is {value}"
      },
      codAmount: {
        title: "Total COD Amount",
        placeholder: "Enter COD amount",
        footerEstimated: "Est. {currency}{amount}",
        tooltipDescription: "If empty, COD amount will follow the item price."
      }
    },
    chargeableWeight: {
      title: "Weight details",
      grossWeight: "Total gross weight",
      volumeWeight: "Total volume weight",
      woodpacking: "Wood packing additional weight",
      final: "Final chargeable weight"
    },
    totalKoli: {
      format: "({n} pcs)"
    },
    // GENESIS-20108 TotalTarifSectionV4 + tariff breakdown dropdown
    footer: {
      save: "Save",
      bookingAction: "Booking",
      totalTariff: "Total",
      recipientPayable: "Amount payable by recipient",
      detailTitle: "Payment details",
      empty: "Tariff is not available yet",
      publishShippingRate: "Publish rate + shipping surcharge",
      originForwardRate: "Origin forward rate",
      destinationForwardRate: "Destination forward rate",
      shippingCost: "Shipping cost",
      commoditySurcharge: "Commodity surcharge",
      heavyweightSurcharge: "Heavyweight surcharge",
      documentSurcharge: "Document surcharge",
      totalAdditionalSurcharge: "Total additional surcharge",
      protection: "Protection",
      protectionBasic: "Basic",
      protectionFree: "Free",
      woodpacking: "Wood Packing",
      woodpackingIncluded: "Includes wood packing surcharge",
      insuranceAdminFee: "Insurance administration fee",
      codGoodsPrice: "COD goods price",
      codFee: "COD fee",
      codReturnFee: "Return fee",
      dfodShippingCod: "DFOD shipping COD fee",
      taxEstimation: "Tax estimation",
      totalAfterVoucher: "Total tariff after voucher",
      discountLabel: "Discount {value}",
      promoBadge: "Promo {value}%",
      promo: {
        tactical: "Tactical promo",
        campaign: "Campaign promo"
      },
      voucher: "Voucher promo",
      refresh: "Refresh",
      error: "Failed to load tariff"
    },
    completeForm: "Please complete all fields",
    validationError: "Form Validation Failed",
    error: {
      limitTagihanInsufficient:
        "Billing limit is insufficient for this transaction"
    },
    success: {
      title: "Booking successful!",
      close: "Close",
      printInvoice: "Create Invoice",
      printReceipt: "Print Receipt",
      copy: "Copy",
      recipient: "Recipient",
      destination: "Destination district, city",
      serviceType: "Service type",
      estimation: "Estimated delivery",
      codFee: "COD Fee",
      dfodFee: "DFOD Fee",
      payableByReceiver: "Payable by receiver",
      totalTariff: "Total rate",
      discount: "Discount",
      pieces: "pieces"
    },
    client: {
      label: "Client",
      fieldPlaceholder: "Select client",
      openList: "View client",
      clear: "Clear client",
      required: "Client name required",
      searchPlaceholder: "Enter & select client branch name/alias/code",
      originPlaceholder: "Enter & select client origin city (3LC)",
      originNotFound: "What you are looking for was not found.",
      serviceTypePlaceholder: "Select shipping service type",
      reset: "Reset",
      emptyInitial: "No branch clients registered",
      emptyFiltered:
        "Branch client not found. Try changing the filter or keyword.",
      notFound: "Data not found.",
      notFoundTitle: "Client search not found",
      notFoundSubtitle: "Check the keyword and try again.",
      listError: "Failed to load client list.",
      retry: "Retry",
      filter: {
        title: "Client search filter",
        originLabel: "Client origin city (3LC)",
        serviceTypeLabel: "Shipping service type"
      },
      list: {
        title: "Client list",
        close: "Close client list",
        clientName: "Client name",
        clientAlias: "Alias",
        clientOrigin: "Origin city",
        clientType: "Client type",
        serviceType: "Shipment service",
        clientCode: "Client code"
      }
    },
    previewInvoice: {
      title: "Preview Create Invoice",
      totalStt: "Total STT",
      totalTariff: "Total Tariff",
      totalInvoice: "Total Amount",
      billedTo: "Billed To",
      billedToPlaceholder: "Select billing target",
      note: "Note",
      notePlaceholder: "Enter note for invoice recipient",
      sendTo: "Send To",
      invoiceFormat: "Invoice format",
      formatPlaceholder: "Select format",
      cancel: "Cancel",
      createInvoice: "Create Invoice",
      errorGetHistory: "Failed to retrieve successful booking history data!",
      errorCreateInvoice: "Failed to create invoice!",
      options: {
        pdfA4: "PDF (A4)",
        pngA4: "PNG (A4)",
        pdfStruk: "PDF (Receipt Size)"
      }
    },
    shipment: {
      additionalWeight: {
        title: "Photo proof of the item is required to change the weight.",
        collapsedButton: "Hide",
        content: `<ul class="custom-list">
          <li><span class="font-bold">Photo resolution</span> is clear and not blurry.</li>
          <li><span class="font-bold">Scale or volume measurement</span> is clearly visible.</li>
          <li><span class="font-bold">STT label, shipment label, or other labels</span> are readable.</li>
          <li><span class="font-bold">The entire package</span> is fully visible in a single photo.</li>
        </ul>`,
        weightPhoto: "Photo of the scale",
        photoWithIdentity: "Photo of item with ID",
        additionalPhoto: "Additional photo",
        belowPieces: "The number of packages cannot be reduced."
      },
      goodsName: {
        title: "Goods category"
      }
    },
    savedAddress: {
      title: "Select detail item saved"
    }, // savedAddress Close
    pos: {
      title: "Booking POS",
      placeholder: "Select POS",
      error: "Booked by is required"
    }
  },
  bookingV4Client: {
    breadcrumb: {
      parent: "Booking",
      title: "Client Booking"
    }
  },
  codIncome: {
    title: "COD Balance",
    search: "Search AWB number or Genesis transaction ID",
    summaryTitle: "COD Income",
    filter: "Filter",
    filterAll: "All",
    emptyMessage: "Oops.. No data to display yet",
    column: {
      id: "Genesis ID transaction",
      transactionDate: "Transaction date",
      route: "Route",
      sttNo: "Airway bill number",
      transactionType: "Transaction type",
      activity: "Activity",
      amount: "Amount",
      balance: "Last balance",
      note: "Note",
      bankName: "Bank",
      accountName: "Account name",
      accountNumber: "Account number",
      refId: "Genesis ID reference",
      status: "Status"
    },
    status: {
      success: "Success",
      request: "Process",
      failed: "Failed"
    },
    downloadStatement: "Download statement",
    withdrawal: {
      title: "Withdrawal",
      titlePage: "Withdrawal",
      codBalance: "COD balance",
      passwordTitle: "Your account password",
      passwordPlaceholder: "Enter your Genesis password",
      errorPassword: "Your password is wrong",
      amountTitle: "Withdraw amount",
      amountPlaceholder: "0",
      amountMinMaxNote: "Withdrawal min. is {min} & max. is {max}",
      amountFrequencyNote: "Max. 1 Withdrawal per week.",
      errorAmountExceedBalance: "Amount exceeds available balance.",
      errorAmountBelowMin: "Minimum withdrawal amount is {min}.",
      errorAmountAboveMax: "Maximum withdrawal amount is {max}.",
      sidebarTitle: "Withdrawal summary",
      destinationAccount: "Destination account",
      amountSummaryLabel: "Withdraw amount",
      withdrawButton: "Withdraw",
      snackbarSuccessTitle: "Withdrawal successful",
      snackbarSuccessMessage: "Your withdrawal for {amount} has been submitted."
    }
  }
};
